/*!
 * jMathEdu Book Viewer v 1.0 beta 2
 * Copyright (c) 2019 MathEdu.Ru. All Rights Reserved.
 *
 * Last Mod Date: 2019-08-02
 * @file: jMathEduBookViewer.js
 */

/*
	TODO:
	[x] [x] [ ] Mobile Mode (Several Iterations)
	[ ] HELP Window
*/
"use strict";

var titleTemplate = {
  single: $('meta[name=title-template-single]').attr("content"),
  "double": $('meta[name=title-template-double]').attr("content")
};
var markDesktop = 5;
var markTablet = 4;
var markMobile = 3;
var maxZoom = {
  '1x1': 280,
  '2x1': 220
};
var minZoom = {
  '1x1': 40,
  '2x1': 40
};
var stepZoom = 10;
var maxHTMLWidth = 100;
var minHTMLWidth = 40;
var stepHTMLWidth = 10;
var throttleViewportChange = 100;
var throttleLoadIframe = 50;
var throttleDetectScroll = 60;
var throttleDetectCurrent = 40;
var throttleSyncTree = 20;
var throttleSyncSearch = 20;
var throttleSyncControls = 10;
var throttleResize = 500;
var throttlePrintPolling = 200;
var throttleBookmarksLoad = 10000;
var htmlChunckSize = 20;
var gfxChunckSize = 20;
/*
 * BOOK VIEWER OBJECT
 */

var bookViewer = function bookViewer($object, settings) {
  var object = $object.get(0),
      self = this,
      vpState;
  if (!settings.url) return false;
  object.bookViewer = self;
  self.bookroot = $object.parent('.bookviewer-root');
  self.bookbox = $object; // try to retrieve settings via UAC and AuthUser/Settings

  settings = jQuery.extend(true, {}, settings, self.uacLoadSettings(), self.authLoadSettings(settings.user));
  jQuery.extend(self, {
    settings: settings,
    $object: $object,
    eventNS: '.bookViewer' + ++bookViewer.count
  });
  $object.attr('data-book-viewer', '1');
  window.activeBook = window.activeBook ? window.activeBook : self;
  self.launchViewer();
  $('.w84domload').removeClass('w84domload');
};
/*
 * BOOK VIEWER CORE METHODS
 */


jQuery.extend(bookViewer.prototype, {
  /*
   * LAUCH
   */
  launchViewer: function launchViewer() {
    var self = this,
        vpState;
    self.setupControls();
    self.setupLoaders();
    self.setupCallbacks();
    self.setupViewportState();
    self.setupTreeBox();
    self.setupInfoBox();
    self.setupSearchBox();
    self.setupHelpBox();
    self.setupPrintBox();
    vpState = self.viewPortState;
    self[self.treeBoxState.visible && !vpState.isMobile ? 'showTreeBox' : '_nop'](self, true);
    self[self.printBoxState.visible && !vpState.isMobile ? 'showPrintBox' : '_nop'](self, true);
    self[self.searchBoxState.visible && !vpState.isMobile ? 'showSearchBox' : '_nop'](self, true);
    self.settings.layoutModePrefer = vpState.isMobile ? '1x1' : self.settings.layoutModePrefer;
    self.changeTheme();
    self.changeLayoutMode(self.settings.layoutModePrefer, true);
    self.changeViewMode(self.settings.viewModePrefer);
    var _zoom = self.settings.zoom[vpState.layoutMode];
    self[_zoom._h ? 'changeZoomLevel' : '_nop']('/', false, true);
    self[!_zoom._h && parseInt(_zoom.level) ? 'changeZoomLevel' : '_nop'](parseInt(_zoom.level), false, true);
    var _width = self.settings.zoom.html;
    self[_width && _width.level != 100 ? 'changeWidthLevel' : '_nop'](parseInt(_width.level), false, true);

    if (vpState.viewMode === 'gfx') {
      setTimeout(function () {
        self.viewportResize(false, false, {
          src: 'laucher',
          action: 'launchViewer',
          param: 'gfx'
        }); //self.gotoPage( self._findStartingPage(), null, { scrollToFirstHL: true } );
      }, throttleViewportChange);
    } else if (self.viewPortState.viewMode === 'html') {
      self.timerPreloadHTML = setInterval(function () {
        if (self.htmlLaunch) {
          clearInterval(self.timerPreloadHTML);
          self.timerPreloadHTML = null;
          setTimeout(function () {
            self.viewportResize(false, false, {
              src: 'laucher',
              action: 'launchViewer',
              param: 'html'
            }); //setTimeout( () => {
            //	self.gotoPage( self._findStartingPage(), null, { scrollToFirstHL: true } );
            //}, throttleViewportChange * 20 );
          }, throttleViewportChange);
        }
      }, throttleViewportChange);
    } // Lazy Init Things We Don't Need Immediately


    setTimeout(function () {
      self.setupBookMarks(); // help tips --> move to method

      $('.is-help-tip').each(function (idx, el) {
        var $el = $(el),
            pcmnt = $el.data('pt-pcmnt'),
            xtraclass = $el.data('pt-xclass');
        $el.powerTip({
          followMouse: false,
          smartPlacement: true,
          popupClass: 'help-tip ' + xtraclass,
          mouseOnToPopup: true,
          offset: 8,
          placement: pcmnt ? pcmnt : 's'
        });
      });
    }, throttleDetectCurrent);
    setTimeout(function () {
      // user dropdown
      $(function () {
        var userBtn = $('.topbar-button.ab-user');
        if (!userBtn.length) return false;
        userBtn.removeClass('no-events');
      });
    }, throttleDetectCurrent * 10);
    console.log(jMathEduBookVersion);
  },

  /**
   * FOR FUTURE USE -- Callbacks
   */
  setupCallbacks: function setupCallbacks() {
    var key,
        fn,
        callbacks = {
      'initialize': 'onInitialize',
      'load': 'onLoad',
      'focus': 'onFocus',
      'blur': 'onBlur'
    };

    for (key in callbacks) {
      if (callbacks.hasOwnProperty(key)) {
        fn = this.settings[callbacks[key]];

        if (fn) {
          this.on(key, fn);
        }
      }
    }
  }
});
/*
 * BOOK VIEWER GFX ZOOM / VIEW MODE / LAYOUT MODE HANDLING
 */

jQuery.extend(bookViewer.prototype, {});
/*
 * BOOK URL MANAGER
 */

jQuery.extend(bookViewer.prototype, {
  /**
   *
   * @param e
   */
  urlManager: function urlManager(e) {
    var self = this,
        browserURL = [],
        docTitles = [],
        stateString = [],
        rootViewMode = $('.bookviewer-root').attr('data-view-mode');
    if (!this.isActive) return;
    clearTimeout(self.stateTimeout);
    self.stateTimeout = setTimeout(function () {
      var objViewers = $('[data-book-viewer="1"]');
      objViewers.each(function (k, objViewer) {
        if (!objViewer.bookViewer || !objViewer.bookViewer.settings) return;
        var objSettings = objViewer.bookViewer.settings,
            pageIDX = objViewer.bookViewer.pageIDX,
            docTitle = objSettings.docTitle,
            query = (objViewer.bookViewer.searchBoxState.valid ? encodeURIComponent(objViewer.bookViewer.searchBoxState.query.replace(/[@#<>:;,\?*.]/g, '')) : '') || '%QUERY%',
            urlPackage = objSettings.url,
            urlTemplate = objSettings.surl.page;
        if (!urlTemplate) return;
        var urlString = urlTemplate.replace('/' + self.settings.root + '/', '').replace('%PACKAGE%', urlPackage).replace('%PAGE%', pageIDX).replace('%QUERY%', query).replace('?query=%QUERY%', '') //.replace( ';pageno,', ';page,' )
        .trimChars('/ ');
        browserURL.push(urlString);
        stateString.push(pageIDX);
        docTitles.push(docTitle);
      });
      var newURL = browserURL.join('@');
      window.history.replaceState(stateString.join('-'), '', '/' + self.settings.root + '/' + newURL + (newURL.indexOf('?') !== -1 ? '' : '/'));
      document.title = titleTemplate[rootViewMode] ? titleTemplate[rootViewMode].replace('%left%', docTitles[0]).replace('%right%', docTitles[1]) : document.title;
    }, throttlePrintPolling);
  }
});
/*
 * BOOK VIEWER PLUGIN
 */

jQuery.fn.openbookViewer = function (objSettings) {
  var defaults = jQuery.fn.openbookViewer.defaults,
      settings = jQuery.extend({}, defaults, objSettings);
  return this.each(function () {
    var instance,
        objectSettings,
        $object = $(this),
        objectData = $object.find('[data-settings]').html(),
        extSettings;
    if (this.bookViewer) return false;

    try {
      extSettings = JSON.parse(objectData);
      if (!extSettings.url) return false;
    } catch (E) {
      console.error(E);
      return false;
    }

    objectSettings = {
      url: extSettings['url'],
      docTitle: $object.find('[data-type="top-bookviewer"] .li-title').text(),
      viewModes: {
        gfx: !!extSettings['mode-gfx'],
        html: !!extSettings['mode-html']
      },
      viewModePrefer: extSettings['mode-prefer'] ? extSettings['mode-prefer'] : extSettings['mode-gfx'] ? 'gfx' : 'html',
      layoutModes: {},
      layoutModePrefer: extSettings['layout-prefer'] ? extSettings['layout-prefer'] : '2x1',
      theme: extSettings['theme'] === 'dark' ? 'dark' : 'light',
      zoom: extSettings['zoom'],
      textSizePrefer: jisNumber(extSettings['textsize-prefer']) ? Number(extSettings['textsize-prefer']) : 2,
      textFontPrefer: extSettings['textfont-prefer'] ? extSettings['textfont-prefer'] : 'a',
      treeBoxType: extSettings['tree-type'] === 'ajax' ? 'ajax' : extSettings['tree-type'] === 'inline' ? 'inline' : false,
      treeBoxInitState: extSettings['tree-state'] === 'visible' ? 'visible' : false,
      printAllowed: jBool(extSettings['print-allowed']),
      printBoxInitState: extSettings['printbox-state'] === 'visible' ? 'visible' : false,
      searchBoxType: extSettings['searchbox-type'] === 'ajax' ? 'ajax' : extSettings['searchbox-type'] === 'inline' ? 'inline' : false,
      searchBoxInitState: extSettings['searchbox-state'] === 'visible' ? 'visible' : false,
      //gotoPage   : jisNumber( extSettings[ 'goto-pageno' ] ) ? parseInt( extSettings[ 'goto-pageno' ], 10 ) : 0,
      gotoIDX: jisNumber(extSettings['goto-page']) ? parseInt(extSettings['goto-page'], 10) : -1,
      queryString: JSON.parse(extSettings['query']),
      surl: {
        "package": extSettings['surl-package'],
        page: extSettings['surl-page']
      },
      section: extSettings['section'],
      root: extSettings['root'],
      position: extSettings['package'],
      downloadFormats: {
        pdf: extSettings['download-pdf'] !== '-1',
        djvu: extSettings['download-djvu'] !== '-1'
      },
      gfx: {
        defw: jisNumber(extSettings['defw']) ? parseInt(extSettings['defw'], 10) : 1000,
        defh: jisNumber(extSettings['defh']) ? parseInt(extSettings['defh'], 10) : 1400,
        minh: jisNumber(extSettings['minh']) ? parseInt(extSettings['minh'], 10) : 1400,
        maxh: jisNumber(extSettings['maxh']) ? parseInt(extSettings['maxh'], 10) : 1400
      },
      fixeven: jBool(extSettings['fixeven']) ? 1 : 0,
      user: extSettings['user']
    };
    objectSettings = jQuery.extend(true, {}, settings, objectSettings);
    new bookViewer($object, objectSettings);
  });
};
/**
 * LAUNCH APP
 */


$(document).ready(function () {
  var launchTimeShift = 200;
  jQuery.each($('.bookviewer-box'), function (idx, bookBox) {
    setTimeout(function () {
      $(bookBox).openbookViewer({
        debug: true
      });
    }, idx * launchTimeShift);
  }); //document.addEventListener( 'touchmove', function ( event ) {
  //	event = event.originalEvent || event;
  //	if ( event.scale > 1 ) {
  //		event.preventDefault();
  //	}
  //}, { passive: false } );
  //document.addEventListener( 'gesturestart', function ( event ) {
  //	event = event.originalEvent || event;
  //	if ( event.scale > 1 ) {
  //		event.preventDefault();
  //	}
  //}, { passive: false } );

  document.addEventListener('gesturechange', function (e) {
    if ((e.originalEvent || e).scale > 1) (e.originalEvent || e).preventDefault();
  }, {
    passive: false
  });
});
"use strict";
/*
 * BOOK BOOKMARKS
 */

var bmSeparator = '|';
jQuery.extend(bookViewer.prototype, {
  setupBookMarks: function setupBookMarks() {
    var self = this;
    self.bookmarksState = {
      prefix: typeof dPrefix !== 'undefined' ? dPrefix : 'mathedu-rtm',
      manager: window.xdLocalStorage ? window.xdLocalStorage : null,
      method: window.xdLocalStorage ? 'xdLocalStorage' : null,
      url: '',
      loaded: false,
      enabled: false,
      list: {},
      count: 0,
      $menuItem: self['ctrl-tb-bookmarks'],
      $counterIcon: self.$object.find('.counter-icon'),
      $dropdownList: self['bookmarks-list'],
      pollTimeout: throttleBookmarksLoad,
      pollTimer: null,
      eventsAttached: false
    };

    if (self.settings.user && self.settings.user.authorized) {
      self.bookmarksState.method = 'ajax';
      self.bookmarksState.manager = 'ajax';
      self.bookmarksState.url = '/' + self.settings.root + '/bookmarks/';
    }

    switch (self.bookmarksState.method) {
      case 'xdLocalStorage':
        if (self.bookmarksState.manager && self.bookmarksState.manager.isReady && self.bookmarksState.manager.isReady()) {
          self.loadBookMarks();
        } else {
          self.bookmarksState.manager.init({
            iframeUrl: dStatic + '/bookmarks-manager.html',
            initCallback: function initCallback() {
              self.loadBookMarks();
            }
          });
        }

        break;

      case 'ajax':
        self.loadBookMarks(self.bookmarksState.method);
        break;

      default:
        break;
    }

    if (!self.bookmarksState.eventsAttached) {
      self.attachBookMarksEvents();
    }
  },

  /**
   * Attach BM Events
   */
  attachBookMarksEvents: function attachBookMarksEvents() {
    var self = this,
        bmState = self.bookmarksState;
    bmState.$dropdownList.on('mouseup' + self.eventNS, 'span', {
      self: self
    }, function (e) {
      self.gotoPage(e);
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
    bmState.$dropdownList.on('mouseup' + self.eventNS, 'span .kill', {
      self: self
    }, function (e) {
      var self = e.data.self,
          bmState = self.bookmarksState,
          $pageEl = $(e.target).closest('span'),
          pageIDX = $pageEl.attr('rel');
      self.addBookMark(pageIDX, 0);
      self.updatePageBookMarks(false);
      $($pageEl).remove();
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
    bmState.eventsAttached = true;
  },
  loadBookMarks: function loadBookMarks() {
    var self = this,
        bmState = self.bookmarksState,
        bmSerialized;
    if (!bmState.manager) return false;

    switch (bmState.method) {
      case 'xdLocalStorage':
        bmState.manager.getItem(lsBookMarksKey + bmSeparator + self.settings.url, function (data) {
          bmState.loaded = true;
          bmSerialized = null;

          try {
            bmSerialized = JSON.parse(data.value);
          } catch (E) {
            bmSerialized = {
              bm: {}
            };
          }

          if (bmSerialized && bmSerialized.bm) {
            if (!bmState.pollTimer || JSON.stringify(bmSerialized.bm) !== JSON.stringify(bmState.list)) {
              bmState.list = bmSerialized.bm;
            } else {}
          }

          self.enableBookMarks();
        });
        break;

      case 'ajax':
        jQuery.ajax({
          type: 'POST',
          url: bmState.url,
          data: {
            action: 'load',
            docurl: self.settings.url
          },
          success: function success(e) {
            bmState.loaded = true;
            bmSerialized = null;

            try {
              bmSerialized = JSON.parse(e);
            } catch (E) {
              bmSerialized = {
                bm: {}
              };
            }

            if (bmSerialized && bmSerialized.bm) {
              if (!bmState.pollTimer || JSON.stringify(bmSerialized.bm) !== JSON.stringify(bmState.list)) {
                bmState.list = bmSerialized.bm;
              } else {}
            }

            self.enableBookMarks();
          },
          failure: function failure(e) {
            bmState.loaded = true;
            bmSerialized = {
              bm: {}
            };
            self.enableBookMarks();
          }
        });
        break;

      default:
        break;
    } // Enable BMs Polling (for ex: sync BMs across browser tabs)


    if (!bmState.pollTimer) {
      bmState.pollTimer = setInterval(function () {
        self.loadBookMarks();
      }, bmState.pollTimeout);
    }
  },
  saveBookMarks: function saveBookMarks() {
    var self = this,
        bmState = self.bookmarksState;
    if (!bmState.enabled) return false;

    switch (bmState.method) {
      case 'xdLocalStorage':
        xdLocalStorage.setItem(lsBookMarksKey + bmSeparator + self.settings.url, JSON.stringify({
          bm: bmState.list
        }));
        break;

      case 'ajax':
        jQuery.ajax({
          type: 'POST',
          url: bmState.url,
          data: {
            action: 'save',
            docurl: self.settings.url,
            bookmarks: JSON.stringify({
              bm: bmState.list
            })
          },
          success: function success(e) {},
          failure: function failure(e) {}
        });
        break;

      default:
        break;
    }
  },
  enableBookMarks: function enableBookMarks() {
    var self = this,
        bmState = self.bookmarksState;
    if (!bmState.loaded) return false;
    bmState.enabled = true;
    self.$object.addClass('is-bm-enabled');
    bmState.$menuItem.removeClass('is-disabled');
    self.updatePageBookMarks();
    self.renderBookMarksList();
  },
  addBookMark: function addBookMark(bmIDX, newState) {
    var self = this,
        bmState = self.bookmarksState;
    if (!bmState.enabled) return false;
    var bmKey =
    /*bmState.prefix + bmSeparator + self.settings.url + bmSeparator +*/
    bmIDX;
    bmState.list[bmKey] = {
      color: newState,
      yahl: $(self['ctrl-nav-page'][bmIDX]).hasClass('nav-page-hl') ? self.searchBoxState.query : ''
    };
    self.saveBookMarks();
  },

  /*deleteBookMark: function ( bmIDX, unusedState ) {
  	let self    = this,
  		bmState = self.bookmarksState;
  	if ( !bmState.enabled ) return false;
  
  	let bmKey = bmState.prefix + bmSeparator + self.settings.url + bmSeparator + bmIDX;
  
  	if ( typeof bmState.list[ bmKey ] === 'undefined' ) return false;
  
  	delete bmState.list[ bmKey ];
  
  	self.saveBookMarks();
  },*/
  renderBookMarksList: function renderBookMarksList() {
    var self = this,
        bmState = self.bookmarksState,
        $bmList = self['bookmarks-list-contents'],
        bmItems = [];
    if (!bmState.enabled) return false;
    if (self['bookmarks-list'].is(":hover")) return false;
    bmState.$dropdownList[bmState.count ? 'removeClass' : 'addClass']('is-empty');
    jQuery.each(bmState.list, function (bmKey, bmItem) {
      if (
      /*bmKey.indexOf( bmState.prefix + bmSeparator + self.settings.url ) === 0 &&*/
      bmItem.color) {
        var bmKeyParts = bmKey.split(bmSeparator);
        var bmIDX = bmKey; // Number( bmKeyParts[ 2 ] );

        var pageName = $(self['ctrl-nav-page'][bmIDX]).text();
        if (!pageName.length) pageName = self['page-num'].text();
        bmItems[bmIDX] = $('<span>', {
          "class": 'color-' + bmItem.color,
          html: '<label>' + pageName + '</label><ins class="kill" />',
          attr: {
            rel: bmIDX
          }
        });
      }
    });
    $bmList.html('').append(bmItems);
  },
  updatePageBookMarks: function updatePageBookMarks() {
    var rebuildList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var self = this,
        bmState = self.bookmarksState;
    if (!bmState || !bmState.enabled) return false;
    bmState.count = 0;
    jQuery.each(bmState.list, function (bmKey, bmItem) {
      //if ( bmKey.indexOf( bmState.prefix + bmSeparator + self.settings.url ) === 0 ) {
      //	let bmKeyParts = bmKey.split( bmSeparator );
      var bmIDX = bmKey;
      self.toggleBookMark(bmIDX
      /*bmKeyParts[ 2 ]*/
      , bmItem.color, false);
      if (parseInt(bmItem.color) > 0) bmState.count++; //}
    });
    self.updateBookMarksCounter(rebuildList);
  },
  updateBookMarksCounter: function updateBookMarksCounter() {
    var rebuildList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var self = this,
        bmState = self.bookmarksState;
    if (!bmState.enabled) return false;
    bmState.count = 0;
    jQuery.each(bmState.list, function (bmKey, bmItem) {
      //if ( bmKey.indexOf( bmState.prefix + bmSeparator + self.settings.url ) === 0 && bmItem.color ) {
      //console.log(bmKey, bmItem);
      if (parseInt(bmItem.color) > 0) bmState.count++; //}
    });
    bmState.$counterIcon.text(bmState.count < 100 ? bmState.count : '99+');
    bmState.$counterIcon[bmState.count ? 'addClass' : 'removeClass']('non-zero');
    bmState.$dropdownList[!bmState.count ? 'addClass' : 'removeClass']('is-empty');
    if (rebuildList) self.renderBookMarksList();
  },
  toggleBookMark: function toggleBookMark(bmIDX, toState) {
    var doSave = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var elBM = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var self = this,
        bmState = self.bookmarksState;
    if (!bmState.enabled || !bmIDX) return false;
    var $bmItemGfx = self.$object.find('span.bm-toggle[rel="' + bmIDX + '"]');
    var $bmItemHTML = self['viewport-html-iframe-contents'] ? self['viewport-html-iframe-contents'].find('span.bm-toggle[rel="' + bmIDX + '"]') : $();
    if (!$bmItemGfx[0] && !$bmItemHTML[0]) return false;

    if (typeof toState === 'undefined') {
      toState = Number(self.getBookMarkByIDX(bmIDX, 'color'));
      toState = toState === 4 ? 0 : toState + 1;
    }

    if ($bmItemGfx[0]) $bmItemGfx.removeClass('color-0 color-1 color-2 color-3 color-4').addClass('color-' + toState);
    if ($bmItemHTML[0]) $bmItemHTML.removeClass('color-0 color-1 color-2 color-3 color-4').addClass('color-' + toState);
    if (!doSave) return false;
    self.addBookMark(bmIDX, toState);
    self.updateBookMarksCounter();
  },
  getBookMarkByIDX: function getBookMarkByIDX(bmIDX, bmAttr) {
    var self = this,
        bmState = self.bookmarksState;
    if (!bmState || !bmState.enabled || !bmIDX) return false;
    var bmItem = bmState.list[
    /*bmState.prefix + bmSeparator + self.settings.url + bmSeparator +*/
    bmIDX];
    if (typeof bmItem === 'undefined') return bmAttr ? '' : {};
    return bmAttr ? bmItem[bmAttr] : bmItem;
  },
  showBookMarksBox: function showBookMarksBox(e) {
    var self = e.data.self,
        bmState = self.bookmarksState,
        isActive = self['ctrl-tb-bookmarks'].hasClass('is-active');
    if (!bmState.enabled) return false;

    if (!isActive) {
      self.hideControlBoxes();
      self.renderBookMarksList();
      self['ctrl-tb-bookmarks'].addClass('is-active');
      self['bookmarks-list'].addClass('is-active');
    } else {
      if (e.type === 'mouseup' && e.target !== self['ctrl-tb-bookmarks'][0]) {
        e.stopPropagation();
        return false;
      }

      self['ctrl-tb-bookmarks'].removeClass('is-active');
      self['bookmarks-list'].removeClass('is-active');
      return false;
    }

    e.preventDefault();
    e.stopPropagation();
    return false;
  }
});
"use strict";

jQuery.extend(bookViewer.prototype, {
  /**
   * GOTOPAGE BY IDX / EVENT
   * @param mixedPage
   * @param event
   */
  gotoPage: function gotoPage(mixedPage, event) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      src: 'gotoPage'
    };
    var self = this,
        vpState = self.viewPortState,
        colCount = vpState.layoutMode === '2x1' ? 2 : 1,
        $elPage;

    if (mixedPage && mixedPage.target && mixedPage.target.nodeName.toLowerCase() === 'span') {
      $elPage = $(mixedPage.target);
      self.pageIDX = Number($elPage.attr('rel'));
    } else if (typeof mixedPage === 'number') {
      //console.log( vpState.fixeven, mixedPage);
      self.pageIDX = Math.max(mixedPage, vpState.fixeven);
    } else if (typeof mixedPage === 'string') {
      switch (mixedPage) {
        case 'next':
          self.pageIDX = Math.min(self.pageIDX + colCount, self.pageMAX - 1);
          break;

        case 'prev':
          self.pageIDX = Math.max(self.pageIDX - colCount, 0);
          break;

        case 'first':
          self.pageIDX = vpState.fixeven;
          break;

        case 'last':
          self.pageIDX = self.pageMAX - 1;
          break;

        case 'next-hl':
          var nextHL = $(self['ctrl-nav-page'][self.pageIDY]).nextAll('.nav-page-hl').eq(0);

          if (nextHL[0]) {
            self.pageIDX = Number($(nextHL).attr('rel'));
            params.scrollToFirstHL = vpState.viewMode === 'html';
          }

          break;

        case 'prev-hl':
          var prevHL = $(self['ctrl-nav-page'][self.pageIDX]).prevAll('.nav-page-hl').eq(0);

          if (prevHL[0]) {
            self.pageIDX = Number($(prevHL).attr('rel'));
            params.scrollToLastHL = vpState.viewMode === 'html';
          }

          break;
      }
    } else if (typeof mixedPage === 'undefined') {}

    self.pageIDX = vpState.layoutMode === '2x1' ? Math.trunc(self.pageIDX / 2) * 2 : self.pageIDX;
    self.pageIDY = vpState.layoutMode === '2x1' ? Math.min(self.pageIDX + 1, self.pageMAX - 1) : self.pageIDX;

    if (!self['viewport-gfx-pages'][self.pageIDX]) {
      self.pageIDX = 0;
      self.pageIDY = 0;
    }

    self.infoBoxState.valid = false;
    self.viewportSync(event, params);
    self.syncControls(true, false, params);
  },

  /**
   * SYNC CONTROLS
   *
   * @param bCloseControlBoxes
   */
  syncControls: function syncControls(bCloseControlBoxes) {
    var light = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var self = this,
        vpState = self.viewPortState,
        sbState = self.searchBoxState,
        isHL,
        idxEl;
    clearTimeout(self.timerSyncControls);
    self.timerSyncControls = setTimeout(function () {
      if (!light) {
        // Tree Buttons
        self['ctrl-tb-tree'][self.settings.treeBoxType ? 'removeClass' : 'addClass']('is-disabled');
        self['ctrl-tb-tree'][self.treeBoxState.visible ? 'addClass' : 'removeClass']('is-active'); // Print Button

        self['ctrl-tb-print'][self.printBoxState.visible ? 'addClass' : 'removeClass']('is-active'); // Search Button

        self['ctrl-tb-search'][self.searchBoxState.visible ? 'addClass' : 'removeClass']('is-active'); // NAV Buttons

        jQuery.each([self['ctrl-nb-next'], self['ctrl-nb-next-hl'], self['ctrl-nb-last']], function (idx, elButton) {
          elButton[self.pageIDX < self.pageMAX - 1 ? 'removeClass' : 'addClass']('is-disabled');
        });
        jQuery.each([self['ctrl-nb-prev'], self['ctrl-nb-prev-hl'], self['ctrl-nb-first']], function (idx, elButton) {
          elButton[self.pageIDX > 0 ? 'removeClass' : 'addClass']('is-disabled');
        }); // NEXT-HL / PREV-HL NAV Buttons

        var nextHL = $(self['ctrl-nav-page'][self.pageIDY]).nextAll('.nav-page-hl');
        var prevHL = $(self['ctrl-nav-page'][self.pageIDX]).prevAll('.nav-page-hl');
        self['ctrl-nb-next-hl'][nextHL.length ? 'removeClass' : 'addClass']('is-disabled');
        self['ctrl-nb-prev-hl'][prevHL.length ? 'removeClass' : 'addClass']('is-disabled'); // Mark current pages in DropDown and HL Pager if Current Page is YAHL

        isHL = false;
        self['ctrl-nav-page'].removeClass('is-active');

        for (idxEl = self.pageIDX; idxEl <= self.pageIDY; idxEl++) {
          $(self['ctrl-nav-page'][idxEl]).addClass('is-active');

          if ($(self['ctrl-nav-page'][idxEl]).hasClass('nav-page-hl')) {
            isHL = true;
          }
        }

        self['ctrl-nav-pager'][isHL ? 'addClass' : 'removeClass']('is-query-hl');
      } // SET PAGE NO (PAGER)


      if (self.pageMAX) {
        var pageNo = [];
        var pageNoFrom = $(self['ctrl-nav-page'][self.pageIDX]).text();
        var pageNoTo = $(self['ctrl-nav-page'][self.pageIDY]).text();
        pageNo.push(pageNoFrom);
        if (pageNoFrom !== pageNoTo && pageNoTo !== '') pageNo.push(pageNoTo); //pageNo = pageNo.join( ' – ' );

        self['page-num'].text(pageNo.join(' – '));
        self['ctrl-nav-pager'].attr('title', pageNo.join(' – '));
        $('[data-type="book-glowbar"] ins').css({
          width: Math.ceil((self.pageIDX < self.pageMAX / 2 ? self.pageIDX : self.pageIDY) / (self.pageMAX - 1) * 100) + '%'
        });
      } // SEARCH BUTTON


      self['ctrl-tb-search'][vpState.viewModes.gfx && vpState.viewModes.html ? 'removeClass' : 'addClass']('is-restricted'); // VIEW MODE Buttons

      self['ctrl-tb-view'][vpState.viewModes.gfx && vpState.viewModes.html ? 'removeClass' : 'addClass']('is-restricted');
      self['ctrl-tb-layout'][vpState.viewModes.gfx || vpState.viewModes.html ? 'removeClass' : 'addClass']('is-disabled');
      self['ctrl-pv-font-a'][vpState.html.textFont === 'a' ? 'addClass' : 'removeClass']('is-disabled');
      self['ctrl-pv-font-b'][vpState.html.textFont === 'b' ? 'addClass' : 'removeClass']('is-disabled'); // ZOOM Buttons

      self['ctrl-pz-zoom-in'][vpState.zoom[vpState.layoutMode].level < maxZoom[vpState.layoutMode] ? 'removeClass' : 'addClass']('is-disabled');
      self['ctrl-pz-zoom-out'][vpState.zoom[vpState.layoutMode].level > minZoom[vpState.layoutMode] ? 'removeClass' : 'addClass']('is-disabled');
      self['ctrl-pz-zoom-w'][vpState.zoom[vpState.layoutMode]._w ? 'addClass' : 'removeClass']('is-disabled');
      self['ctrl-pz-zoom-h'][vpState.zoom[vpState.layoutMode]._h ? 'addClass' : 'removeClass']('is-disabled'); // TEXT SIZE BUTTONS

      self['ctrl-pz-texsize-dec'][vpState.html.textSize === 0 ? 'addClass' : 'removeClass']('is-disabled');
      self['ctrl-pz-texsize-inc'][vpState.html.textSize >= 4 ? 'addClass' : 'removeClass']('is-disabled'); // TEXT WIDTH BUTTONS

      self['ctrl-pz-textwidth-inc'][vpState.zoom.html.level < maxHTMLWidth && vpState.layoutMode != '2x1' ? 'removeClass' : 'addClass']('is-disabled');
      self['ctrl-pz-textwidth-dec'][vpState.zoom.html.level > minHTMLWidth && vpState.layoutMode != '2x1' ? 'removeClass' : 'addClass']('is-disabled'); // ROTATE BUTTONS

      var rotAllowed = vpState.layoutMode === '1x1' && vpState.viewMode === 'gfx' && self['viewport-gfx-pages'][self.pageIDX] && !$(self['viewport-gfx-pages'][self.pageIDX]).hasClass('ls-page') && !$(self['viewport-gfx-pages'][self.pageIDX]).hasClass('ns-page');
      self['ctrl-pz-rot-cw'][rotAllowed ? 'removeClass' : 'addClass']('is-disabled');
      self['ctrl-pz-rot-ccw'][rotAllowed ? 'removeClass' : 'addClass']('is-disabled'); // Close Popups if Forced to

      if (!light && bCloseControlBoxes) self.hideControlBoxes(); // Rewrite Browser URL & Title

      self.urlManager('update');
    }, throttleSyncControls);
  },

  /**
   * 1) Find All Controls, Assign Event Listeners
   * 2) Add SCROLL/RESIZE Event Listeners
   */
  setupControls: function setupControls() {
    var self = this,
        $object = self.$object,
        $window = $(window),
        eventNS = self.eventNS,
        key,
        fn,
        type,
        param;
    self.controls = {
      '.tb-tree': {
        fnHandler: 'showTreeBox',
        eventType: 'mouseup'
      },
      '.tb-print': {
        fnHandler: 'showPrintBox',
        eventType: 'mouseup'
      },
      '.tb-search': {
        fnHandler: 'showSearchBox',
        eventType: 'mouseup'
      },
      '.tb-bookmarks': {
        fnHandler: 'showBookMarksBox',
        eventType: 'mouseup'
      },
      '.tb-help': {
        fnHandler: 'showHelpBox',
        eventType: 'mouseup'
      },
      '.tb-theme': {
        fnHandler: 'switchTheme',
        eventType: 'mouseup'
      },
      '.tb-zoom': {
        fnHandler: 'showZoomBox',
        eventType: 'mouseup'
      },
      '.tb-view': {
        fnHandler: 'toggleViewMode',
        eventType: 'mouseup'
      },
      '.tb-layout': {
        fnHandler: 'toggleLayoutMode',
        eventType: 'mouseup'
      },
      '.tb-info': {
        fnHandler: 'showInfoBox',
        eventType: 'mouseup'
      },
      '.nb-first': {
        fnHandler: 'onNav',
        eventType: 'mouseup',
        param: 'first'
      },
      '.nb-prev': {
        fnHandler: 'onNav',
        eventType: 'mouseup',
        param: 'prev'
      },
      '.nb-prev-hl': {
        fnHandler: 'onNav',
        eventType: 'mouseup',
        param: 'prev-hl'
      },
      '.nb-last': {
        fnHandler: 'onNav',
        eventType: 'mouseup',
        param: 'last'
      },
      '.nb-next': {
        fnHandler: 'onNav',
        eventType: 'mouseup',
        param: 'next'
      },
      '.nb-next-hl': {
        fnHandler: 'onNav',
        eventType: 'mouseup',
        param: 'next-hl'
      },
      '.nav-page': {
        fnHandler: 'onNavPage',
        eventType: 'mousedown'
      },
      '.nav-pager': {
        fnHandler: 'onPagesList',
        eventType: 'mouseup'
      },
      '.pz-zoom-in': {
        fnHandler: 'onZoom',
        eventType: 'mouseup',
        param: '+'
      },
      '.pz-zoom-out': {
        fnHandler: 'onZoom',
        eventType: 'mouseup',
        param: '-'
      },
      '.pz-zoom-w': {
        fnHandler: 'onZoom',
        eventType: 'mouseup',
        param: '*'
      },
      '.pz-zoom-h': {
        fnHandler: 'onZoom',
        eventType: 'mouseup',
        param: '/'
      },
      '.pz-texsize-dec': {
        fnHandler: 'onTextSize',
        eventType: 'mouseup',
        param: '-'
      },
      '.pz-texsize-inc': {
        fnHandler: 'onTextSize',
        eventType: 'mouseup',
        param: '+'
      },
      '.pz-textwidth-dec': {
        fnHandler: 'onWidth',
        eventType: 'mouseup',
        param: '['
      },
      '.pz-textwidth-inc': {
        fnHandler: 'onWidth',
        eventType: 'mouseup',
        param: ']'
      },
      '.pv-font-a': {
        fnHandler: 'onTextFont',
        eventType: 'mouseup',
        param: 'a'
      },
      '.pv-font-b': {
        fnHandler: 'onTextFont',
        eventType: 'mouseup',
        param: 'b'
      },
      '.pz-rot-cw': {
        fnHandler: 'onPageRotate',
        eventType: 'mouseup',
        param: 'cw'
      },
      '.pz-rot-ccw': {
        fnHandler: 'onPageRotate',
        eventType: 'mouseup',
        param: 'ccw'
      },
      '.li-close': {
        fnHandler: 'onClose',
        eventType: 'mouseup',
        param: self.settings.position
      },
      '.close-box.close-info-box': {
        fnHandler: 'hideInfoBox',
        eventType: 'mouseup'
      },
      '.close-box.close-tree-box': {
        fnHandler: 'hideTreeBox',
        eventType: 'mouseup'
      },
      '.close-box.close-print-box': {
        fnHandler: 'hidePrintBox',
        eventType: 'mouseup'
      },
      '.close-box.close-search-box': {
        fnHandler: 'hideSearchBox',
        eventType: 'mouseup'
      },
      '.close-box.close-help-box': {
        fnHandler: 'hideHelpBox',
        eventType: 'mouseup'
      }
    };
    self['info-box'] = $object.find('[data-type="info-box"]');
    self['info-box-container'] = self['info-box'].find('.data-container');
    self['help-box'] = $object.find('[data-type="help-box"]');
    self['help-box-container'] = self['help-box'].find('.data-container');
    self['tree-box'] = $object.find('[data-type="tree-box"]');
    self['tree-box-container'] = self['tree-box'].find('.data-container');
    self['tree-data-list'] = self['tree-box'].find('.data-list');
    self['tree-links'] = [];
    self['print-box'] = $object.find('[data-type="print-box"]');
    self['print-box-container'] = self['print-box'].find('.data-container');
    self['print-data-list'] = self['print-box'].find('.data-list');
    self['search-box'] = $object.find('[data-type="search-box"]');
    self['search-box-container'] = self['search-box'].find('.data-container');
    self['search-box-counter'] = $object.find('.counter-search-icon');
    self['search-box-data-list'] = self['search-box'].find('.wrapper-list');
    self['search-box-data-map'] = self['search-box'].find('.wrapper-map');
    self['pages-list'] = $object.find('[data-type="pages-list"]');
    self['pages-data-container'] = self['pages-list'].find('.data-container');
    self['pages-data-list'] = self['pages-list'].find('.data-list');
    self['page-num'] = $object.find('[data-type="page-num"]');
    self['toolbar'] = $object.find('[data-type="book-toolbar"]');
    self['toolbar-nav'] = self['toolbar'].find('[data-type=book-nav]');
    self['viewport-gfx'] = $object.find('[data-view-mode="gfx"]');
    self['viewport-gfx-container'] = self['viewport-gfx'].find('.data-container');
    self['viewport-gfx-contents'] = self['viewport-gfx'].find('.data-contents');
    self['viewport-gfx-pages'] = self['viewport-gfx-contents'].find('.page-gfx');
    self['viewport-html'] = $object.find('[data-view-mode="html"]');
    self['viewport-html-container'] = self['viewport-html'].find('.data-container');
    self['viewport-html-contents'] = self['viewport-html-container'].find('.data-contents');
    self['viewport-html-iframe'] = null;
    self['viewport-ruler'] = $object.find('[data-view-mode="ruler"]');
    self['bookmarks-list'] = $object.find('[data-type=popup-bookmarks]');
    self['bookmarks-list-contents'] = self['bookmarks-list'].find('.data-list');
    self['load-overlay'] = $('.box-load-overlay');
    self['mobile-marker'] = $object.find('.book-mobile-marker');
    self['vp-center'] = $object.find('.vp-center');
    $object.on('mousedown' + eventNS, '', {
      self: self
    }, function () {
      return self.onMouseDown.apply(self, arguments);
    }).on('mouseenter' + eventNS, '', {
      self: self
    }, function () {
      return self.onRollOver.apply(self, arguments);
    }).on('mouseover' + eventNS, '', {
      self: self
    }, function () {
      return self.onRollOver.apply(self, arguments);
    }).on('mouseup' + eventNS, '', {
      self: self
    }, function () {
      return self.onClick.apply(self, arguments);
    });
    $window.on('keyup' + eventNS, '', {
      self: self
    }, function () {
      return self.onKeyboard.apply(self, arguments);
    }).on('resize' + eventNS + ' orientationChange' + eventNS, function (e) {
      clearTimeout(self.resizeTimer);
      jQuery.powerTip.hide(null, true);
      requestAnimationFrame(function () {
        self.$object.addClass('no-transition is-rendering');
        self.hideControlBoxes(e);
      });
      self.resizeTimer = setTimeout(function () {
        self.resizeInProgress = true;
        self.viewportResize(true, true);
        self.resizeTimer = null;
      }, throttleResize);
    });
    self.drgGFX = {
      clicked: false,
      allowClick: true,
      mouseX: -1,
      mouseY: -1
    };
    self['viewport-gfx-container'].on('mousewheel' + eventNS, '', {
      self: self
    }, function (e) {
      var self = e.data.self;
      self.hideControlBoxes(e);

      if (e.altKey && e.originalEvent.deltaY) {
        self.changeZoomLevel(e.originalEvent.deltaY < 0 ? '+' : '-');
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    }).on('scroll' + eventNS, '', {
      self: self
    }, function (e) {
      var self = e.data.self;
      if (self.scrollTimer) clearTimeout(self.scrollTimer);
      if (e.target.deflectScrollEvent || self.resizeInProgress || self.resizeTimer) return false;
      jQuery.powerTip.hide();
      self.scrollTimer = setTimeout(function () {
        self.viewportDetectCurrent();
        self.scrollTimer = null;
      }, throttleDetectScroll);
    }).on('mousemove' + eventNS, '', {
      self: self
    }, function (e) {
      var self = e.data.self;
      if (self.resizeInProgress || self.resizeTimer) return;

      if (self.drgGFX.clicked) {
        self['viewport-gfx-container'].scrollLeft(self['viewport-gfx-container'].scrollLeft() + (self.drgGFX.mouseX - e.pageX));
        self['viewport-gfx-container'].scrollTop(self['viewport-gfx-container'].scrollTop() + (self.drgGFX.mouseY - e.pageY));
        self.drgGFX.mouseX = e.pageX;
        self.drgGFX.mouseY = e.pageY;
      }
    }).on('mousedown' + eventNS, '', {
      self: self
    }, function (e) {
      var self = e.data.self;
      if (self.resizeInProgress || self.resizeTimer || self.isMobile) return;
      self['viewport-gfx-container'].addClass('is-draggable');
      self.drgGFX.clicked = true;
      self.drgGFX.mouseX = e.pageX;
      self.drgGFX.mouseY = e.pageY; //e.preventDefault();
      //e.stopPropagation();
      //return false;
    }).on('mouseup' + eventNS + ' mouseleave' + eventNS, '', {
      self: self
    }, function (e) {
      var self = e.data.self;
      self['viewport-gfx-container'].removeClass('is-draggable');
      self.drgGFX.clicked = false;
      self.drgGFX.allowClick = true;
    });
    self['viewport-gfx-pages'].on('click' + eventNS, '.bm-toggle', {
      self: self
    }, function (e) {
      var self = e.data.self;
      self.onBookMarkToggle(e, 'bookmark-toggle');
      e.preventDefault();
      e.stopPropagation();
      return false;
    }) //.on( 'click' + eventNS, '.pg-rotate', { self: self }, function ( e ) {
    //	let self = e.data.self;
    //
    //	self.onBookMarkToggle( e, 'bookmark-toggle' );
    //
    //self.onPageRotate( e );
    //
    //e.preventDefault();
    //e.stopPropagation();
    //return false;
    //} )
    .on('mouseup' + eventNS, '', {
      self: self
    }, function (e) {// self.gotoPage( Number( $( this ).attr( 'rel' ) ) );
    });
    self['viewport-html-container'].on('mousewheel' + eventNS, '', {
      self: self
    }, function (e) {
      var self = e.data.self;
      self.hideControlBoxes(e);
    }).on('scroll' + eventNS, '', {
      self: self
    }, function (e) {
      var self = e.data.self;
      if (self.scrollTimer) clearTimeout(self.scrollTimer);
      if (e.target.deflectScrollEvent || self.resizeInProgress || self.resizeTimer || self.viewPortState.viewMode !== 'html' || self.$object.hasClass('is-loading')) return false;
      jQuery.powerTip.hide(null, true);
      self.scrollTimer = setTimeout(function () {
        self.viewportDetectCurrent();
        self.scrollTimer = null;
      }, throttleDetectScroll);
    });

    for (key in self.controls) {
      if (self.controls.hasOwnProperty(key)) {
        fn = self.controls[key].fnHandler;
        type = self.controls[key].eventType;
        param = self.controls[key].param;

        if (fn && type) {
          $object.on(type + eventNS, key, {
            self: self,
            param: param
          }, self[fn]);
          self['ctrl-' + key.replace('.', '').replace(' ', '-')] = $object.find(key);
        }
      }
    }

    self['info-box'].on('mouseup' + eventNS, function (e) {
      if ($(e.target)[0] !== self['ctrl-close-box.close-info-box'][0]) {
        e.stopPropagation();
      }
    });
    self['help-box'].on('mouseup' + eventNS, function (e) {
      if ($(e.target)[0] !== self['ctrl-close-box.close-help-box'][0]) {
        e.stopPropagation();
      }
    });
  },
  onClick: function onClick(e) {
    var self = e.data.self;
    return self.hideControlBoxes(e);
  },
  onMouseDown: function onMouseDown(e) {},
  onRollOver: function onRollOver(e) {
    window.activeBook = e.data.self;
  },
  // Keyboard Listener
  onKeyboard: function onKeyboard(e) {
    var self = e && e.data && e.data.self ? e.data.self : this,
        vpState = self.viewPortState;

    if (!self.isActive || window.activeBook !== self || e && e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'input') {
      return;
    }

    switch (e.key) {
      case 'ArrowLeft':
        self.gotoPage(!e.ctrlKey ? 'prev' : 'prev-hl');
        e.preventDefault();
        break;

      case 'ArrowRight':
        self.gotoPage(!e.ctrlKey ? 'next' : 'next-hl');
        e.preventDefault();
        break;

      case '+':
      case '=':
      case '-':
      case '/':
      case '*':
        if (vpState.viewMode === 'gfx') self.changeZoomLevel(e.key);
        if (vpState.viewMode === 'html') self.changeTextSize(e.key);
        break;

      case 'Escape':
      case 'Esc':
        var $app = $('.ph-app');

        if ($app.hasClass('is-help-visible')) {
          $app.removeClass('is-help-visible');
          e.preventDefault();
          return false;
        }

        self.hideControlBoxes(e);
        break;

      case '1':
        // Num Pad etc
        self.changeLayoutMode('1x1');
        break;

      case '2':
        self.changeLayoutMode('2x1');
        break;

      default:
        switch (e.keyCode) {
          case 77:
            self.toggleViewMode(e);
            break;

          case 76:
            self.toggleLayoutMode(e);
            break;

          case 49:
            self.changeLayoutMode('1x1');
            break;

          case 50:
            self.changeLayoutMode('2x1');
            break;

          case 192: // ~

          case 84:
            // t
            self.showTreeBox(e);
            break;

          case 72:
            // h
            self.showHelpBox(e);
            break;

          case 73:
            // i
            self.showInfoBox(e);
            break;

          case 83:
            // s
            if (!e.ctrlKey) self.showSearchBox(e);
            break;

          case 80:
            // p
            if (!e.ctrlKey) self.showPrintBox(e);
            break;

          case 69:
            // e
            self.switchTheme(e);
            break;
          //case 81: // q
          //	self.showSearchBox( e );
          //	break;

          case 66:
            // b
            self.showBookMarksBox(e);
            break;

          case 188: // <

          case 219:
            // [
            self.changeWidthLevel('[');
            break;

          case 190: // >

          case 221:
            // ]
            self.changeWidthLevel(']');
            break;

          case 90:
            // Z
            self.pageRotate('ccw');
            break;

          case 88:
            // X
            self.pageRotate('cw');
            break;

          default:
            break;
        }

        break;
    }
  },
  // Popup Zoom - SHOW/HIDE
  showZoomBox: function showZoomBox(e) {
    var self = e.data.self;
    self.hideControlBoxes(e);
    self['ctrl-tb-zoom'].toggleClass('is-active');
  },
  // Nav Buttons
  onNav: function onNav(e) {
    var self = e.data.self,
        param = e.data.param;
    self.gotoPage(param);
  },
  // Zoom Popup + - / *
  onZoom: function onZoom(e) {
    var self = e.data.self,
        param = e.data.param;
    self.changeZoomLevel(param);
    e.preventDefault();
    e.stopPropagation();
    return false;
  },
  onPageRotate: function onPageRotate(e) {
    var self = e.data.self,
        param = e.data.param;
    self.pageRotate(param);
    e.preventDefault();
    e.stopPropagation();
    return false;
  },
  // Zoom Popup + - / *
  onWidth: function onWidth(e) {
    var self = e.data.self,
        param = e.data.param;
    self.changeWidthLevel(param);
    e.preventDefault();
    e.stopPropagation();
    return false;
  },
  // Page Navigation Dropdown - SHOW
  onPagesList: function onPagesList(e) {
    var self = e.data.self,
        isVisible; //self.hideControlBoxes( e );

    isVisible = self['ctrl-nav-pager'].hasClass('is-active');
    if (e.target !== self['ctrl-nav-pager'][0]) return false;

    if (isVisible) {
      self['pages-list'].delayHide();
      self['ctrl-nav-pager'].removeClass('is-active');
    } else {
      self['pages-list'].delayShow();
      setTimeout(function () {
        self['ctrl-nav-pager'].addClass('is-active');
      }, 1);
      $(self['ctrl-nav-page'][self.pageIDX]).scrollIntoViewIfNeeded(true, self['pages-data-container']);
    }
  },
  // Page Dropdown Item Click -- GOTOPAGE
  onNavPage: function onNavPage(e) {
    var self = e.data.self;
    self.gotoPage(e);
    e.stopPropagation();
    return false;
  },
  // Close All Controls and Popups
  hideControlBoxes: function hideControlBoxes(e) {
    var self = e && e.data && e.data.self ? e.data.self : this,
        vpState = self.viewPortState,
        _e = e ? e : {};

    if (!self.isActive) return;

    if (vpState.isMobile) {
      if (_e.target !== self['ctrl-tb-tree'][0] && $(_e.target).closest('[data-side-box]')[0] !== self['tree-box'][0]) self.forceHideTreeBox();
      if (_e.target !== self['ctrl-tb-print'][0] && $(_e.target).closest('[data-side-box]')[0] !== self['print-box'][0]) self.forceHidePrintBox();
      if (_e.target !== self['ctrl-tb-search'][0] && $(_e.target).closest('[data-side-box]')[0] !== self['search-box'][0]) self.forceHideSearchBox();
      if (_e.target !== self['ctrl-tb-info'][0] && $(_e.target).closest('[data-side-box]')[0] !== self['info-box'][0]) self.forceHideInfoBox();
      if (_e.target !== self['ctrl-tb-help'][0] && $(_e.target).closest('[data-side-box]')[0] !== self['help-box'][0]) self.forceHideHelpBox();
    }

    if (_e.target !== self['ctrl-tb-info'][0]) self.forceHideInfoBox();
    if (_e.target !== self['ctrl-tb-help'][0]) self.forceHideHelpBox();
    if (_e.target !== self['ctrl-nav-pager'][0]) self['ctrl-nav-pager'].removeClass('is-active');
    if (_e.target !== self['ctrl-tb-zoom'][0]) self['ctrl-tb-zoom'].removeClass('is-active');
    if (_e.target !== self['ctrl-tb-view'][0]) self['ctrl-tb-view'].removeClass('is-active');

    if (_e.target !== self['ctrl-tb-bookmarks'][0]) {
      self['ctrl-tb-bookmarks'].removeClass('is-active');
      self['bookmarks-list'].removeClass('is-active');
    }
  },
  // BookMarks -- Toggler
  onBookMarkToggle: function onBookMarkToggle(e) {
    var self = e.data.self;
    if (!self.bookmarksState.enabled) return false;
    self.toggleBookMark($(e.target).attr('rel'), undefined, true, $(e.target));
    return false;
  },
  // Text Size - +/-
  onTextSize: function onTextSize(e) {
    var self = e.data.self,
        param = e.data.param;
    if ($(e.currentTarget).hasClass('is-restricted')) return false;
    self.changeTextSize(param);
    e.preventDefault();
    e.stopPropagation();
    return false;
  },
  // Text Font -- SWITCH
  onTextFont: function onTextFont(e) {
    var self = e.data.self,
        param = e.data.param;
    if ($(e.currentTarget).hasClass('is-restricted')) return false;
    self.changeTextFont(param);
    e.preventDefault();
    e.stopPropagation();
    return false;
  },

  /**
   * 2x1 <> 1x1 LAYOUT TOGGLE
   * @param e
   */
  toggleLayoutMode: function toggleLayoutMode(e) {
    var self = e.data.self,
        oldMode = self.viewPortState.layoutMode;
    if ($(e.currentTarget).hasClass('is-restricted')) return false;
    self.changeLayoutMode(oldMode === '2x1' ? '1x1' : '2x1');
  },

  /**
   * HTML <> GFX MODE TOGGLE
   * @param e
   */
  toggleViewMode: function toggleViewMode(e) {
    var self = e.data.self,
        oldMode = self.viewPortState.viewMode;
    if ($(e.currentTarget).hasClass('is-restricted')) return false;
    self.changeViewMode(oldMode === 'gfx' ? 'html' : 'gfx');
  }
});
"use strict";

jQuery.extend(bookViewer.prototype, {
  /*
   *
   */
  setupHelpBox: function setupHelpBox() {
    var self = this;
    self.helpBoxState = {
      exists: true,
      type: 'ajax',
      visible: false,
      enabled: true,
      valid: false,
      loading: false,
      ajaxloader: self['help-box'].find('.side-loader')
    };
    self.helpBoxState.ajaxloader.hide(0);
    self['help-box'].hide(0);
    self.helpBoxState.enabled = true;
  },

  /*
   * Help Box - OPEN
   */
  showHelpBox: function showHelpBox(e) {
    var self = e && e.data && e.data.self || e,
        boxState = self.helpBoxState,
        newVisibleState = !boxState.visible;
    self.hideControlBoxes(e);

    if (newVisibleState) {
      self['help-box'].delayShow();
      setTimeout(function () {
        self['help-box'].addClass('is-active');
      }, 1);
      self['ctrl-tb-help'].addClass('is-active');
      self.loadHelpBox();
    } else {
      self['help-box'].removeClass('is-active');
      self['help-box'].delayHide();
      self['ctrl-tb-help'].removeClass('is-active');
      boxState.ajaxloader.delayHide();
    }

    boxState.visible = newVisibleState;
  },

  /*
   * Help Box - CLOSE
   */
  hideHelpBox: function hideHelpBox(e) {
    var self = e && e.data && e.data.self || e,
        boxState = self.helpBoxState;
    boxState.visible = false;
    boxState.ajaxloader.delayHide();
    self['help-box'].delayHide();
    self['ctrl-tb-help'].removeClass('is-active');
  },

  /*
   *
   */
  forceHideHelpBox: function forceHideHelpBox(obj) {
    var self = obj ? obj : this,
        boxState = self.helpBoxState;
    if (!boxState.exists) return false;
    boxState.visible = false;
    boxState.ajaxloader.delayHide();
    self['help-box'].delayHide();
    self['help-box'].removeClass('is-active');
    self['ctrl-tb-help'].removeClass('is-active');
  },

  /*
   *
   */
  resizeHelpBox: function resizeHelpBox() {
    var self = this,
        vpState = self.viewPortState,
        boxState = self.helpBoxState,
        boxCnt = self['help-box'].find('[data-type="help-box-contents"]'),
        hCnt = 0,
        hVP = 0; //return;

    if (!boxState || !boxState.valid || boxState.loading || vpState.isMobile) {
      self['help-box-container'].css({
        height: ''
      });
      return;
    }

    if (boxCnt.length) {
      requestAnimationFrame(function () {
        hVP = self['viewport-ruler'][0].offsetHeight;
        hCnt = Math.min(boxCnt[0].scrollHeight, hVP - 50);
        self['help-box-container'].css({
          height: hCnt + 5
        });
      });
    }
  }
});
"use strict";

jQuery.extend(bookViewer.prototype, {
  /*
   * No Operation
   */
  _nop: function _nop() {},

  /*
   * HELPER -- Find Page to Open on Load/Launch
   */
  _findStartingPage: function _findStartingPage() {
    var self = this,
        startingPage = 0,
        nextHL,
        prevHL;

    if (self.searchBoxState.query) {
      if (self.settings.gotoIDX < 0 && self.settings.gotoPage < 0) {
        nextHL = $(self['ctrl-nav-page'][self.pageIDY]).nextAll('.nav-page-hl');
        prevHL = $(self['ctrl-nav-page'][self.pageIDX]).prevAll('.nav-page-hl');

        if ($(self['ctrl-nav-page'][self.pageIDX]).hasClass('nav-page-hl') || $(self['ctrl-nav-page'][self.pageIDY]).hasClass('nav-page-hl')) {
          startingPage = self.pageIDX;
        } else if (nextHL.length) {
          startingPage = Number($(nextHL.first()).attr('rel'));
        } else if (prevHL.length) {
          startingPage = Number($(prevHL.last()).attr('rel'));
        }
      } else {
        self.settings.gotoIDX = self.settings.gotoPage >= 0 && self.settings.gotoIDX < 0 ? self._findIDXByPageName(self.settings.gotoPage) : self.settings.gotoIDX;
        var $requestedPage = $(self['ctrl-nav-page'][self.settings.gotoIDX]);
        startingPage = $requestedPage.hasClass('nav-page-hl') ? Number($requestedPage.attr('rel')) || 0 : Number($($requestedPage.nextAll('.nav-page-hl')[0]).attr('rel')) || 0;
      }
    } else {
      startingPage = self.settings.gotoIDX >= 0 ? self.settings.gotoIDX : self._findIDXByPageName(self.settings.gotoPage);
    }

    if (!self['viewport-gfx-pages'][self.pageIDX]) {
      self.pageIDX = 0;
      self.pageIDY = 0;
    }

    return startingPage;
  },
  _findIDXByOrdName: function _findIDXByOrdName(pageName) {
    var self = this;
    var elPage = self['ctrl-nav-page'].filter(function (key, el) {
      return $(el).text().toLowerCase() === String(pageName);
    }).first();

    if (elPage && elPage.attr('rel')) {
      return Number(elPage.attr('rel') - self.viewPortState.fixeven);
    }

    return 0;
  },

  /**
   * Find IDX by "Real" Page Number. Should (?) work for string "Real" name, too (untested)
   *
   * @param pageName
   * @returns {number}
   * @private
   */
  _findIDXByPageName: function _findIDXByPageName(pageName) {
    var self = this;
    var elPage = self['ctrl-nav-page'].filter(function (key, el) {
      return $(el).text().toLowerCase() === String(pageName);
    }).first();

    if (elPage && elPage.attr('rel')) {
      return Number(elPage.attr('rel') - self.viewPortState.fixeven);
    }

    return 0;
  },

  /**
   * Check if we entered mobile mode by querying border width of element that is being modified by CSS @media-queries
   *
   * @returns {boolean}
   * @private
   */
  _isInMobileMode: function _isInMobileMode() {
    var self = this,
        vpState = self.viewPortState,
        markerState = self['mobile-marker'].cssInt('borderLeftWidth'),
        isMobile = markerState === markMobile,
        isTablet = markerState === markTablet;

    if (vpState) {
      vpState.isMobile = isMobile;
      vpState.isTablet = isTablet;
    }

    return isMobile;
  }
});
/**
 * HELPER TO HIDE EL WITH DELAY
 */

jQuery.fn.delayHide = function () {
  var $this = $(this);
  clearTimeout($this.data('hideTimeout'));
  $this.data('hideTimeout', setTimeout(function () {
    $this.css({
      display: 'none'
    });
  }, 200));
  return $this;
};

jQuery.fn.delayShow = function () {
  var $this = $(this);
  clearTimeout($this.data('hideTimeout'));
  $this.css({
    display: '',
    visibility: ''
  });
  return $this;
};

jQuery.fn.blink = function () {
  var $this = $(this); //$this.fadeOut( 100 ).fadeIn( 300 );

  $this.finish().addClass('blink').delay(600).queue(function () {
    $(this).removeClass('blink');
    $(this).dequeue();
  });
  return $this;
};

jQuery.fn.scrollIntoViewIfNeeded = function (centerIfNeeded, scrollParent) {
  if (!this || !$(this)[0]) return null;
  var targetElement = this[0];
  var targetParent = $(scrollParent)[0];
  targetElement.scrollIntoViewIfNeeded(centerIfNeeded, targetParent);
};

Element.prototype.scrollIntoViewIfNeeded = function (centerIfNeeded, scrollParent) {
  centerIfNeeded = arguments.length === 0 ? true : !!centerIfNeeded;
  var parent = scrollParent || this.parentNode,
      parentComputedStyle = window.getComputedStyle(parent, null),
      parentBorderTopWidth = parseInt(parentComputedStyle.getPropertyValue('border-top-width')),
      parentBorderLeftWidth = parseInt(parentComputedStyle.getPropertyValue('border-left-width')),
      overTop = this.offsetTop - parent.offsetTop < parent.scrollTop,
      overBottom = this.offsetTop - parent.offsetTop + this.clientHeight - parentBorderTopWidth > parent.scrollTop + parent.clientHeight,
      overLeft = this.offsetLeft - parent.offsetLeft < parent.scrollLeft,
      overRight = this.offsetLeft - parent.offsetLeft + this.clientWidth - parentBorderLeftWidth > parent.scrollLeft + parent.clientWidth,
      alignWithTop = overTop && !overBottom;

  if ((overTop || overBottom) && centerIfNeeded) {
    parent.scrollTop = this.offsetTop - parent.offsetTop - parent.clientHeight / 2 - parentBorderTopWidth + this.clientHeight / 2;
  }

  if ((overLeft || overRight) && centerIfNeeded) {
    parent.scrollLeft = this.offsetLeft - parent.offsetLeft - parent.clientWidth / 2 - parentBorderLeftWidth + this.clientWidth / 2;
  }

  if ((overTop || overBottom || overLeft || overRight) && !centerIfNeeded) {
    this.scrollIntoView(alignWithTop);
  }
};

Element.prototype.scrollHLIntoView = function () {
  var forced = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var scrollParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var smooth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var $el = $(this),
      parent = scrollParent || this.parentNode,
      rcParent = parent.getBoundingClientRect(),
      rcThis = this.getBoundingClientRect(),
      posThis = __getPosition__(this),
      curScrollTop = parent.scrollTop,
      newScrollTop = posThis.top - parent.clientHeight / 2 + this.clientHeight / 2,
      pages = Math.abs((curScrollTop - newScrollTop) / parent.offsetHeight);

  if (forced || rcThis.top < rcParent.top + 30 || rcThis.bottom > rcParent.bottom - 30) {
    if (!smooth) {
      parent.scrollTop = newScrollTop;
    } else {
      $(parent).animate({
        scrollTop: newScrollTop
      }, {
        duration: Math.min(300 + Math.floor(pages) * 40, 2500),
        easing: 'easeInOutCubic',
        complete: function complete() {
          $el.blink();
        }
      });
    }
  }

  function __getPosition__(el) {
    var x = 0,
        y = 0;

    while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
      x += el.offsetLeft - el.scrollLeft;
      y += el.offsetTop - el.scrollTop;
      el = el.offsetParent;
    }

    return {
      top: y,
      left: x
    };
  }

  ;
}; // EASING CUT FOR ANIMATE


jQuery.extend(jQuery.easing, {
  easeInCubic: function easeInCubic(x, t, b, c, d) {
    return c * (t /= d) * t * t + b;
  },
  easeOutCubic: function easeOutCubic(x, t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
  },
  easeInOutCubic: function easeInOutCubic(x, t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
    return c / 2 * ((t -= 2) * t * t + 2) + b;
  }
});
"use strict";

jQuery.extend(bookViewer.prototype, {
  /*
   *
   */
  setupInfoBox: function setupInfoBox() {
    var self = this;
    self.infoBoxState = {
      exists: true,
      type: 'ajax',
      visible: false,
      enabled: true,
      valid: false,
      loading: false,
      ajaxloader: self['info-box'].find('.side-loader')
    };
    self.infoBoxState.ajaxloader.hide(0);
    self['info-box'].hide(0);
    this.attachInfoBoxEvents();
    self.infoBoxState.enabled = true;
  },

  /*
   * Info Box - OPEN
   */
  showInfoBox: function showInfoBox(e) {
    var self = e && e.data && e.data.self || e,
        boxState = self.infoBoxState,
        newVisibleState = !boxState.visible;
    self.hideControlBoxes(e);

    if (newVisibleState) {
      self['info-box'].delayShow();
      setTimeout(function () {
        self['info-box'].addClass('is-active');
      }, 1);
      self['ctrl-tb-info'].addClass('is-active');
      self.loadInfoBox();
    } else {
      self['info-box'].removeClass('is-active');
      self['info-box'].delayHide();
      self['ctrl-tb-info'].removeClass('is-active');
      boxState.ajaxloader.delayHide();
      setTimeout(function () {
        self['info-box'].find('[data-action="cancel-new-set"]').trigger('click');
        self['info-box'].find('[data-set-box]').removeClass('is-expanded');
      }, 100);
    }

    boxState.visible = newVisibleState;
  },

  /*
   * UNUSED!
   * Info Box - CLOSE
   */
  hideInfoBox: function hideInfoBox(e) {
    var self = e && e.data && e.data.self || e,
        boxState = self.infoBoxState; // ...NOW, WITH SETS,  WE"RE ALWAYS RELOADING BOX

    boxState.valid = false;
    boxState.visible = false;
    boxState.ajaxloader.delayHide();
    setTimeout(function () {
      self['info-box'].find('[data-action="cancel-new-set"]').trigger('click');
      self['info-box'].find('[data-set-box]').removeClass('is-expanded');
    }, 100);
    self['info-box'].delayHide();
    self['ctrl-tb-info'].removeClass('is-active');
  },

  /*
   * Info Box - CLOSE
   */
  forceHideInfoBox: function forceHideInfoBox(obj) {
    var self = obj ? obj : this,
        boxState = self.infoBoxState;
    if (!boxState.exists) return false; // ...NOW, WITH SETS,  WE"RE ALWAYS RELOADING BOX

    boxState.valid = false;
    boxState.visible = false;
    boxState.ajaxloader.delayHide();
    self['info-box'].delayHide();
    setTimeout(function () {
      self['info-box'].find('[data-action="cancel-new-set"]').trigger('click');
      self['info-box'].find('[data-set-box]').removeClass('is-expanded');
    }, 100);
    self['info-box'].removeClass('is-active');
    self['ctrl-tb-info'].removeClass('is-active');
  },

  /*
   *
   */
  resizeInfoBox: function resizeInfoBox() {
    var self = this,
        vpState = self.viewPortState,
        boxState = self.infoBoxState,
        boxCnt = self['info-box'].find('[data-type="info-box-contents"]'),
        hCnt = 0,
        hVP = 0,
        hBox = 0;

    if (!boxState || !boxState.valid || boxState.loading || vpState.isMobile) {
      self['info-box-container'].css({
        height: ''
      });
      return;
    } //setTimeout( function () {


    if (boxCnt.length) {
      requestAnimationFrame(function () {
        hVP = self['viewport-ruler'][0].offsetHeight; //hCnt = Math.min( boxCnt[ 0 ].scrollHeight, hVP / 1.5, 600 );

        hBox = boxCnt[0].scrollHeight;
        hCnt = Math.min(hBox, hVP - 50);
        self['info-box-container'].css({
          overflowY: hBox <= hCnt ? 'hidden' : 'auto',
          height: hCnt
        });
      });
    } //}, 1 );

  },
  attachInfoBoxEvents: function attachInfoBoxEvents() {
    var self = this,
        infoBox = self['info-box'];
    infoBox.on('click', '[data-action]', function (e) {
      var $el = $(e.target),
          $objCreator = $(window.setCreator),
          $elSetBox = $el.closest('[data-set-box]'),
          $elSetlist = $elSetBox.find('[data-set-list]'),
          $elTitle = $elSetBox.find('input[type="text"]'),
          szTitle = $elTitle.val();

      switch ($el.data('action')) {
        case 'open-set-list':
          requestAnimationFrame(function () {
            $elSetBox.toggleClass('is-expanded');
            self.resizeInfoBox();
          });
          break;

        case 'save-new-set':
          if (!window.setCreator) return false; // Simple validate

          if (!szTitle.replace(/[\s-\/\\^$*+?.()|[\]{}<>!]/g, '').length) {
            $elTitle.addClass('is-invalid').trigger('focus');
            return false;
          }

          $objCreator.removeClass('in-edit-mode').addClass('in-save-mode');
          $elTitle.removeClass('is-invalid') //.attr( 'readonly', '1' )
          .trigger('blur'); // todo: check title not empty

          self.addSet($elSetBox, $elSetlist, szTitle);
          break;

        case 'cancel-new-set':
          if (!window.setCreator) return false;
          $objCreator.removeClass('in-edit-mode');
          $elTitle.removeClass('is-invalid') //.attr( 'readonly', '1' )
          .val($elTitle.data('empty')).trigger('blur').trigger('input');
          window.setCreator = null;
          break;

        default:
          break;
      }
    }).on('click', 'input[type=text]', function (e) {
      var $elSet = $(e.target).closest('[data-set-new-form]'),
          $elSetBox = $(e.target).closest('[data-set-box]'),
          $elInput = $elSet.find('input');
      if ($elSetBox.hasClass('in-edit-mode')) return false;
      if (window.setCreator) $(window.setCreator).find('[data-action="cancel-new-set"]').trigger('click');
      $elSetBox.addClass('in-edit-mode');
      requestAnimationFrame(function () {
        $elInput //.removeAttr( 'readonly' )
        .val('').trigger('focus').trigger('input');
      });
      window.setCreator = $elSetBox;
    }).on('input', 'input[type=text]', function (e) {
      $(e.target).removeClass('is-invalid');
      self.resizeInfoBox();
    }).on('click', 'input[type=text]', function (e) {}).on('blur', 'input[type=text]', function (e) {}).on('click', '[data-set]', function (e) {
      var $elSet = $(e.target),
          $elSetBox = $elSet.closest('[data-set-box]'),
          action = $elSet.hasClass('is-active') ? 'removeitem' : 'additem',
          setUUID = $elSet.data('set'),
          objData = $elSet.closest('[data-set-box]'),
          objParams = objData.get(0) ? objData.data('set-box').split(':') : '',
          objType = objParams ? objParams[0] : '',
          objURL = objParams ? objParams[1] : ''; //console.log($elSet, setUUID, objType, objURL);

      if (setUUID && objType && objURL) {
        if (window.setCreator) $(window.setCreator).find('[data-action="cancel-new-set"]').trigger('click');
        self.modifySetList(action, $elSetBox, $elSet, setUUID, objType, objURL);
      }
    }).on('keydown', function (e) {
      if (!window.setCreator) return true;
      var event = e.originalEvent || e;

      if (event.key === 'Escape') {
        setTimeout(function () {
          $(window.setCreator).find('[data-action="cancel-new-set"]').trigger('click');
        }, 100);
        return false;
      }

      if (event.key === 'Enter') {
        $(window.setCreator).find('[data-action="save-new-set"]').trigger('click');
        return false;
      }

      return true;
    });
  },
  ajaxInfoBox: function ajaxInfoBox(action) {
    var self = this;
    self['info-box'][action === 'loadstart' ? 'addClass' : 'removeClass']('is-ajax-action');
  }
});
"use strict";
/*
 * BOOK VIEWER BOX LOADERS
 */

$.extend(bookViewer.prototype, {
  /**
   * Set Up Data/HTML Loaders
   */
  setupLoaders: function setupLoaders() {
    var self = this,
        $object = self.$object,
        $window = $(window),
        eventNS = self.eventNS;
  },

  /**
   * Load Info Box
   */
  loadInfoBox: function loadInfoBox() {
    var self = this,
        boxState = this.infoBoxState,
        boxTitle = self['info-box'].find('.box-title');
    self.resizeInfoBox();
    if (boxState.valid) return;
    boxState.ajaxloader.delayShow();
    self['info-box'].delayShow();
    setTimeout(function () {
      self['info-box'].addClass('is-loading');
    }, 1);
    self.$object.find('.page-range').text(self['page-num'].text());
    boxTitle.html(boxTitle.data('desc-title')); //return;

    self['info-box-container'].html('').load('/' + self.settings.root + '/info/', {
      docurl: self.settings.url,
      fpage: self.pageIDX,
      tpage: self.pageIDY
    }, function (response, status, xhr) {
      self['info-box'].removeClass('is-loading');
      boxState.ajaxloader.delayHide();

      if (status === 'error') {
        self['info-box'].addClass('is-error');
      } else if (status === 'success') {
        boxState.valid = true;
        setTimeout(function () {
          boxTitle.html(self['info-box-container'].find('[data-type=info-box-contents]').data('box-title'));
          $('[data-autoresize]').autoresize({
            padding: 0,
            minWidth: 71,
            "class": 'acc-popupset-resizer'
          });
          self.resizeInfoBox();
        }, 1);
      }
    });
  },

  /**
   * Load Help Box
   */
  loadHelpBox: function loadHelpBox() {
    var self = this,
        boxState = this.helpBoxState,
        boxTitle = self['help-box'].find('.box-title');
    self.resizeHelpBox();
    if (boxState.valid) return;
    boxState.ajaxloader.delayShow();
    self['help-box'].delayShow();
    setTimeout(function () {
      self['help-box'].addClass('is-loading');
    }, 1);
    self.$object.find('.page-range').text(self['page-num'].text()); //boxTitle.html( boxTitle.data( 'desc-title' ) );
    //self.resizeHelpBox();

    self['help-box-container'].html('').load('/' + self.settings.root + '/help/', {
      docurl: self.settings.url,
      fpage: self.pageIDX,
      tpage: self.pageIDY
    }, function (response, status, xhr) {
      self['help-box'].removeClass('is-loading');
      boxState.ajaxloader.delayHide();

      if (status === 'error') {
        self['help-box'].addClass('is-error');
      } else if (status === 'success') {
        boxState.valid = true;
        setTimeout(function () {
          self.resizeHelpBox(); //boxTitle.html( self[ 'help-box-container' ].find( '[data-type=help-box-contents]' ).data( 'box-title' ) );
        }, 1);
      }
    });
  },

  /**
   * Load Tree Box
   */
  loadTreeBox: function loadTreeBox() {
    var self = this;
    if (self.treeBoxState.valid) return;

    if (self.treeBoxState.type === 'ajax') {
      self.treeBoxState.ajaxloader.delayShow();
      setTimeout(function () {
        self['tree-box'].addClass('is-loading');
      }, 1);
      self['tree-data-list'].html('').load('/' + self.settings.root + '/tree/', {
        docurl: self.settings.url
      }, function (response, status, xhr) {
        self['tree-box'].removeClass('is-loading');
        self.treeBoxState.ajaxloader.delayHide();

        if (status === 'error') {
          self['tree-box'].addClass('is-error');
        } else if (status === 'success') {
          self['tree-links'] = self['tree-data-list'].find('a');
          self.treeBoxState.valid = true;
          self.syncSearchBox();
          self.syncPrintBox();
          self.syncTreeBox(null, {
            forceTreeSync: true
          });
        }
      });
    } else {
      // INLINE TREE
      self['tree-links'] = self['tree-data-list'].find('a');
      self.treeBoxState.valid = true;
      self.syncSearchBox();
      self.syncPrintBox();
      self.syncTreeBox(null, {
        forceTreeSync: true
      });
    }
  },

  /**
   * Load Search Box
   */
  loadSearchBox: function loadSearchBox() {
    var forcereset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var self = this,
        vpState = self.viewPortState,
        boxState = self.searchBoxState;
    if (!forcereset && (boxState.valid || boxState.loading)) return;

    if (boxState.type === 'ajax' || forcereset) {
      boxState.ajaxloader.delayShow();
      setTimeout(function () {
        self['search-box'].addClass('is-loading');
        boxState.$searchInput.blur();
      }, 1);
      boxState.loading = true;
      boxState.$dataList.html('').load('/' + self.settings.root + '/search/', {
        docurl: self.settings.url,
        query: boxState.query
      }, function (response, status, xhr) {
        self['search-box'].removeClass('is-loading');
        boxState.ajaxloader.delayHide();
        boxState.loading = false;
        self['search-box-list-links'] = self['search-box'].find('div[rel]');
        self['search-box-map-links'] = self['search-box'].find('span[rel].non-zero');

        if (status === 'error') {
          self['search-box'].addClass('is-error');
        }

        try {
          boxState.pages = JSON.parse(self['search-box-container'].find('[data-search-pages-list]').text());
          boxState.valid = true;
        } catch (E) {
          boxState.pages = [];
          boxState.valid = false;
        }

        if (!boxState.pages) boxState.pages = [];
        self.searchApplyResults(forcereset);
        self.syncSearchBox();
      });
    } else {
      // INLINE SEARCH
      self['search-box-list-links'] = self['search-box'].find('div[rel]');
      self['search-box-map-links'] = self['search-box'].find('span[rel].non-zero');

      try {
        boxState.pages = JSON.parse(self['search-box-container'].find('[data-search-pages-list]').text());
        boxState.valid = true;
      } catch (E) {
        boxState.pages = [];
        boxState.valid = false;
      }

      if (!boxState.pages) boxState.pages = [];
      self.searchApplyResults();
      self.syncSearchBox();
    }
  },
  loadViewPortHTML: function loadViewPortHTML() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var findPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var self = this,
        gfxContainer = self['viewport-gfx-container'][0],
        htmlContainer = self['viewport-html-container'][0],
        vpState = self.viewPortState;
    if (!force && vpState.html.loaded) return false;
    self['viewport-html'].addClass('is-loading');
    gfxContainer.deflectScrollEvent = true;
    htmlContainer.deflectScrollEvent = true;
    requestAnimationFrame(function () {
      self.$object.removeClass('is-active').addClass('is-iframe-loading'); //self[ 'load-overlay' ]
      //	.removeClass( 'is-complete' )
      //	.delayShow();
    });

    if (!self['viewport-html-iframe']) {
      self['viewport-html-iframe'] = $('<iframe>', {
        id: 'iframe-html',
        attr: {
          'data-html-iframe': self.settings.url
        },
        "class": '',
        scrolling: 'no'
      }).css('width', (vpState.layoutMode === '2x1' || vpState.isMobile ? 100 : vpState.zoom.html.level) + '%').appendTo(self['viewport-html-contents']);
      self['viewport-html-iframe'].on('load', function () {
        setTimeout(function () {
          var iframeProto = self['viewport-html-iframe'][0].contentWindow || self['viewport-html-iframe'][0].contentDocument;
          if (iframeProto) iframeProto.Element.prototype.scrollHLIntoView = Element.prototype.scrollHLIntoView;
          self['viewport-html-iframe-contents'] = self['viewport-html-iframe'].contents();
          self['viewport-html-iframe-root'] = self['viewport-html-iframe-contents'].find('[data-type]');
          self['viewport-html-pages'] = self['viewport-html-iframe-contents'].find('.page-html');
          self.updatePageBookMarks();
          self.attachViewPortHTMLHandlers();

          if (self.isActive) {
            self.viewportResize(false, true, {
              src: 'viewport',
              action: 'iframeLoad',
              param: self.eventNS
            });
          }

          vpState.html.loaded = true;
          self.htmlLaunch = true;
        }, throttleLoadIframe);
      });
    }

    self['viewport-html-iframe'].attr('src', '/' + self.settings.root + '/htmldoc/' + '?docurl=' + self.settings.url + '&query=' + self.searchBoxState.query + '&pf=' + vpState.html.textFont + '&ps=' + vpState.html.textSize + '&lm=' + vpState.layoutMode + '&theme=' + self.settings.theme);
  }
});
"use strict";
/*
 * PRINTING ENGINE
 */

jQuery.extend(bookViewer.prototype, {
  setupPrintBox: function setupPrintBox() {
    var self = this;

    if (!self.settings.printAllowed) {
      self.printBoxState = {
        enabled: false
      };
      return false;
    }

    self.printBoxState = {
      exists: !!self.settings.printAllowed,
      visible: self.settings.printBoxInitState === 'visible',
      enabled: false,
      printing: false,
      $menuItem: self['ctrl-tb-print'],
      $box: self['print-box'].find('.data-container'),
      $counter: self['print-box'].find('.counter'),
      $pageselectors: self['print-box'].find('.print-page-selector [rel]'),
      $btnSelectAll: self['print-box'].find('.btn-sel-all'),
      $btnSelectNone: self['print-box'].find('.btn-sel-none'),
      //$btnSelectCur : self[ 'print-box' ].find( '.btn-sel-cur' ),
      $btnPrint: self['print-box'].find('.btn-print'),
      $btnStop: self['print-box'].find('.btn-stop'),
      $queueProgress: self['print-box'].find('.progress'),
      $queueBar: self['print-box'].find('.progressbar ins'),
      eventsAttached: false,
      inSelectMode: false,
      selectMode: 'add',
      firstSelected: null,
      list: {},
      selected: 0,
      total: 0,
      countFormat: '%0/%1',
      progressFormat: '%0%',
      queue: null,
      $spooler: $('[data-printable]'),
      $printer: $('[data-bookviewer-page]'),
      pageTemplate: $('[data-pagetemplate]').attr('data-pagetemplate'),
      quality: 60
    };
    self.printBoxState.total = self.printBoxState.$pageselectors.length;
    self.printBoxState.countFormat = self.printBoxState.$counter.attr('data-format') || self.printBoxState.countFormat;
    self.printBoxState.progressFormat = self.printBoxState.$queueProgress.attr('data-format') || self.printBoxState.progressFormat;

    if (!self.printBoxState.$spooler.length || !self.printBoxState.$printer.length) {
      self.printBoxState.exists = false;
      return false;
    }

    self['print-box'].hide(0);
    self.printBoxState.$queueBar.addClass('is-hidden');

    if (!self.printBoxState.eventsAttached) {
      self.attachPrintBoxEvents();
      self.updatePrintBoxControls();
    }

    self.printBoxState.enabled = true;
  },
  // PRINT EVENTS' HANDLERS
  attachPrintBoxEvents: function attachPrintBoxEvents() {
    var self = this,
        boxState = self.printBoxState;
    boxState.$box // SELECTION MODE START
    .on('mousedown' + self.eventNS, '', {
      self: self
    }, function (e) {
      var $self = e && e.data && e.data.self,
          boxState = $self.printBoxState;
      if (!$self) return false;
      boxState.inSelectMode = true;
    }) // SELECTION MODE END
    .on('mouseup' + self.eventNS + ' mouseleave' + self.eventNS + ' blur' + self.eventNS, '', {
      self: self
    }, function (e) {
      var $self = e && e.data && e.data.self,
          boxState = $self.printBoxState;
      if (!$self) return false;
      boxState.$pageselectors.filter('.pre-add').addClass('is-active').removeClass('pre-add');
      boxState.$pageselectors.filter('.pre-remove').removeClass('is-active').removeClass('pre-remove');
      $self.updatePrintBoxControls();
      boxState.inSelectMode = false;
      boxState.selectMode = 'add';
    }) // PAGE SELECT ON DRAG
    .on('mouseenter' + self.eventNS, 'span', {
      self: self
    }, function (e) {
      var $self = e && e.data && e.data.self,
          $this = $(this),
          boxState = $self.printBoxState;
      if (!$self || !boxState.inSelectMode) return false;
      var pageIDX = parseInt($this.attr('rel'), 10);
      boxState.$pageselectors.removeClass('pre-add pre-remove');

      if (boxState.firstSelected !== null) {
        var firstSelected = boxState.firstSelected;

        if (jisNumber(pageIDX) && jisNumber(firstSelected)) {
          boxState.$pageselectors.filter(function (key, el) {
            var idxRel = Number($(el).attr('rel'));
            return idxRel >= Math.min(firstSelected, pageIDX) && idxRel <= Math.max(firstSelected, pageIDX);
          }).addClass(boxState.selectMode === 'add' ? 'pre-add' : 'pre-remove');
        }
      }

      $self.updatePrintBoxControls();
    }) // PAGE SELECT ON CLICK
    .on('mousedown' + self.eventNS, 'span', {
      self: self
    }, function (e) {
      var $self = e && e.data && e.data.self,
          $this = $(this),
          boxState = $self.printBoxState;
      if (!$self) return false;
      boxState.selectMode = $this.hasClass('is-active') ? 'remove' : 'add';
      var pageIDX = parseInt($this.attr('rel'), 10);

      if (e.shiftKey && boxState.firstSelected !== null) {
        var firstSelected = boxState.firstSelected;

        if (jisNumber(pageIDX) && jisNumber(firstSelected)) {
          boxState.$pageselectors.filter(function (key, el) {
            var idxRel = Number($(el).attr('rel'));
            return idxRel >= Math.min(firstSelected, pageIDX) && idxRel <= Math.max(firstSelected, pageIDX);
          })[boxState.selectMode === 'add' ? 'addClass' : 'removeClass']('is-active');
        }

        boxState.firstSelected = null;
      } else if (!e.ctrlKey) {
        $this.removeClass('pre-add pre-remove').addClass(boxState.selectMode === 'add' ? 'pre-add' : 'pre-remove');
        boxState.firstSelected = pageIDX;
      }

      if (e.ctrlKey) $self.gotoPage(pageIDX);
    }).on('mouseup' + self.eventNS, 'span', {
      self: self
    }, function (e) {
      var $self = e && e.data && e.data.self,
          $this = $(this),
          boxState = $self.printBoxState;
      if (!$self) return false;
      var pageIDX = parseInt($this.attr('rel'), 10);
      if (boxState.firstSelected !== pageIDX) boxState.firstSelected = null;
    }); // BUTTONS' EVENTS

    boxState.$btnSelectAll.on('click' + self.eventNS, '', {
      self: self
    }, function (e) {
      var $self = e && e.data && e.data.self,
          $this = $(this),
          boxState = $self.printBoxState;
      if (!$self) return false;
      boxState.$pageselectors.addClass('is-active');
      $self.updatePrintBoxControls();
    });
    boxState.$btnSelectNone.on('click' + self.eventNS, '', {
      self: self
    }, function (e) {
      var $self = e && e.data && e.data.self,
          $this = $(this),
          boxState = $self.printBoxState;
      if (!$self) return false;
      boxState.$pageselectors.removeClass('is-active');
      $self.updatePrintBoxControls();
    });
    /*
    CONSIDER REMOVAL
    boxState.$btnSelectCur
    		.on( 'click' + self.eventNS, '', { self: self }, function ( e ) {
    			let $self    = ( e && e.data && e.data.self ),
    				$this    = $( this ),
    				boxState = $self.printBoxState;
    					if ( !$self ) return false;
    					boxState.$pageselectors.removeClass( 'is-active' );
    					// Select And Scroll Into VP
    			let idx = parseInt( $( $self[ 'ctrl-nav-page' ][ $self.pageIDX ] ).attr( 'rel' ), 10 );
    			let idy = parseInt( $( $self[ 'ctrl-nav-page' ][ $self.pageIDY ] ).attr( 'rel' ), 10 );
    			let $elToPos = null;
    					boxState.$pageselectors.filter( ( key, el ) => {
    				let idxRel = Number( $( el ).attr( 'rel' ) );
    						if ( idxRel >= idx && idxRel <= idy ) {
    					$elToPos = $( el );
    					return true;
    				}
    				return false;
    			} )[ 'addClass' ]( 'is-active' );
    					if ( $elToPos ) {
    				$elToPos.scrollIntoViewIfNeeded( true, self[ 'print-box-container' ] );
    			}
    					$self.updatePrintBoxControls();
    		} );
     */

    boxState.$btnPrint.on('click' + self.eventNS, '', {
      self: self
    }, function (e) {
      var $self = e && e.data && e.data.self,
          $this = $(this);
      if (!$self) return false;
      $self.printQueueStart();
      $self.updatePrintBoxControls();
    });
    boxState.$btnStop.on('click' + self.eventNS, '', {
      self: self
    }, function (e) {
      var $self = e && e.data && e.data.self,
          $this = $(this);
      if (!$self) return false;
      $self.printQueueStop();
      $self.updatePrintBoxControls();
    }); // AFTER PRINT

    $(window).on('afterprint' + self.eventNS, '', {
      self: self
    }, function (e) {
      var $self = e && e.data && e.data.self,
          $this = $(this);
      if (!$self) return false;
      $self.printQueueStop();
      $self.updatePrintBoxControls();
    });
    boxState.eventsAttached = true;
  },
  // PRINT START
  printQueueStart: function printQueueStart(e) {
    var self = e && e.data && e.data.self ? e.data.self : this,
        boxState = self.printBoxState,
        vpState = self.viewPortState,
        $spooler = boxState.$spooler,
        $printer = boxState.$printer;
    if (!boxState || !boxState.enabled || !boxState.selected) return false;
    if (boxState.queue) self.printQueueStop();
    boxState.$btnPrint.addClass('is-disabled');
    boxState.printing = true;
    self.updatePrintBoxControls();
    $spooler.addClass('is-printing');
    boxState.queue = {
      chunks: [],
      total: boxState.selected,
      ready: 0
    };
    boxState.queue.pollID = setInterval(function () {
      if (!boxState.queue) return false;
      self.updatePrintBoxControls();
      boxState.queue.ready = $printer.find('img:not(.is-loading)').length;

      if (boxState.queue.total === boxState.queue.ready) {
        clearTimeout(boxState.queue.pollID);
        self.printQueueSpool();
      }
    }, throttlePrintPolling);
    boxState.$pageselectors.filter('.is-active').map(function (idx, el) {
      var pageIDX = $(el).attr('rel'),
          $pageEl = $(self['viewport-gfx-pages'][pageIDX]);
      var $pageChunk = $('<div>', {
        "class": 'page-chunk '
      });
      var pt = boxState.pageTemplate.replace('%BOOK-PAGE%', $(self['ctrl-nav-page'][pageIDX]).text()).split('|');
      var $pageHeader = $('<div>', {
        "class": 'header',
        html: '<div>' + pt[0] + '</div><div>' + pt[1] + '</div>'
      });
      var $pageFooter = $('<div>', {
        "class": 'footer',
        html: '<div>' + pt[2] + '</div><div>' + pt[3] + '</div>'
      });
      var $imgEl = $('<img>', {
        "class": 'is-loading',
        src: '/' + self.settings.root + '/image/?docurl=' + self.settings.url + '&page=' + $pageEl.attr('data-filename') + '&s=' + boxState.quality + '&w=' + vpState.gfx.defw + '&h=' + vpState.gfx.defh
      }).on('load', function (e) {
        var $this = $(e.currentTarget);
        $this.removeClass('is-loading');
      });
      $pageChunk.append($pageHeader, $imgEl, $pageFooter);
      boxState.queue.chunks.push($pageChunk);
    });
    $printer.html('').append(boxState.queue.chunks);
  },
  printQueueSpool: function printQueueSpool(e) {
    var self = e && e.data && e.data.self ? e.data.self : this,
        boxState = self.printBoxState,
        $spooler = boxState.$spooler,
        $printer = boxState.$printer; // DANGEROUS!

    setTimeout(function () {
      boxState.$pageselectors.removeClass('is-active');
      self['print-box'].removeClass('is-printing');
      boxState.$btnSelectAll.removeClass('is-disabled');
      boxState.$btnSelectNone.addClass('is-disabled');
      boxState.$btnPrint.addClass('is-disabled');
      boxState.$counter.text(boxState.countFormat.replace('%0', '0').replace('%1', boxState.total)); //boxState.printing = false;
      //self.updatePrintBoxControls();
      //boxState.$btnSelectNone.trigger('click');
      //self[ 'print-box' ].removeClass( 'is-printing' );
    }, throttlePrintPolling);
    setTimeout(function () {
      window.print();
      boxState.printing = false;
      self.updatePrintBoxControls();
    }, throttlePrintPolling * 2);
  },
  // PRINT STOP
  printQueueStop: function printQueueStop(e) {
    var self = e && e.data && e.data.self ? e.data.self : this,
        boxState = self.printBoxState,
        $spooler = boxState.$spooler,
        $printer = boxState.$printer;
    if (!boxState || !boxState.enabled || !boxState.selected || !boxState.queue) return false;
    clearTimeout(boxState.queue.pollID);
    $printer.html('');
    $spooler.removeClass('is-printing');
    boxState.$pageselectors.removeClass('is-active');
    boxState.queue = null;
    boxState.printing = null;
    self.updatePrintBoxControls();
  },
  updatePrintBoxControls: function updatePrintBoxControls(e) {
    var self = e && e.data && e.data.self ? e.data.self : this,
        boxState = self.printBoxState;
    boxState.selected = boxState.$pageselectors.filter('.is-active').length;
    self['print-box'][!boxState.printing ? 'removeClass' : 'addClass']('is-printing');
    boxState.$btnSelectAll[boxState.selected !== boxState.total ? 'removeClass' : 'addClass']('is-disabled');
    boxState.$btnSelectNone[boxState.selected ? 'removeClass' : 'addClass']('is-disabled'); //boxState.$btnSelectCur[ 'removeClass' ]( 'is-disabled' );

    boxState.$btnPrint[boxState.selected ? 'removeClass' : 'addClass']('is-disabled');
    boxState.$btnStop[boxState.printing ? 'removeClass' : 'addClass']('is-disabled');

    if (boxState.printing && boxState.queue) {
      var pcDone = Math.ceil(boxState.queue.ready / boxState.queue.total * 100);
      boxState.$queueBar.css({
        backgroundPosition: pcDone + '%'
      });
      boxState.$queueProgress.text(boxState.progressFormat.replace('%0', pcDone));
    } else {
      boxState.$queueBar.css({
        backgroundPosition: '0'
      });
    }

    boxState.$counter.text(boxState.countFormat.replace('%0', boxState.selected).replace('%1', boxState.total));
  },
  // Print Box - OPEN
  showPrintBox: function showPrintBox(e) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var self = e && e.data && e.data.self || e,
        vpState = self.viewPortState,
        boxState = self ? self.printBoxState : {}; //if( !self.settings.user || !self.settings.user.authorized ) return false;

    if (!boxState.exists || self.resizeInProgress || vpState.isMobile) return false;
    boxState.visible = force || !boxState.visible;

    if (boxState.visible) {
      self['print-box'].delayShow();
      setTimeout(function () {
        self['print-box'].addClass('is-active');
      }, 1);
      self.printBoxState.$queueBar.removeClass('is-hidden');
      self['ctrl-tb-print'].addClass('is-active');
      setTimeout(function () {
        self.syncPrintBox();
      }, throttleViewportChange);
    } else {
      self['print-box'].removeClass('is-active').delayHide();
      self.printBoxState.$queueBar.addClass('is-hidden');
      self['ctrl-tb-print'].removeClass('is-active');
    }

    self.viewportResize(false, false, {
      src: 'print-box',
      action: boxState.visible ? 'addClass' : 'removeClass',
      param: 'is-print-pinned',
      norender: self.$object.hasClass('is-tree-pinned')
    });
  },
  hidePrintBox: function hidePrintBox(e) {
    var self = e && e.data && e.data.self ? e.data.self : this,
        boxState = self ? self.printBoxState : {};
    if (!boxState.exists || self.resizeInProgress) return false;
    boxState.visible = false;
    self['print-box'].delayHide();
    self.printBoxState.$queueBar.addClass('is-hidden');
    self.viewportResize(false, false, {
      src: 'print-box',
      action: boxState.visible ? 'addClass' : 'removeClass',
      param: 'is-print-pinned',
      norender: self.$object.hasClass('is-tree-pinned')
    });
  },
  forceHidePrintBox: function forceHidePrintBox(obj) {
    var self = obj ? obj : this,
        boxState = self ? self.printBoxState : {};
    if (!boxState.exists) return false;
    boxState.visible = false;
    self['print-box'].delayHide();
    self.printBoxState.$queueBar.addClass('is-hidden');
    self['print-box'].removeClass('is-active');
    self['ctrl-tb-print'].removeClass('is-active');
    self.$object.removeClass('is-print-pinned');
  },
  syncPrintBox: function syncPrintBox(mixedObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var self = this,
        boxState = self.printBoxState;
    if (!boxState || !boxState.visible) return false;
    boxState.$pageselectors.removeClass('is-current'); // Select And Scroll Into VP

    var idx = parseInt($(self['ctrl-nav-page'][self.pageIDX]).attr('rel'), 10);
    var idy = parseInt($(self['ctrl-nav-page'][self.pageIDY]).attr('rel'), 10);
    var $elToPos = null;
    boxState.$pageselectors.filter(function (key, el) {
      var idxRel = Number($(el).attr('rel'));

      if (idxRel >= idx && idxRel <= idy) {
        $elToPos = $(el);
        return true;
      }

      return false;
    })['addClass']('is-current');

    if ($elToPos) {
      $elToPos.scrollIntoViewIfNeeded(true, self['print-box-container']);
    }
  }
});
"use strict";
/*
 * SEARCH ENGINE
 */

jQuery.extend(bookViewer.prototype, {
  // Seach Box - Init
  setupSearchBox: function setupSearchBox() {
    var self = this,
        vpState = self.viewPortState;

    if (!self.settings.searchBoxType) {
      return self.searchBoxState = {
        exists: false,
        type: false
      };
    }

    self.searchBoxState = {
      exists: true,
      type: self.settings.searchBoxType,
      visible: self.settings.searchBoxInitState === 'visible' && !vpState.isMobile,
      pages: [],
      count: 0,
      enabled: false,
      valid: false,
      loading: false,
      mode: 'list',
      ajaxloader: self['search-box'].find('.side-loader'),
      query: self.settings.queryString,
      exquery: self.settings.queryString,
      $box: self['search-box'].find('.data-container'),
      $dataList: self['search-data-list'] = self['search-box'].find('.data-list'),
      $searchInput: self['search-box'].find('[name=query]'),
      $form: self['search-box'].find('form'),
      $btnModeList: self['search-box'].find('.sw-list'),
      $btnModeMap: self['search-box'].find('.sw-map'),
      $locString: null,
      locStringTpl: {
        hl: '%0 / %1',
        nohl: '%0'
      },
      eventsAttached: false
    };
    self.searchBoxState.ajaxloader.hide(0);
    self['search-box'].hide(0);

    if (!self.searchBoxState.eventsAttached) {
      self.attachSearchBoxEvents();
    }

    if (!self.searchBoxState.valid && self.searchBoxState.query !== '') {
      self.loadSearchBox();
    }

    self.searchBoxState.enabled = true;
  },
  attachSearchBoxEvents: function attachSearchBoxEvents() {
    var self = this,
        boxState = self.searchBoxState;
    boxState.$form.materialvalidation().on('submit', '', {
      self: self
    }, function (e) {
      var self = e.data.self,
          vpState = self.viewPortState,
          boxState = self.searchBoxState,
          strQuery = boxState.$searchInput.val().replace(/[@#<>:;,\?*.]/g, '');
      boxState.$form.data().materialvalidation.methods.validate();
      self.settings.gotoIDX = -1;
      self.settings.gotoPage = -1;

      if (!boxState.loading) {
        if (strQuery.length && strQuery) {
          if (strQuery.trim().toLowerCase() === boxState.exquery.trim().toLowerCase()) {
            self.gotoPage('next-hl');
            e.preventDefault();
            return false;
          }

          boxState.query = strQuery;
          boxState.exquery = strQuery;
          boxState.valid = false;
          boxState.type = 'ajax';
          self.loadSearchBox();
        }
      }

      e.preventDefault();
      return false;
    }).on('reset', '', {
      self: self
    }, function (e) {
      var self = e.data.self,
          vpState = self.viewPortState;

      if (!boxState.loading) {
        boxState.$form.data().materialvalidation.methods.reset();
        self.searchVoidify();
        self.loadSearchBox(true);
      }

      e.preventDefault();
      return false;
    });
    boxState.$dataList.on('mouseup', '.is-expandable ins', {
      self: self
    }, function (e) {
      var $this = $(e.currentTarget).closest('.is-expandable');
      $this.toggleClass('is-closed');
      e.preventDefault();
      return false;
    }).on('mouseup', '[rel]', {
      self: self
    }, function (e) {
      var $self = e.data.self,
          $this = $(e.currentTarget),
          pageIDX = parseInt($this.attr('rel'), 10);
      $self.gotoPage(pageIDX, e, {
        forceTreeSync: true,
        scrollToFirstHL: true
      });
    });
    boxState.$btnModeList.on('mouseup', function (e) {
      boxState.mode = 'list';
      self.syncSearchBox();
      requestAnimationFrame(function () {
        self['search-box'].removeClass('mode-map').addClass('mode-list');
      });
      e.preventDefault();
      return false;
    });
    boxState.$btnModeMap.on('mouseup', function (e) {
      boxState.mode = 'map';
      self.syncSearchBox();
      requestAnimationFrame(function () {
        self['search-box'].removeClass('mode-list').addClass('mode-map');
      });
      e.preventDefault();
      return false;
    });
    boxState.eventsAttached = true;
  },
  // Search Box - Open
  showSearchBox: function showSearchBox(e) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var self = e && e.data && e.data.self || e,
        vpState = self.viewPortState,
        boxState = self ? self.searchBoxState : {};
    if (!boxState.exists || self.resizeInProgress) return false;
    if (vpState.isMobile && boxState.visible) self.forceHideTreeBox();
    boxState.visible = force || !boxState.visible;
    self.hideControlBoxes(e);

    if (boxState.visible) {
      self['search-box'].delayShow();
      setTimeout(function () {
        self['search-box'].addClass('is-active');
      }, 1);
      self['ctrl-tb-search'].addClass('is-active'); //if(self.isActive) setTimeout( () => { boxState.$searchInput.focus().select(); }, throttleViewportChange * 10 );
    } else {
      self['search-box'].removeClass('is-active');
      self['search-box'].delayHide();
      self['ctrl-tb-search'].removeClass('is-active');
    }

    self.viewportResize(false, false, {
      src: 'search-box',
      action: boxState.visible ? 'addClass' : 'removeClass',
      param: 'is-search-pinned'
    });
    self[boxState.visible && !boxState.valid && boxState.query !== '' ? 'loadSearchBox' : 'syncSearchBox']();
  },
  // Search Box - Hide
  hideSearchBox: function hideSearchBox(e) {
    var self = e && e.data && e.data.self ? e.data.self : this,
        boxState = self ? self.searchBoxState : {};
    if (!boxState.exists || self.resizeInProgress) return false;
    boxState.visible = false;
    boxState.ajaxloader.delayHide();
    self['search-box'].delayHide();
    self.viewportResize(false, false, {
      src: 'search-box',
      action: boxState.visible ? 'addClass' : 'removeClass',
      param: 'is-search-pinned'
    });
  },
  // Search Box - Force Hide
  forceHideSearchBox: function forceHideSearchBox(obj) {
    var self = obj ? obj : this,
        boxState = self ? self.searchBoxState : {};
    if (!boxState.exists) return false;
    boxState.visible = false;
    boxState.ajaxloader.delayHide();
    self['search-box'].delayHide();
    self['search-box'].removeClass('is-active');
    self['ctrl-tb-search'].removeClass('is-active');
    self.$object.removeClass('is-search-pinned');
  },
  // Search Box - Sync
  syncSearchBox: function syncSearchBox(mixedObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var self = this,
        boxState = self.searchBoxState,
        hlItems = [],
        hlIndexes = [],
        lastHlItem = null;
    if (!boxState.valid || !boxState.visible || !self['ctrl-nav-page'][self.pageIDX]) return;
    clearTimeout(self.timerSyncSearch);
    self.timerSyncSearch = setTimeout(function () {
      if (boxState.mode === 'list') {
        hlItems = self['search-box-list-links'].filter(function (key, treeItem) {
          var isHL = parseInt($(treeItem).attr('rel')) === self.pageIDX || parseInt($(treeItem).attr('rel')) === self.pageIDY;
          if (isHL) hlIndexes.push(key + 1);
          return isHL;
        });
        requestAnimationFrame(function () {
          self['search-box-list-links'].removeClass('is-highlighted');
          hlItems.addClass('is-highlighted');
        }); // If mixedObj is null, syncSearchBox wasn't invoked by user actions -> scroll to visible item (last element of hlTreeItems array)

        if (typeof mixedObj === 'undefined' || !mixedObj || params.forceSearchSync) {
          lastHlItem = hlItems.last();
          $(lastHlItem).scrollIntoViewIfNeeded(true, self['search-box-data-list']);
        }
      }

      if (boxState.mode === 'map') {
        hlItems = self['search-box-map-links'].filter(function (key, treeItem) {
          var isHL = parseInt($(treeItem).attr('rel')) === self.pageIDX || parseInt($(treeItem).attr('rel')) === self.pageIDY;
          if (isHL) hlIndexes.push(key + 1);
          return isHL;
        });
        requestAnimationFrame(function () {
          self['search-box-map-links'].removeClass('is-highlighted');
          hlItems.addClass('is-highlighted');
        }); // If mixedObj is null, syncSearchBox wasn't invoked by user actions -> scroll to visible item (last element of hlTreeItems array)

        if (typeof mixedObj === 'undefined' || !mixedObj || params.forceSearchSync) {
          lastHlItem = hlItems.last();
          $(lastHlItem).scrollIntoViewIfNeeded(true, self['search-box-data-map']);
        }
      } // SEARCH BOX


      if (!hlIndexes.length) {
        boxState.$locString.html(boxState.locStringTpl.nohl.replace('%0', '<ins>' + boxState.count + '</ins>'));
      } else {
        boxState.$locString.html(boxState.locStringTpl[hlIndexes.length > 1 ? 'hl2' : 'hl'].replace('%0', '<ins>' + hlIndexes.join(', ') + '</ins>').replace('%1', '<ins>' + boxState.count + '</ins>'));
      }
    }, typeof mixedObj === 'undefined' ? throttleSyncSearch : 0);
  },
  // Search Results - Apply
  searchApplyResults: function searchApplyResults() {
    var forcereset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var self = this,
        vpState = self.viewPortState,
        boxState = self.searchBoxState;
    boxState.count = boxState.pages ? boxState.pages.length : 0;
    boxState.$locString = self['search-box'].find('[data-type=search-location]');
    boxState.locStringTpl = {
      hl: boxState.$locString.attr('data-hl'),
      hl2: boxState.$locString.attr('data-hl2'),
      nohl: boxState.$locString.attr('data-nohl')
    }; //let hlCnt =;

    self['search-box-data-list'] = self['search-box'].find('.wrapper-list');
    self['search-box-data-map'] = self['search-box'].find('.wrapper-map');
    $(self['ctrl-nav-page']).filter('.nav-page-hl').removeClass('nav-page-hl');
    $(self['viewport-gfx-pages']).filter('.page-hl').removeClass('page-hl');

    if (vpState.html.loaded) {
      self['viewport-html-iframe-root'].addClass('is-hl-hidden');
      $(self['viewport-html-pages']).filter('.page-hl').removeClass('page-hl');
    }

    $(self['search-box-counter']).text(boxState.count).removeClass('non-zero is-wide is-widest').addClass(boxState.count ? 'non-zero' : '').addClass(boxState.count > 99 ? 'is-widest' : boxState.count > 9 ? 'is-wide' : '');
    self['ctrl-tb-search'].attr('title', boxState.count ? self['ctrl-tb-search'].attr('data-title-found').replace('%0', boxState.count) : self['ctrl-tb-search'].attr('data-title-empty'));
    self['toolbar-nav'][boxState.pages.length ? 'removeClass' : 'addClass']('hide-hl-nav');

    if (boxState.count) {
      boxState.pages.map(function (ord) {
        $(self['ctrl-nav-page'][ord]).addClass('nav-page-hl');
        if (self['viewport-gfx-pages']) $(self['viewport-gfx-pages'][ord]).addClass('page-hl');
        return false;
      });

      if (vpState.html.loaded) {
        self['viewport-html-iframe-root'].removeClass('is-hl-hidden');
        if (!forcereset) vpState.html.loaded = false;
      }
    }

    self['search-box'].removeClass('show-no-results show-no-query').addClass(!boxState.count ? boxState.query ? 'show-no-results' : 'show-no-query' : '');
    if (!forcereset && boxState.count) self.gotoPage(self._findStartingPage());

    if (vpState.viewMode === 'html') {
      self.loadViewPortHTML(boxState.query !== '' && boxState.count, true);
    }

    self.syncControls();
  },
  // Search Results -- Clear
  searchVoidify: function searchVoidify() {
    var self = this,
        vpState = self.viewPortState,
        boxState = self.searchBoxState;
    boxState.$searchInput.val('');
    boxState.query = '';
    boxState.exquery = '';
  }
});
"use strict";

jQuery.extend(bookViewer.prototype, {
  modifySetList: function modifySetList(action, $elSetBox, $elSet, setUUID, objType, objURL) {
    var self = this,
        boxState = self.infoBoxState,
        infoBox = self['info-box'];
    self.ajaxInfoBox('loadstart');
    jQuery.ajax({
      context: self,
      type: 'POST',
      url: '/' + self.settings.root + '/set/',
      data: {
        action: action,
        uuid: setUUID,
        objtype: objType,
        objurl: objURL
      }
    }).always(function (e) {
      self.ajaxInfoBox('loadstop');
    }).done(function (e) {
      var res;

      try {
        res = JSON.parse(e);
      } catch (E) {
        res = {};
      }

      if (res.result === 'OK') {
        $elSet[action === 'additem' ? 'addClass' : 'removeClass']('is-active');
        self['ctrl-tb-info'].find('.sets-enabled')[res.setscount ? 'addClass' : 'removeClass']('sets-added');
      }
    }).fail(function (e) {
      return e;
    });
  },
  addSet: function addSet($elSetBox, $elSetList, $szTitle) {
    var self = this,
        boxState = self.infoBoxState,
        infoBox = self['info-box'];
    self.ajaxInfoBox('loadstart');
    jQuery.ajax({
      type: 'POST',
      url: '/' + self.settings.root + '/set/',
      data: {
        action: 'addset',
        title: $szTitle
      }
    }).always(function (e) {
      self.ajaxInfoBox('loadstop');
      setTimeout(function () {
        $(window.setCreator).find('[data-action="cancel-new-set"]').trigger('click');
        self.resizeInfoBox();
      }, 20);
    }).done(function (e) {
      var res, $setBoxes, $elNewSet;

      try {
        res = JSON.parse(e);
      } catch (E) {
        res = {};
      }

      if (res.result === 'OK') {
        $elNewSet = $('<div data-created="1" data-set="' + res.uuid + '"></div>').text(res.title);
        $elNewSet.insertBefore('[data-set-list] [data-set-new-form]');
        setTimeout(function () {
          infoBox.find('[data-created]').css({
            opacity: 1
          });
          $(window.setCreator).find('[data-set="' + res.uuid + '"]').trigger('click');
          self.resizeInfoBox();
        }, 10);
      } else {}
    }).fail(function (e) {});
  }
});
"use strict";
/*
 * BOOK VIEWER DEFAULTS
 */

bookViewer.count = 0;
bookViewer.defaults = {
  version: '1.0',
  debug: false,
  url: null,
  docTitle: '?',
  viewModes: {
    gfx: false,
    html: false
  },
  viewModePrefer: 'gfx',
  theme: 'light',
  layoutModes: {
    '1x1': true,
    '2x1': true
  },
  layoutModePrefer: '2x1',
  textSizePrefer: 2,
  textFontPrefer: 'a',
  treeBoxType: 'ajax',
  // false | 'ajax' | 'inline'
  treeBoxInitState: 'visible',
  // 'visible' | 'hidden'
  printAllowed: false,
  printBoxInitState: 'hidden',
  searchBoxType: 'ajax',
  searchBoxInitState: 'hidden',
  gotoPage: -1,
  gotoIDX: -1,
  queryString: '',
  surl: {
    "package": '',
    page: ''
  },
  section: 'library',
  root: 'text',
  position: 'left',
  downloadFormats: {
    pdf: false,
    djvu: false
  },
  gfx: {
    defw: 1,
    defh: 1
  },
  zoom: {
    '1x1': {
      level: 100,
      _w: false,
      _h: true
    },
    '2x1': {
      level: 100,
      _w: true,
      _h: false
    },
    html: {
      level: 100
    }
  }
};
/**
 * BOOK VIEWER PLUGIN DEFAULTS
 */

jQuery.fn.openbookViewer.defaults = bookViewer.defaults;
"use strict";
/*
 * THEME SUPPORT
 */

jQuery.extend(bookViewer.prototype, {
  switchTheme: function switchTheme(e) {
    var self = e && e.data && e.data.self || e,
        settings = self.settings;
    if (!self.settings.user || !self.settings.user.authorized) return false;
    settings.theme = settings.theme === 'light' ? 'dark' : 'light';
    self.changeTheme();
  },
  changeTheme: function changeTheme(e, theme) {
    var self = e && e.data && e.data.self || e || this,
        vpState = self.viewPortState,
        settings = self.settings;
    if (!self.settings.user || !self.settings.user.authorized) return false;
    if (!theme && !settings.theme) theme = 'light';
    if (settings.theme) theme = settings.theme;
    $('body').removeClass('theme-light theme-dark').addClass('theme-' + theme);
    self['ctrl-tb-theme'][theme === 'light' ? 'removeClass' : 'addClass']('is-active');

    if (vpState.html.valid && vpState.html.loaded) {
      self['viewport-html-iframe-root'].removeClass('theme-light theme-dark').addClass('theme-' + theme);
    }

    self.uacSaveSettings();
  }
});
"use strict"; // BOX

jQuery.extend(bookViewer.prototype, {
  /*
   *
   */
  setupTreeBox: function setupTreeBox() {
    var self = this,
        vpState = self.viewPortState;

    if (!self.settings.treeBoxType) {
      return self.treeBoxState = {
        exists: false,
        type: false
      };
    }

    self.treeBoxState = {
      exists: !!self.settings.treeBoxType,
      type: self.settings.treeBoxType,
      visible: self.settings.treeBoxInitState === 'visible' && !vpState.isMobile,
      valid: self.settings.treeBoxType !== 'ajax',
      ajaxloader: self['tree-box'].find('.side-loader'),
      enabled: false,
      normalized: false,
      eventsAttached: false
    };
    self.treeBoxState.ajaxloader.hide(0);
    self['tree-box'].hide(0);

    if (!self.treeBoxState.eventsAttached) {
      self.attachTreeBoxEvents();
    }

    self.treeBoxState.enabled = true;
  },

  /*
   *
   */
  attachTreeBoxEvents: function attachTreeBoxEvents() {
    var self = this,
        vpState = self.viewPortState,
        boxState = self.treeBoxState;
    self['tree-box'].on('mouseup' + self.eventNS, 'a, ins', function (e) {
      var $elTree;

      if ($elTree = $(e.target).closest('a')) {
        if (e.target.tagName.toLowerCase() === 'ins') {
          if ($elTree.attr('data-child')) {
            self['tree-box'].find('.simple-children[data-parent=' + $elTree.attr('data-child') + ']').toggleClass('is-open-item');
            $elTree.toggleClass('is-open-item');
          } else {
            self.gotoPage(vpState.fixeven + (Number($elTree.attr('data-goto-page')) || 0), e, {
              forceSearchSync: true
            });
          }
        } else {
          self.gotoPage(vpState.fixeven + (Number($elTree.attr('data-goto-page')) || 0), e, {
            forceSearchSync: true
          });
        }
      }

      e.stopPropagation();
    });
    boxState.eventsAttached = true;
  },

  /*
   * Tree Box - OPEN
   */
  showTreeBox: function showTreeBox(e) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var self = e && e.data && e.data.self || e,
        vpState = self.viewPortState,
        boxState = self.treeBoxState;
    if (!boxState.exists || self.resizeInProgress) return false;
    if (vpState.isMobile && boxState.visible) self.forceHideSearchBox();
    boxState.visible = force || !boxState.visible;
    self.hideControlBoxes(e);

    if (boxState.visible) {
      self['tree-box'].delayShow();
      setTimeout(function () {
        self['tree-box'].addClass('is-active');
      }, 1);
      self['ctrl-tb-tree'].addClass('is-active');
    } else {
      self['tree-box'].removeClass('is-active').delayHide();
      self['ctrl-tb-tree'].removeClass('is-active');
    }

    self.viewportResize(false, false, {
      src: 'tree-box',
      action: boxState.visible ? 'addClass' : 'removeClass',
      param: 'is-tree-pinned',
      norender: self.$object.hasClass('is-print-pinned')
    });
    self[boxState.visible && !boxState.valid ? 'loadTreeBox' : 'syncTreeBox']();
  },

  /*
   * Tree Box - CLOSE
   */
  hideTreeBox: function hideTreeBox(e) {
    var self = e && e.data && e.data.self ? e.data.self : this,
        boxState = self ? self.treeBoxState : {};
    if (!boxState.exists || self.resizeInProgress) return false;
    boxState.visible = false;
    boxState.ajaxloader.delayHide();
    self['tree-box'].delayHide();
    self.viewportResize(false, false, {
      src: 'tree-box',
      action: boxState.visible ? 'addClass' : 'removeClass',
      param: 'is-tree-pinned',
      norender: self.$object.hasClass('is-print-pinned')
    });
  },

  /*
   *
   */
  forceHideTreeBox: function forceHideTreeBox(obj) {
    var self = obj ? obj : this,
        boxState = self ? self.treeBoxState : {};
    if (!boxState.exists) return false;
    boxState.visible = false;
    boxState.ajaxloader.delayHide();
    self['tree-box'].delayHide();
    self['tree-box'].removeClass('is-active');
    self['ctrl-tb-tree'].removeClass('is-active');
    self.$object.removeClass('is-tree-pinned');
  },

  /*
   * Finds items' ending pages
   */
  normalizeTreeBox: function normalizeTreeBox() {
    var grabNext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var self = this,
        boxState = self.treeBoxState,
        maxlevel,
        treeItems,
        $curEl,
        $nextEl,
        $curGrp,
        $nextGrp,
        parOrdTo,
        lev;
    maxlevel = Number(self['tree-box'].find('[data-type=tree-box-contents]').attr('data-max-level'));

    for (lev = 1; lev <= maxlevel; lev++) {
      parOrdTo = null;
      treeItems = self['tree-box'].find('a[data-level="' + lev + '"]');
      treeItems.map(function (idx, el) {
        $curEl = $(el);
        if ($curEl.attr('data-ord-to')) return;
        $nextEl = $(treeItems[idx + 1]); // check if next element has the same parent as current does

        if (lev > 1) {
          $curGrp = $curEl.closest('[data-parent]');
          $nextGrp = $nextEl.closest('[data-parent]');
          if (!$curGrp.is($nextGrp)) $nextEl = null;
          parOrdTo = $(self['tree-box'].find('a[data-child="' + $curGrp.attr('data-parent') + '"]')).attr('data-to');
        }

        $curEl.attr('data-to', $nextEl && $nextEl.get(0) ? Math.max(Number($curEl.attr('data-from')), Number($nextEl.attr('data-from')) - (grabNext ? 0 : 1)) : parOrdTo ? parOrdTo : self.pageMAX - 1);
      });
    }

    boxState.normalized = true;
  },

  /**
   * SYNCHRONIZE TREE WITN PAGE(S) NO
   *
   * @param mixedObj
   */
  syncTreeBox: function syncTreeBox(mixedObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var self = this,
        hlTtreeItems = [],
        lastHlTreeItem = null;
    if (!self.treeBoxState.valid || !self['tree-box'].hasClass('is-active') || !self['ctrl-nav-page'][self.pageIDX]) return;
    if (!self.treeBoxState.normalized) self.normalizeTreeBox();
    clearTimeout(self.timerSyncTree);
    self.timerSyncTree = setTimeout(function () {
      hlTtreeItems = self['tree-links'].filter(function (key, treeItem) {
        return parseInt($(treeItem).attr('data-from')) <= self.pageIDY && parseInt($(treeItem).attr('data-to')) >= self.pageIDX;
      });
      self['tree-links'].removeClass('is-highlighted');
      hlTtreeItems.addClass('is-highlighted');
      jQuery.each(hlTtreeItems, function (key, treeHLItem) {
        // Open Item
        $(treeHLItem).addClass('is-open-item');
        $(self['tree-box'].find('div[data-parent="' + $(treeHLItem).attr('data-child') + '"]')).addClass('is-open-item'); // Open Item Parents

        jQuery.each($(treeHLItem).parents('div.simple-children'), function (key, treeHLPlaceHolder) {
          $(treeHLPlaceHolder).addClass('is-open-item');
          $(self['tree-box'].find('div[data-child="' + $(treeHLPlaceHolder).attr('data-parent') + '"]')).addClass('is-open-item');
        });
      }); // If mixedObj is null, syncTreeBox wasn't invoked by user actions -> scroll to visible item (last element of hlTreeItems array)

      if (typeof mixedObj === 'undefined' || !mixedObj || params.forceTreeSync) {
        lastHlTreeItem = hlTtreeItems.last();
        $(lastHlTreeItem).scrollIntoViewIfNeeded(true, self['tree-box-container']);
      }
    }, typeof mixedObj === 'undefined' ? throttleSyncTree : 0);
  }
});
"use strict";
/*
 * USER-ACC -- Save Settings
 */
// TODO: Add USER support

jQuery.extend(bookViewer.prototype, {
  // Save Settings
  uacSaveSettings: function uacSaveSettings() {
    var self = this,
        vpState = self.viewPortState,
        settings = {
      //viewModePrefer  : vpState.viewMode,
      layoutModePrefer: vpState.layoutMode,
      textSizePrefer: vpState.html.textSize,
      textFontPrefer: vpState.html.textFont,
      zoom: vpState.zoom,
      theme: self.settings.theme
    };
    if (typeof Storage === 'undefined') return false;
    localStorage.setItem(lsSettingsKey, JSON.stringify(settings));
  },
  // Retrieve Settings
  uacLoadSettings: function uacLoadSettings() {
    var self = this,
        settings = {};
    if (typeof Storage === 'undefined') return false;
    settings = JSON.parse(localStorage.getItem(lsSettingsKey));
    return settings ? settings : {};
  },
  // Retrieve AuthUser Settings
  authLoadSettings: function authLoadSettings(user) {
    var settings = {};
    if (!user || !user.uuid || !user.settings) return {};
    if (['1x1', '2x1'].includes(user.settings.layoutmode)) settings.layoutModePrefer = user.settings.layoutmode;
    if (['gfx', 'html'].includes(user.settings.viewmode)) settings.viewModePrefer = user.settings.viewmode;
    if (['light', 'dark'].includes(user.settings.theme)) settings.theme = user.settings.theme;
    return settings;
  }
});
"use strict";

jQuery.extend(bookViewer.prototype, {
  /**
   * LOAD GFX:VISIBLE
   *
   */
  viewportLoadVisible: function viewportLoadVisible() {
    var self = this,
        vpState = self.viewPortState,
        elContainer = self['viewport-gfx-container'][0],
        vpHeight = elContainer.clientHeight,
        maxRows = Math.max(0, Math.ceil(vpHeight / vpState.gfx.curminh * (vpState.layoutMode === '1x1' ? 1 : 2))),
        fetchBack = maxRows,
        fetchFwd = maxRows,
        loadPages = [],
        $pageEl,
        $imgPH,
        $imgEl,
        idxEl,
        pg;
    if (vpState.viewMode !== 'gfx') return false;

    for (pg = self.pageIDX; pg <= self.pageIDY; pg++) {
      loadPages.push(pg);
    }

    for (pg = self.pageIDY + 1; pg <= self.pageIDY + fetchFwd + 1; pg++) {
      loadPages.push(pg);
    }

    for (pg = self.pageIDX - 1; pg >= self.pageIDX - fetchBack - 1; pg--) {
      loadPages.push(pg);
    }

    self['viewport-gfx-pages'].removeClass('is-in-viewport');

    for (pg = 0; pg < loadPages.length; pg++) {
      idxEl = loadPages[pg];
      if (idxEl < 0 || idxEl >= self.pageMAX) continue;
      $pageEl = $(self['viewport-gfx-pages'][idxEl]);
      if ($pageEl.hasClass('fixeven')) continue;
      $pageEl.addClass('is-in-viewport');
      $imgPH = $pageEl.find('.ph-img');
      $imgEl = $imgPH.find('img').addClass('is-in-viewport');

      if (!$imgEl.length) {
        $pageEl.addClass('is-loading');
        $imgPH.html('');
        $imgEl = $('<img>', {
          "class": 'is-in-viewport',
          attr: {
            'data-filename': $pageEl.attr('data-filename'),
            rel: idxEl,
            title: '',
            draggable: false
          },
          src: '/' + self.settings.root + '/image/?docurl=' + self.settings.url + '&page=' + $pageEl.attr('data-filename') + '&s=' + vpState.gfx.scale + '&w=' + vpState.gfx.defw + '&h=' + vpState.gfx.defh
        }).on('load', function (e) {
          var $this = $(e.currentTarget);
          var $pageEl = $(self['viewport-gfx-pages'][Number($this.attr('rel'))]);
          $pageEl.attr('data-loaded-scale', vpState.gfx.scale).attr('data-img-loaded', 'ok').removeClass('is-loading');
        });
        $imgPH.append($imgEl);
      } else {
        var srcLoaded = $imgEl.attr('src'),
            srcToLoad = '/' + self.settings.root + '/image/?docurl=' + self.settings.url + '&page=' + $pageEl.attr('data-filename') + '&s=' + vpState.gfx.scale + '&w=' + vpState.gfx.defw + '&h=' + vpState.gfx.defh;

        if (srcLoaded !== srcToLoad) {
          $imgEl.attr('src', srcToLoad);
        }
      }

      if (!$pageEl.attr('data-init-done')) {
        // Build BookMarks Button
        $('<span>', {
          "class": 'page-tool bm-toggle color-' + self.getBookMarkByIDX($pageEl.attr('rel'), 'color'),
          attr: {
            rel: $pageEl.attr('rel')
          }
        }).appendTo($pageEl); // Build Copy Page Button

        /*
        $( '<span>', {
        	class: 'copy-text',
        	attr : {
        		rel: $pageEl.attr( 'rel' )
        	}
        } ).appendTo( $pageEl );
        */
        // Build Rotate Button

        /*
        					$( '<span>', {
        						class: 'page-tool pg-rotate',
        						attr : {
        							rel: $pageEl.attr( 'rel' )
        						}
        					} ).appendTo( $pageEl );
        */

        $pageEl.attr('data-init-done', 1);
      }
    } // CLEAN NON-IN-VIEWPORT

    /*
    let cancelImages = self[ 'viewport-gfx-pages' ].filter( ':not(.is-in-viewport)' );
    		jQuery.each( cancelImages, function ( idx, pageEl ) {
    	$( pageEl ).attr( 'data-img-loaded', null );
    			let $imgEl = $( pageEl ).find( 'img' );
    	//$imgEl.attr( 'src', '' );
    	//$imgEl.remove();
    } );
     */

  },

  /**
   *
   * @param idx
   */
  pageRotate: function pageRotate() {
    var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cw';
    var self = this,
        vpState = self.viewPortState,
        pgEl = $(self['viewport-gfx-pages'][self.pageIDX]),
        rot = pgEl[0].className.match(/rot-(\d)/),
        deg = rot ? parseInt(rot[1]) : 0,
        newdeg = direction === 'cw' ? deg + 1 === 5 ? 0 : deg + 1 : deg - 1 === -1 ? 3 : deg - 1;
    if (vpState.isMobile || vpState.layoutMode !== '1x1' || vpState.viewMode !== 'gfx' || pgEl.hasClass('ls-page') || pgEl.hasClass('ns-page')) return false;

    if (direction === 'cw') {
      pgEl.removeClass('rot-0 rot-1 rot-2 rot-3 rot-4').addClass('rot-' + newdeg);

      if (newdeg === 4) {
        setTimeout(function () {
          requestAnimationFrame(function () {
            pgEl.addClass('rot-xxx');
            pgEl.removeClass('rot-4');
            pgEl.addClass('rot-0');
            requestAnimationFrame(function () {
              pgEl.removeClass('rot-xxx');
            });
          });
        }, 100);
      }
    }

    if (direction === 'ccw') {
      //setTimeout( () => {
      if (newdeg === 3) {
        requestAnimationFrame(function () {
          pgEl.addClass('rot-xxx');
          pgEl.removeClass('rot-0');
          pgEl.addClass('rot-4');
          requestAnimationFrame(function () {
            pgEl.removeClass('rot-xxx');
            pgEl.removeClass('rot-4');
            pgEl.addClass('rot-3');
          });
        });
      } else {
        pgEl.removeClass('rot-0 rot-1 rot-2 rot-3 rot-4').addClass('rot-' + newdeg);
      } //}, 100 );

    }
  },

  /**
   * GFX: ZOOM LEVEL
   * @param level
   * @param adjust
   * @param force
   * @returns {boolean}
   */
  changeZoomLevel: function changeZoomLevel(level) {
    var adjust = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var self = this,
        vpState = self.viewPortState,
        curRound10 = Math.floor(Math.floor(vpState.zoom[vpState.layoutMode].level / stepZoom) * stepZoom),
        elContainer = self['viewport-gfx'][0],
        vpWidth = elContainer.clientWidth,
        vpHeight = elContainer.clientHeight,
        curH = vpState.gfx.curh,
        defH = vpState.gfx.defh,
        defW = vpState.gfx.defw,
        curW100 = 0;
    if (!force && (self.resizeInProgress || !self.isActive || vpState.viewMode !== 'gfx' || self['ctrl-tb-zoom'].hasClass('is-disabled'))) return;

    switch (level) {
      case '+':
      case '=':
        if (!force && (self['ctrl-pz-zoom-in'].hasClass('is-disabled') || curRound10 + stepZoom > maxZoom[vpState.layoutMode])) return false;
        vpState.zoom[vpState.layoutMode].level = curRound10 + stepZoom;
        vpState.zoom[vpState.layoutMode]._w = vpState.zoom[vpState.layoutMode].level === 100;
        vpState.zoom[vpState.layoutMode]._h = false;
        break;

      case '-':
        if (!force && (self['ctrl-pz-zoom-out'].hasClass('is-disabled') || curRound10 - stepZoom < minZoom[vpState.layoutMode])) return false;
        vpState.zoom[vpState.layoutMode].level = curRound10 - stepZoom;
        vpState.zoom[vpState.layoutMode]._w = vpState.zoom[vpState.layoutMode].level === 100;
        vpState.zoom[vpState.layoutMode]._h = false;
        break;

      case '*':
        if (!force && (self['ctrl-pz-zoom-w'].hasClass('is-disabled') || self['ctrl-pz-zoom-w'].hasClass('is-active') || vpState.zoom[vpState.layoutMode]._w)) return false;
        vpState.zoom[vpState.layoutMode].level = 100;
        vpState.zoom[vpState.layoutMode]._w = true;
        vpState.zoom[vpState.layoutMode]._h = false;
        break;

      case '/':
        if (!force && (self['ctrl-pz-zoom-h'].hasClass('is-disabled') || self['ctrl-pz-zoom-h'].hasClass('is-active') || vpState.zoom[vpState.layoutMode]._h)) return false;
        curW100 = vpState.layoutMode === '1x1' ? vpWidth : (vpWidth - 12) / 2;
        curH = curW100 * (defH / defW);
        vpState.zoom[vpState.layoutMode].level = vpHeight / curH * 100;
        vpState.zoom[vpState.layoutMode]._w = false;
        vpState.zoom[vpState.layoutMode]._h = true;
        break;

      default:
        if (typeof level !== 'number') return false;
        vpState.zoom[vpState.layoutMode].level = level;
        vpState.zoom[vpState.layoutMode]._w = vpState.zoom[vpState.layoutMode].level === 100;
        vpState.zoom[vpState.layoutMode]._h = false;
        break;
    }

    if (!self.isActive && !force) return;
    self.viewportResize(false, true, {
      src: 'viewport-gfx',
      action: 'changeZoomLevel',
      param: level
    });
    self.uacSaveSettings();
  }
});
"use strict";
/*
 * BOOK VIEWER HTML/IFRAME
 */

jQuery.extend(bookViewer.prototype, {
  /**
   * HTML : Fit Table to Page Width
   */
  resizeHTMLDoc: function resizeHTMLDoc() {
    var self = this,
        vpWidth = self.viewPortState.html.curw;
    self['viewport-html-iframe-contents'].find('table').each(function (idx, table) {
      var $table = $(table),
          fontSize = 1.0,
          fontStep = 0.1,
          tblWidth = 0;

      do {
        fontSize -= fontStep;
        $table.css({
          'font-size': fontSize + 'em'
        });
        tblWidth = table.scrollWidth - 10;

        if (fontSize <= 0.6) {
          fontStep = 0.05;
        }
      } while (tblWidth > vpWidth && fontSize > 0.1);
    });
  },

  /**
   * HTML: TEXT SIZE
   * @param size
   * @returns {boolean}
   */
  changeTextSize: function changeTextSize(size) {
    var self = this,
        vpState = self.viewPortState,
        textSize = parseInt(vpState.html.textSize);
    if (!vpState.html.valid || !vpState.html.loaded) return false;
    vpState.html.textSize = size === '-' && textSize - 1 >= 0 ? textSize - 1 : size === '+' && textSize + 1 <= 4 ? textSize + 1 : size === '*' ? 2 : textSize;
    if (vpState.html.textSize === textSize) return false; //		console.log( textSize, vpState.html.textSize );

    self.viewportResize(false, true, {
      src: 'viewport-html',
      action: 'changeTextSize',
      param: vpState.html.textSize
    });
    self.uacSaveSettings();
  },

  /**
   * HTML: TEXT FONT
   * @param font
   * @returns {boolean}
   */
  changeTextFont: function changeTextFont(font) {
    var self = this,
        vpState = self.viewPortState;
    if (!vpState.html.valid || !vpState.html.loaded || vpState.html.textFont === font) return false;
    vpState.html.textFont = font;
    self.viewportResize(false, true, {
      src: 'viewport-html',
      action: 'changeTextFont',
      param: font
    });
    self.uacSaveSettings();
  },

  /**
   * HTML: TEXT WIDTH
   * @param font
   * @returns {boolean}
   */
  changeWidthLevel: function changeWidthLevel(level) {
    var adjust = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var self = this,
        vpState = self.viewPortState,
        curWidth = vpState.zoom.html.level;

    if (!curWidth || curWidth > 100) {
      if (typeof vpState.zoom.html.level === 'undefined') vpState.zoom.html = {};
      vpState.zoom.html.level = 100;
      curWidth = 100;
    }

    if (vpState.layoutMode === '2x1' || vpState.isMobile || !force && (self.resizeInProgress || !self.isActive || vpState.viewMode !== 'html'
    /*|| self[ 'ctrl-tb-zoom' ].hasClass( 'is-disabled' ) */
    )) return;

    switch (level) {
      case ']':
        if (!force && (self['ctrl-pz-textwidth-inc'].hasClass('is-disabled') || curWidth + stepHTMLWidth > maxHTMLWidth)) return false;
        vpState.zoom.html.level = curWidth + stepHTMLWidth;
        break;

      case '[':
        if (!force && (self['ctrl-pz-textwidth-dec'].hasClass('is-disabled') || curWidth - stepHTMLWidth < minHTMLWidth)) return false;
        vpState.zoom.html.level = curWidth - stepHTMLWidth;
        break;

      default:
        if (typeof level !== 'number') return false;
        vpState.zoom.html.level = level;
        break;
    }

    if (!self.isActive && !force) return;
    self.viewportResize(false, true, {
      src: 'viewport-html',
      action: 'changeWidthLevel',
      param: level
    });
    self.uacSaveSettings();
  },

  /*
   *
   */
  attachViewPortHTMLHandlers: function attachViewPortHTMLHandlers() {
    var _this = this;

    var self = this,
        vpState = self.viewPortState,
        tipTrigger;
    self['viewport-html-iframe-contents'].on('keydown' + self.eventNS, '', {
      self: self
    }, function (e) {
      return self.onKeyboard.apply(self, arguments);
    }).on('mouseup' + self.eventNS, '', {
      self: self
    }, function (e) {
      var self = e.data.self;
      self.hideControlBoxes(e);
    }).on('mouseup' + self.eventNS, '.bm-toggle', {
      self: self
    }, function (e) {
      var self = e.data.self;
      self.onBookMarkToggle(e, 'bookmark-toggle');
    }); // ON UNLOAD/RELOAD

    self['viewport-html-iframe'][0].contentWindow.onunload = function () {
      var vpState = self.viewPortState;
      vpState.html.loaded = false;
      vpState.html.valid = false;
      vpState.html.pageSizes = [];
    }; // DISABLE GESTURES


    self['viewport-html-iframe'][0].contentDocument.addEventListener('gesturechange', function (event) {
      if ((event.originalEvent || event).scale > 1) (event.originalEvent || event).preventDefault();
    }, {
      passive: false
    }); // HLWORDS

    if (1) {
      var $hlwords = self['viewport-html-iframe-root'].find('hlword');
      $hlwords.first().addClass('first');
      $hlwords.last().addClass('last');
      $hlwords.append('<go next /><go prev />');
      $hlwords.on('mouseover' + self.eventNS, function (e) {
        var $this = $(this);
      }).on('mouseout' + self.eventNS, function (e) {}).on('mouseup' + self.eventNS, '', function (e) {
        var $this = $(e.delegateTarget);
        var $el = $($hlwords.eq($hlwords.index($this) + (!$this.hasClass('last') ? 1 : -1)));
        if (!$el.length) return false;
        $el //.blink()
        .get(0).scrollHLIntoView(true, self['viewport-html-container'].get(0)
        /*, !vpState.isMobile*/
        );
      }).on('mouseup' + self.eventNS, '[prev]', function (e) {
        var $this = $(e.delegateTarget);
        var $el = $($hlwords.eq($hlwords.index($this) - 1));
        if (!$el.length) return false;
        $el //.blink()
        .get(0).scrollHLIntoView(true, self['viewport-html-container'].get(0)
        /*, !vpState.isMobile*/
        );
        e.stopPropagation();
        return false;
      });
    } // TIPS


    if (!(tipTrigger = vpState.html.tipTrigger)) {
      tipTrigger = vpState.html.tipTrigger = $('<tip-trigger>').appendTo(self['viewport-html']);
      tipTrigger.data('powertip', '<span>...</span>').on('mousedown' + self.eventNS, function (e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }).on('mouseenter' + self.eventNS, function (e) {
        clearInterval(tipTrigger.timerHide);
      }).on('mouseleave' + self.eventNS, function (e) {
        if (vpState.isMobile) {
          e.stopPropagation();
          e.preventDefault();
          return false;
        }

        clearInterval(tipTrigger.timerHide);
        tipTrigger.timerHide = setInterval(function () {
          if (!$('#powerTip:hover').length) {
            clearInterval(tipTrigger.timerHide);
            tipTrigger.removeClass('is-active');
            jQuery.powerTip.hide(null);
          }
        }, 500);
      }).on('powerTipPreRender' + self.eventNS, function (e) {
        if (!tipTrigger.hasClass('is-active')) {}
      }).on('powerTipClose' + self.eventNS, function (e) {
        tipTrigger.removeClass('is-active');
      }).powerTip({
        manual: true,
        closeDelay: 2000,
        followMouse: false,
        popupClass: 'html-tip-trigger is-grey'
        /* + ' is-dark' */
        ,
        mouseOnToPopup: true,
        offset: 5,
        smartPlacement: true,
        noDesyncCheck: true,
        placement: 's'
      });
    }

    var $tips = self['viewport-html-iframe-root'].find('.pagebox > *:not(.fn) .fnsymbol'); //$tips

    $tips.on('mouseenter' + self.eventNS + ' click' + self.eventNS, function (e) {
      var $this = $(e.target),
          tipRect = $this[0].getBoundingClientRect(),
          elContainer = self['viewport-html-container'][0],
          iframeOffsetX = self['viewport-html-iframe'][0].offsetLeft,
          cntScrollY = elContainer.scrollTop,
          cntScrollX = elContainer.scrollLeft,
          tipIndex = $tips.index($this);
      if ($('#powerTip:visible').length && tipTrigger.data('tipIndex') === tipIndex) return false;
      tipTrigger.data('tipIndex', tipIndex);
      jQuery.powerTip.hide();
      var $tipPage = $this.closest('.pagebox'),
          $tipFootNote = $('');
      var $allTips = $tipPage.find('.fn'),
          $allTexts = $tipPage.find('> *:not(.fn) .fnsymbol');

      try {
        if ($allTips.length === $allTexts.length) {
          // Try to use simple mapping (fnsymbol count === fn count) ...
          $tipFootNote = $allTips.eq($allTexts.index($this)).clone();
          $tipFootNote.find('.fnsymbol').remove();
        } else {
          // ... otherwise, try to find fn by its' symbol
          $tipFootNote = $allTips.filter(function () {
            return $(this).text().toLowerCase().indexOf($this.text().toLowerCase()) >= 0;
          }).first();
        }

        if (!$tipFootNote.length) return false;
        requestAnimationFrame(function () {
          tipTrigger.addClass('is-active').data('powertip', '<dd>' + $tipFootNote.html() + '</dd>').css({
            top: tipRect.top - cntScrollY - 5,
            left: tipRect.left - cntScrollX + iframeOffsetX - 5,
            width: tipRect.width + 10,
            height: tipRect.height + 10
          });
          jQuery.powerTip.show($(tipTrigger), e);
        });
      } catch (E) {
        console.warn('Failed to show footnote tip. ' + $(_this).text());
      }

      e.stopPropagation();
      e.preventDefault();
      return false;
    });
    self['viewport-html-iframe-root'].on('click' + self.eventNS, function (e) {
      jQuery.powerTip.hide();
    });
  }
});
"use strict";
/*
 * BOOK VIEWER RESIZER
 */

jQuery.extend(bookViewer.prototype, {
  /**
   * SETUP VARIABLES AND VIEWPORT STATE OBJECT
   */
  setupViewportState: function setupViewportState() {
    var self = this,
        settings = self.settings,
        eventNS = self.eventNS,
        $window = $(window),
        $document = $(document),
        $object = self.$object;
    self.isActive = false;
    self.htmlLaunch = false;
    self.pageIDX = 0;
    self.pageIDY = 0;
    self.pageMAX = self['ctrl-nav-page'].length;
    self.viewPortState = {
      viewModes: self.settings.viewModes,
      viewMode: self.settings.viewModePrefer,
      isMobile: self._isInMobileMode(),
      layoutModes: self.settings.layoutModes,
      layoutMode: self.settings.layoutModePrefer,
      gfx: {
        valid: false,
        loaded: false,
        //zoomLevel : self.settings.zoomLevelPrefer,
        //zoomLevelW: self.settings.zoomLevelPreferW,
        //zoomLevelH: self.settings.zoomLevelPreferH,
        defw: self.settings.gfx.defw,
        defh: self.settings.gfx.defh,
        minh: self.settings.gfx.minh,
        maxh: self.settings.gfx.maxh,
        curw: 1,
        curh: 1,
        scale: 100,
        colCount: 1,
        rowCount: 1,
        gapY: 0,
        pageSizes: [],
        pageSizesChunks: []
      },
      zoom: self.settings.zoom,
      html: {
        valid: false,
        loaded: false,
        textSizesList: [0, 1, 2, 3, 4],
        textSize: Number(self.settings.textSizePrefer),
        textFontsList: ['a', 'b', 'c'],
        textFont: self.settings.textFontPrefer,
        colCount: 1,
        pageSizes: [],
        pageSizesChunks: [],
        curw: 1
      },
      fixeven: self.settings.fixeven
    };
  },

  /**
   * RESIZE EVENT HANDLER
   * @param forceMobileMode
   * @param forceInvalid
   * @returns {boolean}
   */
  viewportResize: function viewportResize() {
    var forceMobileMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var forceInvalid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var self = this,
        vpState = self.viewPortState,
        gfxContainer = self['viewport-gfx-container'][0],
        htmlContainer = self['viewport-html-container'][0],
        vpRuler = self['viewport-ruler'][0],
        vpWidth = null,
        vpHeight = null,
        vpGfx = self['viewport-gfx'][0],
        vpHtml = self['viewport-html'][0],
        vpGfxWidth = vpGfx.clientWidth,
        vpGfxHeight = vpGfx.clientHeight,
        vpHtmlWidth = vpHtml.clientWidth,
        vpHtmlHeight = vpHtml.clientHeight,
        curH = vpState.gfx.curh,
        defH = vpState.gfx.defh,
        defW = vpState.gfx.defw,
        curW100 = 0,
        subData = {};
    gfxContainer.deflectScrollEvent = true;
    htmlContainer.deflectScrollEvent = true;
    jQuery.powerTip.hide();
    self.syncControls(false, true);

    self._isInMobileMode();

    if (forceInvalid) {
      vpState.gfx.valid = false;
      vpState.html.valid = false;
    }

    if (forceMobileMode && vpState.isMobile) {
      self.$object.addClass('is-rendering');
      requestAnimationFrame(function () {
        if (vpState.layoutMode === '2x1') {
          vpState.layoutMode = '1x1';
          vpState.zoom.html.level = 100;
          self.$object.removeClass('is-2x1-mode').addClass('is-1x1-mode');
          self['viewport-gfx'].removeClass('mode-2x1').addClass('mode-1x1');
          self['viewport-gfx-contents'].css('width', vpState.zoom[vpState.layoutMode].level + '%');

          if (vpState.html.loaded) {
            self['viewport-html-iframe'].css('width', vpState.zoom.html.level + '%');
            self['viewport-html'].removeClass('mode-2x1').addClass('mode-1x1');
            self['viewport-html-iframe-root'].removeClass('mode-1x1 mode-2x1').addClass('mode-' + vpState.layoutMode);
          }
        }

        if (self.treeBoxState.visible) self.forceHideTreeBox();
        if (self.printBoxState.visible) self.forceHidePrintBox();
        if (self.searchBoxState.visible) self.forceHideSearchBox();
      });
    } // Do the Re-Layout Actions


    if (data && data.action) {
      requestAnimationFrame(function () {
        if (!data.norender && !vpState.isMobile) self.$object.addClass('is-rendering');
      });
      setTimeout(function () {
        // console.log( 'Acnt: ' + data.action );
        requestAnimationFrame(function () {
          switch (data.action) {
            case 'addClass':
            case 'removeClass':
              self.$object[data.action](data.param);
              break;

            case 'launchViewer':
              self.isActive = true;
              self.$object.removeClass('is-loading is-ajax-loading no-transition').addClass('is-active');
              setTimeout(function () {
                self['load-overlay'].addClass('is-complete');
              }, throttleViewportChange);
              setTimeout(function () {
                self['load-overlay'].delayHide();
                self['viewport-ruler'].find('.book-render').css({
                  visibility: 'visible'
                });
              }, throttleViewportChange * 5);
              subData.jump2page = true;
              break;

            case 'changeMode':
              self.$object.addClass('is-rendering').removeClass(vpState.viewMode === 'gfx' ? 'is-html-mode' : 'is-gfx-mode').addClass('is-' + vpState.viewMode + '-mode');
              if (vpState.viewMode === 'gfx') self['viewport-gfx'].delayShow();
              if (vpState.viewMode === 'html') self['viewport-html'].delayShow();
              self['viewport-gfx'][vpState.viewMode === 'gfx' ? 'addClass' : 'removeClass']('is-active');
              self['viewport-html'][vpState.viewMode === 'html' ? 'addClass' : 'removeClass']('is-active');
              if (vpState.viewMode === 'gfx') self['viewport-html'].delayHide();
              if (vpState.viewMode === 'html') self['viewport-gfx'].delayHide();
              break;

            case 'changeLayout':
              self.$object.addClass('is-rendering').removeClass(vpState.layoutMode === '2x1' ? 'is-1x1-mode' : 'is-2x1-mode').addClass('is-rendering is-' + vpState.layoutMode + '-mode');
              self['viewport-gfx'].removeClass('mode-1x1 mode-2x1').addClass('mode-' + vpState.layoutMode);
              self['viewport-gfx-contents'].css('width', vpState.zoom[vpState.layoutMode].level + '%');

              if (vpState.html.loaded) {
                self['viewport-html-iframe'].css('width', (vpState.layoutMode === '2x1' || vpState.isMobile ? 100 : vpState.zoom.html.level) + '%');
                self['viewport-html'].removeClass('mode-1x1 mode-2x1').addClass('mode-' + vpState.layoutMode);
                self['viewport-html-iframe-root'].removeClass('mode-1x1 mode-2x1').addClass('mode-' + vpState.layoutMode);
              }

              break;

            case 'changeZoomLevel':
              self['viewport-gfx-contents'].css('width', vpState.zoom[vpState.layoutMode].level + '%');
              break;

            case 'changeWidthLevel':
              if (vpState.html.loaded) self['viewport-html-iframe'].css('width', (vpState.viewMode === '2x1' ? 100 : vpState.zoom.html.level) + '%');
              break;

            case 'changeTextFont':
              self['viewport-html-iframe-root'].removeClass('font-family-a font-family-b font-family-c').addClass('font-family-' + vpState.html.textFont);
              break;

            case 'changeTextSize':
              self['viewport-html-iframe-root'].removeClass('font-size-0 font-size-1 font-size-2 font-size-3 font-size-4').addClass('font-size-' + vpState.html.textSize);
              break;

            case 'iframeLoad':
              self['viewport-html'].removeClass('mode-1x1 mode-2x1').addClass('mode-' + vpState.layoutMode);
              self['viewport-html-iframe-root'].removeClass('mode-1x1 mode-2x1').addClass('mode-' + vpState.layoutMode);
              self['load-overlay'].addClass('is-complete').delayHide();
              subData.jump2page = !self.isActive;
              break;
          }

          setTimeout(function () {
            self.viewportResize(false, false, subData);
          }, 10);
        });
      }, 10);
      return false;
    }

    if (self.isActive) {
      requestAnimationFrame(function () {
        self.resizeInProgress = true;
        vpWidth = vpRuler.clientWidth;
        vpHeight = vpRuler.clientHeight;
        if (vpState.viewMode === 'gfx' && (vpWidth !== vpGfxWidth || vpHeight !== vpGfxHeight)) vpState.gfx.valid = false;
        if (vpState.viewMode === 'html' && (vpWidth !== vpHtmlWidth || vpHeight !== vpHtmlHeight)) vpState.html.valid = false;

        if (vpState.viewMode === 'gfx' && !vpState.gfx.valid || vpState.viewMode === 'html' && !vpState.html.valid) {
          self.$object.addClass('is-rendering');
          self['viewport-gfx'].css({
            width: vpWidth,
            height: vpHeight
          });
          self['viewport-html'].css({
            width: vpWidth,
            height: vpHeight
          });
        }

        self.viewportValidate();

        if (self['viewport-html-iframe-contents'] && !vpState.html.valid) {
          vpState.html.curw = Math.max(self['viewport-html-pages'][0].offsetWidth - 20, self['viewport-html-pages'][1].offsetWidth - 20, 1);
        }

        if (vpState.viewModes.gfx && vpState.viewMode === 'gfx' && !vpState.gfx.valid) {
          // AUTOFIT IF ZOOM-H IS SET
          if (vpState.zoom[vpState.layoutMode]._h) {
            curW100 = vpState.layoutMode === '1x1' ? vpWidth : (vpWidth - 12) / 2;
            curH = curW100 * (defH / defW);
            vpState.zoom[vpState.layoutMode].level = vpHeight / curH * 100;
            self['viewport-gfx-contents'].css('width', vpState.zoom[vpState.layoutMode].level + '%');
          }

          setTimeout(function () {
            requestAnimationFrame(function () {
              vpState.gfx.pageSizes = [];
              vpState.gfx.pageSizesChunks = [];
              jQuery.each(self['viewport-gfx-pages'], function (idx, gfxPage) {
                var pageRel = Number($(gfxPage).attr('rel'));
                vpState.gfx.pageSizes[pageRel] = {
                  offsetTop: gfxPage.offsetTop,
                  offsetHeight: gfxPage.offsetHeight,
                  rel: pageRel + vpState.fixeven
                };
              });
              vpState.gfx.pageSizesChunks = new Array(Math.ceil(vpState.gfx.pageSizes.length / gfxChunckSize)).fill().map(function (_, i) {
                return vpState.gfx.pageSizes.slice(i * gfxChunckSize, i * gfxChunckSize + gfxChunckSize);
              });

              if (self.isActive) {
                vpState.gfx.valid = true;

                if (!data.jump2page) {
                  self.viewportSync(null, {
                    src: 'vpResize#gfx'
                  });
                } else {
                  self.gotoPage(self._findStartingPage(), null, {
                    scrollToFirstHL: true
                  });
                }

                self.viewportDetectCurrent();
              }
            });
          }, 10);
        } // if gfx


        if (vpState.viewModes.html && vpState.viewMode === 'html' && !vpState.html.valid && self['viewport-html-iframe-contents']) {
          self.resizeHTMLDoc(); // Make sure element height is calculated

          self['viewport-html-iframe'].height(self['viewport-html-iframe-root'].outerHeight());
          requestAnimationFrame(function () {
            self['viewport-html-iframe'].height(self['viewport-html-iframe-root'].outerHeight());
          });
          setTimeout(function () {
            requestAnimationFrame(function () {
              self['viewport-html-iframe'].height(self['viewport-html-iframe-root'].outerHeight());
            });
          }, throttleViewportChange);
          vpState.html.pageSizes = [];
          vpState.html.pageSizesChunks = [];
          setTimeout(function () {
            requestAnimationFrame(function () {
              jQuery.each(self['viewport-html-pages'], function (idx, htmlPage) {
                var pageRel = Number($(htmlPage).attr('rel'));
                vpState.html.pageSizes[pageRel] = {
                  offsetTop: htmlPage.offsetTop,
                  offsetHeight: htmlPage.offsetHeight,
                  rel: pageRel
                };
              });
              vpState.html.pageSizesChunks = new Array(Math.ceil(vpState.html.pageSizes.length / htmlChunckSize)).fill().map(function (_, i) {
                return vpState.html.pageSizes.slice(i * htmlChunckSize, i * htmlChunckSize + htmlChunckSize);
              });

              if (self.isActive) {
                vpState.html.valid = true;

                if (!data.jump2page) {
                  self.viewportSync(null, {
                    src: 'vpResize#html'
                  });
                } else {
                  //self.viewportSync( null, { src: 'vpResize#2' } );
                  self.gotoPage(self._findStartingPage(), null, {
                    scrollToFirstHL: true
                  });
                }

                self.viewportDetectCurrent();
              }
            });
          }, throttleDetectScroll);
        } // if html


        setTimeout(function () {
          self.$object.addClass('is-active').removeClass('no-transition is-rendering is-ajax-loading ' + (vpState.html.loaded ? 'is-iframe-loading' : ''));
          if (vpState.gfx.loaded) self['viewport-gfx'].removeClass('is-loading');
          if (vpState.html.loaded) self['viewport-html'].removeClass('is-loading');
          if (!vpState.isMobile) self.hideControlBoxes();
          self.resizeInProgress = false;
          requestAnimationFrame(function () {
            if (self.isActive) {
              //self.viewportSync( null, { src: 'vpResize#3' } );
              self.viewportFocus(self);
            }

            clearTimeout(vpState.timerDeflect);
            vpState.timerDeflect = setTimeout(function () {
              gfxContainer.deflectScrollEvent = false;
              htmlContainer.deflectScrollEvent = false;
            }, throttleViewportChange);
          });
        }, throttleViewportChange);
      }); // raf.callback
    } else {
      self.viewportSync();
      self.syncControls();
    }

    self.viewportSync();
    self.syncControls();
  },

  /**
   * SYNCHRONIZE VIEWPORT WITH CURRENT PAGE(S) NO
   * @param mixedObj
   */
  viewportSync: function viewportSync(mixedObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var self = this,
        vpState = self.viewPortState,
        gfxContainer = self['viewport-gfx-container'][0],
        htmlContainer = self['viewport-html-container'][0],
        vpHeightGfx = gfxContainer.clientHeight,
        vpHeightHtml = htmlContainer.clientHeight,
        gapY = vpState.gfx.gapY,
        scrollYGfx = null,
        elPageGfx = null,
        scrollYHtml = null,
        elPageHtml = null,
        $hlwords = null,
        $hlwordsX = null,
        $hlwordsY = null,
        hlword = null,
        rcWord = null;
    self.viewportValidate();

    if (self.isActive) {
      gfxContainer.deflectScrollEvent = true;
      htmlContainer.deflectScrollEvent = true; // Gfx

      if (elPageGfx = self['viewport-gfx-pages'][self.pageIDX]) {
        scrollYGfx = elPageGfx.offsetHeight < vpHeightGfx ? elPageGfx.offsetTop + 5 + Math.floor((elPageGfx.offsetHeight - vpHeightGfx) / 2.5) || 0 : elPageGfx.offsetTop - gapY || 0;
      } // HTML


      if (elPageHtml = vpState.html.pageSizes[self.pageIDX]) {
        scrollYHtml = elPageHtml.offsetHeight < vpHeightHtml ? elPageHtml.offsetTop + Math.floor((elPageHtml.offsetHeight - vpHeightHtml) / 2.5) || 0 : elPageHtml.offsetTop - gapY || 0;
      }

      $(gfxContainer).scrollTop(scrollYGfx);
      $(htmlContainer).scrollTop(scrollYHtml);

      if (vpState.viewMode === 'html' && (params.scrollToFirstHL || params.scrollToLastHL)) {
        $hlwordsX = $(self['viewport-html-pages'][self.pageIDX]);

        if (vpState.layoutMode === '1x1') {
          $hlwords = $hlwordsX;
        } else {
          $hlwordsY = $(self['viewport-html-pages'][self.pageIDY]);
          $hlwords = params.scrollToFirstHL ? $hlwordsX.add($hlwordsY) : $hlwordsY.add($hlwordsX);
        }

        hlword = params.scrollToFirstHL ? $hlwords.find('hlword').first()[0] : $hlwords.find('hlword').last()[0];

        if (hlword) {
          rcWord = hlword.getBoundingClientRect();

          if (rcWord.top - htmlContainer.scrollTop < 0 || rcWord.bottom - htmlContainer.scrollTop > htmlContainer.offsetHeight) {
            hlword.scrollHLIntoView(false, self['viewport-html-container'].get(0), false);
          } //$( hlword ).blink();

        }
      }

      self.viewportMarkCurrent();
      self.viewportLoadVisible();

      if (!self.resizeInProgress) {
        clearTimeout(vpState.timerDeflect);
        vpState.timerDeflect = setTimeout(function () {
          gfxContainer.deflectScrollEvent = false;
          htmlContainer.deflectScrollEvent = false;
        }, 0);
      }
    }

    self.syncTreeBox(mixedObj, params);
    self.syncSearchBox(mixedObj, params);
    self.syncPrintBox(mixedObj, params);
    self.syncControls(mixedObj, false, params);
  },

  /**
   * VALIDATE PAGE SIZES / LOADED IMAGES SCALE
   *
   * @returns {boolean}
   */
  viewportValidate: function viewportValidate() {
    var self = this,
        vpState = self.viewPortState;
    vpState.gfx.curw = Math.max(self['viewport-gfx-pages'][0].offsetWidth, self['viewport-gfx-pages'][1].offsetWidth, 1);
    vpState.gfx.realscale = Math.ceil(vpState.gfx.curw / vpState.gfx.defw * 100);
    vpState.gfx.scale = Math.ceil(vpState.gfx.realscale / 20) * 20;
    vpState.gfx.curminh = vpState.gfx.realscale * vpState.gfx.minh / 100;

    if (self['viewport-html-iframe-contents'] && !vpState.html.valid) {
      vpState.html.curw = Math.max(self['viewport-html-pages'][0].offsetWidth, self['viewport-html-pages'][1].offsetWidth, 1);
    }
  }
});
jQuery.extend(bookViewer.prototype, {
  /**
   * DETECT CURRENT PAGE(S)
   */
  viewportDetectCurrent: function viewportDetectCurrent() {
    var self = this,
        vpState = self.viewPortState,
        viewMode = vpState.viewMode,
        layoutMode = vpState.layoutMode,
        elContainer = self['viewport-' + viewMode + '-container'][0],
        cntHeight = elContainer.scrollHeight,
        vpHeight = elContainer.clientHeight,
        cntScrollY = elContainer.scrollTop,
        vpCenterY = vpHeight / 2,
        newIDX = -1,
        curPageFound = false,
        idxChunk = -1,
        curIDX = self.pageIDX,
        curIDY = self.pageIDY;
    if (!self.isActive) return;

    if (cntScrollY < vpHeight) {
      vpCenterY = vpHeight * 0.7 / 2 * (cntScrollY / vpHeight) + 10;
    } else if (cntScrollY > cntHeight - vpHeight * 2) {
      vpCenterY = vpHeight / 1.6 * (1.6 - (cntHeight - vpHeight - cntScrollY) / vpHeight) - 10;
    } else {
      vpCenterY = vpHeight / 3;
    }

    self['vp-center'].css({
      top: vpCenterY
    });

    if (viewMode === 'gfx') {
      for (idxChunk = 0; idxChunk < vpState.gfx.pageSizesChunks.length; idxChunk++) {
        var pagesChunk = vpState.gfx.pageSizesChunks[idxChunk];
        var chunkLast = pagesChunk[pagesChunk.length - 1];

        if (chunkLast.offsetTop + chunkLast.offsetHeight < cntScrollY + vpCenterY) {
          continue;
        }

        curPageFound = vpState.gfx.pageSizesChunks[idxChunk].some(function (gfxPage, pageIDX) {
          newIDX = gfxPage.rel;
          return gfxPage.offsetTop - 10 <= cntScrollY + vpCenterY && gfxPage.offsetTop + gfxPage.offsetHeight + 10 >= cntScrollY + vpCenterY;
        });
        if (curPageFound) break;
      }

      if (vpState.fixeven) {
        if (layoutMode === '2x1' && newIDX === 1) newIDX = 0;
      }
    } else if (viewMode === 'html') {
      for (idxChunk = 0; idxChunk < vpState.html.pageSizesChunks.length; idxChunk++) {
        var _pagesChunk = vpState.html.pageSizesChunks[idxChunk];
        var _chunkLast = _pagesChunk[_pagesChunk.length - 1];

        if (_chunkLast.offsetTop + _chunkLast.offsetHeight < cntScrollY + vpCenterY) {
          continue;
        }

        curPageFound = vpState.html.pageSizesChunks[idxChunk].some(function (htmlPage, pageIDX) {
          newIDX = htmlPage.rel;
          return htmlPage.offsetTop - 10 <= cntScrollY + vpCenterY && htmlPage.offsetTop + htmlPage.offsetHeight + 10 >= cntScrollY + vpCenterY;
        });
        if (curPageFound) break;
      }

      if (vpState.fixeven) {
        if (layoutMode === '2x1' && newIDX === 1) newIDX = 0;
        if (layoutMode === '1x1' && newIDX === 0) newIDX = 1;
      }
    }

    if (curPageFound) {
      self.pageIDX = newIDX;
      self.pageIDY = Math.min(layoutMode === '2x1' ? 1 + newIDX : newIDX, self.pageMAX - 1);
      self.infoBoxState.valid = false;
    }

    if (curIDX !== self.pageIDX || curIDY !== self.pageIDY || !curIDX * curIDY) {
      self.viewportMarkCurrent();
      self.viewportLoadVisible();
      self.syncControls(true);
      self.syncTreeBox();
      self.syncSearchBox();
      self.syncPrintBox();
    }
  },

  /**
   * MARK CURRENT PAGE(S)
   */
  viewportMarkCurrent: function viewportMarkCurrent() {
    var self = this,
        viewMode = self.viewPortState.viewMode;

    if (viewMode === 'gfx') {
      self.viewportGfxMarkCurrent();
      setTimeout(function () {
        self.viewportHtmlMarkCurrent();
      }, throttleDetectCurrent);
    }

    if (viewMode === 'html') {
      self.viewportHtmlMarkCurrent();
      setTimeout(function () {
        self.viewportGfxMarkCurrent();
      }, throttleDetectCurrent);
    }
  },
  viewportGfxMarkCurrent: function viewportGfxMarkCurrent() {
    var self = this,
        $pageEl,
        idxEl;
    requestAnimationFrame(function () {
      self['viewport-gfx-pages'].filter('.is-current').removeClass('is-current');

      for (idxEl = self.pageIDX; idxEl <= self.pageIDY; idxEl++) {
        $pageEl = $(self['viewport-gfx-pages'][idxEl]);
        $pageEl.addClass('is-current');
      }
    });
  },
  viewportHtmlMarkCurrent: function viewportHtmlMarkCurrent() {
    var self = this,
        $pageEl,
        idxEl;
    if (!self.viewPortState.html.loaded) return;
    requestAnimationFrame(function () {
      self['viewport-html-pages'].filter('.is-current').removeClass('is-current');

      for (idxEl = self.pageIDX; idxEl <= self.pageIDY; idxEl++) {
        $pageEl = $(self['viewport-html-pages'][idxEl]);
        $pageEl.addClass('is-current');
      }
    });
  }
});
/**
 * BOOK VIEWER -- SYNC CONTROLS / VALIDATE VIEWPORT / RESIZE HANDLING
 */

jQuery.extend(bookViewer.prototype, {
  viewportFocus: function viewportFocus(obj) {
    var self = obj,
        vpState = self.viewPortState;
    setTimeout(function () {
      self['viewport-' + vpState.viewMode + '-container'].focus();
    }, 300);
  },

  /**
   * GFX/HTML MODE SWITCH
   * @param mode
   */
  changeViewMode: function changeViewMode(mode) {
    var self = this,
        vpState = self.viewPortState,
        oldMode = vpState.viewMode;
    if (mode === oldMode && self.isActive) return false;
    vpState.viewMode = mode === 'html' && !vpState.viewModes[mode] ? 'gfx' : mode; // PRELOAD HTML IFRAME

    if (vpState.viewMode === 'html' && !vpState.html.loaded) {
      self.loadViewPortHTML();
    }

    if (vpState.viewMode === 'gfx' && !vpState.gfx.loaded) {
      vpState.gfx.loaded = true;
    }

    self.viewportResize(false, false, {
      src: 'viewport',
      action: 'changeMode',
      param: mode
    });
    self.uacSaveSettings();
  },

  /**
   * 1x1/2x1 MODE SWITCH
   * @param mode
   * @param force
   */
  changeLayoutMode: function changeLayoutMode(mode) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var noresize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var self = this,
        vpState = self.viewPortState;

    self._isInMobileMode();

    if (!force && vpState.layoutMode === mode || vpState.isMobile && mode === '2x1' || !vpState.layoutModes[mode] || self.resizeInProgress) return;
    vpState.layoutMode = mode;
    self.resizeInProgress = true;

    if (!noresize) {
      self.viewportResize(false, true, {
        src: 'viewport',
        action: 'changeLayout',
        param: mode
      });
    }

    self.uacSaveSettings();
  }
});
$(function () {
  var dlgCookie, selDlgCookie;
  if (!(dlgCookie = $(selDlgCookie = '[data-dialog="cookie-accept"]')).get(0)) return false;
  dlgCookie.on('click', '[data-action="acceptcookie"]', function (e) {
    var $this = $(e.target);
    jQuery.ajax({
      context: $this,
      type: 'POST',
      url: '/rpc/',
      data: {
        action: 'acceptcookie'
      }
    }).always(function (e) {}).done(function (e) {
      dlgCookie.removeClass('is-visible');
    }).fail(function (e) {});
  });
  setTimeout(function () {
    dlgCookie.addClass('is-visible');
  }, 100);
});
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*
* iziToast | v1.4.0
* http://izitoast.marcelodolce.com
* by Marcelo Dolce.
*/
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], factory(root));
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    module.exports = factory(root);
  } else {
    root.iziToast = factory(root);
  }
})(typeof global !== 'undefined' ? global : window || this.window || this.global, function (root) {
  'use strict'; //
  // Variables
  //

  var $iziToast = {},
      PLUGIN_NAME = 'iziToast',
      BODY = document.querySelector('body'),
      ISMOBILE = /Mobi/.test(navigator.userAgent),
      ISCHROME = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor),
      ISFIREFOX = typeof InstallTrigger !== 'undefined',
      ACCEPTSTOUCH = 'ontouchstart' in document.documentElement,
      POSITIONS = ['bottomRight', 'bottomLeft', 'bottomCenter', 'topRight', 'topLeft', 'topCenter', 'center'],
      THEMES = {
    info: {
      color: 'blue',
      icon: 'ico-info'
    },
    success: {
      color: 'green',
      icon: 'ico-success'
    },
    warning: {
      color: 'orange',
      icon: 'ico-warning'
    },
    error: {
      color: 'red',
      icon: 'ico-error'
    },
    question: {
      color: 'yellow',
      icon: 'ico-question'
    }
  },
      MOBILEWIDTH = 568,
      CONFIG = {};
  $iziToast.children = {}; // Default settings

  var defaults = {
    id: null,
    "class": '',
    title: '',
    titleColor: '',
    titleSize: '',
    titleLineHeight: '',
    message: '',
    messageColor: '',
    messageSize: '',
    messageLineHeight: '',
    backgroundColor: '',
    theme: 'light',
    // dark
    color: '',
    // blue, red, green, yellow
    icon: '',
    iconText: '',
    iconColor: '',
    iconUrl: null,
    image: '',
    imageWidth: 50,
    maxWidth: null,
    zindex: null,
    layout: 1,
    balloon: false,
    close: true,
    closeOnEscape: false,
    closeOnClick: false,
    displayMode: 0,
    position: 'bottomRight',
    // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter, center
    target: '',
    targetFirst: true,
    timeout: 5000,
    rtl: false,
    animateInside: true,
    drag: true,
    pauseOnHover: true,
    resetOnHover: false,
    progressBar: true,
    progressBarColor: '',
    progressBarEasing: 'linear',
    overlay: false,
    overlayClose: false,
    overlayColor: 'rgba(0, 0, 0, 0.6)',
    transitionIn: 'fadeInUp',
    // bounceInLeft, bounceInRight, bounceInUp, bounceInDown, fadeIn, fadeInDown, fadeInUp, fadeInLeft, fadeInRight, flipInX
    transitionOut: 'fadeOut',
    // fadeOut, fadeOutUp, fadeOutDown, fadeOutLeft, fadeOutRight, flipOutX
    transitionInMobile: 'fadeInUp',
    transitionOutMobile: 'fadeOutDown',
    buttons: {},
    inputs: {},
    onOpening: function onOpening() {},
    onOpened: function onOpened() {},
    onClosing: function onClosing() {},
    onClosed: function onClosed() {}
  }; //
  // Methods
  //

  /**
   * Polyfill for remove() method
   */

  if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  }
  /*
      * Polyfill for CustomEvent for IE >= 9
      * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
      */


  if (typeof window.CustomEvent !== 'function') {
    var CustomEventPolyfill = function CustomEventPolyfill(event, params) {
      params = params || {
        bubbles: false,
        cancelable: false,
        detail: undefined
      };
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
    };

    CustomEventPolyfill.prototype = window.Event.prototype;
    window.CustomEvent = CustomEventPolyfill;
  }
  /**
   * A simple forEach() implementation for Arrays, Objects and NodeLists
   * @private
   * @param {Array|Object|NodeList} collection Collection of items to iterate
   * @param {Function} callback Callback function for each iteration
   * @param {Array|Object|NodeList} scope Object/NodeList/Array that forEach is iterating over (aka `this`)
   */


  var forEach = function forEach(collection, callback) {
    var scope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (Object.prototype.toString.call(collection) === '[object Object]') {
      for (var prop in collection) {
        if (Object.prototype.hasOwnProperty.call(collection, prop)) {
          callback.call(scope, collection[prop], prop, collection);
        }
      }
    } else {
      if (collection) {
        for (var i = 0, len = collection.length; i < len; i++) {
          callback.call(scope, collection[i], i, collection);
        }
      }
    }
  };
  /**
   * Merge defaults with user options
   * @private
   * @param {Object} defaults Default settings
   * @param {Object} options User options
   * @returns {Object} Merged values of defaults and options
   */


  var extend = function extend(defaults, options) {
    var extended = {};
    forEach(defaults, function (value, prop) {
      extended[prop] = defaults[prop];
    });
    forEach(options, function (value, prop) {
      extended[prop] = options[prop];
    });
    return extended;
  };
  /**
   * Create a fragment DOM elements
   * @private
   */


  var createFragElem = function createFragElem(htmlStr) {
    var frag = document.createDocumentFragment(),
        temp = document.createElement('div');
    temp.innerHTML = htmlStr;

    while (temp.firstChild) {
      frag.appendChild(temp.firstChild);
    }

    return frag;
  };
  /**
   * Generate new ID
   * @private
   */


  var generateId = function generateId(params) {
    var newId = btoa(encodeURIComponent(params)); //newId = btoa ( String((Date.now ? Date.now() : new Date().getTime()) / 1000 ));

    return newId.replace(/=/g, "");
  };
  /**
   * Check if is a color
   * @private
   */


  var isColor = function isColor(color) {
    return color.substring(0, 1) === '#' || color.substring(0, 3) === 'rgb' || color.substring(0, 3) === 'hsl';
  };
  /**
   * Check if is a Base64 string
   * @private
   */


  var isBase64 = function isBase64(str) {
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  };
  /**
   * Drag method of toasts
   * @private
   */


  var drag = function () {
    return {
      move: function move(toast, instance, settings, xpos) {
        var opacity,
            opacityRange = 0.3,
            distance = 180;

        if (xpos !== 0) {
          toast.classList.add(PLUGIN_NAME + '-dragged');
          toast.style.transform = 'translateX(' + xpos + 'px)';

          if (xpos > 0) {
            opacity = (distance - xpos) / distance;

            if (opacity < opacityRange) {
              instance.hide(extend(settings, {
                transitionOut: 'fadeOutRight',
                transitionOutMobile: 'fadeOutRight'
              }), toast, 'drag');
            }
          } else {
            opacity = (distance + xpos) / distance;

            if (opacity < opacityRange) {
              instance.hide(extend(settings, {
                transitionOut: 'fadeOutLeft',
                transitionOutMobile: 'fadeOutLeft'
              }), toast, 'drag');
            }
          }

          toast.style.opacity = opacity;

          if (opacity < opacityRange) {
            if (ISCHROME || ISFIREFOX) toast.style.left = xpos + 'px';
            toast.parentNode.style.opacity = opacityRange;
            this.stopMoving(toast);
          }
        }
      },
      startMoving: function startMoving(toast, instance, settings, e) {
        e = e || window.event;
        var posX = ACCEPTSTOUCH ? e.touches[0].clientX : e.clientX,
            toastLeft = toast.style.transform.replace('px)', '');
        toastLeft = toastLeft.replace('translateX(', '');
        var offsetX = posX - toastLeft;

        if (settings.transitionIn) {
          toast.classList.remove(settings.transitionIn);
        }

        if (settings.transitionInMobile) {
          toast.classList.remove(settings.transitionInMobile);
        }

        toast.style.transition = '';

        if (ACCEPTSTOUCH) {
          document.ontouchmove = function (e) {
            e.preventDefault();
            e = e || window.event;
            var posX = e.touches[0].clientX,
                finalX = posX - offsetX;
            drag.move(toast, instance, settings, finalX);
          };
        } else {
          document.onmousemove = function (e) {
            e.preventDefault();
            e = e || window.event;
            var posX = e.clientX,
                finalX = posX - offsetX;
            drag.move(toast, instance, settings, finalX);
          };
        }
      },
      stopMoving: function stopMoving(toast) {
        if (ACCEPTSTOUCH) {
          document.ontouchmove = function () {};
        } else {
          document.onmousemove = function () {};
        }

        toast.style.opacity = '';
        toast.style.transform = '';

        if (toast.classList.contains(PLUGIN_NAME + '-dragged')) {
          toast.classList.remove(PLUGIN_NAME + '-dragged');
          toast.style.transition = 'transform 0.4s ease, opacity 0.4s ease';
          setTimeout(function () {
            toast.style.transition = '';
          }, 400);
        }
      }
    };
  }();

  $iziToast.setSetting = function (ref, option, value) {
    $iziToast.children[ref][option] = value;
  };

  $iziToast.getSetting = function (ref, option) {
    return $iziToast.children[ref][option];
  };
  /**
   * Destroy the current initialization.
   * @public
   */


  $iziToast.destroy = function () {
    forEach(document.querySelectorAll('.' + PLUGIN_NAME + '-overlay'), function (element) {
      element.remove();
    });
    forEach(document.querySelectorAll('.' + PLUGIN_NAME + '-wrapper'), function (element) {
      element.remove();
    });
    forEach(document.querySelectorAll('.' + PLUGIN_NAME), function (element) {
      element.remove();
    });
    this.children = {}; // Remove event listeners

    document.removeEventListener(PLUGIN_NAME + '-opened', {}, false);
    document.removeEventListener(PLUGIN_NAME + '-opening', {}, false);
    document.removeEventListener(PLUGIN_NAME + '-closing', {}, false);
    document.removeEventListener(PLUGIN_NAME + '-closed', {}, false);
    document.removeEventListener('keyup', {}, false); // Reset variables

    CONFIG = {};
  };
  /**
   * Initialize Plugin
   * @public
   * @param {Object} options User settings
   */


  $iziToast.settings = function (options) {
    // Destroy any existing initializations
    $iziToast.destroy();
    CONFIG = options;
    defaults = extend(defaults, options || {});
  };
  /**
   * Building themes functions.
   * @public
   * @param {Object} options User settings
   */


  forEach(THEMES, function (theme, name) {
    $iziToast[name] = function (options) {
      var settings = extend(CONFIG, options || {});
      settings = extend(theme, settings || {});
      this.show(settings);
    };
  });
  /**
   * Do the calculation to move the progress bar
   * @private
   */

  $iziToast.progress = function (options, $toast, callback) {
    var that = this,
        ref = $toast.getAttribute('data-iziToast-ref'),
        settings = extend(this.children[ref], options || {}),
        $elem = $toast.querySelector('.' + PLUGIN_NAME + '-progressbar div');
    return {
      start: function start() {
        if (typeof settings.time.REMAINING == 'undefined') {
          $toast.classList.remove(PLUGIN_NAME + '-reseted');

          if ($elem !== null) {
            $elem.style.transition = 'width ' + settings.timeout + 'ms ' + settings.progressBarEasing;
            $elem.style.width = '0%';
          }

          settings.time.START = new Date().getTime();
          settings.time.END = settings.time.START + settings.timeout;
          settings.time.TIMER = setTimeout(function () {
            clearTimeout(settings.time.TIMER);

            if (!$toast.classList.contains(PLUGIN_NAME + '-closing')) {
              that.hide(settings, $toast, 'timeout');

              if (typeof callback === 'function') {
                callback.apply(that);
              }
            }
          }, settings.timeout);
          that.setSetting(ref, 'time', settings.time);
        }
      },
      pause: function pause() {
        if (typeof settings.time.START !== 'undefined' && !$toast.classList.contains(PLUGIN_NAME + '-paused') && !$toast.classList.contains(PLUGIN_NAME + '-reseted')) {
          $toast.classList.add(PLUGIN_NAME + '-paused');
          settings.time.REMAINING = settings.time.END - new Date().getTime();
          clearTimeout(settings.time.TIMER);
          that.setSetting(ref, 'time', settings.time);

          if ($elem !== null) {
            var computedStyle = window.getComputedStyle($elem),
                propertyWidth = computedStyle.getPropertyValue('width');
            $elem.style.transition = 'none';
            $elem.style.width = propertyWidth;
          }

          if (typeof callback === 'function') {
            setTimeout(function () {
              callback.apply(that);
            }, 10);
          }
        }
      },
      resume: function resume() {
        if (typeof settings.time.REMAINING !== 'undefined') {
          $toast.classList.remove(PLUGIN_NAME + '-paused');

          if ($elem !== null) {
            $elem.style.transition = 'width ' + settings.time.REMAINING + 'ms ' + settings.progressBarEasing;
            $elem.style.width = '0%';
          }

          settings.time.END = new Date().getTime() + settings.time.REMAINING;
          settings.time.TIMER = setTimeout(function () {
            clearTimeout(settings.time.TIMER);

            if (!$toast.classList.contains(PLUGIN_NAME + '-closing')) {
              that.hide(settings, $toast, 'timeout');

              if (typeof callback === 'function') {
                callback.apply(that);
              }
            }
          }, settings.time.REMAINING);
          that.setSetting(ref, 'time', settings.time);
        } else {
          this.start();
        }
      },
      reset: function reset() {
        clearTimeout(settings.time.TIMER);
        delete settings.time.REMAINING;
        that.setSetting(ref, 'time', settings.time);
        $toast.classList.add(PLUGIN_NAME + '-reseted');
        $toast.classList.remove(PLUGIN_NAME + '-paused');

        if ($elem !== null) {
          $elem.style.transition = 'none';
          $elem.style.width = '100%';
        }

        if (typeof callback === 'function') {
          setTimeout(function () {
            callback.apply(that);
          }, 10);
        }
      }
    };
  };
  /**
   * Close the specific Toast
   * @public
   * @param {Object} options User settings
   * @param $toast
   * @param closedBy
   */


  $iziToast.hide = function (options, $toast, closedBy) {
    if (_typeof($toast) != 'object') {
      $toast = document.querySelector($toast ? $toast : '.' + PLUGIN_NAME);
    }

    if (!$toast) return false;
    var that = this,
        settings = extend(this.children[$toast.getAttribute('data-iziToast-ref')], options || {});
    settings.closedBy = closedBy || null;
    delete settings.time.REMAINING;
    $toast.classList.add(PLUGIN_NAME + '-closing'); // Overlay

    (function () {
      var $overlay = document.querySelector('.' + PLUGIN_NAME + '-overlay');

      if ($overlay !== null) {
        var refs = $overlay.getAttribute('data-iziToast-ref');
        refs = refs.split(',');
        var index = refs.indexOf(String(settings.ref));

        if (index !== -1) {
          refs.splice(index, 1);
        }

        $overlay.setAttribute('data-iziToast-ref', refs.join());

        if (refs.length === 0) {
          $overlay.classList.remove('fadeIn');
          $overlay.classList.add('fadeOut');
          setTimeout(function () {
            $overlay.remove();
          }, 700);
        }
      }
    })();

    if (settings.transitionIn) {
      $toast.classList.remove(settings.transitionIn);
    }

    if (settings.transitionInMobile) {
      $toast.classList.remove(settings.transitionInMobile);
    }

    if (ISMOBILE || window.innerWidth <= MOBILEWIDTH) {
      if (settings.transitionOutMobile) $toast.classList.add(settings.transitionOutMobile);
    } else {
      if (settings.transitionOut) $toast.classList.add(settings.transitionOut);
    }

    var H = $toast.parentNode.offsetHeight;
    $toast.parentNode.style.height = H + 'px';
    $toast.style.pointerEvents = 'none';

    if (!ISMOBILE || window.innerWidth > MOBILEWIDTH) {
      $toast.parentNode.style.transitionDelay = '0.2s';
    }

    try {
      var event = new CustomEvent(PLUGIN_NAME + '-closing', {
        detail: settings,
        bubbles: true,
        cancelable: true
      });
      document.dispatchEvent(event);
    } catch (ex) {
      console.warn(ex);
    }

    setTimeout(function () {
      $toast.parentNode.style.height = '0px';
      $toast.parentNode.style.overflow = '';
      setTimeout(function () {
        delete that.children[settings.ref];
        $toast.parentNode.remove();

        try {
          var event = new CustomEvent(PLUGIN_NAME + '-closed', {
            detail: settings,
            bubbles: true,
            cancelable: true
          });
          document.dispatchEvent(event);
        } catch (ex) {
          console.warn(ex);
        }

        if (typeof settings.onClosed !== 'undefined') {
          settings.onClosed.apply(null, [settings, $toast, closedBy]);
        }
      }, 1000);
    }, 200);

    if (typeof settings.onClosing !== 'undefined') {
      settings.onClosing.apply(null, [settings, $toast, closedBy]);
    }
  };
  /**
   * Create and show the Toast
   * @public
   * @param {Object} options User settings
   */


  $iziToast.show = function (options) {
    var that = this; // Merge user options with defaults

    var settings = extend(CONFIG, options || {});
    settings = extend(defaults, settings);
    settings.time = {};

    if (settings.id === null) {
      settings.id = generateId(settings.title + settings.message + settings.color);
    }

    if (settings.displayMode === 1 || settings.displayMode === 'once') {
      try {
        if (document.querySelectorAll('.' + PLUGIN_NAME + '#' + settings.id).length > 0) {
          return false;
        }
      } catch (exc) {
        console.warn('[' + PLUGIN_NAME + '] Could not find an element with this selector: ' + '#' + settings.id + '. Try to set an valid id.');
      }
    }

    if (settings.displayMode === 2 || settings.displayMode === 'replace') {
      //console.error( ( '.' + PLUGIN_NAME + '#' + settings.id ) );
      //console.warn(document.querySelectorAll( '.' + PLUGIN_NAME + '#' + settings.id ));
      //console.warn(document.querySelectorAll( '.' + PLUGIN_NAME + '#' + settings.id ));
      try {
        //forEach( document.querySelectorAll( '.' + PLUGIN_NAME + '#' + settings.id ), function ( element) {
        forEach(document.querySelectorAll('.' + PLUGIN_NAME
        /*+ '#' + settings.id*/
        ), function (element) {
          that.hide(settings, element, 'replaced');
        });
      } catch (exc) {
        console.warn('[' + PLUGIN_NAME + '] Could not find an element with this selector: ' + '#' + settings.id + '. Try to set an valid id.');
      }
    }

    settings.ref = new Date().getTime() + Math.floor(Math.random() * 10000000 + 1);
    $iziToast.children[settings.ref] = settings;
    var $DOM = {
      body: document.querySelector('body'),
      overlay: document.createElement('div'),
      toast: document.createElement('div'),
      toastBody: document.createElement('div'),
      toastTexts: document.createElement('div'),
      toastCapsule: document.createElement('div'),
      cover: document.createElement('div'),
      buttons: document.createElement('div'),
      inputs: document.createElement('div'),
      icon: !settings.iconUrl ? document.createElement('i') : document.createElement('img'),
      wrapper: null
    };
    $DOM.toast.setAttribute('data-iziToast-ref', settings.ref);
    $DOM.toast.appendChild($DOM.toastBody);
    $DOM.toastCapsule.appendChild($DOM.toast); // CSS Settings

    (function () {
      $DOM.toast.classList.add(PLUGIN_NAME);
      $DOM.toast.classList.add(PLUGIN_NAME + '-opening');
      $DOM.toastCapsule.classList.add(PLUGIN_NAME + '-capsule');
      $DOM.toastBody.classList.add(PLUGIN_NAME + '-body');
      $DOM.toastTexts.classList.add(PLUGIN_NAME + '-texts');

      if (ISMOBILE || window.innerWidth <= MOBILEWIDTH) {
        if (settings.transitionInMobile) $DOM.toast.classList.add(settings.transitionInMobile);
      } else {
        if (settings.transitionIn) $DOM.toast.classList.add(settings.transitionIn);
      }

      if (settings["class"]) {
        var classes = settings["class"].split(' ');
        forEach(classes, function (value) {
          $DOM.toast.classList.add(value);
        });
      }

      if (settings.id) {
        $DOM.toast.id = settings.id;
      }

      if (settings.rtl) {
        $DOM.toast.classList.add(PLUGIN_NAME + '-rtl');
        $DOM.toast.setAttribute('dir', 'rtl');
      }

      if (settings.layout > 1) {
        $DOM.toast.classList.add(PLUGIN_NAME + '-layout' + settings.layout);
      }

      if (settings.balloon) {
        $DOM.toast.classList.add(PLUGIN_NAME + '-balloon');
      }

      if (settings.maxWidth) {
        if (!isNaN(settings.maxWidth)) {
          $DOM.toast.style.maxWidth = settings.maxWidth + 'px';
        } else {
          $DOM.toast.style.maxWidth = settings.maxWidth;
        }
      }

      if (settings.theme !== '' || settings.theme !== 'light') {
        $DOM.toast.classList.add(PLUGIN_NAME + '-theme-' + settings.theme);
      }

      if (settings.color) {
        //#, rgb, rgba, hsl
        if (isColor(settings.color)) {
          $DOM.toast.style.background = settings.color;
        } else {
          $DOM.toast.classList.add(PLUGIN_NAME + '-color-' + settings.color);
        }
      }

      if (settings.backgroundColor) {
        $DOM.toast.style.background = settings.backgroundColor;

        if (settings.balloon) {
          $DOM.toast.style.borderColor = settings.backgroundColor;
        }
      }
    })(); // Cover image


    (function () {
      if (settings.image) {
        $DOM.cover.classList.add(PLUGIN_NAME + '-cover');
        $DOM.cover.style.width = settings.imageWidth + 'px';

        if (isBase64(settings.image.replace(/ /g, ''))) {
          $DOM.cover.style.backgroundImage = 'url(data:image/png;base64,' + settings.image.replace(/ /g, '') + ')';
        } else {
          $DOM.cover.style.backgroundImage = 'url(' + settings.image + ')';
        }

        if (settings.rtl) {
          $DOM.toastBody.style.marginRight = settings.imageWidth + 10 + 'px';
        } else {
          $DOM.toastBody.style.marginLeft = settings.imageWidth + 10 + 'px';
        }

        $DOM.toast.appendChild($DOM.cover);
      }
    })(); // Button close


    (function () {
      if (settings.close) {
        $DOM.buttonClose = document.createElement('button');
        $DOM.buttonClose.type = 'button';
        $DOM.buttonClose.classList.add(PLUGIN_NAME + '-close');
        $DOM.buttonClose.addEventListener('click', function (e) {
          that.hide(settings, $DOM.toast, 'button');
        });
        $DOM.toast.appendChild($DOM.buttonClose);
      } else {
        if (settings.rtl) {
          //$DOM.toast.style.paddingLeft = '18px';
          $DOM.toast.classList.add('no-close-button');
        } else {
          //$DOM.toast.style.paddingRight = '18px';
          $DOM.toast.classList.add('no-close-button');
        }
      }
    })(); // Progress Bar & Timeout


    (function () {
      if (settings.progressBar) {
        $DOM.progressBar = document.createElement('div');
        $DOM.progressBarDiv = document.createElement('div');
        $DOM.progressBar.classList.add(PLUGIN_NAME + '-progressbar');
        $DOM.progressBarDiv.style.background = settings.progressBarColor;
        $DOM.progressBar.appendChild($DOM.progressBarDiv);
        $DOM.toast.appendChild($DOM.progressBar);
      }

      if (settings.timeout) {
        if (settings.pauseOnHover && !settings.resetOnHover) {
          $DOM.toast.addEventListener('mouseenter', function () {
            that.progress(settings, $DOM.toast).pause();
          });
          $DOM.toast.addEventListener('mouseleave', function () {
            that.progress(settings, $DOM.toast).resume();
          });
        }

        if (settings.resetOnHover) {
          $DOM.toast.addEventListener('mouseenter', function () {
            that.progress(settings, $DOM.toast).reset();
          });
          $DOM.toast.addEventListener('mouseleave', function () {
            that.progress(settings, $DOM.toast).start();
          });
        }
      }
    })(); // Icon


    (function () {
      if (settings.iconUrl) {
        $DOM.icon.setAttribute('class', PLUGIN_NAME + '-icon');
        $DOM.icon.setAttribute('src', settings.iconUrl);
      } else if (settings.icon) {
        $DOM.icon.setAttribute('class', PLUGIN_NAME + '-icon ' + settings.icon);

        if (settings.iconText) {
          $DOM.icon.appendChild(document.createTextNode(settings.iconText));
        }

        if (settings.iconColor) {
          $DOM.icon.style.color = settings.iconColor;
        }
      }

      if (settings.icon || settings.iconUrl) {
        if (settings.rtl) {
          $DOM.toastBody.classList.add('has-icon'); //$DOM.toastBody.style.paddingRight = '33px';
        } else {
          $DOM.toastBody.classList.add('has-icon'); //$DOM.toastBody.style.paddingLeft = '33px';
        }

        $DOM.toastBody.appendChild($DOM.icon);
      }
    })(); // Title & Message


    (function () {
      if (settings.title.length > 0) {
        $DOM.strong = document.createElement('strong');
        $DOM.strong.classList.add(PLUGIN_NAME + '-title');
        $DOM.strong.appendChild(createFragElem(settings.title));
        $DOM.toastTexts.appendChild($DOM.strong);

        if (settings.titleColor) {
          $DOM.strong.style.color = settings.titleColor;
        }

        if (settings.titleSize) {
          if (!isNaN(settings.titleSize)) {
            $DOM.strong.style.fontSize = settings.titleSize + 'px';
          } else {
            $DOM.strong.style.fontSize = settings.titleSize;
          }
        }

        if (settings.titleLineHeight) {
          if (!isNaN(settings.titleSize)) {
            $DOM.strong.style.lineHeight = settings.titleLineHeight + 'px';
          } else {
            $DOM.strong.style.lineHeight = settings.titleLineHeight;
          }
        }
      }

      if (settings.message.length > 0) {
        $DOM.p = document.createElement('p');
        $DOM.p.classList.add(PLUGIN_NAME + '-message');
        $DOM.p.appendChild(createFragElem(settings.message));
        $DOM.toastTexts.appendChild($DOM.p);

        if (settings.messageColor) {
          $DOM.p.style.color = settings.messageColor;
        }

        if (settings.messageSize) {
          if (!isNaN(settings.titleSize)) {
            $DOM.p.style.fontSize = settings.messageSize + 'px';
          } else {
            $DOM.p.style.fontSize = settings.messageSize;
          }
        }

        if (settings.messageLineHeight) {
          if (!isNaN(settings.titleSize)) {
            $DOM.p.style.lineHeight = settings.messageLineHeight + 'px';
          } else {
            $DOM.p.style.lineHeight = settings.messageLineHeight;
          }
        }
      }

      if (settings.title.length > 0 && settings.message.length > 0) {
        if (settings.rtl) {
          $DOM.strong.style.marginLeft = '10px';
        } else if (settings.layout !== 2 && !settings.rtl) {
          $DOM.strong.style.marginRight = '10px';
        }
      }
    })();

    $DOM.toastBody.appendChild($DOM.toastTexts); // Inputs

    var $inputs;

    (function () {
      if (settings.inputs.length > 0) {
        $DOM.inputs.classList.add(PLUGIN_NAME + '-inputs');
        forEach(settings.inputs, function (value, index) {
          $DOM.inputs.appendChild(createFragElem(value[0]));
          $inputs = $DOM.inputs.childNodes;
          $inputs[index].classList.add(PLUGIN_NAME + '-inputs-child');

          if (value[3]) {
            setTimeout(function () {
              $inputs[index].focus();
            }, 300);
          }

          $inputs[index].addEventListener(value[1], function (e) {
            var ts = value[2];
            return ts(that, $DOM.toast, this, e);
          });
        });
        $DOM.toastBody.appendChild($DOM.inputs);
      }
    })(); // Buttons


    (function () {
      if (settings.buttons.length > 0) {
        $DOM.buttons.classList.add(PLUGIN_NAME + '-buttons');
        forEach(settings.buttons, function (value, index) {
          $DOM.buttons.appendChild(createFragElem(value[0]));
          var $btns = $DOM.buttons.childNodes;
          $btns[index].classList.add(PLUGIN_NAME + '-buttons-child');

          if (value[2]) {
            setTimeout(function () {
              $btns[index].focus();
            }, 300);
          }

          $btns[index].addEventListener('click', function (e) {
            e.preventDefault();
            var ts = value[1];
            return ts(that, $DOM.toast, this, e, $inputs);
          });
        });
      }

      $DOM.toastBody.appendChild($DOM.buttons);
    })();

    if (settings.message.length > 0 && (settings.inputs.length > 0 || settings.buttons.length > 0)) {
      $DOM.p.style.marginBottom = '0';
    }

    if (settings.inputs.length > 0 || settings.buttons.length > 0) {
      if (settings.rtl) {
        $DOM.toastTexts.style.marginLeft = '10px';
      } else {
        $DOM.toastTexts.style.marginRight = '10px';
      }

      if (settings.inputs.length > 0 && settings.buttons.length > 0) {
        if (settings.rtl) {
          $DOM.inputs.style.marginLeft = '8px';
        } else {
          $DOM.inputs.style.marginRight = '8px';
        }
      }
    } // Wrap


    (function () {
      $DOM.toastCapsule.style.visibility = 'hidden';
      setTimeout(function () {
        var H = $DOM.toast.offsetHeight;
        var style = $DOM.toast.currentStyle || window.getComputedStyle($DOM.toast);
        var marginTop = style.marginTop;
        marginTop = marginTop.split('px');
        marginTop = parseInt(marginTop[0]);
        var marginBottom = style.marginBottom;
        marginBottom = marginBottom.split('px');
        marginBottom = parseInt(marginBottom[0]);
        $DOM.toastCapsule.style.visibility = '';
        $DOM.toastCapsule.style.height = H + marginBottom + marginTop + 'px';
        setTimeout(function () {
          $DOM.toastCapsule.style.height = 'auto';

          if (settings.target) {
            $DOM.toastCapsule.style.overflow = 'visible';
          }
        }, 500);

        if (settings.timeout) {
          that.progress(settings, $DOM.toast).start();
        }
      }, 100);
    })(); // Target


    (function () {
      var position = settings.position;

      if (settings.target) {
        $DOM.wrapper = document.querySelector(settings.target);
        $DOM.wrapper.classList.add(PLUGIN_NAME + '-target');

        if (settings.targetFirst) {
          $DOM.wrapper.insertBefore($DOM.toastCapsule, $DOM.wrapper.firstChild);
        } else {
          $DOM.wrapper.appendChild($DOM.toastCapsule);
        }
      } else {
        if (POSITIONS.indexOf(settings.position) === -1) {
          console.warn('[' + PLUGIN_NAME + '] Incorrect position.\nIt can be › ' + POSITIONS);
          return;
        }

        if (ISMOBILE || window.innerWidth <= MOBILEWIDTH) {
          if (settings.position === 'bottomLeft' || settings.position === 'bottomRight' || settings.position === 'bottomCenter') {
            position = PLUGIN_NAME + '-wrapper-bottomCenter';
          } else if (settings.position === 'topLeft' || settings.position === 'topRight' || settings.position === 'topCenter') {
            position = PLUGIN_NAME + '-wrapper-topCenter';
          } else {
            position = PLUGIN_NAME + '-wrapper-center';
          }
        } else {
          position = PLUGIN_NAME + '-wrapper-' + position;
        }

        $DOM.wrapper = document.querySelector('.' + PLUGIN_NAME + '-wrapper.' + position);

        if (!$DOM.wrapper) {
          $DOM.wrapper = document.createElement('div');
          $DOM.wrapper.classList.add(PLUGIN_NAME + '-wrapper');
          $DOM.wrapper.classList.add(position);
          document.body.appendChild($DOM.wrapper);
        }

        if (settings.position === 'topLeft' || settings.position === 'topCenter' || settings.position === 'topRight') {
          $DOM.wrapper.insertBefore($DOM.toastCapsule, $DOM.wrapper.firstChild);
        } else {
          $DOM.wrapper.appendChild($DOM.toastCapsule);
        }
      }

      if (!isNaN(settings.zindex)) {
        $DOM.wrapper.style.zIndex = settings.zindex;
      } else {
        console.warn('[' + PLUGIN_NAME + '] Invalid zIndex.');
      }
    })(); // Overlay


    (function () {
      if (settings.overlay) {
        if (document.querySelector('.' + PLUGIN_NAME + '-overlay.fadeIn') !== null) {
          $DOM.overlay = document.querySelector('.' + PLUGIN_NAME + '-overlay');
          $DOM.overlay.setAttribute('data-iziToast-ref', $DOM.overlay.getAttribute('data-iziToast-ref') + ',' + settings.ref);

          if (!isNaN(settings.zindex) && settings.zindex !== null) {
            $DOM.overlay.style.zIndex = settings.zindex - 1;
          }
        } else {
          $DOM.overlay.classList.add(PLUGIN_NAME + '-overlay');
          $DOM.overlay.classList.add('fadeIn');
          $DOM.overlay.style.background = settings.overlayColor;
          $DOM.overlay.setAttribute('data-iziToast-ref', settings.ref);

          if (!isNaN(settings.zindex) && settings.zindex !== null) {
            $DOM.overlay.style.zIndex = settings.zindex - 1;
          }

          document.querySelector('body').appendChild($DOM.overlay);
        }

        if (settings.overlayClose) {
          $DOM.overlay.removeEventListener('click', {});
          $DOM.overlay.addEventListener('click', function () {
            that.hide(settings, $DOM.toast, 'overlay');
          });
        } else {
          $DOM.overlay.removeEventListener('click', {});
        }
      }
    })(); // Inside animations


    (function () {
      if (settings.animateInside) {
        $DOM.toast.classList.add(PLUGIN_NAME + '-animateInside');
        var animationTimes = [200, 100, 300];

        if (settings.transitionIn === 'bounceInLeft' || settings.transitionIn === 'bounceInRight') {
          animationTimes = [400, 200, 400];
        }

        if (settings.title.length > 0) {
          setTimeout(function () {
            $DOM.strong.classList.add('slideIn');
          }, animationTimes[0]);
        }

        if (settings.message.length > 0) {
          setTimeout(function () {
            $DOM.p.classList.add('slideIn');
          }, animationTimes[1]);
        }

        if (settings.icon || settings.iconUrl) {
          setTimeout(function () {
            $DOM.icon.classList.add('revealIn');
          }, animationTimes[2]);
        }

        var counter = 150;

        if (settings.buttons.length > 0 && $DOM.buttons) {
          setTimeout(function () {
            forEach($DOM.buttons.childNodes, function (element) {
              setTimeout(function () {
                element.classList.add('revealIn');
              }, counter);
              counter = counter + 150;
            });
          }, settings.inputs.length > 0 ? 150 : 0);
        }

        if (settings.inputs.length > 0 && $DOM.inputs) {
          counter = 150;
          forEach($DOM.inputs.childNodes, function (element) {
            setTimeout(function () {
              element.classList.add('revealIn');
            }, counter);
            counter = counter + 150;
          });
        }
      }
    })();

    settings.onOpening.apply(null, [settings, $DOM.toast]);

    try {
      var event = new CustomEvent(PLUGIN_NAME + '-opening', {
        detail: settings,
        bubbles: true,
        cancelable: true
      });
      document.dispatchEvent(event);
    } catch (ex) {
      console.warn(ex);
    }

    setTimeout(function () {
      $DOM.toast.classList.remove(PLUGIN_NAME + '-opening');
      $DOM.toast.classList.add(PLUGIN_NAME + '-opened');

      try {
        var event = new CustomEvent(PLUGIN_NAME + '-opened', {
          detail: settings,
          bubbles: true,
          cancelable: true
        });
        document.dispatchEvent(event);
      } catch (ex) {
        console.warn(ex);
      }

      settings.onOpened.apply(null, [settings, $DOM.toast]);
    }, 1000);

    if (settings.drag) {
      if (ACCEPTSTOUCH) {
        $DOM.toast.addEventListener('touchstart', function (e) {
          drag.startMoving(this, that, settings, e);
        }, false);
        $DOM.toast.addEventListener('touchend', function () {
          drag.stopMoving(this);
        }, false);
      } else {
        $DOM.toast.addEventListener('mousedown', function (e) {
          e.preventDefault();
          drag.startMoving(this, that, settings, e);
        }, false);
        $DOM.toast.addEventListener('mouseup', function (e) {
          e.preventDefault();
          drag.stopMoving(this);
        }, false);
      }
    }

    if (settings.closeOnEscape) {
      document.addEventListener('keyup', function (evt) {
        evt = evt || window.event;

        if (evt.keyCode === 27) {
          that.hide(settings, $DOM.toast, 'esc');
        }
      });
    }

    if (settings.closeOnClick) {
      $DOM.toast.addEventListener('click', function () {
        that.hide(settings, $DOM.toast, 'toast');
      });
    }

    that.toast = $DOM.toast;
  };

  return $iziToast;
});
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (root, factory) {
  // support loading the plugin via common patterns
  if (typeof define === 'function' && define.amd) {
    // load the plugin as an amd module
    define(['jquery'], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && module.exports) {
    // load the plugin as a commonjs module
    module.exports = factory(require('jquery'));
  } else {
    // load the plugin as a global
    factory(root.jQuery);
  }
})(this, function ($) {
  // useful private variables
  var $document = $(document),
      $window = $(window),
      $body = $('body'); // constants

  var DATA_DISPLAYCONTROLLER = 'displayController',
      DATA_HASACTIVEHOVER = 'hasActiveHover',
      DATA_FORCEDOPEN = 'forcedOpen',
      DATA_HASMOUSEMOVE = 'hasMouseMove',
      DATA_MOUSEONTOTIP = 'mouseOnToPopup',
      DATA_ORIGINALTITLE = 'originalTitle',
      DATA_POWERTIP = 'powertip',
      DATA_POWERTIPJQ = 'powertipjq',
      DATA_POWERTIPTARGET = 'powertiptarget',
      EVENT_NAMESPACE = '.powertip',
      RAD2DEG = 180 / Math.PI,
      MOUSE_EVENTS = ['click', 'dblclick', 'mousedown', 'mouseup', 'mousemove', 'mouseover', 'mouseout', 'mouseenter', 'mouseleave', 'contextmenu'];
  /**
   * Session data
   * Private properties global to all powerTip instances
   */

  var session = {
    elements: null,
    tooltips: null,
    isTipOpen: false,
    isFixedTipOpen: false,
    isClosing: false,
    tipOpenImminent: false,
    activeHover: null,
    currentX: 0,
    currentY: 0,
    previousX: 0,
    previousY: 0,
    desyncTimeout: null,
    closeDelayTimeout: null,
    mouseTrackingActive: false,
    delayInProgress: false,
    windowWidth: 0,
    windowHeight: 0,
    scrollTop: 0,
    scrollLeft: 0
  };
  /**
   * Collision enumeration
   * @enum {number}
   */

  var Collision = {
    none: 0,
    top: 1,
    bottom: 2,
    left: 4,
    right: 8
  };
  /**
   * Display hover tooltips on the matched elements.
   * @param {(Object|string)=} opts The options object to use for the plugin, or
   *     the name of a method to invoke on the first matched element.
   * @param {*=} [arg] Argument for an invoked method (optional).
   * @return {jQuery} jQuery object for the matched selectors.
   */

  $.fn.powerTip = function (opts, arg) {
    var targetElements = this,
        options,
        tipController; // don't do any work if there were no matched elements

    if (!targetElements.length) {
      return targetElements;
    } // handle api method calls on the plugin, e.g. powerTip('hide')


    if ($.type(opts) === 'string' && $.powerTip[opts]) {
      return $.powerTip[opts].call(targetElements, targetElements, arg);
    } // extend options


    options = $.extend({}, $.fn.powerTip.defaults, opts); // handle repeated powerTip calls on the same element by destroying any
    // original instance hooked to it and replacing it with this call

    $.powerTip.destroy(targetElements); // instantiate the TooltipController for this instance

    tipController = new TooltipController(options); // hook mouse and viewport dimension tracking

    initTracking(); // setup the elements

    targetElements.each(function elementSetup() {
      var $this = $(this),
          dataPowertip = $this.data(DATA_POWERTIP),
          dataElem = $this.data(DATA_POWERTIPJQ),
          dataTarget = $this.data(DATA_POWERTIPTARGET),
          title = $this.attr('title'); // attempt to use title attribute text if there is no data-powertip,
      // data-powertipjq or data-powertiptarget. If we do use the title
      // attribute, delete the attribute so the browser will not show it

      if (!dataPowertip && !dataTarget && !dataElem && title) {
        $this.data(DATA_POWERTIP, title);
        $this.data(DATA_ORIGINALTITLE, title);
        $this.removeAttr('title');
      } // create hover controllers for each element


      $this.data(DATA_DISPLAYCONTROLLER, new DisplayController($this, options, tipController));
    }); // attach events to matched elements if the manual option is not enabled

    if (!options.manual) {
      // attach open events
      $.each(options.openEvents, function (idx, evt) {
        if ($.inArray(evt, options.closeEvents) > -1) {
          // event is in both openEvents and closeEvents, so toggle it
          targetElements.on(evt + EVENT_NAMESPACE, function elementToggle(event) {
            $.powerTip.toggle(this, event);
          });
        } else {
          targetElements.on(evt + EVENT_NAMESPACE, function elementOpen(event) {
            $.powerTip.show(this, event);
          });
        }
      }); // attach close events

      $.each(options.closeEvents, function (idx, evt) {
        if ($.inArray(evt, options.openEvents) < 0) {
          targetElements.on(evt + EVENT_NAMESPACE, function elementClose(event) {
            // set immediate to true for any event without mouse info
            $.powerTip.hide(this, !isMouseEvent(event));
          });
        }
      }); // attach escape key close event

      targetElements.on('keydown' + EVENT_NAMESPACE, function elementKeyDown(event) {
        // always close tooltip when the escape key is pressed
        if (event.keyCode === 27) {
          $.powerTip.hide(this, true);
        }
      });
    } // remember elements that the plugin is attached to


    session.elements = session.elements ? session.elements.add(targetElements) : targetElements;
    return targetElements;
  };
  /**
   * Default options for the powerTip plugin.
   */


  $.fn.powerTip.defaults = {
    fadeInTime: 200,
    fadeOutTime: 100,
    followMouse: false,
    popupId: 'powerTip',
    popupClass: null,
    intentSensitivity: 7,
    intentPollInterval: 100,
    closeDelay: 100,
    placement: 'n',
    smartPlacement: false,
    offset: 10,
    mouseOnToPopup: false,
    manual: false,
    noDesyncCheck: false,
    openEvents: ['mouseenter', 'focus'],
    closeEvents: ['mouseleave', 'blur']
  };
  /**
   * Default smart placement priority lists.
   * The first item in the array is the highest priority, the last is the lowest.
   * The last item is also the default, which will be used if all previous options
   * do not fit.
   */

  $.fn.powerTip.smartPlacementLists = {
    n: ['n', 'ne', 'nw', 's'],
    e: ['e', 'ne', 'se', 'w', 'nw', 'sw', 'n', 's', 'e'],
    s: ['s', 'se', 'sw', 'n'],
    w: ['w', 'nw', 'sw', 'e', 'ne', 'se', 'n', 's', 'w'],
    nw: ['nw', 'w', 'sw', 'n', 's', 'se', 'nw'],
    ne: ['ne', 'e', 'se', 'n', 's', 'sw', 'ne'],
    sw: ['sw', 'w', 'nw', 's', 'n', 'ne', 'sw'],
    se: ['se', 'e', 'ne', 's', 'n', 'nw', 'se'],
    'nw-alt': ['nw-alt', 'n', 'ne-alt', 'sw-alt', 's', 'se-alt', 'w', 'e'],
    'ne-alt': ['ne-alt', 'n', 'nw-alt', 'se-alt', 's', 'sw-alt', 'e', 'w'],
    'sw-alt': ['sw-alt', 's', 'se-alt', 'nw-alt', 'n', 'ne-alt', 'w', 'e'],
    'se-alt': ['se-alt', 's', 'sw-alt', 'ne-alt', 'n', 'nw-alt', 'e', 'w']
  };
  /**
   * Public API
   */

  $.powerTip = {
    /**
     * Attempts to show the tooltip for the specified element.
     * @param {jQuery|Element} element The element to open the tooltip for.
     * @param {jQuery.Event=} event jQuery event for hover intent and mouse
     *     tracking (optional).
     * @return {jQuery|Element} The original jQuery object or DOM Element.
     */
    show: function apiShowTip(element, event) {
      // if we were given a mouse event then run the hover intent testing,
      // otherwise, simply show the tooltip asap
      if (isMouseEvent(event)) {
        trackMouse(event);
        session.previousX = event.pageX;
        session.previousY = event.pageY;
        $(element).data(DATA_DISPLAYCONTROLLER).show();
      } else {
        $(element).first().data(DATA_DISPLAYCONTROLLER).show(true, true);
      }

      return element;
    },

    /**
     * Repositions the tooltip on the element.
     * @param {jQuery|Element} element The element the tooltip is shown for.
     * @return {jQuery|Element} The original jQuery object or DOM Element.
     */
    reposition: function apiResetPosition(element) {
      $(element).first().data(DATA_DISPLAYCONTROLLER).resetPosition();
      return element;
    },

    /**
     * Attempts to close any open tooltips.
     * @param {(jQuery|Element)=} element The element with the tooltip that
     *     should be closed (optional).
     * @param {boolean=} immediate Disable close delay (optional).
     * @return {jQuery|Element|undefined} The original jQuery object or DOM
     *     Element, if one was specified.
     */
    hide: function apiCloseTip(element, immediate) {
      var displayController; // set immediate to true when no element is specified

      immediate = element ? immediate : true; // find the relevant display controller

      if (element) {
        displayController = $(element).first().data(DATA_DISPLAYCONTROLLER);
      } else if (session.activeHover) {
        displayController = session.activeHover.data(DATA_DISPLAYCONTROLLER);
      } // if found, hide the tip


      if (displayController) {
        displayController.hide(immediate);
      }

      return element;
    },

    /**
     * Toggles the tooltip for the specified element. This will open a closed
     * tooltip, or close an open tooltip.
     * @param {jQuery|Element} element The element with the tooltip that
     *     should be toggled.
     * @param {jQuery.Event=} event jQuery event for hover intent and mouse
     *     tracking (optional).
     * @return {jQuery|Element} The original jQuery object or DOM Element.
     */
    toggle: function apiToggle(element, event) {
      if (session.activeHover && session.activeHover.is(element)) {
        // tooltip for element is active, so close it
        $.powerTip.hide(element, !isMouseEvent(event));
      } else {
        // tooltip for element is not active, so open it
        $.powerTip.show(element, event);
      }

      return element;
    },

    /**
     * Destroy and roll back any powerTip() instance on the specified elements.
     * If no elements are specified then all elements that the plugin is
     * currently attached to will be rolled back.
     * @param {(jQuery|Element)=} element The element with the powerTip instance.
     * @return {jQuery|Element|undefined} The original jQuery object or DOM
     *     Element, if one was specified.
     */
    destroy: function apiDestroy(element) {
      var $element = element ? $(element) : session.elements; // if the plugin is not hooked to any elements then there is no point
      // trying to destroy anything, or dealing with the possible errors

      if (!session.elements || session.elements.length === 0) {
        return element;
      } // if a tooltip is currently open for an element we are being asked to
      // destroy then it should be forced to close


      if (session.isTipOpen && !session.isClosing && $element.filter(session.activeHover).length > 0) {
        // if the tooltip is waiting to close then cancel that delay timer
        if (session.delayInProgress) {
          session.activeHover.data(DATA_DISPLAYCONTROLLER).cancel();
        } // hide the tooltip, immediately


        $.powerTip.hide(session.activeHover, true);
      } // unhook events and destroy plugin changes to each element


      $element.off(EVENT_NAMESPACE).each(function destroy() {
        var $this = $(this),
            dataAttributes = [DATA_ORIGINALTITLE, DATA_DISPLAYCONTROLLER, DATA_HASACTIVEHOVER, DATA_FORCEDOPEN]; // revert title attribute

        if ($this.data(DATA_ORIGINALTITLE)) {
          $this.attr('title', $this.data(DATA_ORIGINALTITLE));
          dataAttributes.push(DATA_POWERTIP);
        } // remove data attributes


        $this.removeData(dataAttributes);
      }); // remove destroyed element from active elements collection

      session.elements = session.elements.not($element); // if there are no active elements left then we will unhook all of the
      // events that we've bound code to and remove the tooltip elements

      if (session.elements.length === 0) {
        $window.off(EVENT_NAMESPACE);
        $document.off(EVENT_NAMESPACE);
        session.mouseTrackingActive = false;
        session.tooltips.remove();
        session.tooltips = null;
      }

      return element;
    }
  }; // API aliasing

  $.powerTip.showTip = $.powerTip.show;
  $.powerTip.closeTip = $.powerTip.hide;
  /**
   * Creates a new CSSCoordinates object.
   * @private
   * @constructor
   */

  function CSSCoordinates() {
    var me = this; // initialize object properties

    me.top = 'auto';
    me.left = 'auto';
    me.right = 'auto';
    me.bottom = 'auto';
    /**
     * Set a property to a value.
     * @private
     * @param {string} property The name of the property.
     * @param {number} value The value of the property.
     */

    me.set = function (property, value) {
      if ($.isNumeric(value)) {
        me[property] = Math.round(value);
      }
    };
  }
  /**
   * Creates a new tooltip display controller.
   * @private
   * @constructor
   * @param {jQuery} element The element that this controller will handle.
   * @param {Object} options Options object containing settings.
   * @param {TooltipController} tipController The TooltipController object for
   *     this instance.
   */


  function DisplayController(element, options, tipController) {
    var hoverTimer = null,
        myCloseDelay = null;
    /**
     * Begins the process of showing a tooltip.
     * @private
     * @param {boolean=} immediate Skip intent testing (optional).
     * @param {boolean=} forceOpen Ignore cursor position and force tooltip to
     *     open (optional).
     */

    function openTooltip(immediate, forceOpen) {
      cancelTimer();

      if (!element.data(DATA_HASACTIVEHOVER)) {
        if (!immediate) {
          session.tipOpenImminent = true;
          hoverTimer = setTimeout(function intentDelay() {
            hoverTimer = null;
            checkForIntent();
          }, options.intentPollInterval);
        } else {
          if (forceOpen) {
            element.data(DATA_FORCEDOPEN, true);
          }

          closeAnyDelayed();
          tipController.showTip(element);
        }
      } else {
        // cursor left and returned to this element, cancel close
        cancelClose();
      }
    }
    /**
     * Begins the process of closing a tooltip.
     * @private
     * @param {boolean=} disableDelay Disable close delay (optional).
     */


    function closeTooltip(disableDelay) {
      // if this instance already has a close delay in progress then halt it
      //console.log(myCloseDelay);
      if (myCloseDelay) {
        myCloseDelay = session.closeDelayTimeout = clearTimeout(myCloseDelay);
        session.delayInProgress = false;
      }

      cancelTimer();
      session.tipOpenImminent = false;

      if (element.data(DATA_HASACTIVEHOVER)) {
        element.data(DATA_FORCEDOPEN, false);

        if (!disableDelay) {
          session.delayInProgress = true;
          session.closeDelayTimeout = setTimeout(function closeDelay() {
            session.closeDelayTimeout = null;
            tipController.hideTip(element);
            session.delayInProgress = false;
            myCloseDelay = null;
          }, options.closeDelay); // save internal reference close delay id so we can check if the
          // active close delay belongs to this instance

          myCloseDelay = session.closeDelayTimeout;
        } else {
          tipController.hideTip(element);
        }
      }
    }
    /**
     * Checks mouse position to make sure that the user intended to hover on the
     * specified element before showing the tooltip.
     * @private
     */


    function checkForIntent() {
      // calculate mouse position difference
      var xDifference = Math.abs(session.previousX - session.currentX),
          yDifference = Math.abs(session.previousY - session.currentY),
          totalDifference = xDifference + yDifference; // check if difference has passed the sensitivity threshold

      if (totalDifference < options.intentSensitivity) {
        cancelClose();
        closeAnyDelayed();
        tipController.showTip(element);
      } else {
        // try again
        session.previousX = session.currentX;
        session.previousY = session.currentY;
        openTooltip();
      }
    }
    /**
     * Cancels active hover timer.
     * @private
     * @param {boolean=} stopClose Cancel any active close delay timer.
     */


    function cancelTimer(stopClose) {
      hoverTimer = clearTimeout(hoverTimer); // cancel the current close delay if the active close delay is for this
      // element or the stopClose argument is true

      if (session.closeDelayTimeout && myCloseDelay === session.closeDelayTimeout || stopClose) {
        cancelClose();
      }
    }
    /**
     * Cancels any active close delay timer.
     * @private
     */


    function cancelClose() {
      session.closeDelayTimeout = clearTimeout(session.closeDelayTimeout);
      session.delayInProgress = false;
    }
    /**
     * Asks any tooltips waiting on their close delay to close now.
     * @private
     */


    function closeAnyDelayed() {
      // if another element is waiting for its close delay then we should ask
      // it to close immediately so we can proceed without unexpected timeout
      // code being run during this tooltip's lifecycle
      if (session.delayInProgress && session.activeHover && !session.activeHover.is(element)) {
        session.activeHover.data(DATA_DISPLAYCONTROLLER).hide(true);
      }
    }
    /**
     * Repositions the tooltip on this element.
     * @private
     */


    function repositionTooltip() {
      tipController.resetPosition(element);
    } // expose the methods


    this.show = openTooltip;
    this.hide = closeTooltip;
    this.cancel = cancelTimer;
    this.resetPosition = repositionTooltip;
  }
  /**
   * Creates a new Placement Calculator.
   * @private
   * @constructor
   */


  function PlacementCalculator() {
    /**
     * Compute the CSS position to display a tooltip at the specified placement
     * relative to the specified element.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     * @param {string} placement The placement for the tooltip.
     * @param {number} tipWidth Width of the tooltip element in pixels.
     * @param {number} tipHeight Height of the tooltip element in pixels.
     * @param {number} offset Distance to offset tooltips in pixels.
     * @return {CSSCoordinates} A CSSCoordinates object with the position.
     */
    function computePlacementCoords(element, placement, tipWidth, tipHeight, offset) {
      var placementBase = placement.split('-')[0],
          // ignore 'alt' for corners
      coords = new CSSCoordinates(),
          position;

      if (isSvgElement(element)) {
        position = getSvgPlacement(element, placementBase);
      } else {
        position = getHtmlPlacement(element, placementBase);
      } // calculate the appropriate x and y position in the document


      switch (placement) {
        case 'n':
          coords.set('left', position.left - tipWidth / 2);
          coords.set('bottom', session.windowHeight - position.top + offset);
          break;

        case 'e':
          coords.set('left', position.left + offset);
          coords.set('top', position.top - tipHeight / 2);
          break;

        case 's':
          coords.set('left', position.left - tipWidth / 2);
          coords.set('top', position.top + offset);
          break;

        case 'w':
          coords.set('top', position.top - tipHeight / 2);
          coords.set('right', session.windowWidth - position.left + offset);
          break;

        case 'nw':
          coords.set('bottom', session.windowHeight - position.top + offset);
          coords.set('right', session.windowWidth - position.left - 20);
          break;

        case 'nw-alt':
          coords.set('left', position.left);
          coords.set('bottom', session.windowHeight - position.top + offset);
          break;

        case 'ne':
          coords.set('left', position.left - 20);
          coords.set('bottom', session.windowHeight - position.top + offset);
          break;

        case 'ne-alt':
          coords.set('bottom', session.windowHeight - position.top + offset);
          coords.set('right', session.windowWidth - position.left);
          break;

        case 'sw':
          coords.set('top', position.top + offset);
          coords.set('right', session.windowWidth - position.left - 20);
          break;

        case 'sw-alt':
          coords.set('left', position.left);
          coords.set('top', position.top + offset);
          break;

        case 'se':
          coords.set('left', position.left - 20);
          coords.set('top', position.top + offset);
          break;

        case 'se-alt':
          coords.set('top', position.top + offset);
          coords.set('right', session.windowWidth - position.left);
          break;
      }

      return coords;
    }
    /**
     * Finds the tooltip attachment point in the document for a HTML DOM element
     * for the specified placement.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     * @param {string} placement The placement for the tooltip.
     * @return {Object} An object with the top,left position values.
     */


    function getHtmlPlacement(element, placement) {
      var objectOffset = element.offset(),
          objectWidth = element.outerWidth(),
          objectHeight = element.outerHeight(),
          left,
          top; // calculate the appropriate x and y position in the document

      switch (placement) {
        case 'n':
          left = objectOffset.left + objectWidth / 2;
          top = objectOffset.top;
          break;

        case 'e':
          left = objectOffset.left + objectWidth;
          top = objectOffset.top + objectHeight / 2;
          break;

        case 's':
          left = objectOffset.left + objectWidth / 2;
          top = objectOffset.top + objectHeight;
          break;

        case 'w':
          left = objectOffset.left;
          top = objectOffset.top + objectHeight / 2;
          break;

        case 'nw':
          left = objectOffset.left;
          top = objectOffset.top;
          break;

        case 'ne':
          left = objectOffset.left + objectWidth;
          top = objectOffset.top;
          break;

        case 'sw':
          left = objectOffset.left;
          top = objectOffset.top + objectHeight;
          break;

        case 'se':
          left = objectOffset.left + objectWidth;
          top = objectOffset.top + objectHeight;
          break;
      }

      return {
        top: top,
        left: left
      };
    }
    /**
     * Finds the tooltip attachment point in the document for a SVG element for
     * the specified placement.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     * @param {string} placement The placement for the tooltip.
     * @return {Object} An object with the top,left position values.
     */


    function getSvgPlacement(element, placement) {
      var svgElement = element.closest('svg')[0],
          domElement = element[0],
          point = svgElement.createSVGPoint(),
          boundingBox = domElement.getBBox(),
          matrix = domElement.getScreenCTM(),
          halfWidth = boundingBox.width / 2,
          halfHeight = boundingBox.height / 2,
          placements = [],
          placementKeys = ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'],
          coords,
          rotation,
          steps,
          x;
      /**
       * Transform and append the current points to the placements list.
       * @private
       */

      function pushPlacement() {
        placements.push(point.matrixTransform(matrix));
      } // get bounding box corners and midpoints


      point.x = boundingBox.x;
      point.y = boundingBox.y;
      pushPlacement();
      point.x += halfWidth;
      pushPlacement();
      point.x += halfWidth;
      pushPlacement();
      point.y += halfHeight;
      pushPlacement();
      point.y += halfHeight;
      pushPlacement();
      point.x -= halfWidth;
      pushPlacement();
      point.x -= halfWidth;
      pushPlacement();
      point.y -= halfHeight;
      pushPlacement(); // determine rotation

      if (placements[0].y !== placements[1].y || placements[0].x !== placements[7].x) {
        rotation = Math.atan2(matrix.b, matrix.a) * RAD2DEG;
        steps = Math.ceil((rotation % 360 - 22.5) / 45);

        if (steps < 1) {
          steps += 8;
        }

        while (steps--) {
          placementKeys.push(placementKeys.shift());
        }
      } // find placement


      for (x = 0; x < placements.length; x++) {
        if (placementKeys[x] === placement) {
          coords = placements[x];
          break;
        }
      }

      return {
        top: coords.y + session.scrollTop,
        left: coords.x + session.scrollLeft
      };
    } // expose methods


    this.compute = computePlacementCoords;
  }
  /**
   * Creates a new tooltip controller.
   * @private
   * @constructor
   * @param {Object} options Options object containing settings.
   */


  function TooltipController(options) {
    var placementCalculator = new PlacementCalculator(),
        tipElement = $('#' + options.popupId); // build and append tooltip div if it does not already exist

    if (tipElement.length === 0) {
      tipElement = $('<div/>', {
        id: options.popupId
      }); // grab body element if it was not populated when the script loaded
      // note: this hack exists solely for jsfiddle support

      if ($body.length === 0) {
        $body = $('body');
      }

      $body.append(tipElement); // remember the tooltip elements that the plugin has created

      session.tooltips = session.tooltips ? session.tooltips.add(tipElement) : tipElement;
    } // hook mousemove for cursor follow tooltips


    if (options.followMouse) {
      // only one positionTipOnCursor hook per tooltip element, please
      if (!tipElement.data(DATA_HASMOUSEMOVE)) {
        $document.on('mousemove' + EVENT_NAMESPACE, positionTipOnCursor);
        $window.on('scroll' + EVENT_NAMESPACE, positionTipOnCursor);
        tipElement.data(DATA_HASMOUSEMOVE, true);
      }
    }
    /**
     * Gives the specified element the active-hover state and queues up the
     * showTip function.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     */


    function beginShowTip(element) {
      element.data(DATA_HASACTIVEHOVER, true); // show tooltip, asap

      tipElement.queue(function queueTipInit(next) {
        showTip(element);
        next();
      });
    }
    /**
     * Shows the tooltip, as soon as possible.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     */


    function showTip(element) {
      var tipContent; // it is possible, especially with keyboard navigation, to move on to
      // another element with a tooltip during the queue to get to this point
      // in the code. if that happens then we need to not proceed or we may
      // have the fadeout callback for the last tooltip execute immediately
      // after this code runs, causing bugs.

      if (!element.data(DATA_HASACTIVEHOVER)) {
        return;
      } // if the tooltip is open and we got asked to open another one then the
      // old one is still in its fadeOut cycle, so wait and try again


      if (session.isTipOpen) {
        if (!session.isClosing) {
          hideTip(session.activeHover);
        }

        tipElement.delay(100).queue(function queueTipAgain(next) {
          showTip(element);
          next();
        });
        return;
      } // trigger powerTipPreRender event


      element.trigger('powerTipPreRender'); // set tooltip content

      tipContent = getTooltipContent(element);

      if (tipContent) {
        tipElement.empty().append(tipContent);
      } else {
        // we have no content to display, give up
        return;
      } // trigger powerTipRender event


      element.trigger('powerTipRender');
      session.activeHover = element;
      session.isTipOpen = true;
      tipElement.data(DATA_MOUSEONTOTIP, options.mouseOnToPopup); // add custom class to tooltip element

      tipElement.addClass(options.popupClass); // set tooltip position
      // revert to static placement when the "force open" flag was set because
      // that flag means that we do not have accurate mouse position info

      if (!options.followMouse || element.data(DATA_FORCEDOPEN)) {
        positionTipOnElement(element);
        session.isFixedTipOpen = true;
      } else {
        positionTipOnCursor();
      } // close tooltip when clicking anywhere on the page, with the exception
      // of the tooltip's trigger element and any elements that are within a
      // tooltip that has 'mouseOnToPopup' option enabled
      // always enable this feature when the "force open" flag is set on a
      // followMouse tooltip because we reverted to static placement above


      if (!element.data(DATA_FORCEDOPEN) && !options.followMouse) {
        $document.on('click' + EVENT_NAMESPACE, function documentClick(event) {
          var target = event.target;

          if (target !== element[0]) {
            if (options.mouseOnToPopup) {
              if (target !== tipElement[0] && !$.contains(tipElement[0], target)) {
                $.powerTip.hide();
              }
            } else {
              $.powerTip.hide();
            }
          }
        });
      } // if we want to be able to mouse on to the tooltip then we need to
      // attach hover events to the tooltip that will cancel a close request
      // on mouseenter and start a new close request on mouseleave
      // only hook these listeners if we're not in manual mode


      if (options.mouseOnToPopup && !options.manual) {
        tipElement.on('mouseenter' + EVENT_NAMESPACE, function tipMouseEnter() {
          // check activeHover in case the mouse cursor entered the
          // tooltip during the fadeOut and close cycle
          if (session.activeHover) {
            session.activeHover.data(DATA_DISPLAYCONTROLLER).cancel();
          }
        });
        tipElement.on('mouseleave' + EVENT_NAMESPACE, function tipMouseLeave() {
          // check activeHover in case the mouse cursor left the tooltip
          // during the fadeOut and close cycle
          if (session.activeHover) {
            session.activeHover.data(DATA_DISPLAYCONTROLLER).hide();
          }
        });
      } // fadein


      tipElement.fadeIn(options.fadeInTime, function fadeInCallback() {
        // start desync polling
        if (!session.desyncTimeout && !options.noDesyncCheck) {
          session.desyncTimeout = setInterval(closeDesyncedTip, 500);
        } // trigger powerTipOpen event


        element.trigger('powerTipOpen');
      });
    }
    /**
     * Hides the tooltip.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     */


    function hideTip(element) {
      // reset session
      session.isClosing = true;
      session.isTipOpen = false; // stop desync polling

      session.desyncTimeout = clearInterval(session.desyncTimeout); // reset element state

      element.data(DATA_HASACTIVEHOVER, false);
      element.data(DATA_FORCEDOPEN, false); // remove document click handler

      $document.off('click' + EVENT_NAMESPACE); // unbind the mouseOnToPopup events if they were set

      tipElement.off(EVENT_NAMESPACE); // fade out

      tipElement.fadeOut(options.fadeOutTime, function fadeOutCallback() {
        var coords = new CSSCoordinates(); // reset session and tooltip element

        session.activeHover = null;
        session.isClosing = false;
        session.isFixedTipOpen = false;
        tipElement.removeClass(); // support mouse-follow and fixed position tips at the same time by
        // moving the tooltip to the last cursor location after it is hidden

        coords.set('top', session.currentY + options.offset);
        coords.set('left', session.currentX + options.offset);
        tipElement.css(coords); // trigger powerTipClose event

        element.trigger('powerTipClose');
      });
    }
    /**
     * Moves the tooltip to the users mouse cursor.
     * @private
     */


    function positionTipOnCursor() {
      var tipWidth, tipHeight, coords, collisions, collisionCount; // to support having fixed tooltips on the same page as cursor tooltips,
      // where both instances are referencing the same tooltip element, we
      // need to keep track of the mouse position constantly, but we should
      // only set the tip location if a fixed tip is not currently open, a tip
      // open is imminent or active, and the tooltip element in question does
      // have a mouse-follow using it.

      if (!session.isFixedTipOpen && (session.isTipOpen || session.tipOpenImminent && tipElement.data(DATA_HASMOUSEMOVE))) {
        // grab measurements
        tipWidth = tipElement.outerWidth();
        tipHeight = tipElement.outerHeight();
        coords = new CSSCoordinates(); // grab collisions

        coords.set('top', session.currentY + options.offset);
        coords.set('left', session.currentX + options.offset);
        collisions = getViewportCollisions(coords, tipWidth, tipHeight); // handle tooltip view port collisions

        if (collisions !== Collision.none) {
          collisionCount = countFlags(collisions);

          if (collisionCount === 1) {
            // if there is only one collision (bottom or right) then
            // simply constrain the tooltip to the view port
            if (collisions === Collision.right) {
              coords.set('left', session.scrollLeft + session.windowWidth - tipWidth);
            } else if (collisions === Collision.bottom) {
              coords.set('top', session.scrollTop + session.windowHeight - tipHeight);
            }
          } else {
            // if the tooltip has more than one collision then it is
            // trapped in the corner and should be flipped to get it out
            // of the users way
            coords.set('left', session.currentX - tipWidth - options.offset);
            coords.set('top', session.currentY - tipHeight - options.offset);
          }
        } // position the tooltip


        tipElement.css(coords);
      }
    }
    /**
     * Sets the tooltip to the correct position relative to the specified target
     * element. Based on options settings.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     */


    function positionTipOnElement(element) {
      var priorityList, finalPlacement; // when the followMouse option is enabled and the "force open" flag is
      // set we revert to static positioning. since the developer may not have
      // considered this scenario we should use smart placement

      if (options.smartPlacement || options.followMouse && element.data(DATA_FORCEDOPEN)) {
        priorityList = $.fn.powerTip.smartPlacementLists[options.placement]; // iterate over the priority list and use the first placement option
        // that does not collide with the view port. if they all collide
        // then the last placement in the list will be used.

        $.each(priorityList, function (idx, pos) {
          // place tooltip and find collisions
          var collisions = getViewportCollisions(placeTooltip(element, pos), tipElement.outerWidth(), tipElement.outerHeight()); // update the final placement variable

          finalPlacement = pos; // break if there were no collisions

          return collisions !== Collision.none;
        });
      } else {
        // if we're not going to use the smart placement feature then just
        // compute the coordinates and do it
        placeTooltip(element, options.placement);
        finalPlacement = options.placement;
      } // add placement as class for CSS arrows


      tipElement.removeClass('w nw sw e ne se n s w se-alt sw-alt ne-alt nw-alt');
      tipElement.addClass(finalPlacement);
    }
    /**
     * Sets the tooltip position to the appropriate values to show the tip at
     * the specified placement. This function will iterate and test the tooltip
     * to support elastic tooltips.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     * @param {string} placement The placement for the tooltip.
     * @return {CSSCoordinates} A CSSCoordinates object with the top, left, and
     *     right position values.
     */


    function placeTooltip(element, placement) {
      var iterationCount = 0,
          tipWidth,
          tipHeight,
          coords = new CSSCoordinates(); // set the tip to 0,0 to get the full expanded width

      coords.set('top', 0);
      coords.set('left', 0);
      tipElement.css(coords); // to support elastic tooltips we need to check for a change in the
      // rendered dimensions after the tooltip has been positioned

      do {
        // grab the current tip dimensions
        tipWidth = tipElement.outerWidth();
        tipHeight = tipElement.outerHeight(); // get placement coordinates

        coords = placementCalculator.compute(element, placement, tipWidth, tipHeight, options.offset); // place the tooltip

        tipElement.css(coords);
      } while ( // sanity check: limit to 5 iterations, and...
      ++iterationCount <= 5 && ( // try again if the dimensions changed after placement
      tipWidth !== tipElement.outerWidth() || tipHeight !== tipElement.outerHeight()));

      return coords;
    }
    /**
     * Checks for a tooltip desync and closes the tooltip if one occurs.
     * @private
     */


    function closeDesyncedTip() {
      var isDesynced = false,
          hasDesyncableCloseEvent = $.grep(['mouseleave', 'mouseout', 'blur', 'focusout'], function (eventType) {
        return $.inArray(eventType, options.closeEvents) !== -1;
      }).length > 0; // It is possible for the mouse cursor to leave an element without
      // firing the mouseleave or blur event. This most commonly happens when
      // the element is disabled under mouse cursor. If this happens it will
      // result in a desynced tooltip because the tooltip was never asked to
      // close. So we should periodically check for a desync situation and
      // close the tip if such a situation arises.

      if (session.isTipOpen && !session.isClosing && !session.delayInProgress && hasDesyncableCloseEvent) {
        if (session.activeHover.data(DATA_HASACTIVEHOVER) === false || session.activeHover.is(':disabled')) {
          // user moused onto another tip or active hover is disabled
          isDesynced = true;
        } else if (!isMouseOver(session.activeHover) && !session.activeHover.is(':focus') && !session.activeHover.data(DATA_FORCEDOPEN)) {
          // hanging tip - have to test if mouse position is not over the
          // active hover and not over a tooltip set to let the user
          // interact with it.
          // for keyboard navigation: this only counts if the element does
          // not have focus.
          // for tooltips opened via the api: we need to check if it has
          // the forcedOpen flag.
          if (tipElement.data(DATA_MOUSEONTOTIP)) {
            if (!isMouseOver(tipElement)) {
              isDesynced = true;
            }
          } else {
            isDesynced = true;
          }
        }

        if (isDesynced) {
          // close the desynced tip
          hideTip(session.activeHover);
        }
      }
    } // expose methods


    this.showTip = beginShowTip;
    this.hideTip = hideTip;
    this.resetPosition = positionTipOnElement;
  }
  /**
   * Determine whether a jQuery object is an SVG element
   * @private
   * @param {jQuery} element The element to check
   * @return {boolean} Whether this is an SVG element
   */


  function isSvgElement(element) {
    return Boolean(window.SVGElement && element[0] instanceof SVGElement);
  }
  /**
   * Determines if the specified jQuery.Event object has mouse data.
   * @private
   * @param {jQuery.Event=} event The jQuery.Event object to test.
   * @return {boolean} True if there is mouse data, otherwise false.
   */


  function isMouseEvent(event) {
    return Boolean(event && $.inArray(event.type, MOUSE_EVENTS) > -1 && typeof event.pageX === 'number');
  }
  /**
   * Initializes the viewport dimension cache and hooks up the mouse position
   * tracking and viewport dimension tracking events.
   * Prevents attaching the events more than once.
   * @private
   */


  function initTracking() {
    if (!session.mouseTrackingActive) {
      session.mouseTrackingActive = true; // grab the current viewport dimensions on load

      getViewportDimensions();
      $(getViewportDimensions); // hook mouse move tracking

      $document.on('mousemove' + EVENT_NAMESPACE, trackMouse); // hook viewport dimensions tracking

      $window.on('resize' + EVENT_NAMESPACE, trackResize);
      $window.on('scroll' + EVENT_NAMESPACE, trackScroll);
    }
  }
  /**
   * Updates the viewport dimensions cache.
   * @private
   */


  function getViewportDimensions() {
    session.scrollLeft = $window.scrollLeft();
    session.scrollTop = $window.scrollTop();
    session.windowWidth = $window.width();
    session.windowHeight = $window.height();
  }
  /**
   * Updates the window size info in the viewport dimensions cache.
   * @private
   */


  function trackResize() {
    session.windowWidth = $window.width();
    session.windowHeight = $window.height();
  }
  /**
   * Updates the scroll offset info in the viewport dimensions cache.
   * @private
   */


  function trackScroll() {
    var x = $window.scrollLeft(),
        y = $window.scrollTop();

    if (x !== session.scrollLeft) {
      session.currentX += x - session.scrollLeft;
      session.scrollLeft = x;
    }

    if (y !== session.scrollTop) {
      session.currentY += y - session.scrollTop;
      session.scrollTop = y;
    }
  }
  /**
   * Saves the current mouse coordinates to the session object.
   * @private
   * @param {jQuery.Event} event The mousemove event for the document.
   */


  function trackMouse(event) {
    session.currentX = event.pageX;
    session.currentY = event.pageY;
  }
  /**
   * Tests if the mouse is currently over the specified element.
   * @private
   * @param {jQuery} element The element to check for hover.
   * @return {boolean} True if the mouse is over the element, otherwise false.
   */


  function isMouseOver(element) {
    // use getBoundingClientRect() because jQuery's width() and height()
    // methods do not work with SVG elements
    // compute width/height because those properties do not exist on the object
    // returned by getBoundingClientRect() in older versions of IE
    var elementPosition = element.offset(),
        elementBox = element[0].getBoundingClientRect(),
        elementWidth = elementBox.right - elementBox.left,
        elementHeight = elementBox.bottom - elementBox.top;
    return session.currentX >= elementPosition.left && session.currentX <= elementPosition.left + elementWidth && session.currentY >= elementPosition.top && session.currentY <= elementPosition.top + elementHeight;
  }
  /**
   * Fetches the tooltip content from the specified element's data attributes.
   * @private
   * @param {jQuery} element The element to get the tooltip content for.
   * @return {(string|jQuery|undefined)} The text/HTML string, jQuery object, or
   *     undefined if there was no tooltip content for the element.
   */


  function getTooltipContent(element) {
    var tipText = element.data(DATA_POWERTIP),
        tipObject = element.data(DATA_POWERTIPJQ),
        tipTarget = element.data(DATA_POWERTIPTARGET),
        targetElement,
        content;

    if (tipText) {
      if ($.isFunction(tipText)) {
        tipText = tipText.call(element[0]);
      }

      content = tipText;
    } else if (tipObject) {
      if ($.isFunction(tipObject)) {
        tipObject = tipObject.call(element[0]);
      }

      if (tipObject.length > 0) {
        content = tipObject.clone(true, true);
      }
    } else if (tipTarget) {
      targetElement = $(tipTarget);

      if (targetElement.length > 0) {
        content = targetElement.html();
      } else {
        targetElement = $('#' + tipTarget);

        if (targetElement.length > 0) {
          content = targetElement.html();
        }
      }
    }

    return content;
  }
  /**
   * Finds any viewport collisions that an element (the tooltip) would have if it
   * were absolutely positioned at the specified coordinates.
   * @private
   * @param {CSSCoordinates} coords Coordinates for the element.
   * @param {number} elementWidth Width of the element in pixels.
   * @param {number} elementHeight Height of the element in pixels.
   * @return {number} Value with the collision flags.
   */


  function getViewportCollisions(coords, elementWidth, elementHeight) {
    var margin = 0,
        viewportTop = session.scrollTop + margin,
        viewportLeft = session.scrollLeft + margin,
        viewportBottom = viewportTop + session.windowHeight - margin * 2,
        viewportRight = viewportLeft + session.windowWidth - margin * 2,
        collisions = Collision.none;

    if (coords.top < viewportTop || Math.abs(coords.bottom - session.windowHeight) - elementHeight < viewportTop) {
      collisions |= Collision.top;
    }

    if (coords.top + elementHeight > viewportBottom || Math.abs(coords.bottom - session.windowHeight) > viewportBottom) {
      collisions |= Collision.bottom;
    }

    if (coords.left < viewportLeft || coords.right + elementWidth > viewportRight) {
      collisions |= Collision.left;
    }

    if (coords.left + elementWidth > viewportRight || coords.right < viewportLeft) {
      collisions |= Collision.right;
    }

    return collisions;
  }
  /**
   * Counts the number of bits set on a flags value.
   * @param {number} value The flags value.
   * @return {number} The number of bits that have been set.
   */


  function countFlags(value) {
    var count = 0;

    while (value) {
      value &= value - 1;
      count++;
    }

    return count;
  } // return api for commonjs and amd environments


  return $.powerTip;
});
// https://raw.githubusercontent.com/robextrem/materialize-validation/master/js/materialize-validation.js
(function ($) {
  $.fn.materialvalidation = function (options) {
    return this.each(function () {
      var element = $(this); // Return early if this element already has a plugin instance

      if (element.data('materialvalidation')) {
        return;
      } // pass options to plugin constructor


      var myplugin = new materialvalidation(this, options); // Store plugin object in this element's data

      element.data('materialvalidation', myplugin);
      element.data().materialvalidation.methods.init();
    });
  };

  var materialvalidation = function materialvalidation(target, options) {
    var componentObj = {
      defaultText: '',
      fields: "fieldset,select,textarea,input[type=checkbox],input[type=text],input[type=email],input[type=number],input[type=password],input[type=search],input[type=tel],input[type=datetime-local],input[type=date],input[type=url]",
      parentContainer: false,
      html5materialvalidationon: true,
      errorClass: 'input-error',
      okClass: 'input-ok',
      notification: false,
      methods: {
        init: function init() {
          var $target = $(target);

          if (options !== undefined) {
            if (options.notification !== undefined) {
              componentObj.notification = options.notification;
            }

            if (options.errorClass !== undefined) {
              componentObj.errorClass = options.errorClass;
            }

            if (options.parentContainer !== undefined) {
              componentObj.parentContainer = options.parentContainer;
            }
          }

          $target.find(componentObj.fields).each(function (i, e) {
            var elField = $(e),
                $this = $(this);
            elField.data().order = i;

            if (elField.data().content === undefined) {
              elField.data("content", componentObj.defaultText);
              elField.attr("data-content", componentObj.defaultText);
            }

            elField.on("focus", function () {
              $this.removeClass(componentObj.errorClass);
              $this.removeClass(componentObj.okClass);
            });
          });
        },
        reset: function reset() {
          var $target = $(target);
          $target.find(componentObj.fields).removeClass(componentObj.errorClass);
          $target.find(componentObj.fields).removeClass(componentObj.okClass);
        },
        validate: function validate() {
          var $target = $(target),
              formvalid = true;
          $target.find(componentObj.fields).each(function (i, e) {
            var valid = true,
                elCheck = $(e),
                elVal = elCheck.val();
            if (elCheck.prop("disabled")) return true;
            var dataVal = elCheck.data("validation");
            if (!dataVal) return;
            var data_validation_ext = dataVal.split(':'),
                data_validation = data_validation_ext[0],
                data_param = data_validation_ext[1];
            if (elCheck.data().optional && elVal.length < 1) return true;

            switch (data_validation) {
              case "empty":
                {
                  if (elVal.trim().length > 0) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "nonempty":
                {
                  if (!elVal.trim().length) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "text":
                {
                  if (!componentObj.methods.isText(elVal.trim())) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case 'minlen':
                {
                  if (elVal.trim().length < Number(data_param)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case 'emptyorminlen':
                {
                  if (elVal.trim().length > 0 && elVal.trim().length < Number(data_param)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "alphanumeric":
                {
                  if (!componentObj.methods.isAlphaNumeric(elVal.trim())) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "zip":
                {
                  if (!componentObj.methods.isCP(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "email":
                {
                  if (!componentObj.methods.isEmail(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "phone":
                {
                  if (!componentObj.methods.isPhone(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "numericonly":
                {
                  if (!componentObj.methods.isNumeric(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "numericonlynozero":
                {
                  if (!componentObj.methods.isNumeric(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  if (elVal <= 0) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "numericorempty":
                {
                  if (elVal !== "") {
                    if (!componentObj.methods.isNumeric(elVal.trim())) {
                      valid = false;
                      formvalid = false;
                    }
                  }

                  break;
                }

              case "address":
                {
                  if (!componentObj.methods.isAddress(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "password":
                {
                  if (!componentObj.methods.isPassword(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "domain":
                {
                  if (!componentObj.methods.isDomain(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "url":
                {
                  if (!componentObj.methods.isURL(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "date":
                {
                  if (!componentObj.methods.isDate(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "samepassword":
                {
                  if (elVal === "") {
                    valid = false;
                    formvalid = false;
                  }

                  if (elVal !== $(".samepassword2").val()) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "select":
                {
                  valid = !!elVal;
                  break;
                }

              case "checked":
                {
                  valid = componentObj.methods.isChecked(e);
                }
            }

            if (!valid) {
              if (componentObj.parentContainer) {
                elCheck.parent().addClass(componentObj.errorClass);
              } else {
                elCheck.addClass(componentObj.errorClass);
                elCheck.removeClass(componentObj.okClass);
              }

              if (componentObj.notification) {
                window.alert(elCheck.data().content);
              } //$( "html, body" ).animate( { scrollTop: elCheck.offset().top - 105 }, 500, function () {
              //$(e).focus();
              //} );
              //return valid;

            } else {
              elCheck.removeClass(componentObj.errorClass).addClass(componentObj.okClass);
            }
          });
          return formvalid;
        },
        isEmail: function isEmail(email) {
          var patternMail = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);
          return patternMail.test(email);
        },
        isDomain: function isDomain(domain) {
          var patternDomain = new RegExp(/^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/);
          return domain.match(patternDomain);
        },
        isText: function isText(name) {
          if (name === "") return false;
          var patternName = new RegExp(/^[a-zA-ZÁÉÍÓÚáéíóúñÑ ]+$/);
          return patternName.test(name);
        },
        isAlphaNumeric: function isAlphaNumeric(name) {
          if (name === "") return false;
          var patternName = new RegExp(/^[a-z0-9]+$/i);
          return patternName.test(name);
        },
        isPhone: function isPhone(phone) {
          var patternPhone = new RegExp(/^\d{10}$/);
          return patternPhone.test(phone);
        },
        isCP: function isCP(cp) {
          var patternCP = new RegExp(/^[0-9]+$/);
          return patternCP.test(cp) && cp.length === 5;
        },
        isDate: function isDate(date) {
          var patternDate = new RegExp(/[0-9]{4}[-][0-9]{2}[-][0-9]{2}$/);
          return patternDate.test(date);
        },
        isNumeric: function isNumeric(n) {
          return !isNaN(parseFloat(n)) && isFinite(n);
        },
        isPassword: function isPassword(password) {
          var re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])\w{8,}$/;
          return re.test(password);
        },
        isAddress: function isAddress(addr) {
          var patternAddress = new RegExp(/^[a-zA-Zа-яА-Я0-9ÁÉÍÓÚáéíóúñÑ\-().,# ]+$/);
          return patternAddress.test(addr);
        },
        isURL: function isURL(url) {
          var regex = /^(ht|f)tps?:\/\/\w+([.\-\w]+)?\.([a-z]{2,4}|travel)(:\d{2,5})?(\/.*)?$/i;
          return regex.test(url);
        },
        isChecked: function isChecked(c) {
          return $(c).is(":checked");
        }
      }
    };
    return componentObj;
  };
})(jQuery);
$(function () {
  removeQueryStringParam('realm');
  iziToastInit();
  realmInit(); // CHECK IF WE NEED  AND SHOW IZITOAST

  $(function () {
    var $objRealm = $('[data-realm]');
    if (!$objRealm.get(0)) return false;
    $objRealm = JSON.parse($objRealm.html());
    if (!$objRealm.message) return false;
    setTimeout(function () {
      iziToast.show({
        title: $objRealm.title,
        message: $objRealm.message,
        icon: 'ico-' + $objRealm.icon,
        "class": 'color-' + $objRealm["class"],
        timeout: 5000
      });
    }, 500);
  });
  /**
   * INIT IZITOAST
   * @returns {boolean}
   */

  function iziToastInit() {
    if (window.iziInitDone) return false;
    iziToast.settings({
      closeOnClick: true,
      close: true,
      position: 'bottomCenter',
      animateInside: false,
      transitionIn: 'fadeInUp',
      transitionOut: 'fadeOutDown',
      transitionInMobile: 'fadeInUp',
      transitionOutMobile: 'fadeOutDown',
      timeout: 5000,
      progressBar: false,
      displayMode: 'replace',
      theme: 'dark'
    });
    window.iziInitDone = true;
  }
  /**
   * READ AND STORE REALMS
   * @returns {boolean}
   */


  function realmInit() {
    if (window.realms) return false;
    var $objRealms = $('[data-realms]');
    if (!$objRealms.get(0)) return false;
    $objRealms = JSON.parse($objRealms.html());
    if (!$objRealms) return false;
    window.realms = $objRealms;
  }
  /**
   * REMOVE QUERYSTRING PARAM
   *
   * @param key
   * @param returnURL
   * @returns {boolean}
   */


  function removeQueryStringParam(key, returnURL) {
    if (typeof URLSearchParams == 'undefined') return false;
    var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
        urlQueryString = document.location.search,
        newURL = baseUrl;
    var params = new URLSearchParams(urlQueryString);
    params["delete"](key);
    params = params.toString();
    newURL = params.length ? [baseUrl, params].join('?') : newURL;
    return returnURL ? newURL : window.history.replaceState({}, '', newURL);
  }
});
/**
 * Created by dagan on 07/04/2014.
 * Updated by Roman "JJam" Koksharoff on 2019-05-10
 * Original Source: https://github.com/ofirdagan/cross-domain-local-storage
 */
'use strict';

window.XdUtils = window.XdUtils || function () {
  function extend(object, defaultObject) {
    var result = defaultObject || {};
    var key;

    for (key in object) {
      if (object.hasOwnProperty(key)) {
        result[key] = object[key];
      }
    }

    return result;
  } //public interface


  return {
    extend: extend
  };
}();

window.xdLocalStorage = window.xdLocalStorage || function () {
  var MESSAGE_NAMESPACE = 'mathedu-cross-domain-local-message';
  var options = {
    iframeId: 'mathedu-cross-domain-iframe',
    iframeUrl: undefined,
    initCallback: function initCallback() {}
  };
  var requestId = -1;
  var iframe;
  var requests = {};
  var _wasInit = false;
  var iframeReady = true;

  function applyCallback(data) {
    if (requests[data.id]) {
      requests[data.id](data);
      delete requests[data.id];
    }
  }

  function receiveMessage(event) {
    var data;

    try {
      data = JSON.parse(event.data);
    } catch (err) {//not our message, can ignore
    }

    if (data && data.namespace === MESSAGE_NAMESPACE) {
      if (data.id === 'iframe-ready') {
        iframeReady = true;
        options.initCallback();
      } else {
        applyCallback(data);
      }
    }
  }

  function buildMessage(action, key, value, callback) {
    requestId++;
    requests[requestId] = callback;
    var data = {
      namespace: MESSAGE_NAMESPACE,
      id: requestId,
      action: action,
      key: key,
      value: value
    };

    try {
      iframe.contentWindow.postMessage(JSON.stringify(data), '*');
    } catch (E) {}
  }

  function _init(customOptions) {
    options = XdUtils.extend(customOptions, options);
    var temp = document.createElement('div');

    if (window.addEventListener) {
      window.addEventListener('message', receiveMessage, false);
    } else {
      window.attachEvent('onmessage', receiveMessage);
    }

    temp.innerHTML = '<iframe id="' + options.iframeId + '" src="' + options.iframeUrl + '" style="display: none;"></iframe>';
    document.body.appendChild(temp);
    iframe = document.getElementById(options.iframeId);
  }

  function isApiReady() {
    if (!_wasInit) {
      return false;
    }

    if (!iframeReady) {
      return false;
    }

    return true;
  }

  function isDomReady() {
    return document.readyState === 'complete';
  }

  return {
    //callback is optional for cases you use the api before window load.
    init: function init(customOptions) {
      if (!customOptions.iframeUrl) {
        throw 'You must specify iframeUrl';
      }

      if (_wasInit) {
        return;
      }

      _wasInit = true;

      if (isDomReady()) {
        _init(customOptions);
      } else {
        if (document.addEventListener) {
          // All browsers expect IE < 9
          document.addEventListener('readystatechange', function () {
            if (isDomReady()) {
              _init(customOptions);
            }
          });
        } else {
          // IE < 9
          document.attachEvent('readystatechange', function () {
            if (isDomReady()) {
              _init(customOptions);
            }
          });
        }
      }
    },
    setItem: function setItem(key, value, callback) {
      if (!isApiReady()) {
        return;
      }

      buildMessage('set', key, value, callback);
    },
    getItem: function getItem(key, callback) {
      if (!isApiReady()) {
        return;
      }

      buildMessage('get', key, null, callback);
    },
    removeItem: function removeItem(key, callback) {
      if (!isApiReady()) {
        return;
      }

      buildMessage('remove', key, null, callback);
    },
    key: function key(index, callback) {
      if (!isApiReady()) {
        return;
      }

      buildMessage('key', index, null, callback);
    },
    getSize: function getSize(callback) {
      if (!isApiReady()) {
        return;
      }

      buildMessage('size', null, null, callback);
    },
    getLength: function getLength(callback) {
      if (!isApiReady()) {
        return;
      }

      buildMessage('length', null, null, callback);
    },
    clear: function clear(callback) {
      if (!isApiReady()) {
        return;
      }

      buildMessage('clear', null, null, callback);
    },
    wasInit: function wasInit() {
      return _wasInit;
    },
    isReady: function isReady() {
      return isApiReady();
    }
  };
}();
/**
 * jMathEdu Admin Stub v 1.0 beta 1
 * Last Mod Date: 2019-08-04
 *
 * @file: _admin-stub.js
 */
$(document).ready(function () {
  var $body = $('body'),
      isAdminMode = $('.admin-top-menu').length,
      $adminIframe = $('#admin-iframe'),
      $adminPopup = $('.admin-popup'),
      $adminLoader = $adminPopup.find(' .ph-loader');

  if (isAdminMode) {
    // ADMIN LINKS / ACTIONS HANDLER
    $('.admin-action').on('click', function (e) {
      var $this = $(e.target);

      switch ($this.tagNameLC()) {
        case 'admin-a':
        case 'a':
          __adminOpenPopup({
            url: $this.attr('href')
          });

          e.stopPropagation();
          e.preventDefault();
          break;
      }

      return false;
    }); // OPEN PANEL WINDOW

    var __adminOpenPopup = document.__adminOpenPopup = function ($popupData) {
      $body.addClass('is-admin-popup-active');
      $adminIframe.attr('src', $popupData.url);
      $adminLoader.addClass('is-visible');
    }; // CLOSE ADMIN WINDOW


    var __adminClosePopup = document.__adminClosePopup = function () {
      $body.removeClass('is-admin-popup-active');
      setTimeout(function () {
        $adminIframe.attr('src', '');
        $adminLoader.removeClass('is-visible');
        if (!$body.hasClass('layout-bookviewer')) window.location.reload();
      }, 500);
    }; // HIDE LOADER ANIMATION ON IFRAME LOAD


    $adminIframe.on('load', function (e) {
      //console.log($adminIframe.attr( 'src' ));
      //$adminLoader[ $adminIframe.attr( 'src' ) !== '' ? 'removeClass' : 'addClass' ]( 'is-visible' );
      $adminLoader.removeClass('is-visible');
    }); // IFRAME MESSAGES HANDLER

    window.addEventListener('message', function (event) {
      var data = event[event.message ? 'message' : 'data'];

      if (data.action === 'close-popup') {
        __adminClosePopup();
      }
    }, false); // KEYBOARD LISTENERS

    $body.on('keydown', function (e) {
      if (e.key === 'Escape' && $body.hasClass('is-admin-popup-active')) {
        __adminClosePopup();
      }
    });
  }
});
/*const */
var jMathEduVersion = 'Kentavr.Ru / Core / 201908.2';
var jMathEduBookVersion = 'Kentavr.Ru / BookViewer / 201908.2';
var lsSettingsKey = 'Kentavr-Settings-1.2'; // change version to clean users' settings

var lsBookMarksKey = 'Kentavr-Bookmarks-1.2';
jQuery.fn.cssInt = function (prop) {
  return parseInt(this.css(prop), 10) || 0;
};

jQuery.fn.cssFloat = function (prop) {
  return parseFloat(this.css(prop)) || 0;
};

jQuery.fn.getWidthInPercent = function () {
  var width = parseFloat($(this).css('width')) / parseFloat($(this).parent().css('width'));
  return Math.ceil(100 * width);
};

jQuery.fn.tagNameLC = function () {
  return $(this).prop('tagName').toLowerCase();
};

String.prototype.trimChars = function (chars) {
  var l = 0;
  var r = this.length - 1;

  while (chars.indexOf(this[l]) >= 0 && l < r) {
    l++;
  }

  while (chars.indexOf(this[r]) >= 0 && r >= l) {
    r--;
  }

  return this.substring(l, r + 1);
};

String.prototype.cyr2lat = function (options) {
  var str = this,
      i,
      ch,
      newStr = new String();
  var c = {
    'а': 'a',
    'б': 'b',
    'в': 'v',
    'г': 'g',
    'д': 'd',
    'е': 'e',
    'ё': 'jo',
    'ж': 'zh',
    'з': 'z',
    'и': 'i',
    'й': 'j',
    'к': 'k',
    'л': 'l',
    'м': 'm',
    'н': 'n',
    'о': 'o',
    'п': 'p',
    'р': 'r',
    'с': 's',
    'т': 't',
    'у': 'u',
    'ф': 'f',
    'х': 'h',
    'ц': 'c',
    'ч': 'ch',
    'ш': 'sh',
    'щ': 'shch',
    'ъ': '',
    'ы': 'y',
    'ь': '',
    'э': 'e',
    'ю': 'ju',
    'я': 'ja'
  };
  var opts = options ? options : {};
  str = str.toLowerCase().replace(/<.+>/g, ' ').replace(/\s+/g, ' ');

  for (i = 0; i < str.length; i++) {
    ch = str.charAt(i);
    newStr += ch in c ? c[ch] : ch;
  }

  if (opts.replaceSpace) newStr = newStr.replace(/\s/g, '_');
  if (opts.alphanumOnly) newStr = newStr.replace(/[^a-z0-9_\s]/gi, '');
  newStr = newStr.replace(/_+/g, '_').trimChars('_');
  return newStr;
};

function jisNumber(val) {
  var str = ('' + val).trim();
  if (str.length === 0) return false;
  return !isNaN(+str);
}

function jBool(val) {
  var num = +val;
  return !isNaN(num) ? !!num : !!String(val).toLowerCase().replace(!!0, '');
}

function formatBytes(bytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (bytes === 0) return '0 Bytes';
  var k = 1024;
  var dm = decimals < 0 ? 0 : decimals;
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

String.prototype.getKwdStrength = function () {
  var valParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var kwd = this;
  if (!valParams.minLength) valParams = {
    minLength: 8,
    minCap: 2,
    minLow: 2,
    minDigit: 1,
    minSpecial: 1
  };
  var level = 0;
  level += kwd.length >= valParams.minLength ? 10 : 0; // 10?

  level += kwd.length >= 2 ? 1 : 0; // ?

  level += RegExp('[!@#$%^&*?_~<>~"\\\\`\'\\-+.,;:№()=/]{' + valParams.minSpecial + ',}', 'gu').test(kwd) ? 1 : 0;
  level += RegExp('[a-zа-я]{' + valParams.minLow + ',}', 'gu').test(kwd) ? 1 : 0;
  level += RegExp('[A-ZА-Я]{' + valParams.minCap + ',}', 'gu').test(kwd) ? 1 : 0;
  level += RegExp('[0-9]{' + valParams.minDigit + ',}', 'gu').test(kwd) ? 1 : 0;
  return level;
};

String.prototype.checkEmailAddress = function () {
  var email = this;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

String.prototype.checkLogin = function () {
  var login = this;
  return !/[^a-z0-9_]/.test(login);
}; // Get width of text with font.  usage: $("div").textWidth();


jQuery.fn.textWidth = function (_text, _font, _class) {
  var fakeEl = $('<span data-autoresize="">').hide().addClass(this.attr('class')).addClass(_class).appendTo(document.body).text(_text || this.val() || this.text()).css({
    font: _font || this.css('font'),
    whiteSpace: "pre"
  }),
      width = fakeEl.width();
  fakeEl.remove();
  return width;
}; // Resizes elements based on content size.  usage: $('input').autoresize({padding:10,minWidth:0,maxWidth:100});


jQuery.fn.autoresize = function (options) {
  //if(window.isMobile) return;
  options = jQuery.extend({
    padding: 10,
    minWidth: 40,
    maxWidth: 10000
  }, options || {});
  $(this).on('input', function () {
    $(this).css('width', Math.min(options.maxWidth, Math.max(options.minWidth, $(this).textWidth(null, null, options["class"] || '') + options.padding)));
  }).trigger('input');
  return this;
};

jQuery.fn.getBox = function () {
  return {
    left: $(this).offset().left,
    top: $(this).offset().top,
    width: $(this).outerWidth(),
    height: $(this).outerHeight()
  };
};

jQuery.fn.position = function (target, options) {
  var anchorOffsets = {
    t: 0,
    l: 0,
    c: 0.5,
    b: 1,
    r: 1
  };
  var defaults = {
    anchor: ['tl', 'tl'],
    animate: false,
    offset: [0, 0]
  };
  options = jQuery.extend(defaults, options);
  var targetBox = $(target).getBox(),
      sourceBox = $(this).getBox(); //origin is at the top-left of the target element

  var left = targetBox.left,
      top = targetBox.top; //alignment with respect to source

  top -= anchorOffsets[options.anchor[0].charAt(0)] * sourceBox.height;
  left -= anchorOffsets[options.anchor[0].charAt(1)] * sourceBox.width; //alignment with respect to target

  top += anchorOffsets[options.anchor[1].charAt(0)] * targetBox.height;
  left += anchorOffsets[options.anchor[1].charAt(1)] * targetBox.width; // get scroll

  top += $('.ph-app').scrollTop(); //add offset to final coordinates

  left += options.offset[0];
  top += options.offset[1];
  $(this).css({
    left: left + 'px',
    top: top + 'px'
  });
};

jQuery.fn.offsetviewport = function () {
  var el = this[0];
  return {
    top: Number(el.getBoundingClientRect().top),
    left: Number(el.getBoundingClientRect().left),
    width: Number(el.getBoundingClientRect().width),
    height: Number(el.getBoundingClientRect().height),
    vpwidth: Number(document.body.clientWidth),
    vpheight: Number(document.body.clientHeight)
  };
};

jQuery.fn.fadeOutAndRemove = function (speed) {
  $(this).fadeOut(speed, function () {
    $(this).remove();
  });
};

jQuery.fn.getScrollParent = function (includeHidden, objDoc) {
  if (this.css('position') === 'fixed') return objDoc.body;
  var excludeStaticParent = this.css('position') === 'absolute',
      overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
      $parent = $(this.parent());

  while ($parent.length) {
    if (excludeStaticParent && $parent.css('position') === 'static') {
      continue;
    }

    if (overflowRegex.test($parent.css('overflow') + $parent.css('overflow-y') + $parent.css('overflow-x'))) {
      return $parent;
    }

    $parent = $($parent.parent());
  }

  return $(objDoc.body);
};

jQuery.fn.onEnter = function (func) {
  this.bind('keypress', function (e) {
    if (e.keyCode == 13) func.apply(this, [e]);
  });
  return this;
};

jQuery.fn.removeOptions = function (mode) {
  var $this = this;
  mode = mode ? mode : 'nonblanks';
  $this.find('option').filter(function () {
    if (mode === 'blanks') return $(this).val().trim() === '';
    if (mode === 'nonblanks') return $(this).val().trim() !== '';
  }).remove();
};

jQuery.fn.extend({
  qcss: function qcss(css) {
    return $(this).queue(function (next) {
      $(this).css(css);
      next();
    });
  }
});
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function r(c, a, f) {
  function o(n, t) {
    if (!a[n]) {
      if (!c[n]) {
        var e = "function" == typeof require && require;
        if (!t && e) return e(n, !0);
        if (s) return s(n, !0);
        var i = new Error("Cannot find module '" + n + "'");
        throw i.code = "MODULE_NOT_FOUND", i;
      }

      var u = a[n] = {
        exports: {}
      };
      c[n][0].call(u.exports, function (t) {
        return o(c[n][1][t] || t);
      }, u, u.exports, r, c, a, f);
    }

    return a[n].exports;
  }

  for (var s = "function" == typeof require && require, t = 0; t < f.length; t++) {
    o(f[t]);
  }

  return o;
}({
  1: [function (t, n, r) {
    "use strict";

    t(2);

    var e = function _interopRequireDefault(t) {
      return t && t.__esModule ? t : {
        "default": t
      };
    }(t(15));

    e["default"]._babelPolyfill && "undefined" != typeof console && console.warn && console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended and may have consequences if different versions of the polyfills are applied sequentially. If you do need to load the polyfill more than once, use @babel/polyfill/noConflict instead to bypass the warning."), e["default"]._babelPolyfill = !0;
  }, {
    15: 15,
    2: 2
  }],
  2: [function (t, n, r) {
    "use strict";

    t(3), t(5), t(4), t(11), t(10), t(13), t(12), t(14), t(7), t(8), t(6), t(9), t(306), t(307);
  }, {
    10: 10,
    11: 11,
    12: 12,
    13: 13,
    14: 14,
    3: 3,
    306: 306,
    307: 307,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9
  }],
  3: [function (t, n, r) {
    t(278), t(214), t(216), t(215), t(218), t(220), t(225), t(219), t(217), t(227), t(226), t(222), t(223), t(221), t(213), t(224), t(228), t(229), t(180), t(182), t(181), t(231), t(230), t(201), t(211), t(212), t(202), t(203), t(204), t(205), t(206), t(207), t(208), t(209), t(210), t(184), t(185), t(186), t(187), t(188), t(189), t(190), t(191), t(192), t(193), t(194), t(195), t(196), t(197), t(198), t(199), t(200), t(265), t(270), t(277), t(268), t(260), t(261), t(266), t(271), t(273), t(256), t(257), t(258), t(259), t(262), t(263), t(264), t(267), t(269), t(272), t(274), t(275), t(276), t(175), t(177), t(176), t(179), t(178), t(163), t(161), t(168), t(165), t(171), t(173), t(160), t(167), t(157), t(172), t(155), t(170), t(169), t(162), t(166), t(154), t(156), t(159), t(158), t(174), t(164), t(247), t(248), t(254), t(249), t(250), t(251), t(252), t(253), t(232), t(183), t(255), t(290), t(291), t(279), t(280), t(285), t(288), t(289), t(283), t(286), t(284), t(287), t(281), t(282), t(233), t(234), t(235), t(236), t(237), t(240), t(238), t(239), t(241), t(242), t(243), t(244), t(246), t(245), n.exports = t(52);
  }, {
    154: 154,
    155: 155,
    156: 156,
    157: 157,
    158: 158,
    159: 159,
    160: 160,
    161: 161,
    162: 162,
    163: 163,
    164: 164,
    165: 165,
    166: 166,
    167: 167,
    168: 168,
    169: 169,
    170: 170,
    171: 171,
    172: 172,
    173: 173,
    174: 174,
    175: 175,
    176: 176,
    177: 177,
    178: 178,
    179: 179,
    180: 180,
    181: 181,
    182: 182,
    183: 183,
    184: 184,
    185: 185,
    186: 186,
    187: 187,
    188: 188,
    189: 189,
    190: 190,
    191: 191,
    192: 192,
    193: 193,
    194: 194,
    195: 195,
    196: 196,
    197: 197,
    198: 198,
    199: 199,
    200: 200,
    201: 201,
    202: 202,
    203: 203,
    204: 204,
    205: 205,
    206: 206,
    207: 207,
    208: 208,
    209: 209,
    210: 210,
    211: 211,
    212: 212,
    213: 213,
    214: 214,
    215: 215,
    216: 216,
    217: 217,
    218: 218,
    219: 219,
    220: 220,
    221: 221,
    222: 222,
    223: 223,
    224: 224,
    225: 225,
    226: 226,
    227: 227,
    228: 228,
    229: 229,
    230: 230,
    231: 231,
    232: 232,
    233: 233,
    234: 234,
    235: 235,
    236: 236,
    237: 237,
    238: 238,
    239: 239,
    240: 240,
    241: 241,
    242: 242,
    243: 243,
    244: 244,
    245: 245,
    246: 246,
    247: 247,
    248: 248,
    249: 249,
    250: 250,
    251: 251,
    252: 252,
    253: 253,
    254: 254,
    255: 255,
    256: 256,
    257: 257,
    258: 258,
    259: 259,
    260: 260,
    261: 261,
    262: 262,
    263: 263,
    264: 264,
    265: 265,
    266: 266,
    267: 267,
    268: 268,
    269: 269,
    270: 270,
    271: 271,
    272: 272,
    273: 273,
    274: 274,
    275: 275,
    276: 276,
    277: 277,
    278: 278,
    279: 279,
    280: 280,
    281: 281,
    282: 282,
    283: 283,
    284: 284,
    285: 285,
    286: 286,
    287: 287,
    288: 288,
    289: 289,
    290: 290,
    291: 291,
    52: 52
  }],
  4: [function (t, n, r) {
    t(292), n.exports = t(52).Array.flatMap;
  }, {
    292: 292,
    52: 52
  }],
  5: [function (t, n, r) {
    t(293), n.exports = t(52).Array.includes;
  }, {
    293: 293,
    52: 52
  }],
  6: [function (t, n, r) {
    t(294), n.exports = t(52).Object.entries;
  }, {
    294: 294,
    52: 52
  }],
  7: [function (t, n, r) {
    t(295), n.exports = t(52).Object.getOwnPropertyDescriptors;
  }, {
    295: 295,
    52: 52
  }],
  8: [function (t, n, r) {
    t(296), n.exports = t(52).Object.values;
  }, {
    296: 296,
    52: 52
  }],
  9: [function (t, n, r) {
    "use strict";

    t(232), t(297), n.exports = t(52).Promise["finally"];
  }, {
    232: 232,
    297: 297,
    52: 52
  }],
  10: [function (t, n, r) {
    t(298), n.exports = t(52).String.padEnd;
  }, {
    298: 298,
    52: 52
  }],
  11: [function (t, n, r) {
    t(299), n.exports = t(52).String.padStart;
  }, {
    299: 299,
    52: 52
  }],
  12: [function (t, n, r) {
    t(301), n.exports = t(52).String.trimRight;
  }, {
    301: 301,
    52: 52
  }],
  13: [function (t, n, r) {
    t(300), n.exports = t(52).String.trimLeft;
  }, {
    300: 300,
    52: 52
  }],
  14: [function (t, n, r) {
    t(302), n.exports = t(151).f("asyncIterator");
  }, {
    151: 151,
    302: 302
  }],
  15: [function (t, n, r) {
    t(32), n.exports = t(18).global;
  }, {
    18: 18,
    32: 32
  }],
  16: [function (t, n, r) {
    n.exports = function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");
      return t;
    };
  }, {}],
  17: [function (t, n, r) {
    var e = t(28);

    n.exports = function (t) {
      if (!e(t)) throw TypeError(t + " is not an object!");
      return t;
    };
  }, {
    28: 28
  }],
  18: [function (t, n, r) {
    var e = n.exports = {
      version: "2.6.11"
    };
    "number" == typeof __e && (__e = e);
  }, {}],
  19: [function (t, n, r) {
    var o = t(16);

    n.exports = function (e, i, t) {
      if (o(e), void 0 === i) return e;

      switch (t) {
        case 1:
          return function (t) {
            return e.call(i, t);
          };

        case 2:
          return function (t, n) {
            return e.call(i, t, n);
          };

        case 3:
          return function (t, n, r) {
            return e.call(i, t, n, r);
          };
      }

      return function () {
        return e.apply(i, arguments);
      };
    };
  }, {
    16: 16
  }],
  20: [function (t, n, r) {
    n.exports = !t(23)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, {
    23: 23
  }],
  21: [function (t, n, r) {
    var e = t(28),
        i = t(24).document,
        o = e(i) && e(i.createElement);

    n.exports = function (t) {
      return o ? i.createElement(t) : {};
    };
  }, {
    24: 24,
    28: 28
  }],
  22: [function (t, n, r) {
    var g = t(24),
        y = t(18),
        d = t(19),
        x = t(26),
        m = t(25),
        S = "prototype",
        b = function b(t, n, r) {
      var e,
          i,
          o,
          u = t & b.F,
          c = t & b.G,
          a = t & b.S,
          f = t & b.P,
          s = t & b.B,
          l = t & b.W,
          h = c ? y : y[n] || (y[n] = {}),
          p = h[S],
          v = c ? g : a ? g[n] : (g[n] || {})[S];

      for (e in c && (r = n), r) {
        (i = !u && v && void 0 !== v[e]) && m(h, e) || (o = i ? v[e] : r[e], h[e] = c && "function" != typeof v[e] ? r[e] : s && i ? d(o, g) : l && v[e] == o ? function (e) {
          function qb(t, n, r) {
            if (this instanceof e) {
              switch (arguments.length) {
                case 0:
                  return new e();

                case 1:
                  return new e(t);

                case 2:
                  return new e(t, n);
              }

              return new e(t, n, r);
            }

            return e.apply(this, arguments);
          }

          return qb[S] = e[S], qb;
        }(o) : f && "function" == typeof o ? d(Function.call, o) : o, f && ((h.virtual || (h.virtual = {}))[e] = o, t & b.R && p && !p[e] && x(p, e, o)));
      }
    };

    b.F = 1, b.G = 2, b.S = 4, b.P = 8, b.B = 16, b.W = 32, b.U = 64, b.R = 128, n.exports = b;
  }, {
    18: 18,
    19: 19,
    24: 24,
    25: 25,
    26: 26
  }],
  23: [function (t, n, r) {
    n.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, {}],
  24: [function (t, n, r) {
    var e = n.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = e);
  }, {}],
  25: [function (t, n, r) {
    var e = {}.hasOwnProperty;

    n.exports = function (t, n) {
      return e.call(t, n);
    };
  }, {}],
  26: [function (t, n, r) {
    var e = t(29),
        i = t(30);
    n.exports = t(20) ? function (t, n, r) {
      return e.f(t, n, i(1, r));
    } : function (t, n, r) {
      return t[n] = r, t;
    };
  }, {
    20: 20,
    29: 29,
    30: 30
  }],
  27: [function (t, n, r) {
    n.exports = !t(20) && !t(23)(function () {
      return 7 != Object.defineProperty(t(21)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, {
    20: 20,
    21: 21,
    23: 23
  }],
  28: [function (t, n, r) {
    n.exports = function (t) {
      return "object" == _typeof(t) ? null !== t : "function" == typeof t;
    };
  }, {}],
  29: [function (t, n, r) {
    var e = t(17),
        i = t(27),
        o = t(31),
        u = Object.defineProperty;
    r.f = t(20) ? Object.defineProperty : function defineProperty(t, n, r) {
      if (e(t), n = o(n, !0), e(r), i) try {
        return u(t, n, r);
      } catch (t) {}
      if ("get" in r || "set" in r) throw TypeError("Accessors not supported!");
      return "value" in r && (t[n] = r.value), t;
    };
  }, {
    17: 17,
    20: 20,
    27: 27,
    31: 31
  }],
  30: [function (t, n, r) {
    n.exports = function (t, n) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: n
      };
    };
  }, {}],
  31: [function (t, n, r) {
    var i = t(28);

    n.exports = function (t, n) {
      if (!i(t)) return t;
      var r, e;
      if (n && "function" == typeof (r = t.toString) && !i(e = r.call(t))) return e;
      if ("function" == typeof (r = t.valueOf) && !i(e = r.call(t))) return e;
      if (!n && "function" == typeof (r = t.toString) && !i(e = r.call(t))) return e;
      throw TypeError("Can't convert object to primitive value");
    };
  }, {
    28: 28
  }],
  32: [function (t, n, r) {
    var e = t(22);
    e(e.G, {
      global: t(24)
    });
  }, {
    22: 22,
    24: 24
  }],
  33: [function (t, n, r) {
    arguments[4][16][0].apply(r, arguments);
  }, {
    16: 16
  }],
  34: [function (t, n, r) {
    var e = t(48);

    n.exports = function (t, n) {
      if ("number" != typeof t && "Number" != e(t)) throw TypeError(n);
      return +t;
    };
  }, {
    48: 48
  }],
  35: [function (t, n, r) {
    var e = t(152)("unscopables"),
        i = Array.prototype;
    null == i[e] && t(72)(i, e, {}), n.exports = function (t) {
      i[e][t] = !0;
    };
  }, {
    152: 152,
    72: 72
  }],
  36: [function (t, n, r) {
    "use strict";

    var e = t(129)(!0);

    n.exports = function (t, n, r) {
      return n + (r ? e(t, n).length : 1);
    };
  }, {
    129: 129
  }],
  37: [function (t, n, r) {
    n.exports = function (t, n, r, e) {
      if (!(t instanceof n) || void 0 !== e && e in t) throw TypeError(r + ": incorrect invocation!");
      return t;
    };
  }, {}],
  38: [function (t, n, r) {
    arguments[4][17][0].apply(r, arguments);
  }, {
    17: 17,
    81: 81
  }],
  39: [function (t, n, r) {
    "use strict";

    var f = t(142),
        s = t(137),
        l = t(141);

    n.exports = [].copyWithin || function copyWithin(t, n) {
      var r = f(this),
          e = l(r.length),
          i = s(t, e),
          o = s(n, e),
          u = 2 < arguments.length ? arguments[2] : void 0,
          c = Math.min((void 0 === u ? e : s(u, e)) - o, e - i),
          a = 1;

      for (o < i && i < o + c && (a = -1, o += c - 1, i += c - 1); 0 < c--;) {
        o in r ? r[i] = r[o] : delete r[i], i += a, o += a;
      }

      return r;
    };
  }, {
    137: 137,
    141: 141,
    142: 142
  }],
  40: [function (t, n, r) {
    "use strict";

    var c = t(142),
        a = t(137),
        f = t(141);

    n.exports = function fill(t) {
      for (var n = c(this), r = f(n.length), e = arguments.length, i = a(1 < e ? arguments[1] : void 0, r), o = 2 < e ? arguments[2] : void 0, u = void 0 === o ? r : a(o, r); i < u;) {
        n[i++] = t;
      }

      return n;
    };
  }, {
    137: 137,
    141: 141,
    142: 142
  }],
  41: [function (t, n, r) {
    var a = t(140),
        f = t(141),
        s = t(137);

    n.exports = function (c) {
      return function (t, n, r) {
        var e,
            i = a(t),
            o = f(i.length),
            u = s(r, o);

        if (c && n != n) {
          for (; u < o;) {
            if ((e = i[u++]) != e) return !0;
          }
        } else for (; u < o; u++) {
          if ((c || u in i) && i[u] === n) return c || u || 0;
        }

        return !c && -1;
      };
    };
  }, {
    137: 137,
    140: 140,
    141: 141
  }],
  42: [function (t, n, r) {
    var m = t(54),
        S = t(77),
        b = t(142),
        w = t(141),
        e = t(45);

    n.exports = function (l, t) {
      var h = 1 == l,
          p = 2 == l,
          v = 3 == l,
          g = 4 == l,
          y = 6 == l,
          d = 5 == l || y,
          x = t || e;
      return function (t, n, r) {
        for (var e, i, o = b(t), u = S(o), c = m(n, r, 3), a = w(u.length), f = 0, s = h ? x(t, a) : p ? x(t, 0) : void 0; f < a; f++) {
          if ((d || f in u) && (i = c(e = u[f], f, o), l)) if (h) s[f] = i;else if (i) switch (l) {
            case 3:
              return !0;

            case 5:
              return e;

            case 6:
              return f;

            case 2:
              s.push(e);
          } else if (g) return !1;
        }

        return y ? -1 : v || g ? g : s;
      };
    };
  }, {
    141: 141,
    142: 142,
    45: 45,
    54: 54,
    77: 77
  }],
  43: [function (t, n, r) {
    var s = t(33),
        l = t(142),
        h = t(77),
        p = t(141);

    n.exports = function (t, n, r, e, i) {
      s(n);
      var o = l(t),
          u = h(o),
          c = p(o.length),
          a = i ? c - 1 : 0,
          f = i ? -1 : 1;
      if (r < 2) for (;;) {
        if (a in u) {
          e = u[a], a += f;
          break;
        }

        if (a += f, i ? a < 0 : c <= a) throw TypeError("Reduce of empty array with no initial value");
      }

      for (; i ? 0 <= a : a < c; a += f) {
        a in u && (e = n(e, u[a], a, o));
      }

      return e;
    };
  }, {
    141: 141,
    142: 142,
    33: 33,
    77: 77
  }],
  44: [function (t, n, r) {
    var e = t(81),
        i = t(79),
        o = t(152)("species");

    n.exports = function (t) {
      var n;
      return i(t) && ("function" != typeof (n = t.constructor) || n !== Array && !i(n.prototype) || (n = void 0), e(n) && null === (n = n[o]) && (n = void 0)), void 0 === n ? Array : n;
    };
  }, {
    152: 152,
    79: 79,
    81: 81
  }],
  45: [function (t, n, r) {
    var e = t(44);

    n.exports = function (t, n) {
      return new (e(t))(n);
    };
  }, {
    44: 44
  }],
  46: [function (t, n, r) {
    "use strict";

    var o = t(33),
        u = t(81),
        c = t(76),
        a = [].slice,
        f = {};

    n.exports = Function.bind || function bind(n) {
      var r = o(this),
          e = a.call(arguments, 1),
          i = function i() {
        var t = e.concat(a.call(arguments));
        return this instanceof i ? function (t, n, r) {
          if (!(n in f)) {
            for (var e = [], i = 0; i < n; i++) {
              e[i] = "a[" + i + "]";
            }

            f[n] = Function("F,a", "return new F(" + e.join(",") + ")");
          }

          return f[n](t, r);
        }(r, t.length, t) : c(r, t, n);
      };

      return u(r.prototype) && (i.prototype = r.prototype), i;
    };
  }, {
    33: 33,
    76: 76,
    81: 81
  }],
  47: [function (t, n, r) {
    var i = t(48),
        o = t(152)("toStringTag"),
        u = "Arguments" == i(function () {
      return arguments;
    }());

    n.exports = function (t) {
      var n, r, e;
      return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (r = function (t, n) {
        try {
          return t[n];
        } catch (t) {}
      }(n = Object(t), o)) ? r : u ? i(n) : "Object" == (e = i(n)) && "function" == typeof n.callee ? "Arguments" : e;
    };
  }, {
    152: 152,
    48: 48
  }],
  48: [function (t, n, r) {
    var e = {}.toString;

    n.exports = function (t) {
      return e.call(t).slice(8, -1);
    };
  }, {}],
  49: [function (t, n, r) {
    "use strict";

    function ag(t, n) {
      var r,
          e = p(n);
      if ("F" !== e) return t._i[e];

      for (r = t._f; r; r = r.n) {
        if (r.k == n) return r;
      }
    }

    var u = t(99).f,
        c = t(98),
        a = t(117),
        f = t(54),
        s = t(37),
        l = t(68),
        e = t(85),
        i = t(87),
        o = t(123),
        h = t(58),
        p = t(94).fastKey,
        v = t(149),
        g = h ? "_s" : "size";
    n.exports = {
      getConstructor: function getConstructor(t, o, r, e) {
        var i = t(function (t, n) {
          s(t, i, o, "_i"), t._t = o, t._i = c(null), t._f = void 0, t._l = void 0, t[g] = 0, null != n && l(n, r, t[e], t);
        });
        return a(i.prototype, {
          clear: function clear() {
            for (var t = v(this, o), n = t._i, r = t._f; r; r = r.n) {
              r.r = !0, r.p && (r.p = r.p.n = void 0), delete n[r.i];
            }

            t._f = t._l = void 0, t[g] = 0;
          },
          "delete": function _delete(t) {
            var n = v(this, o),
                r = ag(n, t);

            if (r) {
              var e = r.n,
                  i = r.p;
              delete n._i[r.i], r.r = !0, i && (i.n = e), e && (e.p = i), n._f == r && (n._f = e), n._l == r && (n._l = i), n[g]--;
            }

            return !!r;
          },
          forEach: function forEach(t) {
            v(this, o);

            for (var n, r = f(t, 1 < arguments.length ? arguments[1] : void 0, 3); n = n ? n.n : this._f;) {
              for (r(n.v, n.k, this); n && n.r;) {
                n = n.p;
              }
            }
          },
          has: function has(t) {
            return !!ag(v(this, o), t);
          }
        }), h && u(i.prototype, "size", {
          get: function get() {
            return v(this, o)[g];
          }
        }), i;
      },
      def: function def(t, n, r) {
        var e,
            i,
            o = ag(t, n);
        return o ? o.v = r : (t._l = o = {
          i: i = p(n, !0),
          k: n,
          v: r,
          p: e = t._l,
          n: void 0,
          r: !1
        }, t._f || (t._f = o), e && (e.n = o), t[g]++, "F" !== i && (t._i[i] = o)), t;
      },
      getEntry: ag,
      setStrong: function setStrong(t, r, n) {
        e(t, r, function (t, n) {
          this._t = v(t, r), this._k = n, this._l = void 0;
        }, function () {
          for (var t = this, n = t._k, r = t._l; r && r.r;) {
            r = r.p;
          }

          return t._t && (t._l = r = r ? r.n : t._t._f) ? i(0, "keys" == n ? r.k : "values" == n ? r.v : [r.k, r.v]) : (t._t = void 0, i(1));
        }, n ? "entries" : "values", !n, !0), o(r);
      }
    };
  }, {
    117: 117,
    123: 123,
    149: 149,
    37: 37,
    54: 54,
    58: 58,
    68: 68,
    85: 85,
    87: 87,
    94: 94,
    98: 98,
    99: 99
  }],
  50: [function (t, n, r) {
    "use strict";

    function _g(t) {
      return t._l || (t._l = new g());
    }

    function bh(t, n) {
      return o(t.a, function (t) {
        return t[0] === n;
      });
    }

    var u = t(117),
        c = t(94).getWeak,
        i = t(38),
        a = t(81),
        f = t(37),
        s = t(68),
        e = t(42),
        l = t(71),
        h = t(149),
        o = e(5),
        p = e(6),
        v = 0,
        g = function g() {
      this.a = [];
    };

    g.prototype = {
      get: function get(t) {
        var n = bh(this, t);
        if (n) return n[1];
      },
      has: function has(t) {
        return !!bh(this, t);
      },
      set: function set(t, n) {
        var r = bh(this, t);
        r ? r[1] = n : this.a.push([t, n]);
      },
      "delete": function _delete(n) {
        var t = p(this.a, function (t) {
          return t[0] === n;
        });
        return ~t && this.a.splice(t, 1), !!~t;
      }
    }, n.exports = {
      getConstructor: function getConstructor(t, r, e, i) {
        var o = t(function (t, n) {
          f(t, o, r, "_i"), t._t = r, t._i = v++, t._l = void 0, null != n && s(n, e, t[i], t);
        });
        return u(o.prototype, {
          "delete": function _delete(t) {
            if (!a(t)) return !1;
            var n = c(t);
            return !0 === n ? _g(h(this, r))["delete"](t) : n && l(n, this._i) && delete n[this._i];
          },
          has: function has(t) {
            if (!a(t)) return !1;
            var n = c(t);
            return !0 === n ? _g(h(this, r)).has(t) : n && l(n, this._i);
          }
        }), o;
      },
      def: function def(t, n, r) {
        var e = c(i(n), !0);
        return !0 === e ? _g(t).set(n, r) : e[t._i] = r, t;
      },
      ufstore: _g
    };
  }, {
    117: 117,
    149: 149,
    37: 37,
    38: 38,
    42: 42,
    68: 68,
    71: 71,
    81: 81,
    94: 94
  }],
  51: [function (t, n, r) {
    "use strict";

    var y = t(70),
        d = t(62),
        x = t(118),
        m = t(117),
        S = t(94),
        b = t(68),
        w = t(37),
        _ = t(81),
        E = t(64),
        O = t(86),
        F = t(124),
        I = t(75);

    n.exports = function (e, t, n, r, i, o) {
      function ci(t) {
        var r = f[t];
        x(f, t, "delete" == t ? function (t) {
          return !(o && !_(t)) && r.call(this, 0 === t ? 0 : t);
        } : "has" == t ? function has(t) {
          return !(o && !_(t)) && r.call(this, 0 === t ? 0 : t);
        } : "get" == t ? function get(t) {
          return o && !_(t) ? void 0 : r.call(this, 0 === t ? 0 : t);
        } : "add" == t ? function add(t) {
          return r.call(this, 0 === t ? 0 : t), this;
        } : function set(t, n) {
          return r.call(this, 0 === t ? 0 : t, n), this;
        });
      }

      var u = y[e],
          c = u,
          a = i ? "set" : "add",
          f = c && c.prototype,
          s = {};

      if ("function" == typeof c && (o || f.forEach && !E(function () {
        new c().entries().next();
      }))) {
        var l = new c(),
            h = l[a](o ? {} : -0, 1) != l,
            p = E(function () {
          l.has(1);
        }),
            v = O(function (t) {
          new c(t);
        }),
            g = !o && E(function () {
          for (var t = new c(), n = 5; n--;) {
            t[a](n, n);
          }

          return !t.has(-0);
        });
        v || (((c = t(function (t, n) {
          w(t, c, e);
          var r = I(new u(), t, c);
          return null != n && b(n, i, r[a], r), r;
        })).prototype = f).constructor = c), (p || g) && (ci("delete"), ci("has"), i && ci("get")), (g || h) && ci(a), o && f.clear && delete f.clear;
      } else c = r.getConstructor(t, e, i, a), m(c.prototype, n), S.NEED = !0;

      return F(c, e), s[e] = c, d(d.G + d.W + d.F * (c != u), s), o || r.setStrong(c, e, i), c;
    };
  }, {
    117: 117,
    118: 118,
    124: 124,
    37: 37,
    62: 62,
    64: 64,
    68: 68,
    70: 70,
    75: 75,
    81: 81,
    86: 86,
    94: 94
  }],
  52: [function (t, n, r) {
    arguments[4][18][0].apply(r, arguments);
  }, {
    18: 18
  }],
  53: [function (t, n, r) {
    "use strict";

    var e = t(99),
        i = t(116);

    n.exports = function (t, n, r) {
      n in t ? e.f(t, n, i(0, r)) : t[n] = r;
    };
  }, {
    116: 116,
    99: 99
  }],
  54: [function (t, n, r) {
    arguments[4][19][0].apply(r, arguments);
  }, {
    19: 19,
    33: 33
  }],
  55: [function (t, n, r) {
    "use strict";

    function Qi(t) {
      return 9 < t ? t : "0" + t;
    }

    var e = t(64),
        i = Date.prototype.getTime,
        o = Date.prototype.toISOString;
    n.exports = e(function () {
      return "0385-07-25T07:06:39.999Z" != o.call(new Date(-5e13 - 1));
    }) || !e(function () {
      o.call(new Date(NaN));
    }) ? function toISOString() {
      if (!isFinite(i.call(this))) throw RangeError("Invalid time value");
      var t = this,
          n = t.getUTCFullYear(),
          r = t.getUTCMilliseconds(),
          e = n < 0 ? "-" : 9999 < n ? "+" : "";
      return e + ("00000" + Math.abs(n)).slice(e ? -6 : -4) + "-" + Qi(t.getUTCMonth() + 1) + "-" + Qi(t.getUTCDate()) + "T" + Qi(t.getUTCHours()) + ":" + Qi(t.getUTCMinutes()) + ":" + Qi(t.getUTCSeconds()) + "." + (99 < r ? r : "0" + Qi(r)) + "Z";
    } : o;
  }, {
    64: 64
  }],
  56: [function (t, n, r) {
    "use strict";

    var e = t(38),
        i = t(143);

    n.exports = function (t) {
      if ("string" !== t && "number" !== t && "default" !== t) throw TypeError("Incorrect hint");
      return i(e(this), "number" != t);
    };
  }, {
    143: 143,
    38: 38
  }],
  57: [function (t, n, r) {
    n.exports = function (t) {
      if (null == t) throw TypeError("Can't call method on  " + t);
      return t;
    };
  }, {}],
  58: [function (t, n, r) {
    arguments[4][20][0].apply(r, arguments);
  }, {
    20: 20,
    64: 64
  }],
  59: [function (t, n, r) {
    arguments[4][21][0].apply(r, arguments);
  }, {
    21: 21,
    70: 70,
    81: 81
  }],
  60: [function (t, n, r) {
    n.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, {}],
  61: [function (t, n, r) {
    var c = t(107),
        a = t(104),
        f = t(108);

    n.exports = function (t) {
      var n = c(t),
          r = a.f;
      if (r) for (var e, i = r(t), o = f.f, u = 0; i.length > u;) {
        o.call(t, e = i[u++]) && n.push(e);
      }
      return n;
    };
  }, {
    104: 104,
    107: 107,
    108: 108
  }],
  62: [function (t, n, r) {
    var g = t(70),
        y = t(52),
        d = t(72),
        x = t(118),
        m = t(54),
        S = "prototype",
        b = function b(t, n, r) {
      var e,
          i,
          o,
          u,
          c = t & b.F,
          a = t & b.G,
          f = t & b.S,
          s = t & b.P,
          l = t & b.B,
          h = a ? g : f ? g[n] || (g[n] = {}) : (g[n] || {})[S],
          p = a ? y : y[n] || (y[n] = {}),
          v = p[S] || (p[S] = {});

      for (e in a && (r = n), r) {
        o = ((i = !c && h && void 0 !== h[e]) ? h : r)[e], u = l && i ? m(o, g) : s && "function" == typeof o ? m(Function.call, o) : o, h && x(h, e, o, t & b.U), p[e] != o && d(p, e, u), s && v[e] != o && (v[e] = o);
      }
    };

    g.core = y, b.F = 1, b.G = 2, b.S = 4, b.P = 8, b.B = 16, b.W = 32, b.U = 64, b.R = 128, n.exports = b;
  }, {
    118: 118,
    52: 52,
    54: 54,
    70: 70,
    72: 72
  }],
  63: [function (t, n, r) {
    var e = t(152)("match");

    n.exports = function (n) {
      var r = /./;

      try {
        "/./"[n](r);
      } catch (t) {
        try {
          return r[e] = !1, !"/./"[n](r);
        } catch (t) {}
      }

      return !0;
    };
  }, {
    152: 152
  }],
  64: [function (t, n, r) {
    arguments[4][23][0].apply(r, arguments);
  }, {
    23: 23
  }],
  65: [function (t, n, r) {
    "use strict";

    t(248);

    var s = t(118),
        l = t(72),
        h = t(64),
        p = t(57),
        v = t(152),
        g = t(120),
        y = v("species"),
        d = !h(function () {
      var t = /./;
      return t.exec = function () {
        var t = [];
        return t.groups = {
          a: "7"
        }, t;
      }, "7" !== "".replace(t, "$<a>");
    }),
        x = function () {
      var t = /(?:)/,
          n = t.exec;

      t.exec = function () {
        return n.apply(this, arguments);
      };

      var r = "ab".split(t);
      return 2 === r.length && "a" === r[0] && "b" === r[1];
    }();

    n.exports = function (r, t, n) {
      var e = v(r),
          o = !h(function () {
        var t = {};
        return t[e] = function () {
          return 7;
        }, 7 != ""[r](t);
      }),
          i = o ? !h(function () {
        var t = !1,
            n = /a/;
        return n.exec = function () {
          return t = !0, null;
        }, "split" === r && (n.constructor = {}, n.constructor[y] = function () {
          return n;
        }), n[e](""), !t;
      }) : void 0;

      if (!o || !i || "replace" === r && !d || "split" === r && !x) {
        var u = /./[e],
            c = n(p, e, ""[r], function maybeCallNative(t, n, r, e, i) {
          return n.exec === g ? o && !i ? {
            done: !0,
            value: u.call(n, r, e)
          } : {
            done: !0,
            value: t.call(r, n, e)
          } : {
            done: !1
          };
        }),
            a = c[0],
            f = c[1];
        s(String.prototype, r, a), l(RegExp.prototype, e, 2 == t ? function (t, n) {
          return f.call(t, this, n);
        } : function (t) {
          return f.call(t, this);
        });
      }
    };
  }, {
    118: 118,
    120: 120,
    152: 152,
    248: 248,
    57: 57,
    64: 64,
    72: 72
  }],
  66: [function (t, n, r) {
    "use strict";

    var e = t(38);

    n.exports = function () {
      var t = e(this),
          n = "";
      return t.global && (n += "g"), t.ignoreCase && (n += "i"), t.multiline && (n += "m"), t.unicode && (n += "u"), t.sticky && (n += "y"), n;
    };
  }, {
    38: 38
  }],
  67: [function (t, n, r) {
    "use strict";

    var p = t(79),
        v = t(81),
        g = t(141),
        y = t(54),
        d = t(152)("isConcatSpreadable");

    n.exports = function flattenIntoArray(t, n, r, e, i, o, u, c) {
      for (var a, f, s = i, l = 0, h = !!u && y(u, c, 3); l < e;) {
        if (l in r) {
          if (a = h ? h(r[l], l, n) : r[l], f = !1, v(a) && (f = void 0 !== (f = a[d]) ? !!f : p(a)), f && 0 < o) s = flattenIntoArray(t, n, a, g(a.length), s, o - 1) - 1;else {
            if (9007199254740991 <= s) throw TypeError();
            t[s] = a;
          }
          s++;
        }

        l++;
      }

      return s;
    };
  }, {
    141: 141,
    152: 152,
    54: 54,
    79: 79,
    81: 81
  }],
  68: [function (t, n, r) {
    var h = t(54),
        p = t(83),
        v = t(78),
        g = t(38),
        y = t(141),
        d = t(153),
        x = {},
        m = {};
    (r = n.exports = function (t, n, r, e, i) {
      var o,
          u,
          c,
          a,
          f = i ? function () {
        return t;
      } : d(t),
          s = h(r, e, n ? 2 : 1),
          l = 0;
      if ("function" != typeof f) throw TypeError(t + " is not iterable!");

      if (v(f)) {
        for (o = y(t.length); l < o; l++) {
          if ((a = n ? s(g(u = t[l])[0], u[1]) : s(t[l])) === x || a === m) return a;
        }
      } else for (c = f.call(t); !(u = c.next()).done;) {
        if ((a = p(c, s, u.value, n)) === x || a === m) return a;
      }
    }).BREAK = x, r.RETURN = m;
  }, {
    141: 141,
    153: 153,
    38: 38,
    54: 54,
    78: 78,
    83: 83
  }],
  69: [function (t, n, r) {
    n.exports = t(126)("native-function-to-string", Function.toString);
  }, {
    126: 126
  }],
  70: [function (t, n, r) {
    arguments[4][24][0].apply(r, arguments);
  }, {
    24: 24
  }],
  71: [function (t, n, r) {
    arguments[4][25][0].apply(r, arguments);
  }, {
    25: 25
  }],
  72: [function (t, n, r) {
    arguments[4][26][0].apply(r, arguments);
  }, {
    116: 116,
    26: 26,
    58: 58,
    99: 99
  }],
  73: [function (t, n, r) {
    var e = t(70).document;
    n.exports = e && e.documentElement;
  }, {
    70: 70
  }],
  74: [function (t, n, r) {
    arguments[4][27][0].apply(r, arguments);
  }, {
    27: 27,
    58: 58,
    59: 59,
    64: 64
  }],
  75: [function (t, n, r) {
    var o = t(81),
        u = t(122).set;

    n.exports = function (t, n, r) {
      var e,
          i = n.constructor;
      return i !== r && "function" == typeof i && (e = i.prototype) !== r.prototype && o(e) && u && u(t, e), t;
    };
  }, {
    122: 122,
    81: 81
  }],
  76: [function (t, n, r) {
    n.exports = function (t, n, r) {
      var e = void 0 === r;

      switch (n.length) {
        case 0:
          return e ? t() : t.call(r);

        case 1:
          return e ? t(n[0]) : t.call(r, n[0]);

        case 2:
          return e ? t(n[0], n[1]) : t.call(r, n[0], n[1]);

        case 3:
          return e ? t(n[0], n[1], n[2]) : t.call(r, n[0], n[1], n[2]);

        case 4:
          return e ? t(n[0], n[1], n[2], n[3]) : t.call(r, n[0], n[1], n[2], n[3]);
      }

      return t.apply(r, n);
    };
  }, {}],
  77: [function (t, n, r) {
    var e = t(48);
    n.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == e(t) ? t.split("") : Object(t);
    };
  }, {
    48: 48
  }],
  78: [function (t, n, r) {
    var e = t(88),
        i = t(152)("iterator"),
        o = Array.prototype;

    n.exports = function (t) {
      return void 0 !== t && (e.Array === t || o[i] === t);
    };
  }, {
    152: 152,
    88: 88
  }],
  79: [function (t, n, r) {
    var e = t(48);

    n.exports = Array.isArray || function isArray(t) {
      return "Array" == e(t);
    };
  }, {
    48: 48
  }],
  80: [function (t, n, r) {
    var e = t(81),
        i = Math.floor;

    n.exports = function isInteger(t) {
      return !e(t) && isFinite(t) && i(t) === t;
    };
  }, {
    81: 81
  }],
  81: [function (t, n, r) {
    arguments[4][28][0].apply(r, arguments);
  }, {
    28: 28
  }],
  82: [function (t, n, r) {
    var e = t(81),
        i = t(48),
        o = t(152)("match");

    n.exports = function (t) {
      var n;
      return e(t) && (void 0 !== (n = t[o]) ? !!n : "RegExp" == i(t));
    };
  }, {
    152: 152,
    48: 48,
    81: 81
  }],
  83: [function (t, n, r) {
    var o = t(38);

    n.exports = function (n, t, r, e) {
      try {
        return e ? t(o(r)[0], r[1]) : t(r);
      } catch (t) {
        var i = n["return"];
        throw void 0 !== i && o(i.call(n)), t;
      }
    };
  }, {
    38: 38
  }],
  84: [function (t, n, r) {
    "use strict";

    var e = t(98),
        i = t(116),
        o = t(124),
        u = {};
    t(72)(u, t(152)("iterator"), function () {
      return this;
    }), n.exports = function (t, n, r) {
      t.prototype = e(u, {
        next: i(1, r)
      }), o(t, n + " Iterator");
    };
  }, {
    116: 116,
    124: 124,
    152: 152,
    72: 72,
    98: 98
  }],
  85: [function (t, n, r) {
    "use strict";

    function Qn() {
      return this;
    }

    var x = t(89),
        m = t(62),
        S = t(118),
        b = t(72),
        w = t(88),
        _ = t(84),
        E = t(124),
        O = t(105),
        F = t(152)("iterator"),
        I = !([].keys && "next" in [].keys()),
        P = "values";

    n.exports = function (t, n, r, e, i, o, u) {
      _(r, n, e);

      function Yn(t) {
        if (!I && t in p) return p[t];

        switch (t) {
          case "keys":
            return function keys() {
              return new r(this, t);
            };

          case P:
            return function values() {
              return new r(this, t);
            };
        }

        return function entries() {
          return new r(this, t);
        };
      }

      var c,
          a,
          f,
          s = n + " Iterator",
          l = i == P,
          h = !1,
          p = t.prototype,
          v = p[F] || p["@@iterator"] || i && p[i],
          g = v || Yn(i),
          y = i ? l ? Yn("entries") : g : void 0,
          d = "Array" == n && p.entries || v;
      if (d && (f = O(d.call(new t()))) !== Object.prototype && f.next && (E(f, s, !0), x || "function" == typeof f[F] || b(f, F, Qn)), l && v && v.name !== P && (h = !0, g = function values() {
        return v.call(this);
      }), x && !u || !I && !h && p[F] || b(p, F, g), w[n] = g, w[s] = Qn, i) if (c = {
        values: l ? g : Yn(P),
        keys: o ? g : Yn("keys"),
        entries: y
      }, u) for (a in c) {
        a in p || S(p, a, c[a]);
      } else m(m.P + m.F * (I || h), n, c);
      return c;
    };
  }, {
    105: 105,
    118: 118,
    124: 124,
    152: 152,
    62: 62,
    72: 72,
    84: 84,
    88: 88,
    89: 89
  }],
  86: [function (t, n, r) {
    var o = t(152)("iterator"),
        u = !1;

    try {
      var e = [7][o]();
      e["return"] = function () {
        u = !0;
      }, Array.from(e, function () {
        throw 2;
      });
    } catch (t) {}

    n.exports = function (t, n) {
      if (!n && !u) return !1;
      var r = !1;

      try {
        var e = [7],
            i = e[o]();
        i.next = function () {
          return {
            done: r = !0
          };
        }, e[o] = function () {
          return i;
        }, t(e);
      } catch (t) {}

      return r;
    };
  }, {
    152: 152
  }],
  87: [function (t, n, r) {
    n.exports = function (t, n) {
      return {
        value: n,
        done: !!t
      };
    };
  }, {}],
  88: [function (t, n, r) {
    n.exports = {};
  }, {}],
  89: [function (t, n, r) {
    n.exports = !1;
  }, {}],
  90: [function (t, n, r) {
    var e = Math.expm1;
    n.exports = !e || 22025.465794806718 < e(10) || e(10) < 22025.465794806718 || -2e-17 != e(-2e-17) ? function expm1(t) {
      return 0 == (t = +t) ? t : -1e-6 < t && t < 1e-6 ? t + t * t / 2 : Math.exp(t) - 1;
    } : e;
  }, {}],
  91: [function (t, n, r) {
    var o = t(93),
        e = Math.pow,
        u = e(2, -52),
        c = e(2, -23),
        a = e(2, 127) * (2 - c),
        f = e(2, -126);

    n.exports = Math.fround || function fround(t) {
      var n,
          r,
          e = Math.abs(t),
          i = o(t);
      return e < f ? i * (e / f / c + 1 / u - 1 / u) * f * c : a < (r = (n = (1 + c / u) * e) - (n - e)) || r != r ? i * (1 / 0) : i * r;
    };
  }, {
    93: 93
  }],
  92: [function (t, n, r) {
    n.exports = Math.log1p || function log1p(t) {
      return -1e-8 < (t = +t) && t < 1e-8 ? t - t * t / 2 : Math.log(1 + t);
    };
  }, {}],
  93: [function (t, n, r) {
    n.exports = Math.sign || function sign(t) {
      return 0 == (t = +t) || t != t ? t : t < 0 ? -1 : 1;
    };
  }, {}],
  94: [function (t, n, r) {
    function tp(t) {
      u(t, e, {
        value: {
          i: "O" + ++c,
          w: {}
        }
      });
    }

    var e = t(147)("meta"),
        i = t(81),
        o = t(71),
        u = t(99).f,
        c = 0,
        a = Object.isExtensible || function () {
      return !0;
    },
        f = !t(64)(function () {
      return a(Object.preventExtensions({}));
    }),
        s = n.exports = {
      KEY: e,
      NEED: !1,
      fastKey: function fastKey(t, n) {
        if (!i(t)) return "symbol" == _typeof(t) ? t : ("string" == typeof t ? "S" : "P") + t;

        if (!o(t, e)) {
          if (!a(t)) return "F";
          if (!n) return "E";
          tp(t);
        }

        return t[e].i;
      },
      getWeak: function getWeak(t, n) {
        if (!o(t, e)) {
          if (!a(t)) return !0;
          if (!n) return !1;
          tp(t);
        }

        return t[e].w;
      },
      onFreeze: function onFreeze(t) {
        return f && s.NEED && a(t) && !o(t, e) && tp(t), t;
      }
    };
  }, {
    147: 147,
    64: 64,
    71: 71,
    81: 81,
    99: 99
  }],
  95: [function (t, n, r) {
    var u = t(70),
        c = t(136).set,
        a = u.MutationObserver || u.WebKitMutationObserver,
        f = u.process,
        s = u.Promise,
        l = "process" == t(48)(f);

    n.exports = function () {
      function Qp() {
        var t, n;

        for (l && (t = f.domain) && t.exit(); r;) {
          n = r.fn, r = r.next;

          try {
            n();
          } catch (t) {
            throw r ? i() : e = void 0, t;
          }
        }

        e = void 0, t && t.enter();
      }

      var r, e, i;
      if (l) i = function i() {
        f.nextTick(Qp);
      };else if (!a || u.navigator && u.navigator.standalone) {
        if (s && s.resolve) {
          var t = s.resolve(void 0);

          i = function i() {
            t.then(Qp);
          };
        } else i = function i() {
          c.call(u, Qp);
        };
      } else {
        var n = !0,
            o = document.createTextNode("");
        new a(Qp).observe(o, {
          characterData: !0
        }), i = function i() {
          o.data = n = !n;
        };
      }
      return function (t) {
        var n = {
          fn: t,
          next: void 0
        };
        e && (e.next = n), r || (r = n, i()), e = n;
      };
    };
  }, {
    136: 136,
    48: 48,
    70: 70
  }],
  96: [function (t, n, r) {
    "use strict";

    var i = t(33);

    function PromiseCapability(t) {
      var r, e;
      this.promise = new t(function (t, n) {
        if (void 0 !== r || void 0 !== e) throw TypeError("Bad Promise constructor");
        r = t, e = n;
      }), this.resolve = i(r), this.reject = i(e);
    }

    n.exports.f = function (t) {
      return new PromiseCapability(t);
    };
  }, {
    33: 33
  }],
  97: [function (t, n, r) {
    "use strict";

    var h = t(58),
        p = t(107),
        v = t(104),
        g = t(108),
        y = t(142),
        d = t(77),
        i = Object.assign;
    n.exports = !i || t(64)(function () {
      var t = {},
          n = {},
          r = Symbol(),
          e = "abcdefghijklmnopqrst";
      return t[r] = 7, e.split("").forEach(function (t) {
        n[t] = t;
      }), 7 != i({}, t)[r] || Object.keys(i({}, n)).join("") != e;
    }) ? function assign(t, n) {
      for (var r = y(t), e = arguments.length, i = 1, o = v.f, u = g.f; i < e;) {
        for (var c, a = d(arguments[i++]), f = o ? p(a).concat(o(a)) : p(a), s = f.length, l = 0; l < s;) {
          c = f[l++], h && !u.call(a, c) || (r[c] = a[c]);
        }
      }

      return r;
    } : i;
  }, {
    104: 104,
    107: 107,
    108: 108,
    142: 142,
    58: 58,
    64: 64,
    77: 77
  }],
  98: [function (e, t, n) {
    function Pq() {}

    var i = e(38),
        o = e(100),
        u = e(60),
        c = e(125)("IE_PROTO"),
        a = "prototype",
        _f = function f() {
      var t,
          n = e(59)("iframe"),
          r = u.length;

      for (n.style.display = "none", e(73).appendChild(n), n.src = "javascript:", (t = n.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), _f = t.F; r--;) {
        delete _f[a][u[r]];
      }

      return _f();
    };

    t.exports = Object.create || function create(t, n) {
      var r;
      return null !== t ? (Pq[a] = i(t), r = new Pq(), Pq[a] = null, r[c] = t) : r = _f(), void 0 === n ? r : o(r, n);
    };
  }, {
    100: 100,
    125: 125,
    38: 38,
    59: 59,
    60: 60,
    73: 73
  }],
  99: [function (t, n, r) {
    arguments[4][29][0].apply(r, arguments);
  }, {
    143: 143,
    29: 29,
    38: 38,
    58: 58,
    74: 74
  }],
  100: [function (t, n, r) {
    var u = t(99),
        c = t(38),
        a = t(107);
    n.exports = t(58) ? Object.defineProperties : function defineProperties(t, n) {
      c(t);

      for (var r, e = a(n), i = e.length, o = 0; o < i;) {
        u.f(t, r = e[o++], n[r]);
      }

      return t;
    };
  }, {
    107: 107,
    38: 38,
    58: 58,
    99: 99
  }],
  101: [function (t, n, r) {
    var e = t(108),
        i = t(116),
        o = t(140),
        u = t(143),
        c = t(71),
        a = t(74),
        f = Object.getOwnPropertyDescriptor;
    r.f = t(58) ? f : function getOwnPropertyDescriptor(t, n) {
      if (t = o(t), n = u(n, !0), a) try {
        return f(t, n);
      } catch (t) {}
      if (c(t, n)) return i(!e.f.call(t, n), t[n]);
    };
  }, {
    108: 108,
    116: 116,
    140: 140,
    143: 143,
    58: 58,
    71: 71,
    74: 74
  }],
  102: [function (t, n, r) {
    var e = t(140),
        i = t(103).f,
        o = {}.toString,
        u = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

    n.exports.f = function getOwnPropertyNames(t) {
      return u && "[object Window]" == o.call(t) ? function (t) {
        try {
          return i(t);
        } catch (t) {
          return u.slice();
        }
      }(t) : i(e(t));
    };
  }, {
    103: 103,
    140: 140
  }],
  103: [function (t, n, r) {
    var e = t(106),
        i = t(60).concat("length", "prototype");

    r.f = Object.getOwnPropertyNames || function getOwnPropertyNames(t) {
      return e(t, i);
    };
  }, {
    106: 106,
    60: 60
  }],
  104: [function (t, n, r) {
    r.f = Object.getOwnPropertySymbols;
  }, {}],
  105: [function (t, n, r) {
    var e = t(71),
        i = t(142),
        o = t(125)("IE_PROTO"),
        u = Object.prototype;

    n.exports = Object.getPrototypeOf || function (t) {
      return t = i(t), e(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? u : null;
    };
  }, {
    125: 125,
    142: 142,
    71: 71
  }],
  106: [function (t, n, r) {
    var u = t(71),
        c = t(140),
        a = t(41)(!1),
        f = t(125)("IE_PROTO");

    n.exports = function (t, n) {
      var r,
          e = c(t),
          i = 0,
          o = [];

      for (r in e) {
        r != f && u(e, r) && o.push(r);
      }

      for (; n.length > i;) {
        u(e, r = n[i++]) && (~a(o, r) || o.push(r));
      }

      return o;
    };
  }, {
    125: 125,
    140: 140,
    41: 41,
    71: 71
  }],
  107: [function (t, n, r) {
    var e = t(106),
        i = t(60);

    n.exports = Object.keys || function keys(t) {
      return e(t, i);
    };
  }, {
    106: 106,
    60: 60
  }],
  108: [function (t, n, r) {
    r.f = {}.propertyIsEnumerable;
  }, {}],
  109: [function (t, n, r) {
    var i = t(62),
        o = t(52),
        u = t(64);

    n.exports = function (t, n) {
      var r = (o.Object || {})[t] || Object[t],
          e = {};
      e[t] = n(r), i(i.S + i.F * u(function () {
        r(1);
      }), "Object", e);
    };
  }, {
    52: 52,
    62: 62,
    64: 64
  }],
  110: [function (t, n, r) {
    var a = t(58),
        f = t(107),
        s = t(140),
        l = t(108).f;

    n.exports = function (c) {
      return function (t) {
        for (var n, r = s(t), e = f(r), i = e.length, o = 0, u = []; o < i;) {
          n = e[o++], a && !l.call(r, n) || u.push(c ? [n, r[n]] : r[n]);
        }

        return u;
      };
    };
  }, {
    107: 107,
    108: 108,
    140: 140,
    58: 58
  }],
  111: [function (t, n, r) {
    var e = t(103),
        i = t(104),
        o = t(38),
        u = t(70).Reflect;

    n.exports = u && u.ownKeys || function ownKeys(t) {
      var n = e.f(o(t)),
          r = i.f;
      return r ? n.concat(r(t)) : n;
    };
  }, {
    103: 103,
    104: 104,
    38: 38,
    70: 70
  }],
  112: [function (t, n, r) {
    var e = t(70).parseFloat,
        i = t(134).trim;
    n.exports = 1 / e(t(135) + "-0") != -1 / 0 ? function parseFloat(t) {
      var n = i(String(t), 3),
          r = e(n);
      return 0 === r && "-" == n.charAt(0) ? -0 : r;
    } : e;
  }, {
    134: 134,
    135: 135,
    70: 70
  }],
  113: [function (t, n, r) {
    var e = t(70).parseInt,
        i = t(134).trim,
        o = t(135),
        u = /^[-+]?0[xX]/;
    n.exports = 8 !== e(o + "08") || 22 !== e(o + "0x16") ? function parseInt(t, n) {
      var r = i(String(t), 3);
      return e(r, n >>> 0 || (u.test(r) ? 16 : 10));
    } : e;
  }, {
    134: 134,
    135: 135,
    70: 70
  }],
  114: [function (t, n, r) {
    n.exports = function (t) {
      try {
        return {
          e: !1,
          v: t()
        };
      } catch (t) {
        return {
          e: !0,
          v: t
        };
      }
    };
  }, {}],
  115: [function (t, n, r) {
    var e = t(38),
        i = t(81),
        o = t(96);

    n.exports = function (t, n) {
      if (e(t), i(n) && n.constructor === t) return n;
      var r = o.f(t);
      return (0, r.resolve)(n), r.promise;
    };
  }, {
    38: 38,
    81: 81,
    96: 96
  }],
  116: [function (t, n, r) {
    arguments[4][30][0].apply(r, arguments);
  }, {
    30: 30
  }],
  117: [function (t, n, r) {
    var i = t(118);

    n.exports = function (t, n, r) {
      for (var e in n) {
        i(t, e, n[e], r);
      }

      return t;
    };
  }, {
    118: 118
  }],
  118: [function (t, n, r) {
    var o = t(70),
        u = t(72),
        c = t(71),
        a = t(147)("src"),
        e = t(69),
        i = "toString",
        f = ("" + e).split(i);
    t(52).inspectSource = function (t) {
      return e.call(t);
    }, (n.exports = function (t, n, r, e) {
      var i = "function" == typeof r;
      i && (c(r, "name") || u(r, "name", n)), t[n] !== r && (i && (c(r, a) || u(r, a, t[n] ? "" + t[n] : f.join(String(n)))), t === o ? t[n] = r : e ? t[n] ? t[n] = r : u(t, n, r) : (delete t[n], u(t, n, r)));
    })(Function.prototype, i, function toString() {
      return "function" == typeof this && this[a] || e.call(this);
    });
  }, {
    147: 147,
    52: 52,
    69: 69,
    70: 70,
    71: 71,
    72: 72
  }],
  119: [function (t, n, r) {
    "use strict";

    var i = t(47),
        o = RegExp.prototype.exec;

    n.exports = function (t, n) {
      var r = t.exec;

      if ("function" == typeof r) {
        var e = r.call(t, n);
        if ("object" != _typeof(e)) throw new TypeError("RegExp exec method returned something other than an Object or null");
        return e;
      }

      if ("RegExp" !== i(t)) throw new TypeError("RegExp#exec called on incompatible receiver");
      return o.call(t, n);
    };
  }, {
    47: 47
  }],
  120: [function (t, n, r) {
    "use strict";

    var e,
        i,
        u = t(66),
        c = RegExp.prototype.exec,
        a = String.prototype.replace,
        o = c,
        f = "lastIndex",
        s = (e = /a/, i = /b*/g, c.call(e, "a"), c.call(i, "a"), 0 !== e[f] || 0 !== i[f]),
        l = void 0 !== /()??/.exec("")[1];
    (s || l) && (o = function exec(t) {
      var n,
          r,
          e,
          i,
          o = this;
      return l && (r = new RegExp("^" + o.source + "$(?!\\s)", u.call(o))), s && (n = o[f]), e = c.call(o, t), s && e && (o[f] = o.global ? e.index + e[0].length : n), l && e && 1 < e.length && a.call(e[0], r, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          void 0 === arguments[i] && (e[i] = void 0);
        }
      }), e;
    }), n.exports = o;
  }, {
    66: 66
  }],
  121: [function (t, n, r) {
    n.exports = Object.is || function is(t, n) {
      return t === n ? 0 !== t || 1 / t == 1 / n : t != t && n != n;
    };
  }, {}],
  122: [function (n, t, r) {
    function Wu(t, n) {
      if (i(t), !e(n) && null !== n) throw TypeError(n + ": can't set as prototype!");
    }

    var e = n(81),
        i = n(38);
    t.exports = {
      set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, r, e) {
        try {
          (e = n(54)(Function.call, n(101).f(Object.prototype, "__proto__").set, 2))(t, []), r = !(t instanceof Array);
        } catch (t) {
          r = !0;
        }

        return function setPrototypeOf(t, n) {
          return Wu(t, n), r ? t.__proto__ = n : e(t, n), t;
        };
      }({}, !1) : void 0),
      check: Wu
    };
  }, {
    101: 101,
    38: 38,
    54: 54,
    81: 81
  }],
  123: [function (t, n, r) {
    "use strict";

    var e = t(70),
        i = t(99),
        o = t(58),
        u = t(152)("species");

    n.exports = function (t) {
      var n = e[t];
      o && n && !n[u] && i.f(n, u, {
        configurable: !0,
        get: function get() {
          return this;
        }
      });
    };
  }, {
    152: 152,
    58: 58,
    70: 70,
    99: 99
  }],
  124: [function (t, n, r) {
    var e = t(99).f,
        i = t(71),
        o = t(152)("toStringTag");

    n.exports = function (t, n, r) {
      t && !i(t = r ? t : t.prototype, o) && e(t, o, {
        configurable: !0,
        value: n
      });
    };
  }, {
    152: 152,
    71: 71,
    99: 99
  }],
  125: [function (t, n, r) {
    var e = t(126)("keys"),
        i = t(147);

    n.exports = function (t) {
      return e[t] || (e[t] = i(t));
    };
  }, {
    126: 126,
    147: 147
  }],
  126: [function (t, n, r) {
    var e = t(52),
        i = t(70),
        o = "__core-js_shared__",
        u = i[o] || (i[o] = {});
    (n.exports = function (t, n) {
      return u[t] || (u[t] = void 0 !== n ? n : {});
    })("versions", []).push({
      version: e.version,
      mode: t(89) ? "pure" : "global",
      copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
    });
  }, {
    52: 52,
    70: 70,
    89: 89
  }],
  127: [function (t, n, r) {
    var i = t(38),
        o = t(33),
        u = t(152)("species");

    n.exports = function (t, n) {
      var r,
          e = i(t).constructor;
      return void 0 === e || null == (r = i(e)[u]) ? n : o(r);
    };
  }, {
    152: 152,
    33: 33,
    38: 38
  }],
  128: [function (t, n, r) {
    "use strict";

    var e = t(64);

    n.exports = function (t, n) {
      return !!t && e(function () {
        n ? t.call(null, function () {}, 1) : t.call(null);
      });
    };
  }, {
    64: 64
  }],
  129: [function (t, n, r) {
    var a = t(139),
        f = t(57);

    n.exports = function (c) {
      return function (t, n) {
        var r,
            e,
            i = String(f(t)),
            o = a(n),
            u = i.length;
        return o < 0 || u <= o ? c ? "" : void 0 : (r = i.charCodeAt(o)) < 55296 || 56319 < r || o + 1 === u || (e = i.charCodeAt(o + 1)) < 56320 || 57343 < e ? c ? i.charAt(o) : r : c ? i.slice(o, o + 2) : e - 56320 + (r - 55296 << 10) + 65536;
      };
    };
  }, {
    139: 139,
    57: 57
  }],
  130: [function (t, n, r) {
    var e = t(82),
        i = t(57);

    n.exports = function (t, n, r) {
      if (e(n)) throw TypeError("String#" + r + " doesn't accept regex!");
      return String(i(t));
    };
  }, {
    57: 57,
    82: 82
  }],
  131: [function (t, n, r) {
    function Aw(t, n, r, e) {
      var i = String(u(t)),
          o = "<" + n;
      return "" !== r && (o += " " + r + '="' + String(e).replace(c, "&quot;") + '"'), o + ">" + i + "</" + n + ">";
    }

    var e = t(62),
        i = t(64),
        u = t(57),
        c = /"/g;

    n.exports = function (n, t) {
      var r = {};
      r[n] = t(Aw), e(e.P + e.F * i(function () {
        var t = ""[n]('"');
        return t !== t.toLowerCase() || 3 < t.split('"').length;
      }), "String", r);
    };
  }, {
    57: 57,
    62: 62,
    64: 64
  }],
  132: [function (t, n, r) {
    var s = t(141),
        l = t(133),
        h = t(57);

    n.exports = function (t, n, r, e) {
      var i = String(h(t)),
          o = i.length,
          u = void 0 === r ? " " : String(r),
          c = s(n);
      if (c <= o || "" == u) return i;
      var a = c - o,
          f = l.call(u, Math.ceil(a / u.length));
      return f.length > a && (f = f.slice(0, a)), e ? f + i : i + f;
    };
  }, {
    133: 133,
    141: 141,
    57: 57
  }],
  133: [function (t, n, r) {
    "use strict";

    var i = t(139),
        o = t(57);

    n.exports = function repeat(t) {
      var n = String(o(this)),
          r = "",
          e = i(t);
      if (e < 0 || e == 1 / 0) throw RangeError("Count can't be negative");

      for (; 0 < e; (e >>>= 1) && (n += n)) {
        1 & e && (r += n);
      }

      return r;
    };
  }, {
    139: 139,
    57: 57
  }],
  134: [function (t, n, r) {
    function tx(t, n, r) {
      var e = {},
          i = c(function () {
        return !!a[t]() || "​" != "​"[t]();
      }),
          o = e[t] = i ? n(s) : a[t];
      r && (e[r] = o), u(u.P + u.F * i, "String", e);
    }

    var u = t(62),
        e = t(57),
        c = t(64),
        a = t(135),
        i = "[" + a + "]",
        o = RegExp("^" + i + i + "*"),
        f = RegExp(i + i + "*$"),
        s = tx.trim = function (t, n) {
      return t = String(e(t)), 1 & n && (t = t.replace(o, "")), 2 & n && (t = t.replace(f, "")), t;
    };

    n.exports = tx;
  }, {
    135: 135,
    57: 57,
    62: 62,
    64: 64
  }],
  135: [function (t, n, r) {
    n.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
  }, {}],
  136: [function (t, n, r) {
    function Zx() {
      var t = +this;

      if (d.hasOwnProperty(t)) {
        var n = d[t];
        delete d[t], n();
      }
    }

    function $x(t) {
      Zx.call(t.data);
    }

    var e,
        i,
        o,
        u = t(54),
        c = t(76),
        a = t(73),
        f = t(59),
        s = t(70),
        l = s.process,
        h = s.setImmediate,
        p = s.clearImmediate,
        v = s.MessageChannel,
        g = s.Dispatch,
        y = 0,
        d = {},
        x = "onreadystatechange";
    h && p || (h = function setImmediate(t) {
      for (var n = [], r = 1; r < arguments.length;) {
        n.push(arguments[r++]);
      }

      return d[++y] = function () {
        c("function" == typeof t ? t : Function(t), n);
      }, e(y), y;
    }, p = function clearImmediate(t) {
      delete d[t];
    }, "process" == t(48)(l) ? e = function e(t) {
      l.nextTick(u(Zx, t, 1));
    } : g && g.now ? e = function e(t) {
      g.now(u(Zx, t, 1));
    } : v ? (o = (i = new v()).port2, i.port1.onmessage = $x, e = u(o.postMessage, o, 1)) : s.addEventListener && "function" == typeof postMessage && !s.importScripts ? (e = function e(t) {
      s.postMessage(t + "", "*");
    }, s.addEventListener("message", $x, !1)) : e = x in f("script") ? function (t) {
      a.appendChild(f("script"))[x] = function () {
        a.removeChild(this), Zx.call(t);
      };
    } : function (t) {
      setTimeout(u(Zx, t, 1), 0);
    }), n.exports = {
      set: h,
      clear: p
    };
  }, {
    48: 48,
    54: 54,
    59: 59,
    70: 70,
    73: 73,
    76: 76
  }],
  137: [function (t, n, r) {
    var e = t(139),
        i = Math.max,
        o = Math.min;

    n.exports = function (t, n) {
      return (t = e(t)) < 0 ? i(t + n, 0) : o(t, n);
    };
  }, {
    139: 139
  }],
  138: [function (t, n, r) {
    var e = t(139),
        i = t(141);

    n.exports = function (t) {
      if (void 0 === t) return 0;
      var n = e(t),
          r = i(n);
      if (n !== r) throw RangeError("Wrong length!");
      return r;
    };
  }, {
    139: 139,
    141: 141
  }],
  139: [function (t, n, r) {
    var e = Math.ceil,
        i = Math.floor;

    n.exports = function (t) {
      return isNaN(t = +t) ? 0 : (0 < t ? i : e)(t);
    };
  }, {}],
  140: [function (t, n, r) {
    var e = t(77),
        i = t(57);

    n.exports = function (t) {
      return e(i(t));
    };
  }, {
    57: 57,
    77: 77
  }],
  141: [function (t, n, r) {
    var e = t(139),
        i = Math.min;

    n.exports = function (t) {
      return 0 < t ? i(e(t), 9007199254740991) : 0;
    };
  }, {
    139: 139
  }],
  142: [function (t, n, r) {
    var e = t(57);

    n.exports = function (t) {
      return Object(e(t));
    };
  }, {
    57: 57
  }],
  143: [function (t, n, r) {
    arguments[4][31][0].apply(r, arguments);
  }, {
    31: 31,
    81: 81
  }],
  144: [function (t, n, r) {
    "use strict";

    if (t(58)) {
      var y = t(89),
          d = t(70),
          x = t(64),
          m = t(62),
          S = t(146),
          e = t(145),
          h = t(54),
          b = t(37),
          i = t(116),
          w = t(72),
          o = t(117),
          u = t(139),
          _ = t(141),
          E = t(138),
          c = t(137),
          a = t(143),
          f = t(71),
          O = t(47),
          F = t(81),
          p = t(142),
          v = t(78),
          I = t(98),
          P = t(105),
          A = t(103).f,
          g = t(153),
          s = t(147),
          l = t(152),
          M = t(42),
          k = t(41),
          N = t(127),
          j = t(164),
          R = t(88),
          T = t(86),
          L = t(123),
          C = t(40),
          G = t(39),
          D = t(99),
          U = t(101),
          W = D.f,
          V = U.f,
          B = d.RangeError,
          q = d.TypeError,
          Y = d.Uint8Array,
          z = "ArrayBuffer",
          X = "Shared" + z,
          $ = "BYTES_PER_ELEMENT",
          Q = "prototype",
          Z = Array[Q],
          J = e.ArrayBuffer,
          H = e.DataView,
          K = M(0),
          tt = M(2),
          nt = M(3),
          rt = M(4),
          et = M(5),
          it = M(6),
          ot = k(!0),
          ut = k(!1),
          ct = j.values,
          at = j.keys,
          ft = j.entries,
          st = Z.lastIndexOf,
          lt = Z.reduce,
          ht = Z.reduceRight,
          pt = Z.join,
          vt = Z.sort,
          gt = Z.slice,
          yt = Z.toString,
          dt = Z.toLocaleString,
          xt = l("iterator"),
          mt = l("toStringTag"),
          St = s("typed_constructor"),
          bt = s("def_constructor"),
          wt = S.CONSTR,
          _t = S.TYPED,
          Et = S.VIEW,
          Ot = "Wrong length!",
          Ft = M(1, function (t, n) {
        return kt(N(t, t[bt]), n);
      }),
          It = x(function () {
        return 1 === new Y(new Uint16Array([1]).buffer)[0];
      }),
          Pt = !!Y && !!Y[Q].set && x(function () {
        new Y(1).set({});
      }),
          At = function At(t, n) {
        var r = u(t);
        if (r < 0 || r % n) throw B("Wrong offset!");
        return r;
      },
          Mt = function Mt(t) {
        if (F(t) && _t in t) return t;
        throw q(t + " is not a typed array!");
      },
          kt = function kt(t, n) {
        if (!(F(t) && St in t)) throw q("It is not a typed array constructor!");
        return new t(n);
      },
          Nt = function Nt(t, n) {
        return jt(N(t, t[bt]), n);
      },
          jt = function jt(t, n) {
        for (var r = 0, e = n.length, i = kt(t, e); r < e;) {
          i[r] = n[r++];
        }

        return i;
      },
          Rt = function Rt(t, n, r) {
        W(t, n, {
          get: function get() {
            return this._d[r];
          }
        });
      },
          Tt = function from(t) {
        var n,
            r,
            e,
            i,
            o,
            u,
            c = p(t),
            a = arguments.length,
            f = 1 < a ? arguments[1] : void 0,
            s = void 0 !== f,
            l = g(c);

        if (null != l && !v(l)) {
          for (u = l.call(c), e = [], n = 0; !(o = u.next()).done; n++) {
            e.push(o.value);
          }

          c = e;
        }

        for (s && 2 < a && (f = h(f, arguments[2], 2)), n = 0, r = _(c.length), i = kt(this, r); n < r; n++) {
          i[n] = s ? f(c[n], n) : c[n];
        }

        return i;
      },
          Lt = function of() {
        for (var t = 0, n = arguments.length, r = kt(this, n); t < n;) {
          r[t] = arguments[t++];
        }

        return r;
      },
          Ct = !!Y && x(function () {
        dt.call(new Y(1));
      }),
          Gt = function toLocaleString() {
        return dt.apply(Ct ? gt.call(Mt(this)) : Mt(this), arguments);
      },
          Dt = {
        copyWithin: function copyWithin(t, n) {
          return G.call(Mt(this), t, n, 2 < arguments.length ? arguments[2] : void 0);
        },
        every: function every(t) {
          return rt(Mt(this), t, 1 < arguments.length ? arguments[1] : void 0);
        },
        fill: function fill(t) {
          return C.apply(Mt(this), arguments);
        },
        filter: function filter(t) {
          return Nt(this, tt(Mt(this), t, 1 < arguments.length ? arguments[1] : void 0));
        },
        find: function find(t) {
          return et(Mt(this), t, 1 < arguments.length ? arguments[1] : void 0);
        },
        findIndex: function findIndex(t) {
          return it(Mt(this), t, 1 < arguments.length ? arguments[1] : void 0);
        },
        forEach: function forEach(t) {
          K(Mt(this), t, 1 < arguments.length ? arguments[1] : void 0);
        },
        indexOf: function indexOf(t) {
          return ut(Mt(this), t, 1 < arguments.length ? arguments[1] : void 0);
        },
        includes: function includes(t) {
          return ot(Mt(this), t, 1 < arguments.length ? arguments[1] : void 0);
        },
        join: function join(t) {
          return pt.apply(Mt(this), arguments);
        },
        lastIndexOf: function lastIndexOf(t) {
          return st.apply(Mt(this), arguments);
        },
        map: function map(t) {
          return Ft(Mt(this), t, 1 < arguments.length ? arguments[1] : void 0);
        },
        reduce: function reduce(t) {
          return lt.apply(Mt(this), arguments);
        },
        reduceRight: function reduceRight(t) {
          return ht.apply(Mt(this), arguments);
        },
        reverse: function reverse() {
          for (var t, n = this, r = Mt(n).length, e = Math.floor(r / 2), i = 0; i < e;) {
            t = n[i], n[i++] = n[--r], n[r] = t;
          }

          return n;
        },
        some: function some(t) {
          return nt(Mt(this), t, 1 < arguments.length ? arguments[1] : void 0);
        },
        sort: function sort(t) {
          return vt.call(Mt(this), t);
        },
        subarray: function subarray(t, n) {
          var r = Mt(this),
              e = r.length,
              i = c(t, e);
          return new (N(r, r[bt]))(r.buffer, r.byteOffset + i * r.BYTES_PER_ELEMENT, _((void 0 === n ? e : c(n, e)) - i));
        }
      },
          Ut = function slice(t, n) {
        return Nt(this, gt.call(Mt(this), t, n));
      },
          Wt = function set(t) {
        Mt(this);

        var n = At(arguments[1], 1),
            r = this.length,
            e = p(t),
            i = _(e.length),
            o = 0;

        if (r < i + n) throw B(Ot);

        for (; o < i;) {
          this[n + o] = e[o++];
        }
      },
          Vt = {
        entries: function entries() {
          return ft.call(Mt(this));
        },
        keys: function keys() {
          return at.call(Mt(this));
        },
        values: function values() {
          return ct.call(Mt(this));
        }
      },
          Bt = function Bt(t, n) {
        return F(t) && t[_t] && "symbol" != _typeof(n) && n in t && String(+n) == String(n);
      },
          qt = function getOwnPropertyDescriptor(t, n) {
        return Bt(t, n = a(n, !0)) ? i(2, t[n]) : V(t, n);
      },
          Yt = function defineProperty(t, n, r) {
        return !(Bt(t, n = a(n, !0)) && F(r) && f(r, "value")) || f(r, "get") || f(r, "set") || r.configurable || f(r, "writable") && !r.writable || f(r, "enumerable") && !r.enumerable ? W(t, n, r) : (t[n] = r.value, t);
      };

      wt || (U.f = qt, D.f = Yt), m(m.S + m.F * !wt, "Object", {
        getOwnPropertyDescriptor: qt,
        defineProperty: Yt
      }), x(function () {
        yt.call({});
      }) && (yt = dt = function toString() {
        return pt.call(this);
      });
      var zt = o({}, Dt);
      o(zt, Vt), w(zt, xt, Vt.values), o(zt, {
        slice: Ut,
        set: Wt,
        constructor: function constructor() {},
        toString: yt,
        toLocaleString: Gt
      }), Rt(zt, "buffer", "b"), Rt(zt, "byteOffset", "o"), Rt(zt, "byteLength", "l"), Rt(zt, "length", "e"), W(zt, mt, {
        get: function get() {
          return this[_t];
        }
      }), n.exports = function (t, l, n, o) {
        function CC(t, i) {
          W(t, i, {
            get: function get() {
              return t = i, (n = this._d).v[r](t * l + n.o, It);
              var t, n;
            },
            set: function set(t) {
              return n = i, r = t, e = this._d, o && (r = (r = Math.round(r)) < 0 ? 0 : 255 < r ? 255 : 255 & r), void e.v[u](n * l + e.o, r, It);
              var n, r, e;
            },
            enumerable: !0
          });
        }

        var h = t + ((o = !!o) ? "Clamped" : "") + "Array",
            r = "get" + t,
            u = "set" + t,
            p = d[h],
            c = p || {},
            e = p && P(p),
            i = !p || !S.ABV,
            a = {},
            f = p && p[Q];
        i ? (p = n(function (t, n, r, e) {
          b(t, p, h, "_d");
          var i,
              o,
              u,
              c,
              a = 0,
              f = 0;

          if (F(n)) {
            if (!(n instanceof J || (c = O(n)) == z || c == X)) return _t in n ? jt(p, n) : Tt.call(p, n);
            i = n, f = At(r, l);
            var s = n.byteLength;

            if (void 0 === e) {
              if (s % l) throw B(Ot);
              if ((o = s - f) < 0) throw B(Ot);
            } else if (s < (o = _(e) * l) + f) throw B(Ot);

            u = o / l;
          } else u = E(n), i = new J(o = u * l);

          for (w(t, "_d", {
            b: i,
            o: f,
            l: o,
            e: u,
            v: new H(i)
          }); a < u;) {
            CC(t, a++);
          }
        }), f = p[Q] = I(zt), w(f, "constructor", p)) : x(function () {
          p(1);
        }) && x(function () {
          new p(-1);
        }) && T(function (t) {
          new p(), new p(null), new p(1.5), new p(t);
        }, !0) || (p = n(function (t, n, r, e) {
          var i;
          return b(t, p, h), F(n) ? n instanceof J || (i = O(n)) == z || i == X ? void 0 !== e ? new c(n, At(r, l), e) : void 0 !== r ? new c(n, At(r, l)) : new c(n) : _t in n ? jt(p, n) : Tt.call(p, n) : new c(E(n));
        }), K(e !== Function.prototype ? A(c).concat(A(e)) : A(c), function (t) {
          t in p || w(p, t, c[t]);
        }), p[Q] = f, y || (f.constructor = p));
        var s = f[xt],
            v = !!s && ("values" == s.name || null == s.name),
            g = Vt.values;
        w(p, St, !0), w(f, _t, h), w(f, Et, !0), w(f, bt, p), (o ? new p(1)[mt] == h : mt in f) || W(f, mt, {
          get: function get() {
            return h;
          }
        }), a[h] = p, m(m.G + m.W + m.F * (p != c), a), m(m.S, h, {
          BYTES_PER_ELEMENT: l
        }), m(m.S + m.F * x(function () {
          c.of.call(p, 1);
        }), h, {
          from: Tt,
          of: Lt
        }), $ in f || w(f, $, l), m(m.P, h, Dt), L(h), m(m.P + m.F * Pt, h, {
          set: Wt
        }), m(m.P + m.F * !v, h, Vt), y || f.toString == yt || (f.toString = yt), m(m.P + m.F * x(function () {
          new p(1).slice();
        }), h, {
          slice: Ut
        }), m(m.P + m.F * (x(function () {
          return [1, 2].toLocaleString() != new p([1, 2]).toLocaleString();
        }) || !x(function () {
          f.toLocaleString.call([1, 2]);
        })), h, {
          toLocaleString: Gt
        }), R[h] = v ? s : g, y || v || w(f, xt, g);
      };
    } else n.exports = function () {};
  }, {
    101: 101,
    103: 103,
    105: 105,
    116: 116,
    117: 117,
    123: 123,
    127: 127,
    137: 137,
    138: 138,
    139: 139,
    141: 141,
    142: 142,
    143: 143,
    145: 145,
    146: 146,
    147: 147,
    152: 152,
    153: 153,
    164: 164,
    37: 37,
    39: 39,
    40: 40,
    41: 41,
    42: 42,
    47: 47,
    54: 54,
    58: 58,
    62: 62,
    64: 64,
    70: 70,
    71: 71,
    72: 72,
    78: 78,
    81: 81,
    86: 86,
    88: 88,
    89: 89,
    98: 98,
    99: 99
  }],
  145: [function (t, n, r) {
    "use strict";

    var e = t(70),
        i = t(58),
        o = t(89),
        u = t(146),
        c = t(72),
        a = t(117),
        f = t(64),
        s = t(37),
        l = t(139),
        h = t(141),
        p = t(138),
        v = t(103).f,
        g = t(99).f,
        y = t(40),
        d = t(124),
        x = "ArrayBuffer",
        m = "DataView",
        S = "prototype",
        b = "Wrong index!",
        w = e[x],
        _ = e[m],
        E = e.Math,
        O = e.RangeError,
        F = e.Infinity,
        I = w,
        P = E.abs,
        A = E.pow,
        M = E.floor,
        k = E.log,
        N = E.LN2,
        j = "byteLength",
        R = "byteOffset",
        T = i ? "_b" : "buffer",
        L = i ? "_l" : j,
        C = i ? "_o" : R;

    function packIEEE754(t, n, r) {
      var e,
          i,
          o,
          u = new Array(r),
          c = 8 * r - n - 1,
          a = (1 << c) - 1,
          f = a >> 1,
          s = 23 === n ? A(2, -24) - A(2, -77) : 0,
          l = 0,
          h = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;

      for ((t = P(t)) != t || t === F ? (i = t != t ? 1 : 0, e = a) : (e = M(k(t) / N), t * (o = A(2, -e)) < 1 && (e--, o *= 2), 2 <= (t += 1 <= e + f ? s / o : s * A(2, 1 - f)) * o && (e++, o /= 2), a <= e + f ? (i = 0, e = a) : 1 <= e + f ? (i = (t * o - 1) * A(2, n), e += f) : (i = t * A(2, f - 1) * A(2, n), e = 0)); 8 <= n; u[l++] = 255 & i, i /= 256, n -= 8) {
        ;
      }

      for (e = e << n | i, c += n; 0 < c; u[l++] = 255 & e, e /= 256, c -= 8) {
        ;
      }

      return u[--l] |= 128 * h, u;
    }

    function unpackIEEE754(t, n, r) {
      var e,
          i = 8 * r - n - 1,
          o = (1 << i) - 1,
          u = o >> 1,
          c = i - 7,
          a = r - 1,
          f = t[a--],
          s = 127 & f;

      for (f >>= 7; 0 < c; s = 256 * s + t[a], a--, c -= 8) {
        ;
      }

      for (e = s & (1 << -c) - 1, s >>= -c, c += n; 0 < c; e = 256 * e + t[a], a--, c -= 8) {
        ;
      }

      if (0 === s) s = 1 - u;else {
        if (s === o) return e ? NaN : f ? -F : F;
        e += A(2, n), s -= u;
      }
      return (f ? -1 : 1) * e * A(2, s - n);
    }

    function unpackI32(t) {
      return t[3] << 24 | t[2] << 16 | t[1] << 8 | t[0];
    }

    function packI8(t) {
      return [255 & t];
    }

    function packI16(t) {
      return [255 & t, t >> 8 & 255];
    }

    function packI32(t) {
      return [255 & t, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255];
    }

    function packF64(t) {
      return packIEEE754(t, 52, 8);
    }

    function packF32(t) {
      return packIEEE754(t, 23, 4);
    }

    function addGetter(t, n, r) {
      g(t[S], n, {
        get: function get() {
          return this[r];
        }
      });
    }

    function get(t, n, r, e) {
      var i = p(+r);
      if (i + n > t[L]) throw O(b);
      var o = t[T]._b,
          u = i + t[C],
          c = o.slice(u, u + n);
      return e ? c : c.reverse();
    }

    function set(t, n, r, e, i, o) {
      var u = p(+r);
      if (u + n > t[L]) throw O(b);

      for (var c = t[T]._b, a = u + t[C], f = e(+i), s = 0; s < n; s++) {
        c[a + s] = f[o ? s : n - s - 1];
      }
    }

    if (u.ABV) {
      if (!f(function () {
        w(1);
      }) || !f(function () {
        new w(-1);
      }) || f(function () {
        return new w(), new w(1.5), new w(NaN), w.name != x;
      })) {
        for (var G, D = (w = function ArrayBuffer(t) {
          return s(this, w), new I(p(t));
        })[S] = I[S], U = v(I), W = 0; U.length > W;) {
          (G = U[W++]) in w || c(w, G, I[G]);
        }

        o || (D.constructor = w);
      }

      var V = new _(new w(2)),
          B = _[S].setInt8;
      V.setInt8(0, 2147483648), V.setInt8(1, 2147483649), !V.getInt8(0) && V.getInt8(1) || a(_[S], {
        setInt8: function setInt8(t, n) {
          B.call(this, t, n << 24 >> 24);
        },
        setUint8: function setUint8(t, n) {
          B.call(this, t, n << 24 >> 24);
        }
      }, !0);
    } else w = function ArrayBuffer(t) {
      s(this, w, x);
      var n = p(t);
      this._b = y.call(new Array(n), 0), this[L] = n;
    }, _ = function DataView(t, n, r) {
      s(this, _, m), s(t, w, m);
      var e = t[L],
          i = l(n);
      if (i < 0 || e < i) throw O("Wrong offset!");
      if (e < i + (r = void 0 === r ? e - i : h(r))) throw O("Wrong length!");
      this[T] = t, this[C] = i, this[L] = r;
    }, i && (addGetter(w, j, "_l"), addGetter(_, "buffer", "_b"), addGetter(_, j, "_l"), addGetter(_, R, "_o")), a(_[S], {
      getInt8: function getInt8(t) {
        return get(this, 1, t)[0] << 24 >> 24;
      },
      getUint8: function getUint8(t) {
        return get(this, 1, t)[0];
      },
      getInt16: function getInt16(t) {
        var n = get(this, 2, t, arguments[1]);
        return (n[1] << 8 | n[0]) << 16 >> 16;
      },
      getUint16: function getUint16(t) {
        var n = get(this, 2, t, arguments[1]);
        return n[1] << 8 | n[0];
      },
      getInt32: function getInt32(t) {
        return unpackI32(get(this, 4, t, arguments[1]));
      },
      getUint32: function getUint32(t) {
        return unpackI32(get(this, 4, t, arguments[1])) >>> 0;
      },
      getFloat32: function getFloat32(t) {
        return unpackIEEE754(get(this, 4, t, arguments[1]), 23, 4);
      },
      getFloat64: function getFloat64(t) {
        return unpackIEEE754(get(this, 8, t, arguments[1]), 52, 8);
      },
      setInt8: function setInt8(t, n) {
        set(this, 1, t, packI8, n);
      },
      setUint8: function setUint8(t, n) {
        set(this, 1, t, packI8, n);
      },
      setInt16: function setInt16(t, n) {
        set(this, 2, t, packI16, n, arguments[2]);
      },
      setUint16: function setUint16(t, n) {
        set(this, 2, t, packI16, n, arguments[2]);
      },
      setInt32: function setInt32(t, n) {
        set(this, 4, t, packI32, n, arguments[2]);
      },
      setUint32: function setUint32(t, n) {
        set(this, 4, t, packI32, n, arguments[2]);
      },
      setFloat32: function setFloat32(t, n) {
        set(this, 4, t, packF32, n, arguments[2]);
      },
      setFloat64: function setFloat64(t, n) {
        set(this, 8, t, packF64, n, arguments[2]);
      }
    });

    d(w, x), d(_, m), c(_[S], u.VIEW, !0), r[x] = w, r[m] = _;
  }, {
    103: 103,
    117: 117,
    124: 124,
    138: 138,
    139: 139,
    141: 141,
    146: 146,
    37: 37,
    40: 40,
    58: 58,
    64: 64,
    70: 70,
    72: 72,
    89: 89,
    99: 99
  }],
  146: [function (t, n, r) {
    for (var e, i = t(70), o = t(72), u = t(147), c = u("typed_array"), a = u("view"), f = !(!i.ArrayBuffer || !i.DataView), s = f, l = 0, h = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(","); l < 9;) {
      (e = i[h[l++]]) ? (o(e.prototype, c, !0), o(e.prototype, a, !0)) : s = !1;
    }

    n.exports = {
      ABV: f,
      CONSTR: s,
      TYPED: c,
      VIEW: a
    };
  }, {
    147: 147,
    70: 70,
    72: 72
  }],
  147: [function (t, n, r) {
    var e = 0,
        i = Math.random();

    n.exports = function (t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++e + i).toString(36));
    };
  }, {}],
  148: [function (t, n, r) {
    var e = t(70).navigator;
    n.exports = e && e.userAgent || "";
  }, {
    70: 70
  }],
  149: [function (t, n, r) {
    var e = t(81);

    n.exports = function (t, n) {
      if (!e(t) || t._t !== n) throw TypeError("Incompatible receiver, " + n + " required!");
      return t;
    };
  }, {
    81: 81
  }],
  150: [function (t, n, r) {
    var e = t(70),
        i = t(52),
        o = t(89),
        u = t(151),
        c = t(99).f;

    n.exports = function (t) {
      var n = i.Symbol || (i.Symbol = o ? {} : e.Symbol || {});
      "_" == t.charAt(0) || t in n || c(n, t, {
        value: u.f(t)
      });
    };
  }, {
    151: 151,
    52: 52,
    70: 70,
    89: 89,
    99: 99
  }],
  151: [function (t, n, r) {
    r.f = t(152);
  }, {
    152: 152
  }],
  152: [function (t, n, r) {
    var e = t(126)("wks"),
        i = t(147),
        o = t(70).Symbol,
        u = "function" == typeof o;
    (n.exports = function (t) {
      return e[t] || (e[t] = u && o[t] || (u ? o : i)("Symbol." + t));
    }).store = e;
  }, {
    126: 126,
    147: 147,
    70: 70
  }],
  153: [function (t, n, r) {
    var e = t(47),
        i = t(152)("iterator"),
        o = t(88);

    n.exports = t(52).getIteratorMethod = function (t) {
      if (null != t) return t[i] || t["@@iterator"] || o[e(t)];
    };
  }, {
    152: 152,
    47: 47,
    52: 52,
    88: 88
  }],
  154: [function (t, n, r) {
    var e = t(62);
    e(e.P, "Array", {
      copyWithin: t(39)
    }), t(35)("copyWithin");
  }, {
    35: 35,
    39: 39,
    62: 62
  }],
  155: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(42)(4);
    e(e.P + e.F * !t(128)([].every, !0), "Array", {
      every: function every(t) {
        return i(this, t, arguments[1]);
      }
    });
  }, {
    128: 128,
    42: 42,
    62: 62
  }],
  156: [function (t, n, r) {
    var e = t(62);
    e(e.P, "Array", {
      fill: t(40)
    }), t(35)("fill");
  }, {
    35: 35,
    40: 40,
    62: 62
  }],
  157: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(42)(2);
    e(e.P + e.F * !t(128)([].filter, !0), "Array", {
      filter: function filter(t) {
        return i(this, t, arguments[1]);
      }
    });
  }, {
    128: 128,
    42: 42,
    62: 62
  }],
  158: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(42)(6),
        o = "findIndex",
        u = !0;
    o in [] && Array(1)[o](function () {
      u = !1;
    }), e(e.P + e.F * u, "Array", {
      findIndex: function findIndex(t) {
        return i(this, t, 1 < arguments.length ? arguments[1] : void 0);
      }
    }), t(35)(o);
  }, {
    35: 35,
    42: 42,
    62: 62
  }],
  159: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(42)(5),
        o = "find",
        u = !0;
    o in [] && Array(1)[o](function () {
      u = !1;
    }), e(e.P + e.F * u, "Array", {
      find: function find(t) {
        return i(this, t, 1 < arguments.length ? arguments[1] : void 0);
      }
    }), t(35)(o);
  }, {
    35: 35,
    42: 42,
    62: 62
  }],
  160: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(42)(0),
        o = t(128)([].forEach, !0);
    e(e.P + e.F * !o, "Array", {
      forEach: function forEach(t) {
        return i(this, t, arguments[1]);
      }
    });
  }, {
    128: 128,
    42: 42,
    62: 62
  }],
  161: [function (t, n, r) {
    "use strict";

    var h = t(54),
        e = t(62),
        p = t(142),
        v = t(83),
        g = t(78),
        y = t(141),
        d = t(53),
        x = t(153);
    e(e.S + e.F * !t(86)(function (t) {
      Array.from(t);
    }), "Array", {
      from: function from(t) {
        var n,
            r,
            e,
            i,
            o = p(t),
            u = "function" == typeof this ? this : Array,
            c = arguments.length,
            a = 1 < c ? arguments[1] : void 0,
            f = void 0 !== a,
            s = 0,
            l = x(o);
        if (f && (a = h(a, 2 < c ? arguments[2] : void 0, 2)), null == l || u == Array && g(l)) for (r = new u(n = y(o.length)); s < n; s++) {
          d(r, s, f ? a(o[s], s) : o[s]);
        } else for (i = l.call(o), r = new u(); !(e = i.next()).done; s++) {
          d(r, s, f ? v(i, a, [e.value, s], !0) : e.value);
        }
        return r.length = s, r;
      }
    });
  }, {
    141: 141,
    142: 142,
    153: 153,
    53: 53,
    54: 54,
    62: 62,
    78: 78,
    83: 83,
    86: 86
  }],
  162: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(41)(!1),
        o = [].indexOf,
        u = !!o && 1 / [1].indexOf(1, -0) < 0;
    e(e.P + e.F * (u || !t(128)(o)), "Array", {
      indexOf: function indexOf(t) {
        return u ? o.apply(this, arguments) || 0 : i(this, t, arguments[1]);
      }
    });
  }, {
    128: 128,
    41: 41,
    62: 62
  }],
  163: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Array", {
      isArray: t(79)
    });
  }, {
    62: 62,
    79: 79
  }],
  164: [function (t, n, r) {
    "use strict";

    var e = t(35),
        i = t(87),
        o = t(88),
        u = t(140);
    n.exports = t(85)(Array, "Array", function (t, n) {
      this._t = u(t), this._i = 0, this._k = n;
    }, function () {
      var t = this._t,
          n = this._k,
          r = this._i++;
      return !t || r >= t.length ? (this._t = void 0, i(1)) : i(0, "keys" == n ? r : "values" == n ? t[r] : [r, t[r]]);
    }, "values"), o.Arguments = o.Array, e("keys"), e("values"), e("entries");
  }, {
    140: 140,
    35: 35,
    85: 85,
    87: 87,
    88: 88
  }],
  165: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(140),
        o = [].join;
    e(e.P + e.F * (t(77) != Object || !t(128)(o)), "Array", {
      join: function join(t) {
        return o.call(i(this), void 0 === t ? "," : t);
      }
    });
  }, {
    128: 128,
    140: 140,
    62: 62,
    77: 77
  }],
  166: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(140),
        o = t(139),
        u = t(141),
        c = [].lastIndexOf,
        a = !!c && 1 / [1].lastIndexOf(1, -0) < 0;
    e(e.P + e.F * (a || !t(128)(c)), "Array", {
      lastIndexOf: function lastIndexOf(t) {
        if (a) return c.apply(this, arguments) || 0;
        var n = i(this),
            r = u(n.length),
            e = r - 1;

        for (1 < arguments.length && (e = Math.min(e, o(arguments[1]))), e < 0 && (e = r + e); 0 <= e; e--) {
          if (e in n && n[e] === t) return e || 0;
        }

        return -1;
      }
    });
  }, {
    128: 128,
    139: 139,
    140: 140,
    141: 141,
    62: 62
  }],
  167: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(42)(1);
    e(e.P + e.F * !t(128)([].map, !0), "Array", {
      map: function map(t) {
        return i(this, t, arguments[1]);
      }
    });
  }, {
    128: 128,
    42: 42,
    62: 62
  }],
  168: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(53);
    e(e.S + e.F * t(64)(function () {
      function F() {}

      return !(Array.of.call(F) instanceof F);
    }), "Array", {
      of: function of() {
        for (var t = 0, n = arguments.length, r = new ("function" == typeof this ? this : Array)(n); t < n;) {
          i(r, t, arguments[t++]);
        }

        return r.length = n, r;
      }
    });
  }, {
    53: 53,
    62: 62,
    64: 64
  }],
  169: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(43);
    e(e.P + e.F * !t(128)([].reduceRight, !0), "Array", {
      reduceRight: function reduceRight(t) {
        return i(this, t, arguments.length, arguments[1], !0);
      }
    });
  }, {
    128: 128,
    43: 43,
    62: 62
  }],
  170: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(43);
    e(e.P + e.F * !t(128)([].reduce, !0), "Array", {
      reduce: function reduce(t) {
        return i(this, t, arguments.length, arguments[1], !1);
      }
    });
  }, {
    128: 128,
    43: 43,
    62: 62
  }],
  171: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(73),
        f = t(48),
        s = t(137),
        l = t(141),
        h = [].slice;
    e(e.P + e.F * t(64)(function () {
      i && h.call(i);
    }), "Array", {
      slice: function slice(t, n) {
        var r = l(this.length),
            e = f(this);
        if (n = void 0 === n ? r : n, "Array" == e) return h.call(this, t, n);

        for (var i = s(t, r), o = s(n, r), u = l(o - i), c = new Array(u), a = 0; a < u; a++) {
          c[a] = "String" == e ? this.charAt(i + a) : this[i + a];
        }

        return c;
      }
    });
  }, {
    137: 137,
    141: 141,
    48: 48,
    62: 62,
    64: 64,
    73: 73
  }],
  172: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(42)(3);
    e(e.P + e.F * !t(128)([].some, !0), "Array", {
      some: function some(t) {
        return i(this, t, arguments[1]);
      }
    });
  }, {
    128: 128,
    42: 42,
    62: 62
  }],
  173: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(33),
        o = t(142),
        u = t(64),
        c = [].sort,
        a = [1, 2, 3];
    e(e.P + e.F * (u(function () {
      a.sort(void 0);
    }) || !u(function () {
      a.sort(null);
    }) || !t(128)(c)), "Array", {
      sort: function sort(t) {
        return void 0 === t ? c.call(o(this)) : c.call(o(this), i(t));
      }
    });
  }, {
    128: 128,
    142: 142,
    33: 33,
    62: 62,
    64: 64
  }],
  174: [function (t, n, r) {
    t(123)("Array");
  }, {
    123: 123
  }],
  175: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Date", {
      now: function now() {
        return new Date().getTime();
      }
    });
  }, {
    62: 62
  }],
  176: [function (t, n, r) {
    var e = t(62),
        i = t(55);
    e(e.P + e.F * (Date.prototype.toISOString !== i), "Date", {
      toISOString: i
    });
  }, {
    55: 55,
    62: 62
  }],
  177: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(142),
        o = t(143);
    e(e.P + e.F * t(64)(function () {
      return null !== new Date(NaN).toJSON() || 1 !== Date.prototype.toJSON.call({
        toISOString: function toISOString() {
          return 1;
        }
      });
    }), "Date", {
      toJSON: function toJSON(t) {
        var n = i(this),
            r = o(n);
        return "number" != typeof r || isFinite(r) ? n.toISOString() : null;
      }
    });
  }, {
    142: 142,
    143: 143,
    62: 62,
    64: 64
  }],
  178: [function (t, n, r) {
    var e = t(152)("toPrimitive"),
        i = Date.prototype;
    e in i || t(72)(i, e, t(56));
  }, {
    152: 152,
    56: 56,
    72: 72
  }],
  179: [function (t, n, r) {
    var e = Date.prototype,
        i = "Invalid Date",
        o = "toString",
        u = e[o],
        c = e.getTime;
    new Date(NaN) + "" != i && t(118)(e, o, function toString() {
      var t = c.call(this);
      return t == t ? u.call(this) : i;
    });
  }, {
    118: 118
  }],
  180: [function (t, n, r) {
    var e = t(62);
    e(e.P, "Function", {
      bind: t(46)
    });
  }, {
    46: 46,
    62: 62
  }],
  181: [function (t, n, r) {
    "use strict";

    var e = t(81),
        i = t(105),
        o = t(152)("hasInstance"),
        u = Function.prototype;
    o in u || t(99).f(u, o, {
      value: function value(t) {
        if ("function" != typeof this || !e(t)) return !1;
        if (!e(this.prototype)) return t instanceof this;

        for (; t = i(t);) {
          if (this.prototype === t) return !0;
        }

        return !1;
      }
    });
  }, {
    105: 105,
    152: 152,
    81: 81,
    99: 99
  }],
  182: [function (t, n, r) {
    var e = t(99).f,
        i = Function.prototype,
        o = /^\s*function ([^ (]*)/;
    "name" in i || t(58) && e(i, "name", {
      configurable: !0,
      get: function get() {
        try {
          return ("" + this).match(o)[1];
        } catch (t) {
          return "";
        }
      }
    });
  }, {
    58: 58,
    99: 99
  }],
  183: [function (t, n, r) {
    "use strict";

    var e = t(49),
        i = t(149);
    n.exports = t(51)("Map", function (t) {
      return function Map() {
        return t(this, 0 < arguments.length ? arguments[0] : void 0);
      };
    }, {
      get: function get(t) {
        var n = e.getEntry(i(this, "Map"), t);
        return n && n.v;
      },
      set: function set(t, n) {
        return e.def(i(this, "Map"), 0 === t ? 0 : t, n);
      }
    }, e, !0);
  }, {
    149: 149,
    49: 49,
    51: 51
  }],
  184: [function (t, n, r) {
    var e = t(62),
        i = t(92),
        o = Math.sqrt,
        u = Math.acosh;
    e(e.S + e.F * !(u && 710 == Math.floor(u(Number.MAX_VALUE)) && u(1 / 0) == 1 / 0), "Math", {
      acosh: function acosh(t) {
        return (t = +t) < 1 ? NaN : 94906265.62425156 < t ? Math.log(t) + Math.LN2 : i(t - 1 + o(t - 1) * o(t + 1));
      }
    });
  }, {
    62: 62,
    92: 92
  }],
  185: [function (t, n, r) {
    var e = t(62),
        i = Math.asinh;
    e(e.S + e.F * !(i && 0 < 1 / i(0)), "Math", {
      asinh: function asinh(t) {
        return isFinite(t = +t) && 0 != t ? t < 0 ? -asinh(-t) : Math.log(t + Math.sqrt(t * t + 1)) : t;
      }
    });
  }, {
    62: 62
  }],
  186: [function (t, n, r) {
    var e = t(62),
        i = Math.atanh;
    e(e.S + e.F * !(i && 1 / i(-0) < 0), "Math", {
      atanh: function atanh(t) {
        return 0 == (t = +t) ? t : Math.log((1 + t) / (1 - t)) / 2;
      }
    });
  }, {
    62: 62
  }],
  187: [function (t, n, r) {
    var e = t(62),
        i = t(93);
    e(e.S, "Math", {
      cbrt: function cbrt(t) {
        return i(t = +t) * Math.pow(Math.abs(t), 1 / 3);
      }
    });
  }, {
    62: 62,
    93: 93
  }],
  188: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Math", {
      clz32: function clz32(t) {
        return (t >>>= 0) ? 31 - Math.floor(Math.log(t + .5) * Math.LOG2E) : 32;
      }
    });
  }, {
    62: 62
  }],
  189: [function (t, n, r) {
    var e = t(62),
        i = Math.exp;
    e(e.S, "Math", {
      cosh: function cosh(t) {
        return (i(t = +t) + i(-t)) / 2;
      }
    });
  }, {
    62: 62
  }],
  190: [function (t, n, r) {
    var e = t(62),
        i = t(90);
    e(e.S + e.F * (i != Math.expm1), "Math", {
      expm1: i
    });
  }, {
    62: 62,
    90: 90
  }],
  191: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Math", {
      fround: t(91)
    });
  }, {
    62: 62,
    91: 91
  }],
  192: [function (t, n, r) {
    var e = t(62),
        a = Math.abs;
    e(e.S, "Math", {
      hypot: function hypot(t, n) {
        for (var r, e, i = 0, o = 0, u = arguments.length, c = 0; o < u;) {
          c < (r = a(arguments[o++])) ? (i = i * (e = c / r) * e + 1, c = r) : i += 0 < r ? (e = r / c) * e : r;
        }

        return c === 1 / 0 ? 1 / 0 : c * Math.sqrt(i);
      }
    });
  }, {
    62: 62
  }],
  193: [function (t, n, r) {
    var e = t(62),
        i = Math.imul;
    e(e.S + e.F * t(64)(function () {
      return -5 != i(4294967295, 5) || 2 != i.length;
    }), "Math", {
      imul: function imul(t, n) {
        var r = 65535,
            e = +t,
            i = +n,
            o = r & e,
            u = r & i;
        return 0 | o * u + ((r & e >>> 16) * u + o * (r & i >>> 16) << 16 >>> 0);
      }
    });
  }, {
    62: 62,
    64: 64
  }],
  194: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Math", {
      log10: function log10(t) {
        return Math.log(t) * Math.LOG10E;
      }
    });
  }, {
    62: 62
  }],
  195: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Math", {
      log1p: t(92)
    });
  }, {
    62: 62,
    92: 92
  }],
  196: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Math", {
      log2: function log2(t) {
        return Math.log(t) / Math.LN2;
      }
    });
  }, {
    62: 62
  }],
  197: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Math", {
      sign: t(93)
    });
  }, {
    62: 62,
    93: 93
  }],
  198: [function (t, n, r) {
    var e = t(62),
        i = t(90),
        o = Math.exp;
    e(e.S + e.F * t(64)(function () {
      return -2e-17 != !Math.sinh(-2e-17);
    }), "Math", {
      sinh: function sinh(t) {
        return Math.abs(t = +t) < 1 ? (i(t) - i(-t)) / 2 : (o(t - 1) - o(-t - 1)) * (Math.E / 2);
      }
    });
  }, {
    62: 62,
    64: 64,
    90: 90
  }],
  199: [function (t, n, r) {
    var e = t(62),
        i = t(90),
        o = Math.exp;
    e(e.S, "Math", {
      tanh: function tanh(t) {
        var n = i(t = +t),
            r = i(-t);
        return n == 1 / 0 ? 1 : r == 1 / 0 ? -1 : (n - r) / (o(t) + o(-t));
      }
    });
  }, {
    62: 62,
    90: 90
  }],
  200: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Math", {
      trunc: function trunc(t) {
        return (0 < t ? Math.floor : Math.ceil)(t);
      }
    });
  }, {
    62: 62
  }],
  201: [function (t, n, r) {
    "use strict";

    function EN(t) {
      var n = s(t, !1);

      if ("string" == typeof n && 2 < n.length) {
        var r,
            e,
            i,
            o = (n = x ? n.trim() : h(n, 3)).charCodeAt(0);

        if (43 === o || 45 === o) {
          if (88 === (r = n.charCodeAt(2)) || 120 === r) return NaN;
        } else if (48 === o) {
          switch (n.charCodeAt(1)) {
            case 66:
            case 98:
              e = 2, i = 49;
              break;

            case 79:
            case 111:
              e = 8, i = 55;
              break;

            default:
              return +n;
          }

          for (var u, c = n.slice(2), a = 0, f = c.length; a < f; a++) {
            if ((u = c.charCodeAt(a)) < 48 || i < u) return NaN;
          }

          return parseInt(c, e);
        }
      }

      return +n;
    }

    var e = t(70),
        i = t(71),
        o = t(48),
        u = t(75),
        s = t(143),
        c = t(64),
        a = t(103).f,
        f = t(101).f,
        l = t(99).f,
        h = t(134).trim,
        p = "Number",
        v = e[p],
        g = v,
        y = v.prototype,
        d = o(t(98)(y)) == p,
        x = "trim" in String.prototype;

    if (!v(" 0o1") || !v("0b1") || v("+0x1")) {
      v = function Number(t) {
        var n = arguments.length < 1 ? 0 : t,
            r = this;
        return r instanceof v && (d ? c(function () {
          y.valueOf.call(r);
        }) : o(r) != p) ? u(new g(EN(n)), r, v) : EN(n);
      };

      for (var m, S = t(58) ? a(g) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), b = 0; S.length > b; b++) {
        i(g, m = S[b]) && !i(v, m) && l(v, m, f(g, m));
      }

      (v.prototype = y).constructor = v, t(118)(e, p, v);
    }
  }, {
    101: 101,
    103: 103,
    118: 118,
    134: 134,
    143: 143,
    48: 48,
    58: 58,
    64: 64,
    70: 70,
    71: 71,
    75: 75,
    98: 98,
    99: 99
  }],
  202: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Number", {
      EPSILON: Math.pow(2, -52)
    });
  }, {
    62: 62
  }],
  203: [function (t, n, r) {
    var e = t(62),
        i = t(70).isFinite;
    e(e.S, "Number", {
      isFinite: function isFinite(t) {
        return "number" == typeof t && i(t);
      }
    });
  }, {
    62: 62,
    70: 70
  }],
  204: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Number", {
      isInteger: t(80)
    });
  }, {
    62: 62,
    80: 80
  }],
  205: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Number", {
      isNaN: function isNaN(t) {
        return t != t;
      }
    });
  }, {
    62: 62
  }],
  206: [function (t, n, r) {
    var e = t(62),
        i = t(80),
        o = Math.abs;
    e(e.S, "Number", {
      isSafeInteger: function isSafeInteger(t) {
        return i(t) && o(t) <= 9007199254740991;
      }
    });
  }, {
    62: 62,
    80: 80
  }],
  207: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Number", {
      MAX_SAFE_INTEGER: 9007199254740991
    });
  }, {
    62: 62
  }],
  208: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Number", {
      MIN_SAFE_INTEGER: -9007199254740991
    });
  }, {
    62: 62
  }],
  209: [function (t, n, r) {
    var e = t(62),
        i = t(112);
    e(e.S + e.F * (Number.parseFloat != i), "Number", {
      parseFloat: i
    });
  }, {
    112: 112,
    62: 62
  }],
  210: [function (t, n, r) {
    var e = t(62),
        i = t(113);
    e(e.S + e.F * (Number.parseInt != i), "Number", {
      parseInt: i
    });
  }, {
    113: 113,
    62: 62
  }],
  211: [function (t, n, r) {
    "use strict";

    function XO(t, n) {
      for (var r = -1, e = n; ++r < 6;) {
        e += t * u[r], u[r] = e % 1e7, e = o(e / 1e7);
      }
    }

    function YO(t) {
      for (var n = 6, r = 0; 0 <= --n;) {
        r += u[n], u[n] = o(r / t), r = r % t * 1e7;
      }
    }

    function ZO() {
      for (var t = 6, n = ""; 0 <= --t;) {
        if ("" !== n || 0 === t || 0 !== u[t]) {
          var r = String(u[t]);
          n = "" === n ? r : n + l.call("0", 7 - r.length) + r;
        }
      }

      return n;
    }

    var e = t(62),
        f = t(139),
        s = t(34),
        l = t(133),
        i = 1..toFixed,
        o = Math.floor,
        u = [0, 0, 0, 0, 0, 0],
        h = "Number.toFixed: incorrect invocation!",
        p = function p(t, n, r) {
      return 0 === n ? r : n % 2 == 1 ? p(t, n - 1, r * t) : p(t * t, n / 2, r);
    };

    e(e.P + e.F * (!!i && ("0.000" !== 8e-5.toFixed(3) || "1" !== .9.toFixed(0) || "1.25" !== 1.255.toFixed(2) || "1000000000000000128" !== 0xde0b6b3a7640080.toFixed(0)) || !t(64)(function () {
      i.call({});
    })), "Number", {
      toFixed: function toFixed(t) {
        var n,
            r,
            e,
            i,
            o = s(this, h),
            u = f(t),
            c = "",
            a = "0";
        if (u < 0 || 20 < u) throw RangeError(h);
        if (o != o) return "NaN";
        if (o <= -1e21 || 1e21 <= o) return String(o);
        if (o < 0 && (c = "-", o = -o), 1e-21 < o) if (r = (n = function (t) {
          for (var n = 0, r = t; 4096 <= r;) {
            n += 12, r /= 4096;
          }

          for (; 2 <= r;) {
            n += 1, r /= 2;
          }

          return n;
        }(o * p(2, 69, 1)) - 69) < 0 ? o * p(2, -n, 1) : o / p(2, n, 1), r *= 4503599627370496, 0 < (n = 52 - n)) {
          for (XO(0, r), e = u; 7 <= e;) {
            XO(1e7, 0), e -= 7;
          }

          for (XO(p(10, e, 1), 0), e = n - 1; 23 <= e;) {
            YO(1 << 23), e -= 23;
          }

          YO(1 << e), XO(1, 1), YO(2), a = ZO();
        } else XO(0, r), XO(1 << -n, 0), a = ZO() + l.call("0", u);
        return a = 0 < u ? c + ((i = a.length) <= u ? "0." + l.call("0", u - i) + a : a.slice(0, i - u) + "." + a.slice(i - u)) : c + a;
      }
    });
  }, {
    133: 133,
    139: 139,
    34: 34,
    62: 62,
    64: 64
  }],
  212: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(64),
        o = t(34),
        u = 1..toPrecision;
    e(e.P + e.F * (i(function () {
      return "1" !== u.call(1, void 0);
    }) || !i(function () {
      u.call({});
    })), "Number", {
      toPrecision: function toPrecision(t) {
        var n = o(this, "Number#toPrecision: incorrect invocation!");
        return void 0 === t ? u.call(n) : u.call(n, t);
      }
    });
  }, {
    34: 34,
    62: 62,
    64: 64
  }],
  213: [function (t, n, r) {
    var e = t(62);
    e(e.S + e.F, "Object", {
      assign: t(97)
    });
  }, {
    62: 62,
    97: 97
  }],
  214: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Object", {
      create: t(98)
    });
  }, {
    62: 62,
    98: 98
  }],
  215: [function (t, n, r) {
    var e = t(62);
    e(e.S + e.F * !t(58), "Object", {
      defineProperties: t(100)
    });
  }, {
    100: 100,
    58: 58,
    62: 62
  }],
  216: [function (t, n, r) {
    var e = t(62);
    e(e.S + e.F * !t(58), "Object", {
      defineProperty: t(99).f
    });
  }, {
    58: 58,
    62: 62,
    99: 99
  }],
  217: [function (t, n, r) {
    var e = t(81),
        i = t(94).onFreeze;
    t(109)("freeze", function (n) {
      return function freeze(t) {
        return n && e(t) ? n(i(t)) : t;
      };
    });
  }, {
    109: 109,
    81: 81,
    94: 94
  }],
  218: [function (t, n, r) {
    var e = t(140),
        i = t(101).f;
    t(109)("getOwnPropertyDescriptor", function () {
      return function getOwnPropertyDescriptor(t, n) {
        return i(e(t), n);
      };
    });
  }, {
    101: 101,
    109: 109,
    140: 140
  }],
  219: [function (t, n, r) {
    t(109)("getOwnPropertyNames", function () {
      return t(102).f;
    });
  }, {
    102: 102,
    109: 109
  }],
  220: [function (t, n, r) {
    var e = t(142),
        i = t(105);
    t(109)("getPrototypeOf", function () {
      return function getPrototypeOf(t) {
        return i(e(t));
      };
    });
  }, {
    105: 105,
    109: 109,
    142: 142
  }],
  221: [function (t, n, r) {
    var e = t(81);
    t(109)("isExtensible", function (n) {
      return function isExtensible(t) {
        return !!e(t) && (!n || n(t));
      };
    });
  }, {
    109: 109,
    81: 81
  }],
  222: [function (t, n, r) {
    var e = t(81);
    t(109)("isFrozen", function (n) {
      return function isFrozen(t) {
        return !e(t) || !!n && n(t);
      };
    });
  }, {
    109: 109,
    81: 81
  }],
  223: [function (t, n, r) {
    var e = t(81);
    t(109)("isSealed", function (n) {
      return function isSealed(t) {
        return !e(t) || !!n && n(t);
      };
    });
  }, {
    109: 109,
    81: 81
  }],
  224: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Object", {
      is: t(121)
    });
  }, {
    121: 121,
    62: 62
  }],
  225: [function (t, n, r) {
    var e = t(142),
        i = t(107);
    t(109)("keys", function () {
      return function keys(t) {
        return i(e(t));
      };
    });
  }, {
    107: 107,
    109: 109,
    142: 142
  }],
  226: [function (t, n, r) {
    var e = t(81),
        i = t(94).onFreeze;
    t(109)("preventExtensions", function (n) {
      return function preventExtensions(t) {
        return n && e(t) ? n(i(t)) : t;
      };
    });
  }, {
    109: 109,
    81: 81,
    94: 94
  }],
  227: [function (t, n, r) {
    var e = t(81),
        i = t(94).onFreeze;
    t(109)("seal", function (n) {
      return function seal(t) {
        return n && e(t) ? n(i(t)) : t;
      };
    });
  }, {
    109: 109,
    81: 81,
    94: 94
  }],
  228: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Object", {
      setPrototypeOf: t(122).set
    });
  }, {
    122: 122,
    62: 62
  }],
  229: [function (t, n, r) {
    "use strict";

    var e = t(47),
        i = {};
    i[t(152)("toStringTag")] = "z", i + "" != "[object z]" && t(118)(Object.prototype, "toString", function toString() {
      return "[object " + e(this) + "]";
    }, !0);
  }, {
    118: 118,
    152: 152,
    47: 47
  }],
  230: [function (t, n, r) {
    var e = t(62),
        i = t(112);
    e(e.G + e.F * (parseFloat != i), {
      parseFloat: i
    });
  }, {
    112: 112,
    62: 62
  }],
  231: [function (t, n, r) {
    var e = t(62),
        i = t(113);
    e(e.G + e.F * (parseInt != i), {
      parseInt: i
    });
  }, {
    113: 113,
    62: 62
  }],
  232: [function (r, t, n) {
    "use strict";

    function $R() {}

    function fS(t) {
      var n;
      return !(!h(t) || "function" != typeof (n = t.then)) && n;
    }

    function gS(s, r) {
      if (!s._n) {
        s._n = !0;
        var e = s._c;
        x(function () {
          for (var a = s._v, f = 1 == s._s, t = 0, n = function n(t) {
            var n,
                r,
                e,
                i = f ? t.ok : t.fail,
                o = t.resolve,
                u = t.reject,
                c = t.domain;

            try {
              i ? (f || (2 == s._h && R(s), s._h = 1), !0 === i ? n = a : (c && c.enter(), n = i(a), c && (c.exit(), e = !0)), n === t.promise ? u(E("Promise-chain cycle")) : (r = fS(n)) ? r.call(n, o, u) : o(n)) : u(a);
            } catch (t) {
              c && !e && c.exit(), u(t);
            }
          }; e.length > t;) {
            n(e[t++]);
          }

          s._c = [], s._n = !1, r && !s._h && N(s);
        });
      }
    }

    function kS(t) {
      var n = this;
      n._d || (n._d = !0, (n = n._w || n)._v = t, n._s = 2, n._a || (n._a = n._c.slice()), gS(n, !0));
    }

    var e,
        i,
        o,
        u,
        c = r(89),
        a = r(70),
        f = r(54),
        s = r(47),
        l = r(62),
        h = r(81),
        p = r(33),
        v = r(37),
        g = r(68),
        y = r(127),
        d = r(136).set,
        x = r(95)(),
        m = r(96),
        S = r(114),
        b = r(148),
        w = r(115),
        _ = "Promise",
        E = a.TypeError,
        O = a.process,
        F = O && O.versions,
        I = F && F.v8 || "",
        P = a[_],
        A = "process" == s(O),
        M = i = m.f,
        k = !!function () {
      try {
        var t = P.resolve(1),
            n = (t.constructor = {})[r(152)("species")] = function (t) {
          t($R, $R);
        };

        return (A || "function" == typeof PromiseRejectionEvent) && t.then($R) instanceof n && 0 !== I.indexOf("6.6") && -1 === b.indexOf("Chrome/66");
      } catch (t) {}
    }(),
        N = function N(o) {
      d.call(a, function () {
        var t,
            n,
            r,
            e = o._v,
            i = j(o);
        if (i && (t = S(function () {
          A ? O.emit("unhandledRejection", e, o) : (n = a.onunhandledrejection) ? n({
            promise: o,
            reason: e
          }) : (r = a.console) && r.error && r.error("Unhandled promise rejection", e);
        }), o._h = A || j(o) ? 2 : 1), o._a = void 0, i && t.e) throw t.v;
      });
    },
        j = function j(t) {
      return 1 !== t._h && 0 === (t._a || t._c).length;
    },
        R = function R(n) {
      d.call(a, function () {
        var t;
        A ? O.emit("rejectionHandled", n) : (t = a.onrejectionhandled) && t({
          promise: n,
          reason: n._v
        });
      });
    },
        T = function T(t) {
      var r,
          e = this;

      if (!e._d) {
        e._d = !0, e = e._w || e;

        try {
          if (e === t) throw E("Promise can't be resolved itself");
          (r = fS(t)) ? x(function () {
            var n = {
              _w: e,
              _d: !1
            };

            try {
              r.call(t, f(T, n, 1), f(kS, n, 1));
            } catch (t) {
              kS.call(n, t);
            }
          }) : (e._v = t, e._s = 1, gS(e, !1));
        } catch (t) {
          kS.call({
            _w: e,
            _d: !1
          }, t);
        }
      }
    };

    k || (P = function Promise(t) {
      v(this, P, _, "_h"), p(t), e.call(this);

      try {
        t(f(T, this, 1), f(kS, this, 1));
      } catch (t) {
        kS.call(this, t);
      }
    }, (e = function Promise(t) {
      this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
    }).prototype = r(117)(P.prototype, {
      then: function then(t, n) {
        var r = M(y(this, P));
        return r.ok = "function" != typeof t || t, r.fail = "function" == typeof n && n, r.domain = A ? O.domain : void 0, this._c.push(r), this._a && this._a.push(r), this._s && gS(this, !1), r.promise;
      },
      "catch": function _catch(t) {
        return this.then(void 0, t);
      }
    }), o = function o() {
      var t = new e();
      this.promise = t, this.resolve = f(T, t, 1), this.reject = f(kS, t, 1);
    }, m.f = M = function M(t) {
      return t === P || t === u ? new o(t) : i(t);
    }), l(l.G + l.W + l.F * !k, {
      Promise: P
    }), r(124)(P, _), r(123)(_), u = r(52)[_], l(l.S + l.F * !k, _, {
      reject: function reject(t) {
        var n = M(this);
        return (0, n.reject)(t), n.promise;
      }
    }), l(l.S + l.F * (c || !k), _, {
      resolve: function resolve(t) {
        return w(c && this === u ? P : this, t);
      }
    }), l(l.S + l.F * !(k && r(86)(function (t) {
      P.all(t)["catch"]($R);
    })), _, {
      all: function all(t) {
        var u = this,
            n = M(u),
            c = n.resolve,
            a = n.reject,
            r = S(function () {
          var e = [],
              i = 0,
              o = 1;
          g(t, !1, function (t) {
            var n = i++,
                r = !1;
            e.push(void 0), o++, u.resolve(t).then(function (t) {
              r || (r = !0, e[n] = t, --o || c(e));
            }, a);
          }), --o || c(e);
        });
        return r.e && a(r.v), n.promise;
      },
      race: function race(t) {
        var n = this,
            r = M(n),
            e = r.reject,
            i = S(function () {
          g(t, !1, function (t) {
            n.resolve(t).then(r.resolve, e);
          });
        });
        return i.e && e(i.v), r.promise;
      }
    });
  }, {
    114: 114,
    115: 115,
    117: 117,
    123: 123,
    124: 124,
    127: 127,
    136: 136,
    148: 148,
    152: 152,
    33: 33,
    37: 37,
    47: 47,
    52: 52,
    54: 54,
    62: 62,
    68: 68,
    70: 70,
    81: 81,
    86: 86,
    89: 89,
    95: 95,
    96: 96
  }],
  233: [function (t, n, r) {
    var e = t(62),
        o = t(33),
        u = t(38),
        c = (t(70).Reflect || {}).apply,
        a = Function.apply;
    e(e.S + e.F * !t(64)(function () {
      c(function () {});
    }), "Reflect", {
      apply: function apply(t, n, r) {
        var e = o(t),
            i = u(r);
        return c ? c(e, n, i) : a.call(e, n, i);
      }
    });
  }, {
    33: 33,
    38: 38,
    62: 62,
    64: 64,
    70: 70
  }],
  234: [function (t, n, r) {
    var e = t(62),
        c = t(98),
        a = t(33),
        f = t(38),
        s = t(81),
        i = t(64),
        l = t(46),
        h = (t(70).Reflect || {}).construct,
        p = i(function () {
      function F() {}

      return !(h(function () {}, [], F) instanceof F);
    }),
        v = !i(function () {
      h(function () {});
    });
    e(e.S + e.F * (p || v), "Reflect", {
      construct: function construct(t, n) {
        a(t), f(n);
        var r = arguments.length < 3 ? t : a(arguments[2]);
        if (v && !p) return h(t, n, r);

        if (t == r) {
          switch (n.length) {
            case 0:
              return new t();

            case 1:
              return new t(n[0]);

            case 2:
              return new t(n[0], n[1]);

            case 3:
              return new t(n[0], n[1], n[2]);

            case 4:
              return new t(n[0], n[1], n[2], n[3]);
          }

          var e = [null];
          return e.push.apply(e, n), new (l.apply(t, e))();
        }

        var i = r.prototype,
            o = c(s(i) ? i : Object.prototype),
            u = Function.apply.call(t, o, n);
        return s(u) ? u : o;
      }
    });
  }, {
    33: 33,
    38: 38,
    46: 46,
    62: 62,
    64: 64,
    70: 70,
    81: 81,
    98: 98
  }],
  235: [function (t, n, r) {
    var e = t(99),
        i = t(62),
        o = t(38),
        u = t(143);
    i(i.S + i.F * t(64)(function () {
      Reflect.defineProperty(e.f({}, 1, {
        value: 1
      }), 1, {
        value: 2
      });
    }), "Reflect", {
      defineProperty: function defineProperty(t, n, r) {
        o(t), n = u(n, !0), o(r);

        try {
          return e.f(t, n, r), !0;
        } catch (t) {
          return !1;
        }
      }
    });
  }, {
    143: 143,
    38: 38,
    62: 62,
    64: 64,
    99: 99
  }],
  236: [function (t, n, r) {
    var e = t(62),
        i = t(101).f,
        o = t(38);
    e(e.S, "Reflect", {
      deleteProperty: function deleteProperty(t, n) {
        var r = i(o(t), n);
        return !(r && !r.configurable) && delete t[n];
      }
    });
  }, {
    101: 101,
    38: 38,
    62: 62
  }],
  237: [function (t, n, r) {
    "use strict";

    function IU(t) {
      this._t = i(t), this._i = 0;
      var n,
          r = this._k = [];

      for (n in t) {
        r.push(n);
      }
    }

    var e = t(62),
        i = t(38);
    t(84)(IU, "Object", function () {
      var t,
          n = this._k;

      do {
        if (this._i >= n.length) return {
          value: void 0,
          done: !0
        };
      } while (!((t = n[this._i++]) in this._t));

      return {
        value: t,
        done: !1
      };
    }), e(e.S, "Reflect", {
      enumerate: function enumerate(t) {
        return new IU(t);
      }
    });
  }, {
    38: 38,
    62: 62,
    84: 84
  }],
  238: [function (t, n, r) {
    var e = t(101),
        i = t(62),
        o = t(38);
    i(i.S, "Reflect", {
      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(t, n) {
        return e.f(o(t), n);
      }
    });
  }, {
    101: 101,
    38: 38,
    62: 62
  }],
  239: [function (t, n, r) {
    var e = t(62),
        i = t(105),
        o = t(38);
    e(e.S, "Reflect", {
      getPrototypeOf: function getPrototypeOf(t) {
        return i(o(t));
      }
    });
  }, {
    105: 105,
    38: 38,
    62: 62
  }],
  240: [function (t, n, r) {
    var o = t(101),
        u = t(105),
        c = t(71),
        e = t(62),
        a = t(81),
        f = t(38);
    e(e.S, "Reflect", {
      get: function get(t, n) {
        var r,
            e,
            i = arguments.length < 3 ? t : arguments[2];
        return f(t) === i ? t[n] : (r = o.f(t, n)) ? c(r, "value") ? r.value : void 0 !== r.get ? r.get.call(i) : void 0 : a(e = u(t)) ? get(e, n, i) : void 0;
      }
    });
  }, {
    101: 101,
    105: 105,
    38: 38,
    62: 62,
    71: 71,
    81: 81
  }],
  241: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Reflect", {
      has: function has(t, n) {
        return n in t;
      }
    });
  }, {
    62: 62
  }],
  242: [function (t, n, r) {
    var e = t(62),
        i = t(38),
        o = Object.isExtensible;
    e(e.S, "Reflect", {
      isExtensible: function isExtensible(t) {
        return i(t), !o || o(t);
      }
    });
  }, {
    38: 38,
    62: 62
  }],
  243: [function (t, n, r) {
    var e = t(62);
    e(e.S, "Reflect", {
      ownKeys: t(111)
    });
  }, {
    111: 111,
    62: 62
  }],
  244: [function (t, n, r) {
    var e = t(62),
        i = t(38),
        o = Object.preventExtensions;
    e(e.S, "Reflect", {
      preventExtensions: function preventExtensions(t) {
        i(t);

        try {
          return o && o(t), !0;
        } catch (t) {
          return !1;
        }
      }
    });
  }, {
    38: 38,
    62: 62
  }],
  245: [function (t, n, r) {
    var e = t(62),
        i = t(122);
    i && e(e.S, "Reflect", {
      setPrototypeOf: function setPrototypeOf(t, n) {
        i.check(t, n);

        try {
          return i.set(t, n), !0;
        } catch (t) {
          return !1;
        }
      }
    });
  }, {
    122: 122,
    62: 62
  }],
  246: [function (t, n, r) {
    var c = t(99),
        a = t(101),
        f = t(105),
        s = t(71),
        e = t(62),
        l = t(116),
        h = t(38),
        p = t(81);
    e(e.S, "Reflect", {
      set: function set(t, n, r) {
        var e,
            i,
            o = arguments.length < 4 ? t : arguments[3],
            u = a.f(h(t), n);

        if (!u) {
          if (p(i = f(t))) return set(i, n, r, o);
          u = l(0);
        }

        if (s(u, "value")) {
          if (!1 === u.writable || !p(o)) return !1;

          if (e = a.f(o, n)) {
            if (e.get || e.set || !1 === e.writable) return !1;
            e.value = r, c.f(o, n, e);
          } else c.f(o, n, l(0, r));

          return !0;
        }

        return void 0 !== u.set && (u.set.call(o, r), !0);
      }
    });
  }, {
    101: 101,
    105: 105,
    116: 116,
    38: 38,
    62: 62,
    71: 71,
    81: 81,
    99: 99
  }],
  247: [function (t, n, r) {
    var e = t(70),
        o = t(75),
        i = t(99).f,
        u = t(103).f,
        c = t(82),
        a = t(66),
        f = e.RegExp,
        s = f,
        l = f.prototype,
        h = /a/g,
        p = /a/g,
        v = new f(h) !== h;

    if (t(58) && (!v || t(64)(function () {
      return p[t(152)("match")] = !1, f(h) != h || f(p) == p || "/a/i" != f(h, "i");
    }))) {
      var DW = function DW(n) {
        n in f || i(f, n, {
          configurable: !0,
          get: function get() {
            return s[n];
          },
          set: function set(t) {
            s[n] = t;
          }
        });
      };

      f = function RegExp(t, n) {
        var r = this instanceof f,
            e = c(t),
            i = void 0 === n;
        return !r && e && t.constructor === f && i ? t : o(v ? new s(e && !i ? t.source : t, n) : s((e = t instanceof f) ? t.source : t, e && i ? a.call(t) : n), r ? this : l, f);
      };

      for (var g = u(s), y = 0; g.length > y;) {
        DW(g[y++]);
      }

      (l.constructor = f).prototype = l, t(118)(e, "RegExp", f);
    }

    t(123)("RegExp");
  }, {
    103: 103,
    118: 118,
    123: 123,
    152: 152,
    58: 58,
    64: 64,
    66: 66,
    70: 70,
    75: 75,
    82: 82,
    99: 99
  }],
  248: [function (t, n, r) {
    "use strict";

    var e = t(120);
    t(62)({
      target: "RegExp",
      proto: !0,
      forced: e !== /./.exec
    }, {
      exec: e
    });
  }, {
    120: 120,
    62: 62
  }],
  249: [function (t, n, r) {
    t(58) && "g" != /./g.flags && t(99).f(RegExp.prototype, "flags", {
      configurable: !0,
      get: t(66)
    });
  }, {
    58: 58,
    66: 66,
    99: 99
  }],
  250: [function (t, n, r) {
    "use strict";

    var l = t(38),
        h = t(141),
        p = t(36),
        v = t(119);
    t(65)("match", 1, function (e, i, f, s) {
      return [function match(t) {
        var n = e(this),
            r = null == t ? void 0 : t[i];
        return void 0 !== r ? r.call(t, n) : new RegExp(t)[i](String(n));
      }, function (t) {
        var n = s(f, t, this);
        if (n.done) return n.value;
        var r = l(t),
            e = String(this);
        if (!r.global) return v(r, e);

        for (var i, o = r.unicode, u = [], c = r.lastIndex = 0; null !== (i = v(r, e));) {
          var a = String(i[0]);
          "" === (u[c] = a) && (r.lastIndex = p(e, h(r.lastIndex), o)), c++;
        }

        return 0 === c ? null : u;
      }];
    });
  }, {
    119: 119,
    141: 141,
    36: 36,
    38: 38,
    65: 65
  }],
  251: [function (t, n, r) {
    "use strict";

    var _ = t(38),
        e = t(142),
        E = t(141),
        O = t(139),
        F = t(36),
        I = t(119),
        P = Math.max,
        A = Math.min,
        h = Math.floor,
        p = /\$([$&`']|\d\d?|<[^>]*>)/g,
        v = /\$([$&`']|\d\d?)/g;

    t(65)("replace", 2, function (i, o, b, w) {
      return [function replace(t, n) {
        var r = i(this),
            e = null == t ? void 0 : t[o];
        return void 0 !== e ? e.call(t, r, n) : b.call(String(r), t, n);
      }, function (t, n) {
        var r = w(b, t, this, n);
        if (r.done) return r.value;

        var e = _(t),
            i = String(this),
            o = "function" == typeof n;

        o || (n = String(n));
        var u = e.global;

        if (u) {
          var c = e.unicode;
          e.lastIndex = 0;
        }

        for (var a = [];;) {
          var f = I(e, i);
          if (null === f) break;
          if (a.push(f), !u) break;
          "" === String(f[0]) && (e.lastIndex = F(i, E(e.lastIndex), c));
        }

        for (var s, l = "", h = 0, p = 0; p < a.length; p++) {
          f = a[p];

          for (var v = String(f[0]), g = P(A(O(f.index), i.length), 0), y = [], d = 1; d < f.length; d++) {
            y.push(void 0 === (s = f[d]) ? s : String(s));
          }

          var x = f.groups;

          if (o) {
            var m = [v].concat(y, g, i);
            void 0 !== x && m.push(x);
            var S = String(n.apply(void 0, m));
          } else S = getSubstitution(v, i, g, y, x, n);

          h <= g && (l += i.slice(h, g) + S, h = g + v.length);
        }

        return l + i.slice(h);
      }];

      function getSubstitution(o, u, c, a, f, t) {
        var s = c + o.length,
            l = a.length,
            n = v;
        return void 0 !== f && (f = e(f), n = p), b.call(t, n, function (t, n) {
          var r;

          switch (n.charAt(0)) {
            case "$":
              return "$";

            case "&":
              return o;

            case "`":
              return u.slice(0, c);

            case "'":
              return u.slice(s);

            case "<":
              r = f[n.slice(1, -1)];
              break;

            default:
              var e = +n;
              if (0 == e) return t;

              if (l < e) {
                var i = h(e / 10);
                return 0 === i ? t : i <= l ? void 0 === a[i - 1] ? n.charAt(1) : a[i - 1] + n.charAt(1) : t;
              }

              r = a[e - 1];
          }

          return void 0 === r ? "" : r;
        });
      }
    });
  }, {
    119: 119,
    139: 139,
    141: 141,
    142: 142,
    36: 36,
    38: 38,
    65: 65
  }],
  252: [function (t, n, r) {
    "use strict";

    var a = t(38),
        f = t(121),
        s = t(119);
    t(65)("search", 1, function (e, i, u, c) {
      return [function search(t) {
        var n = e(this),
            r = null == t ? void 0 : t[i];
        return void 0 !== r ? r.call(t, n) : new RegExp(t)[i](String(n));
      }, function (t) {
        var n = c(u, t, this);
        if (n.done) return n.value;
        var r = a(t),
            e = String(this),
            i = r.lastIndex;
        f(i, 0) || (r.lastIndex = 0);
        var o = s(r, e);
        return f(r.lastIndex, i) || (r.lastIndex = i), null === o ? -1 : o.index;
      }];
    });
  }, {
    119: 119,
    121: 121,
    38: 38,
    65: 65
  }],
  253: [function (t, n, r) {
    "use strict";

    var l = t(82),
        m = t(38),
        S = t(127),
        b = t(36),
        w = t(141),
        _ = t(119),
        h = t(120),
        e = t(64),
        E = Math.min,
        p = [].push,
        u = "split",
        v = "length",
        g = "lastIndex",
        O = 4294967295,
        F = !e(function () {
      RegExp(O, "y");
    });

    t(65)("split", 2, function (i, o, y, d) {
      var x;
      return x = "c" == "abbc"[u](/(b)*/)[1] || 4 != "test"[u](/(?:)/, -1)[v] || 2 != "ab"[u](/(?:ab)*/)[v] || 4 != "."[u](/(.?)(.?)/)[v] || 1 < "."[u](/()()/)[v] || ""[u](/.?/)[v] ? function (t, n) {
        var r = String(this);
        if (void 0 === t && 0 === n) return [];
        if (!l(t)) return y.call(r, t, n);

        for (var e, i, o, u = [], c = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""), a = 0, f = void 0 === n ? O : n >>> 0, s = new RegExp(t.source, c + "g"); (e = h.call(s, r)) && !(a < (i = s[g]) && (u.push(r.slice(a, e.index)), 1 < e[v] && e.index < r[v] && p.apply(u, e.slice(1)), o = e[0][v], a = i, u[v] >= f));) {
          s[g] === e.index && s[g]++;
        }

        return a === r[v] ? !o && s.test("") || u.push("") : u.push(r.slice(a)), u[v] > f ? u.slice(0, f) : u;
      } : "0"[u](void 0, 0)[v] ? function (t, n) {
        return void 0 === t && 0 === n ? [] : y.call(this, t, n);
      } : y, [function split(t, n) {
        var r = i(this),
            e = null == t ? void 0 : t[o];
        return void 0 !== e ? e.call(t, r, n) : x.call(String(r), t, n);
      }, function (t, n) {
        var r = d(x, t, this, n, x !== y);
        if (r.done) return r.value;
        var e = m(t),
            i = String(this),
            o = S(e, RegExp),
            u = e.unicode,
            c = (e.ignoreCase ? "i" : "") + (e.multiline ? "m" : "") + (e.unicode ? "u" : "") + (F ? "y" : "g"),
            a = new o(F ? e : "^(?:" + e.source + ")", c),
            f = void 0 === n ? O : n >>> 0;
        if (0 == f) return [];
        if (0 === i.length) return null === _(a, i) ? [i] : [];

        for (var s = 0, l = 0, h = []; l < i.length;) {
          a.lastIndex = F ? l : 0;

          var p,
              v = _(a, F ? i : i.slice(l));

          if (null === v || (p = E(w(a.lastIndex + (F ? 0 : l)), i.length)) === s) l = b(i, l, u);else {
            if (h.push(i.slice(s, l)), h.length === f) return h;

            for (var g = 1; g <= v.length - 1; g++) {
              if (h.push(v[g]), h.length === f) return h;
            }

            l = s = p;
          }
        }

        return h.push(i.slice(s)), h;
      }];
    });
  }, {
    119: 119,
    120: 120,
    127: 127,
    141: 141,
    36: 36,
    38: 38,
    64: 64,
    65: 65,
    82: 82
  }],
  254: [function (n, t, r) {
    "use strict";

    n(249);

    function XZ(t) {
      n(118)(RegExp.prototype, u, t, !0);
    }

    var e = n(38),
        i = n(66),
        o = n(58),
        u = "toString",
        c = /./[u];
    n(64)(function () {
      return "/a/b" != c.call({
        source: "a",
        flags: "b"
      });
    }) ? XZ(function toString() {
      var t = e(this);
      return "/".concat(t.source, "/", "flags" in t ? t.flags : !o && t instanceof RegExp ? i.call(t) : void 0);
    }) : c.name != u && XZ(function toString() {
      return c.call(this);
    });
  }, {
    118: 118,
    249: 249,
    38: 38,
    58: 58,
    64: 64,
    66: 66
  }],
  255: [function (t, n, r) {
    "use strict";

    var e = t(49),
        i = t(149);
    n.exports = t(51)("Set", function (t) {
      return function Set() {
        return t(this, 0 < arguments.length ? arguments[0] : void 0);
      };
    }, {
      add: function add(t) {
        return e.def(i(this, "Set"), t = 0 === t ? 0 : t, t);
      }
    }, e);
  }, {
    149: 149,
    49: 49,
    51: 51
  }],
  256: [function (t, n, r) {
    "use strict";

    t(131)("anchor", function (n) {
      return function anchor(t) {
        return n(this, "a", "name", t);
      };
    });
  }, {
    131: 131
  }],
  257: [function (t, n, r) {
    "use strict";

    t(131)("big", function (t) {
      return function big() {
        return t(this, "big", "", "");
      };
    });
  }, {
    131: 131
  }],
  258: [function (t, n, r) {
    "use strict";

    t(131)("blink", function (t) {
      return function blink() {
        return t(this, "blink", "", "");
      };
    });
  }, {
    131: 131
  }],
  259: [function (t, n, r) {
    "use strict";

    t(131)("bold", function (t) {
      return function bold() {
        return t(this, "b", "", "");
      };
    });
  }, {
    131: 131
  }],
  260: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(129)(!1);
    e(e.P, "String", {
      codePointAt: function codePointAt(t) {
        return i(this, t);
      }
    });
  }, {
    129: 129,
    62: 62
  }],
  261: [function (t, n, r) {
    "use strict";

    var e = t(62),
        u = t(141),
        c = t(130),
        a = "endsWith",
        f = ""[a];
    e(e.P + e.F * t(63)(a), "String", {
      endsWith: function endsWith(t) {
        var n = c(this, t, a),
            r = 1 < arguments.length ? arguments[1] : void 0,
            e = u(n.length),
            i = void 0 === r ? e : Math.min(u(r), e),
            o = String(t);
        return f ? f.call(n, o, i) : n.slice(i - o.length, i) === o;
      }
    });
  }, {
    130: 130,
    141: 141,
    62: 62,
    63: 63
  }],
  262: [function (t, n, r) {
    "use strict";

    t(131)("fixed", function (t) {
      return function fixed() {
        return t(this, "tt", "", "");
      };
    });
  }, {
    131: 131
  }],
  263: [function (t, n, r) {
    "use strict";

    t(131)("fontcolor", function (n) {
      return function fontcolor(t) {
        return n(this, "font", "color", t);
      };
    });
  }, {
    131: 131
  }],
  264: [function (t, n, r) {
    "use strict";

    t(131)("fontsize", function (n) {
      return function fontsize(t) {
        return n(this, "font", "size", t);
      };
    });
  }, {
    131: 131
  }],
  265: [function (t, n, r) {
    var e = t(62),
        o = t(137),
        u = String.fromCharCode,
        i = String.fromCodePoint;
    e(e.S + e.F * (!!i && 1 != i.length), "String", {
      fromCodePoint: function fromCodePoint(t) {
        for (var n, r = [], e = arguments.length, i = 0; i < e;) {
          if (n = +arguments[i++], o(n, 1114111) !== n) throw RangeError(n + " is not a valid code point");
          r.push(n < 65536 ? u(n) : u(55296 + ((n -= 65536) >> 10), n % 1024 + 56320));
        }

        return r.join("");
      }
    });
  }, {
    137: 137,
    62: 62
  }],
  266: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(130),
        o = "includes";
    e(e.P + e.F * t(63)(o), "String", {
      includes: function includes(t) {
        return !!~i(this, t, o).indexOf(t, 1 < arguments.length ? arguments[1] : void 0);
      }
    });
  }, {
    130: 130,
    62: 62,
    63: 63
  }],
  267: [function (t, n, r) {
    "use strict";

    t(131)("italics", function (t) {
      return function italics() {
        return t(this, "i", "", "");
      };
    });
  }, {
    131: 131
  }],
  268: [function (t, n, r) {
    "use strict";

    var e = t(129)(!0);
    t(85)(String, "String", function (t) {
      this._t = String(t), this._i = 0;
    }, function () {
      var t,
          n = this._t,
          r = this._i;
      return r >= n.length ? {
        value: void 0,
        done: !0
      } : (t = e(n, r), this._i += t.length, {
        value: t,
        done: !1
      });
    });
  }, {
    129: 129,
    85: 85
  }],
  269: [function (t, n, r) {
    "use strict";

    t(131)("link", function (n) {
      return function link(t) {
        return n(this, "a", "href", t);
      };
    });
  }, {
    131: 131
  }],
  270: [function (t, n, r) {
    var e = t(62),
        u = t(140),
        c = t(141);
    e(e.S, "String", {
      raw: function raw(t) {
        for (var n = u(t.raw), r = c(n.length), e = arguments.length, i = [], o = 0; o < r;) {
          i.push(String(n[o++])), o < e && i.push(String(arguments[o]));
        }

        return i.join("");
      }
    });
  }, {
    140: 140,
    141: 141,
    62: 62
  }],
  271: [function (t, n, r) {
    var e = t(62);
    e(e.P, "String", {
      repeat: t(133)
    });
  }, {
    133: 133,
    62: 62
  }],
  272: [function (t, n, r) {
    "use strict";

    t(131)("small", function (t) {
      return function small() {
        return t(this, "small", "", "");
      };
    });
  }, {
    131: 131
  }],
  273: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(141),
        o = t(130),
        u = "startsWith",
        c = ""[u];
    e(e.P + e.F * t(63)(u), "String", {
      startsWith: function startsWith(t) {
        var n = o(this, t, u),
            r = i(Math.min(1 < arguments.length ? arguments[1] : void 0, n.length)),
            e = String(t);
        return c ? c.call(n, e, r) : n.slice(r, r + e.length) === e;
      }
    });
  }, {
    130: 130,
    141: 141,
    62: 62,
    63: 63
  }],
  274: [function (t, n, r) {
    "use strict";

    t(131)("strike", function (t) {
      return function strike() {
        return t(this, "strike", "", "");
      };
    });
  }, {
    131: 131
  }],
  275: [function (t, n, r) {
    "use strict";

    t(131)("sub", function (t) {
      return function sub() {
        return t(this, "sub", "", "");
      };
    });
  }, {
    131: 131
  }],
  276: [function (t, n, r) {
    "use strict";

    t(131)("sup", function (t) {
      return function sup() {
        return t(this, "sup", "", "");
      };
    });
  }, {
    131: 131
  }],
  277: [function (t, n, r) {
    "use strict";

    t(134)("trim", function (t) {
      return function trim() {
        return t(this, 3);
      };
    });
  }, {
    134: 134
  }],
  278: [function (t, n, r) {
    "use strict";

    function B1(t) {
      var n = W[t] = E(j[L]);
      return n._k = t, n;
    }

    function E1(t, n) {
      x(t);

      for (var r, e = y(n = b(n)), i = 0, o = e.length; i < o;) {
        Q(t, r = e[i++], n[r]);
      }

      return t;
    }

    function G1(t) {
      var n = D.call(this, t = w(t, !0));
      return !(this === B && u(W, t) && !u(V, t)) && (!(n || !u(this, t) || !u(W, t) || u(this, C) && this[C][t]) || n);
    }

    function H1(t, n) {
      if (t = b(t), n = w(n, !0), t !== B || !u(W, n) || u(V, n)) {
        var r = M(t, n);
        return !r || !u(W, n) || u(t, C) && t[C][n] || (r.enumerable = !0), r;
      }
    }

    function I1(t) {
      for (var n, r = N(b(t)), e = [], i = 0; r.length > i;) {
        u(W, n = r[i++]) || n == C || n == a || e.push(n);
      }

      return e;
    }

    function J1(t) {
      for (var n, r = t === B, e = N(r ? V : b(t)), i = [], o = 0; e.length > o;) {
        !u(W, n = e[o++]) || r && !u(B, n) || i.push(W[n]);
      }

      return i;
    }

    var e = t(70),
        u = t(71),
        i = t(58),
        o = t(62),
        c = t(118),
        a = t(94).KEY,
        f = t(64),
        s = t(126),
        l = t(124),
        h = t(147),
        p = t(152),
        v = t(151),
        g = t(150),
        y = t(61),
        d = t(79),
        x = t(38),
        m = t(81),
        S = t(142),
        b = t(140),
        w = t(143),
        _ = t(116),
        E = t(98),
        O = t(102),
        F = t(101),
        I = t(104),
        P = t(99),
        A = t(107),
        M = F.f,
        k = P.f,
        N = O.f,
        j = e.Symbol,
        R = e.JSON,
        T = R && R.stringify,
        L = "prototype",
        C = p("_hidden"),
        G = p("toPrimitive"),
        D = {}.propertyIsEnumerable,
        U = s("symbol-registry"),
        W = s("symbols"),
        V = s("op-symbols"),
        B = Object[L],
        q = "function" == typeof j && !!I.f,
        Y = e.QObject,
        z = !Y || !Y[L] || !Y[L].findChild,
        X = i && f(function () {
      return 7 != E(k({}, "a", {
        get: function get() {
          return k(this, "a", {
            value: 7
          }).a;
        }
      })).a;
    }) ? function (t, n, r) {
      var e = M(B, n);
      e && delete B[n], k(t, n, r), e && t !== B && k(B, n, e);
    } : k,
        $ = q && "symbol" == _typeof(j.iterator) ? function (t) {
      return "symbol" == _typeof(t);
    } : function (t) {
      return t instanceof j;
    },
        Q = function defineProperty(t, n, r) {
      return t === B && Q(V, n, r), x(t), n = w(n, !0), x(r), u(W, n) ? (r.enumerable ? (u(t, C) && t[C][n] && (t[C][n] = !1), r = E(r, {
        enumerable: _(0, !1)
      })) : (u(t, C) || k(t, C, _(1, {})), t[C][n] = !0), X(t, n, r)) : k(t, n, r);
    };

    q || (c((j = function _Symbol() {
      if (this instanceof j) throw TypeError("Symbol is not a constructor!");

      var n = h(0 < arguments.length ? arguments[0] : void 0),
          r = function r(t) {
        this === B && r.call(V, t), u(this, C) && u(this[C], n) && (this[C][n] = !1), X(this, n, _(1, t));
      };

      return i && z && X(B, n, {
        configurable: !0,
        set: r
      }), B1(n);
    })[L], "toString", function toString() {
      return this._k;
    }), F.f = H1, P.f = Q, t(103).f = O.f = I1, t(108).f = G1, I.f = J1, i && !t(89) && c(B, "propertyIsEnumerable", G1, !0), v.f = function (t) {
      return B1(p(t));
    }), o(o.G + o.W + o.F * !q, {
      Symbol: j
    });

    for (var Z = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), J = 0; Z.length > J;) {
      p(Z[J++]);
    }

    for (var H = A(p.store), K = 0; H.length > K;) {
      g(H[K++]);
    }

    o(o.S + o.F * !q, "Symbol", {
      "for": function _for(t) {
        return u(U, t += "") ? U[t] : U[t] = j(t);
      },
      keyFor: function keyFor(t) {
        if (!$(t)) throw TypeError(t + " is not a symbol!");

        for (var n in U) {
          if (U[n] === t) return n;
        }
      },
      useSetter: function useSetter() {
        z = !0;
      },
      useSimple: function useSimple() {
        z = !1;
      }
    }), o(o.S + o.F * !q, "Object", {
      create: function create(t, n) {
        return void 0 === n ? E(t) : E1(E(t), n);
      },
      defineProperty: Q,
      defineProperties: E1,
      getOwnPropertyDescriptor: H1,
      getOwnPropertyNames: I1,
      getOwnPropertySymbols: J1
    });
    var tt = f(function () {
      I.f(1);
    });
    o(o.S + o.F * tt, "Object", {
      getOwnPropertySymbols: function getOwnPropertySymbols(t) {
        return I.f(S(t));
      }
    }), R && o(o.S + o.F * (!q || f(function () {
      var t = j();
      return "[null]" != T([t]) || "{}" != T({
        a: t
      }) || "{}" != T(Object(t));
    })), "JSON", {
      stringify: function stringify(t) {
        for (var n, r, e = [t], i = 1; i < arguments.length;) {
          e.push(arguments[i++]);
        }

        if (r = n = e[1], (m(n) || void 0 !== t) && !$(t)) return d(n) || (n = function n(t, _n) {
          if ("function" == typeof r && (_n = r.call(this, t, _n)), !$(_n)) return _n;
        }), e[1] = n, T.apply(R, e);
      }
    }), j[L][G] || t(72)(j[L], G, j[L].valueOf), l(j, "Symbol"), l(Math, "Math", !0), l(e.JSON, "JSON", !0);
  }, {
    101: 101,
    102: 102,
    103: 103,
    104: 104,
    107: 107,
    108: 108,
    116: 116,
    118: 118,
    124: 124,
    126: 126,
    140: 140,
    142: 142,
    143: 143,
    147: 147,
    150: 150,
    151: 151,
    152: 152,
    38: 38,
    58: 58,
    61: 61,
    62: 62,
    64: 64,
    70: 70,
    71: 71,
    72: 72,
    79: 79,
    81: 81,
    89: 89,
    94: 94,
    98: 98,
    99: 99
  }],
  279: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(146),
        o = t(145),
        f = t(38),
        s = t(137),
        l = t(141),
        u = t(81),
        c = t(70).ArrayBuffer,
        h = t(127),
        p = o.ArrayBuffer,
        v = o.DataView,
        a = i.ABV && c.isView,
        g = p.prototype.slice,
        y = i.VIEW,
        d = "ArrayBuffer";
    e(e.G + e.W + e.F * (c !== p), {
      ArrayBuffer: p
    }), e(e.S + e.F * !i.CONSTR, d, {
      isView: function isView(t) {
        return a && a(t) || u(t) && y in t;
      }
    }), e(e.P + e.U + e.F * t(64)(function () {
      return !new p(2).slice(1, void 0).byteLength;
    }), d, {
      slice: function slice(t, n) {
        if (void 0 !== g && void 0 === n) return g.call(f(this), t);

        for (var r = f(this).byteLength, e = s(t, r), i = s(void 0 === n ? r : n, r), o = new (h(this, p))(l(i - e)), u = new v(this), c = new v(o), a = 0; e < i;) {
          c.setUint8(a++, u.getUint8(e++));
        }

        return o;
      }
    }), t(123)(d);
  }, {
    123: 123,
    127: 127,
    137: 137,
    141: 141,
    145: 145,
    146: 146,
    38: 38,
    62: 62,
    64: 64,
    70: 70,
    81: 81
  }],
  280: [function (t, n, r) {
    var e = t(62);
    e(e.G + e.W + e.F * !t(146).ABV, {
      DataView: t(145).DataView
    });
  }, {
    145: 145,
    146: 146,
    62: 62
  }],
  281: [function (t, n, r) {
    t(144)("Float32", 4, function (e) {
      return function Float32Array(t, n, r) {
        return e(this, t, n, r);
      };
    });
  }, {
    144: 144
  }],
  282: [function (t, n, r) {
    t(144)("Float64", 8, function (e) {
      return function Float64Array(t, n, r) {
        return e(this, t, n, r);
      };
    });
  }, {
    144: 144
  }],
  283: [function (t, n, r) {
    t(144)("Int16", 2, function (e) {
      return function Int16Array(t, n, r) {
        return e(this, t, n, r);
      };
    });
  }, {
    144: 144
  }],
  284: [function (t, n, r) {
    t(144)("Int32", 4, function (e) {
      return function Int32Array(t, n, r) {
        return e(this, t, n, r);
      };
    });
  }, {
    144: 144
  }],
  285: [function (t, n, r) {
    t(144)("Int8", 1, function (e) {
      return function Int8Array(t, n, r) {
        return e(this, t, n, r);
      };
    });
  }, {
    144: 144
  }],
  286: [function (t, n, r) {
    t(144)("Uint16", 2, function (e) {
      return function Uint16Array(t, n, r) {
        return e(this, t, n, r);
      };
    });
  }, {
    144: 144
  }],
  287: [function (t, n, r) {
    t(144)("Uint32", 4, function (e) {
      return function Uint32Array(t, n, r) {
        return e(this, t, n, r);
      };
    });
  }, {
    144: 144
  }],
  288: [function (t, n, r) {
    t(144)("Uint8", 1, function (e) {
      return function Uint8Array(t, n, r) {
        return e(this, t, n, r);
      };
    });
  }, {
    144: 144
  }],
  289: [function (t, n, r) {
    t(144)("Uint8", 1, function (e) {
      return function Uint8ClampedArray(t, n, r) {
        return e(this, t, n, r);
      };
    }, !0);
  }, {
    144: 144
  }],
  290: [function (t, n, r) {
    "use strict";

    function R4(t) {
      return function WeakMap() {
        return t(this, 0 < arguments.length ? arguments[0] : void 0);
      };
    }

    var o,
        e = t(70),
        i = t(42)(0),
        u = t(118),
        c = t(94),
        a = t(97),
        f = t(50),
        s = t(81),
        l = t(149),
        h = t(149),
        p = !e.ActiveXObject && "ActiveXObject" in e,
        v = "WeakMap",
        g = c.getWeak,
        y = Object.isExtensible,
        d = f.ufstore,
        x = {
      get: function get(t) {
        if (s(t)) {
          var n = g(t);
          return !0 === n ? d(l(this, v)).get(t) : n ? n[this._i] : void 0;
        }
      },
      set: function set(t, n) {
        return f.def(l(this, v), t, n);
      }
    },
        m = n.exports = t(51)(v, R4, x, f, !0, !0);
    h && p && (a((o = f.getConstructor(R4, v)).prototype, x), c.NEED = !0, i(["delete", "has", "get", "set"], function (e) {
      var t = m.prototype,
          i = t[e];
      u(t, e, function (t, n) {
        if (!s(t) || y(t)) return i.call(this, t, n);
        this._f || (this._f = new o());

        var r = this._f[e](t, n);

        return "set" == e ? this : r;
      });
    }));
  }, {
    118: 118,
    149: 149,
    42: 42,
    50: 50,
    51: 51,
    70: 70,
    81: 81,
    94: 94,
    97: 97
  }],
  291: [function (t, n, r) {
    "use strict";

    var e = t(50),
        i = t(149),
        o = "WeakSet";
    t(51)(o, function (t) {
      return function WeakSet() {
        return t(this, 0 < arguments.length ? arguments[0] : void 0);
      };
    }, {
      add: function add(t) {
        return e.def(i(this, o), t, !0);
      }
    }, e, !1, !0);
  }, {
    149: 149,
    50: 50,
    51: 51
  }],
  292: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(67),
        o = t(142),
        u = t(141),
        c = t(33),
        a = t(45);
    e(e.P, "Array", {
      flatMap: function flatMap(t) {
        var n,
            r,
            e = o(this);
        return c(t), n = u(e.length), r = a(e, 0), i(r, e, e, n, 0, 1, t, arguments[1]), r;
      }
    }), t(35)("flatMap");
  }, {
    141: 141,
    142: 142,
    33: 33,
    35: 35,
    45: 45,
    62: 62,
    67: 67
  }],
  293: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(41)(!0);
    e(e.P, "Array", {
      includes: function includes(t) {
        return i(this, t, 1 < arguments.length ? arguments[1] : void 0);
      }
    }), t(35)("includes");
  }, {
    35: 35,
    41: 41,
    62: 62
  }],
  294: [function (t, n, r) {
    var e = t(62),
        i = t(110)(!0);
    e(e.S, "Object", {
      entries: function entries(t) {
        return i(t);
      }
    });
  }, {
    110: 110,
    62: 62
  }],
  295: [function (t, n, r) {
    var e = t(62),
        a = t(111),
        f = t(140),
        s = t(101),
        l = t(53);
    e(e.S, "Object", {
      getOwnPropertyDescriptors: function getOwnPropertyDescriptors(t) {
        for (var n, r, e = f(t), i = s.f, o = a(e), u = {}, c = 0; o.length > c;) {
          void 0 !== (r = i(e, n = o[c++])) && l(u, n, r);
        }

        return u;
      }
    });
  }, {
    101: 101,
    111: 111,
    140: 140,
    53: 53,
    62: 62
  }],
  296: [function (t, n, r) {
    var e = t(62),
        i = t(110)(!1);
    e(e.S, "Object", {
      values: function values(t) {
        return i(t);
      }
    });
  }, {
    110: 110,
    62: 62
  }],
  297: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(52),
        o = t(70),
        u = t(127),
        c = t(115);
    e(e.P + e.R, "Promise", {
      "finally": function _finally(n) {
        var r = u(this, i.Promise || o.Promise),
            t = "function" == typeof n;
        return this.then(t ? function (t) {
          return c(r, n()).then(function () {
            return t;
          });
        } : n, t ? function (t) {
          return c(r, n()).then(function () {
            throw t;
          });
        } : n);
      }
    });
  }, {
    115: 115,
    127: 127,
    52: 52,
    62: 62,
    70: 70
  }],
  298: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(132),
        o = t(148),
        u = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(o);
    e(e.P + e.F * u, "String", {
      padEnd: function padEnd(t) {
        return i(this, t, 1 < arguments.length ? arguments[1] : void 0, !1);
      }
    });
  }, {
    132: 132,
    148: 148,
    62: 62
  }],
  299: [function (t, n, r) {
    "use strict";

    var e = t(62),
        i = t(132),
        o = t(148),
        u = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(o);
    e(e.P + e.F * u, "String", {
      padStart: function padStart(t) {
        return i(this, t, 1 < arguments.length ? arguments[1] : void 0, !0);
      }
    });
  }, {
    132: 132,
    148: 148,
    62: 62
  }],
  300: [function (t, n, r) {
    "use strict";

    t(134)("trimLeft", function (t) {
      return function trimLeft() {
        return t(this, 1);
      };
    }, "trimStart");
  }, {
    134: 134
  }],
  301: [function (t, n, r) {
    "use strict";

    t(134)("trimRight", function (t) {
      return function trimRight() {
        return t(this, 2);
      };
    }, "trimEnd");
  }, {
    134: 134
  }],
  302: [function (t, n, r) {
    t(150)("asyncIterator");
  }, {
    150: 150
  }],
  303: [function (t, n, r) {
    for (var e = t(164), i = t(107), o = t(118), u = t(70), c = t(72), a = t(88), f = t(152), s = f("iterator"), l = f("toStringTag"), h = a.Array, p = {
      CSSRuleList: !0,
      CSSStyleDeclaration: !1,
      CSSValueList: !1,
      ClientRectList: !1,
      DOMRectList: !1,
      DOMStringList: !1,
      DOMTokenList: !0,
      DataTransferItemList: !1,
      FileList: !1,
      HTMLAllCollection: !1,
      HTMLCollection: !1,
      HTMLFormElement: !1,
      HTMLSelectElement: !1,
      MediaList: !0,
      MimeTypeArray: !1,
      NamedNodeMap: !1,
      NodeList: !0,
      PaintRequestList: !1,
      Plugin: !1,
      PluginArray: !1,
      SVGLengthList: !1,
      SVGNumberList: !1,
      SVGPathSegList: !1,
      SVGPointList: !1,
      SVGStringList: !1,
      SVGTransformList: !1,
      SourceBufferList: !1,
      StyleSheetList: !0,
      TextTrackCueList: !1,
      TextTrackList: !1,
      TouchList: !1
    }, v = i(p), g = 0; g < v.length; g++) {
      var y,
          d = v[g],
          x = p[d],
          m = u[d],
          S = m && m.prototype;
      if (S && (S[s] || c(S, s, h), S[l] || c(S, l, d), a[d] = h, x)) for (y in e) {
        S[y] || o(S, y, e[y], !0);
      }
    }
  }, {
    107: 107,
    118: 118,
    152: 152,
    164: 164,
    70: 70,
    72: 72,
    88: 88
  }],
  304: [function (t, n, r) {
    var e = t(62),
        i = t(136);
    e(e.G + e.B, {
      setImmediate: i.set,
      clearImmediate: i.clear
    });
  }, {
    136: 136,
    62: 62
  }],
  305: [function (t, n, r) {
    function y7(i) {
      return function (t, n) {
        var r = 2 < arguments.length,
            e = r && u.call(arguments, 2);
        return i(r ? function () {
          ("function" == typeof t ? t : Function(t)).apply(this, e);
        } : t, n);
      };
    }

    var e = t(70),
        i = t(62),
        o = t(148),
        u = [].slice,
        c = /MSIE .\./.test(o);
    i(i.G + i.B + i.F * c, {
      setTimeout: y7(e.setTimeout),
      setInterval: y7(e.setInterval)
    });
  }, {
    148: 148,
    62: 62,
    70: 70
  }],
  306: [function (t, n, r) {
    t(305), t(304), t(303), n.exports = t(52);
  }, {
    303: 303,
    304: 304,
    305: 305,
    52: 52
  }],
  307: [function (t, n, r) {
    var e = function (o) {
      "use strict";

      var c,
          t = Object.prototype,
          a = t.hasOwnProperty,
          n = "function" == typeof Symbol ? Symbol : {},
          i = n.iterator || "@@iterator",
          r = n.asyncIterator || "@@asyncIterator",
          e = n.toStringTag || "@@toStringTag";

      function wrap(t, n, r, e) {
        var i = n && n.prototype instanceof Generator ? n : Generator,
            o = Object.create(i.prototype),
            u = new Context(e || []);
        return o._invoke = function makeInvokeMethod(o, u, c) {
          var a = f;
          return function invoke(t, n) {
            if (a === l) throw new Error("Generator is already running");

            if (a === h) {
              if ("throw" === t) throw n;
              return doneResult();
            }

            for (c.method = t, c.arg = n;;) {
              var r = c.delegate;

              if (r) {
                var e = maybeInvokeDelegate(r, c);

                if (e) {
                  if (e === p) continue;
                  return e;
                }
              }

              if ("next" === c.method) c.sent = c._sent = c.arg;else if ("throw" === c.method) {
                if (a === f) throw a = h, c.arg;
                c.dispatchException(c.arg);
              } else "return" === c.method && c.abrupt("return", c.arg);
              a = l;
              var i = tryCatch(o, u, c);

              if ("normal" === i.type) {
                if (a = c.done ? h : s, i.arg === p) continue;
                return {
                  value: i.arg,
                  done: c.done
                };
              }

              "throw" === i.type && (a = h, c.method = "throw", c.arg = i.arg);
            }
          };
        }(t, r, u), o;
      }

      function tryCatch(t, n, r) {
        try {
          return {
            type: "normal",
            arg: t.call(n, r)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }

      o.wrap = wrap;
      var f = "suspendedStart",
          s = "suspendedYield",
          l = "executing",
          h = "completed",
          p = {};

      function Generator() {}

      function GeneratorFunction() {}

      function GeneratorFunctionPrototype() {}

      var u = {};

      u[i] = function () {
        return this;
      };

      var v = Object.getPrototypeOf,
          g = v && v(v(values([])));
      g && g !== t && a.call(g, i) && (u = g);
      var y = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(u);

      function defineIteratorMethods(t) {
        ["next", "throw", "return"].forEach(function (n) {
          t[n] = function (t) {
            return this._invoke(n, t);
          };
        });
      }

      function AsyncIterator(c) {
        var t;

        this._invoke = function enqueue(r, e) {
          function callInvokeWithMethodAndArg() {
            return new Promise(function (t, n) {
              !function invoke(t, n, r, e) {
                var i = tryCatch(c[t], c, n);

                if ("throw" !== i.type) {
                  var o = i.arg,
                      u = o.value;
                  return u && "object" == _typeof(u) && a.call(u, "__await") ? Promise.resolve(u.__await).then(function (t) {
                    invoke("next", t, r, e);
                  }, function (t) {
                    invoke("throw", t, r, e);
                  }) : Promise.resolve(u).then(function (t) {
                    o.value = t, r(o);
                  }, function (t) {
                    return invoke("throw", t, r, e);
                  });
                }

                e(i.arg);
              }(r, e, t, n);
            });
          }

          return t = t ? t.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
      }

      function maybeInvokeDelegate(t, n) {
        var r = t.iterator[n.method];

        if (r === c) {
          if (n.delegate = null, "throw" === n.method) {
            if (t.iterator["return"] && (n.method = "return", n.arg = c, maybeInvokeDelegate(t, n), "throw" === n.method)) return p;
            n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return p;
        }

        var e = tryCatch(r, t.iterator, n.arg);
        if ("throw" === e.type) return n.method = "throw", n.arg = e.arg, n.delegate = null, p;
        var i = e.arg;
        return i ? i.done ? (n[t.resultName] = i.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = c), n.delegate = null, p) : i : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, p);
      }

      function pushTryEntry(t) {
        var n = {
          tryLoc: t[0]
        };
        1 in t && (n.catchLoc = t[1]), 2 in t && (n.finallyLoc = t[2], n.afterLoc = t[3]), this.tryEntries.push(n);
      }

      function resetTryEntry(t) {
        var n = t.completion || {};
        n.type = "normal", delete n.arg, t.completion = n;
      }

      function Context(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(pushTryEntry, this), this.reset(!0);
      }

      function values(t) {
        if (t) {
          var n = t[i];
          if (n) return n.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var r = -1,
                e = function next() {
              for (; ++r < t.length;) {
                if (a.call(t, r)) return next.value = t[r], next.done = !1, next;
              }

              return next.value = c, next.done = !0, next;
            };

            return e.next = e;
          }
        }

        return {
          next: doneResult
        };
      }

      function doneResult() {
        return {
          value: c,
          done: !0
        };
      }

      return GeneratorFunction.prototype = y.constructor = GeneratorFunctionPrototype, GeneratorFunctionPrototype.constructor = GeneratorFunction, GeneratorFunctionPrototype[e] = GeneratorFunction.displayName = "GeneratorFunction", o.isGeneratorFunction = function (t) {
        var n = "function" == typeof t && t.constructor;
        return !!n && (n === GeneratorFunction || "GeneratorFunction" === (n.displayName || n.name));
      }, o.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, e in t || (t[e] = "GeneratorFunction")), t.prototype = Object.create(y), t;
      }, o.awrap = function (t) {
        return {
          __await: t
        };
      }, defineIteratorMethods(AsyncIterator.prototype), AsyncIterator.prototype[r] = function () {
        return this;
      }, o.AsyncIterator = AsyncIterator, o.async = function (t, n, r, e) {
        var i = new AsyncIterator(wrap(t, n, r, e));
        return o.isGeneratorFunction(n) ? i : i.next().then(function (t) {
          return t.done ? t.value : i.next();
        });
      }, defineIteratorMethods(y), y[e] = "Generator", y[i] = function () {
        return this;
      }, y.toString = function () {
        return "[object Generator]";
      }, o.keys = function (n) {
        var r = [];

        for (var t in n) {
          r.push(t);
        }

        return r.reverse(), function next() {
          for (; r.length;) {
            var t = r.pop();
            if (t in n) return next.value = t, next.done = !1, next;
          }

          return next.done = !0, next;
        };
      }, o.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = c, this.done = !1, this.delegate = null, this.method = "next", this.arg = c, this.tryEntries.forEach(resetTryEntry), !t) for (var n in this) {
            "t" === n.charAt(0) && a.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = c);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(r) {
          if (this.done) throw r;
          var e = this;

          function handle(t, n) {
            return i.type = "throw", i.arg = r, e.next = t, n && (e.method = "next", e.arg = c), !!n;
          }

          for (var t = this.tryEntries.length - 1; 0 <= t; --t) {
            var n = this.tryEntries[t],
                i = n.completion;
            if ("root" === n.tryLoc) return handle("end");

            if (n.tryLoc <= this.prev) {
              var o = a.call(n, "catchLoc"),
                  u = a.call(n, "finallyLoc");

              if (o && u) {
                if (this.prev < n.catchLoc) return handle(n.catchLoc, !0);
                if (this.prev < n.finallyLoc) return handle(n.finallyLoc);
              } else if (o) {
                if (this.prev < n.catchLoc) return handle(n.catchLoc, !0);
              } else {
                if (!u) throw new Error("try statement without catch or finally");
                if (this.prev < n.finallyLoc) return handle(n.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, n) {
          for (var r = this.tryEntries.length - 1; 0 <= r; --r) {
            var e = this.tryEntries[r];

            if (e.tryLoc <= this.prev && a.call(e, "finallyLoc") && this.prev < e.finallyLoc) {
              var i = e;
              break;
            }
          }

          i && ("break" === t || "continue" === t) && i.tryLoc <= n && n <= i.finallyLoc && (i = null);
          var o = i ? i.completion : {};
          return o.type = t, o.arg = n, i ? (this.method = "next", this.next = i.finallyLoc, p) : this.complete(o);
        },
        complete: function complete(t, n) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && n && (this.next = n), p;
        },
        finish: function finish(t) {
          for (var n = this.tryEntries.length - 1; 0 <= n; --n) {
            var r = this.tryEntries[n];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), p;
          }
        },
        "catch": function _catch(t) {
          for (var n = this.tryEntries.length - 1; 0 <= n; --n) {
            var r = this.tryEntries[n];

            if (r.tryLoc === t) {
              var e = r.completion;

              if ("throw" === e.type) {
                var i = e.arg;
                resetTryEntry(r);
              }

              return i;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, n, r) {
          return this.delegate = {
            iterator: values(t),
            resultName: n,
            nextLoc: r
          }, "next" === this.method && (this.arg = c), p;
        }
      }, o;
    }("object" == _typeof(n) ? n.exports : {});

    try {
      regeneratorRuntime = e;
    } catch (t) {
      Function("r", "regeneratorRuntime = r")(e);
    }
  }, {}]
}, {}, [1]);